import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type APIKey = {
  __typename?: 'APIKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  analyticsId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type AnalyticsFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnalyticsLog = {
  __typename?: 'AnalyticsLog';
  analyticsId: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnalyticsSearchDetail = {
  __typename?: 'AnalyticsSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Annotation = {
  __typename?: 'Annotation';
  annotationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId: Scalars['String']['output'];
  format: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type AnnotationFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnnotationLog = {
  __typename?: 'AnnotationLog';
  annotationId: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnnotationMap = {
  __typename?: 'AnnotationMap';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AnnotationMapFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnnotationMapSearchDetail = {
  __typename?: 'AnnotationMapSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type AnnotationSearchDetail = {
  __typename?: 'AnnotationSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Banner = {
  __typename?: 'Banner';
  bannerColor?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type Channel = {
  __typename?: 'Channel';
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  documentation?: Maybe<Scalars['Boolean']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  interfaceVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  /** @deprecated Support for organizations has ended, please upgrade your client. */
  organizations?: Maybe<Array<Maybe<ChannelOrganization>>>;
  /** @deprecated Support for preview parameter has ended, please remove from your client. */
  preview?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeavg?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ChannelDeployment = {
  __typename?: 'ChannelDeployment';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  deploymentId: Scalars['String']['output'];
  status: ChannelDeploymentStatus;
  updatedAt: Scalars['String']['output'];
};

export type ChannelDeploymentStatus = {
  __typename?: 'ChannelDeploymentStatus';
  message: Scalars['String']['output'];
  state: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type ChannelDocumentationUpload = {
  __typename?: 'ChannelDocumentationUpload';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ChannelEditor = {
  __typename?: 'ChannelEditor';
  amiId?: Maybe<Scalars['String']['output']>;
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  editorId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  instanceType?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelEditorStatus>;
  storageSizeGb?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ChannelEditorDeleteResponse = {
  __typename?: 'ChannelEditorDeleteResponse';
  editorId: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelEditorStatus>;
};

export type ChannelEditorMutationResponse = {
  __typename?: 'ChannelEditorMutationResponse';
  editorId: Scalars['String']['output'];
  editorUrl?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelEditorStatus>;
};

/**
 * ChannelEditor API — EC2-backed successor to RemoteDevelopment. See
 * tmp/designs/channel-editor.md. Rows live in the same `channelEditorSessions`
 * table as the legacy RemoteDevelopment API; new rows are distinguished by a
 * `ce-` prefix on `editorSessionId`.
 */
export type ChannelEditorStatus = {
  __typename?: 'ChannelEditorStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type ChannelFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type ChannelOrganization = {
  __typename?: 'ChannelOrganization';
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type ChannelSearchDetail = {
  __typename?: 'ChannelSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type ChannelTemplate = {
  __typename?: 'ChannelTemplate';
  defaultVersion: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ecrRepo: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

export type ComputeUsage = {
  __typename?: 'ComputeUsage';
  byInstance?: Maybe<Array<Maybe<InstanceTypeUsage>>>;
  byUser?: Maybe<Array<Maybe<UserUsage>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type ContentCode = {
  __typename?: 'ContentCode';
  code: Scalars['String']['output'];
  contactUs: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type CreateChannelFromTemplateResponse = {
  __typename?: 'CreateChannelFromTemplateResponse';
  channelId: Scalars['String']['output'];
  editor: ChannelEditor;
};

export type Dataset = {
  __typename?: 'Dataset';
  annotations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Support for count has ended, please upgrade your client */
  count?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for datasetid has ended, please upgrade your client */
  datasetid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Scalars['Int']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Support for scenarios has ended, please upgrade your client */
  scenarios?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
  services?: Maybe<MicroserviceSupport>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for user has ended, please upgrade your client */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  graphs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  size?: InputMaybe<Array<InputMaybe<FloatComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type DatasetJob = {
  __typename?: 'DatasetJob';
  averageRuntime?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  estimatedEndAt?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId?: Maybe<Scalars['String']['output']>;
  instancesQueued?: Maybe<Scalars['Int']['output']>;
  instancesRunning?: Maybe<Scalars['Int']['output']>;
  instancesStarting?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Scalars['Int']['output']>;
  runsCancelled?: Maybe<Scalars['Int']['output']>;
  runsFailed?: Maybe<Scalars['Int']['output']>;
  runsQueued?: Maybe<Scalars['Int']['output']>;
  runsRunning?: Maybe<Scalars['Int']['output']>;
  runsStarting?: Maybe<Scalars['Int']['output']>;
  runsSuccess?: Maybe<Scalars['Int']['output']>;
  runsTimeout?: Maybe<Scalars['Int']['output']>;
  seed?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetJobFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  graphs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type DatasetJobSearchDetail = {
  __typename?: 'DatasetJobSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  type?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type DatasetLog = {
  __typename?: 'DatasetLog';
  channelId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetMetrics = {
  __typename?: 'DatasetMetrics';
  channelId?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetRun = {
  __typename?: 'DatasetRun';
  channelId?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetSearchDetail = {
  __typename?: 'DatasetSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  type?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type DateComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRemoteSessionResponse = {
  __typename?: 'DeleteRemoteSessionResponse';
  editorSessionId: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type ECRCredential = {
  __typename?: 'ECRCredential';
  ecrEndpoint: Scalars['String']['output'];
  ecrPassword: Scalars['String']['output'];
};

export type ECRDeployment = {
  __typename?: 'ECRDeployment';
  deploymentId: Scalars['String']['output'];
  ecrEndpoint: Scalars['String']['output'];
  ecrPassword: Scalars['String']['output'];
};

export type Editor = {
  __typename?: 'Editor';
  autoDeleteEnabled?: Maybe<Scalars['Boolean']['output']>;
  autoDeleteTimeoutDays?: Maybe<Scalars['Int']['output']>;
  autoStopCpuThreshold?: Maybe<Scalars['Int']['output']>;
  autoStopEnabled?: Maybe<Scalars['Boolean']['output']>;
  autoStopTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  autoUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deleteAfter?: Maybe<Scalars['String']['output']>;
  editorId?: Maybe<Scalars['String']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  serverPath?: Maybe<Scalars['String']['output']>;
  sshPort?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EditorStatus>;
  stoppedAt?: Maybe<Scalars['String']['output']>;
  storageSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  visibility?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type EditorComputeCost = {
  __typename?: 'EditorComputeCost';
  byInstance?: Maybe<Array<Maybe<EditorInstanceUsage>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type EditorCost = {
  __typename?: 'EditorCost';
  compute?: Maybe<EditorComputeCost>;
  editorId: Scalars['String']['output'];
  editorName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<EditorStorageCost>;
  tokens?: Maybe<EditorTokenCost>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type EditorImage = {
  __typename?: 'EditorImage';
  architecture?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  lastUsedBy?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EditorImageStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type EditorImageStatus = {
  __typename?: 'EditorImageStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type EditorInstanceUsage = {
  __typename?: 'EditorInstanceUsage';
  cost?: Maybe<Scalars['Float']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type EditorSearchDetail = {
  __typename?: 'EditorSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type EditorStatus = {
  __typename?: 'EditorStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type EditorStorageCost = {
  __typename?: 'EditorStorageCost';
  cost?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type EditorTokenCost = {
  __typename?: 'EditorTokenCost';
  byModel?: Maybe<Array<Maybe<EditorTokenUsage>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type EditorTokenUsage = {
  __typename?: 'EditorTokenUsage';
  completionTokens?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  promptTokens?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type EditorsFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type ExactComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  feedbackId: Scalars['String']['output'];
  uploads?: Maybe<Array<Maybe<FeedbackUpload>>>;
};

export type FeedbackUpload = {
  __typename?: 'FeedbackUpload';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FloatComparator = {
  gte?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type GANDataset = {
  __typename?: 'GANDataset';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type GANDatasetLog = {
  __typename?: 'GANDatasetLog';
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type GANModel = {
  __typename?: 'GANModel';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type GANModelFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type GANModelSearchDetail = {
  __typename?: 'GANModelSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Graph = {
  __typename?: 'Graph';
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  /** @deprecated Support for graphid has ended, please upgrade your client */
  graphid?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previewId?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  showPreview?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for user has ended, please upgrade your client */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GraphFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type GraphSearchDetail = {
  __typename?: 'GraphSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type GraphUpdateReponse = {
  __typename?: 'GraphUpdateReponse';
  description?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  showPreview?: Maybe<Scalars['Boolean']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GraphValidationError = {
  __typename?: 'GraphValidationError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Hyperparameter = {
  __typename?: 'Hyperparameter';
  default?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ImageInference = {
  __typename?: 'ImageInference';
  dataset?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inferenceId?: Maybe<Scalars['String']['output']>;
  inferences?: Maybe<Array<Maybe<Inference>>>;
  model?: Maybe<Scalars['String']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Inference = {
  __typename?: 'Inference';
  bbox?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  class?: Maybe<Scalars['Int']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
};

export type Inpaint = {
  __typename?: 'Inpaint';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  dilation?: Maybe<Scalars['Int']['output']>;
  inpaintId: Scalars['String']['output'];
  inputType?: Maybe<InpaintInputType>;
  location: Scalars['String']['output'];
  outputType?: Maybe<InpaintOutputType>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  volumeId: Scalars['String']['output'];
};

export type InpaintFormat = {
  __typename?: 'InpaintFormat';
  info?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum InpaintInputType {
  COCO = 'COCO',
  GEOJSON = 'GEOJSON',
  KITTI = 'KITTI',
  MASK = 'MASK',
  PASCAL = 'PASCAL',
  YOLO = 'YOLO'
}

export type InpaintLog = {
  __typename?: 'InpaintLog';
  inpaintId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  volumeId: Scalars['String']['output'];
};

export enum InpaintOutputType {
  JPG = 'JPG',
  PNG = 'PNG',
  SATRGB_BACKGROUND = 'SATRGB_BACKGROUND'
}

export type InstanceTypeDetails = {
  __typename?: 'InstanceTypeDetails';
  cpuClockSpeed?: Maybe<Scalars['Float']['output']>;
  cpuCount: Scalars['Int']['output'];
  gpuAvailable: Scalars['Boolean']['output'];
  gpuType?: Maybe<Scalars['String']['output']>;
  hourlyPrice?: Maybe<Scalars['Float']['output']>;
  instanceType: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  preferred: Scalars['Boolean']['output'];
  ramGB: Scalars['Float']['output'];
  vramGB?: Maybe<Scalars['Float']['output']>;
  workloadType: Scalars['String']['output'];
};

export type InstanceTypeSearchDetail = {
  __typename?: 'InstanceTypeSearchDetail';
  cpuCount?: Maybe<Array<Maybe<SearchDetail>>>;
  gpuTypes?: Maybe<Array<Maybe<SearchDetail>>>;
  ramGB?: Maybe<Array<Maybe<SearchDetail>>>;
  vramGB?: Maybe<Array<Maybe<SearchDetail>>>;
  workloadTypes?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type InstanceTypeUsage = {
  __typename?: 'InstanceTypeUsage';
  cost?: Maybe<Scalars['Float']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type InstanceTypesFilter = {
  cpuCount?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  gpuAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  gpuTypes?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  /** Filter by specific instance type names (exact match) */
  instanceTypes?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  ramGB?: InputMaybe<Array<InputMaybe<FloatComparator>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vramGB?: InputMaybe<Array<InputMaybe<FloatComparator>>>;
  workloadTypes?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type IntComparator = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LLMChannelNodeTypes = {
  __typename?: 'LLMChannelNodeTypes';
  baseChannel: Scalars['String']['output'];
  nodeTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type LLMModel = {
  __typename?: 'LLMModel';
  completionCost?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  maxCompletionSize?: Maybe<Scalars['Int']['output']>;
  maxPromptSize?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promptCost?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  supportsFunctionCalling?: Maybe<Scalars['Boolean']['output']>;
  supportsVision?: Maybe<Scalars['Boolean']['output']>;
};

export type LLMResponse = {
  __typename?: 'LLMResponse';
  baseChannel: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  nodeName: Scalars['String']['output'];
  nodeResponse?: Maybe<Scalars['String']['output']>;
  nodeType: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  promptId: Scalars['String']['output'];
  schemaResponse?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LinkedApp = {
  __typename?: 'LinkedApp';
  appId: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type MLArchitecture = {
  __typename?: 'MLArchitecture';
  annotations?: Maybe<Scalars['String']['output']>;
  architectureId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hyperparameters?: Maybe<Array<Maybe<Hyperparameter>>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MLInference = {
  __typename?: 'MLInference';
  architecture?: Maybe<Scalars['String']['output']>;
  architectureId?: Maybe<Scalars['String']['output']>;
  architectureType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  inferenceId: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type MLInferenceFilter = {
  architectures?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type MLInferenceLog = {
  __typename?: 'MLInferenceLog';
  inferenceId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type MLInferenceSearchDetail = {
  __typename?: 'MLInferenceSearchDetail';
  architectures?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type MLModel = {
  __typename?: 'MLModel';
  architecture: Scalars['String']['output'];
  architectureId: Scalars['String']['output'];
  architectureType?: Maybe<Scalars['String']['output']>;
  checkpoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type MLModelFilter = {
  architectures?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type MLModelLog = {
  __typename?: 'MLModelLog';
  log?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type MLModelSearchDetail = {
  __typename?: 'MLModelSearchDetail';
  architectures?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type MapData = {
  __typename?: 'MapData';
  fields?: Maybe<UploadFields>;
  key?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * MCP Server configuration stored at different scope levels.
 * Scope hierarchy for aggregation: Organization (base) -> Workspace -> User (highest priority)
 */
export type McpServer = {
  __typename?: 'McpServer';
  /** Full MCP server configuration as JSON string (command, args, env, etc.) */
  config: Scalars['String']['output'];
  /** Timestamp when the record was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** User ID who created the record */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Optional description of what this MCP server does */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the server is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the MCP server configuration */
  mcpServerId: Scalars['String']['output'];
  /** Display name of the MCP server (also used as key for aggregation) */
  name: Scalars['String']['output'];
  /** Organization ID (set when scopeType='organization') */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Scope type: 'organization', 'workspace', or 'user' */
  scopeType: Scalars['String']['output'];
  /** Timestamp when the record was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** User ID who last updated the record */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** User ID (set when scopeType='user') */
  userId?: Maybe<Scalars['String']['output']>;
  /** Workspace ID (set when scopeType='workspace') */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type McpTemplate = {
  __typename?: 'McpTemplate';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  mcpServerId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalMcpServerId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type McpTemplateDetails = {
  __typename?: 'McpTemplateDetails';
  category?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  demoVideo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  keyFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  license?: Maybe<Scalars['String']['output']>;
  mcpServerId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalMcpServerId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type Member = {
  __typename?: 'Member';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  role: RoleType;
  userId: Scalars['String']['output'];
};

export type MicroserviceSupport = {
  __typename?: 'MicroserviceSupport';
  analytics?: Maybe<Scalars['Boolean']['output']>;
  annotations?: Maybe<Scalars['Boolean']['output']>;
  gan?: Maybe<Scalars['Boolean']['output']>;
  inference?: Maybe<Scalars['Boolean']['output']>;
  training?: Maybe<Scalars['Boolean']['output']>;
  umap?: Maybe<Scalars['Boolean']['output']>;
};

export type ModelTokenUsage = {
  __typename?: 'ModelTokenUsage';
  completionTokens?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  promptTokens?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type MultipartInput = {
  eTag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addEditorMembers: Scalars['Boolean']['output'];
  addMember?: Maybe<Scalars['Boolean']['output']>;
  addWorkspaceMembers: Scalars['Boolean']['output'];
  addWorkspacePersistentServices?: Maybe<Scalars['Boolean']['output']>;
  addWorkspaceServices?: Maybe<Scalars['Boolean']['output']>;
  addWorkspaceVolumes?: Maybe<Scalars['Boolean']['output']>;
  cancelAllPersistentServiceJobs?: Maybe<Scalars['Int']['output']>;
  cancelPersistentServiceJob?: Maybe<Scalars['Boolean']['output']>;
  clearDatasetJobs?: Maybe<Scalars['Boolean']['output']>;
  cloneWorkspaceWithTemplate?: Maybe<TemplateReturn>;
  completeSkillUpload?: Maybe<Scalars['Boolean']['output']>;
  createAPIKey: Scalars['String']['output'];
  createAnalytics: Scalars['String']['output'];
  createAnnotation: Scalars['String']['output'];
  createChannel: Scalars['String']['output'];
  createChannelEditor: ChannelEditor;
  createChannelFromTemplate: CreateChannelFromTemplateResponse;
  createDataset?: Maybe<Scalars['String']['output']>;
  createEditor?: Maybe<Scalars['String']['output']>;
  createFeedback: Feedback;
  createGANDataset: Scalars['String']['output'];
  /** @deprecated Support for createGraph has ended, please upgrade your client */
  createGraph: Scalars['String']['output'];
  createInpaint: Scalars['String']['output'];
  createLLMPrompt: Scalars['String']['output'];
  createMLInference: Scalars['String']['output'];
  createMLModel: Scalars['String']['output'];
  /** @deprecated Support for createManagedChannel has ended, please upgrade your client. */
  createManagedChannel: Scalars['String']['output'];
  /** @deprecated Support for createManagedGANV2 has ended, please upgrade your client. */
  createManagedGANV2: UploadGANResponse;
  /** @deprecated Support for createManagedGANV2Finalizer has ended, please upgrade your client. */
  createManagedGANV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for createManagedMap has ended, please upgrade your client. */
  createManagedMap: MapData;
  /** @deprecated Support for createManagedVolume has ended, please upgrade your client. */
  createManagedVolume: Scalars['String']['output'];
  /** Create a new MCP server configuration. */
  createMcpServer?: Maybe<McpServer>;
  /** Install a marketplace MCP server into organization, workspace, or user scope. */
  createMcpWithTemplate?: Maybe<McpServer>;
  createMixedDataset: Scalars['String']['output'];
  createPersistentService?: Maybe<Scalars['String']['output']>;
  createPersistentServiceJob?: Maybe<Scalars['String']['output']>;
  createPreview: Scalars['String']['output'];
  /**
   * Create a remote development session.
   * - version = 1 (default): provisions an EC2-backed Channel Editor via the
   *   new manager service. Returns in RemoteDevelopment shape for backward
   *   compatibility with existing clients.
   * - version = 0: legacy k8s-backed editor path. Kept available during
   *   migration so callers can pin to the old behavior if needed.
   */
  createRemoteDevelopment: RemoteDevelopment;
  createSSHKey: Scalars['Boolean']['output'];
  createSecret?: Maybe<Scalars['Boolean']['output']>;
  createService?: Maybe<Scalars['String']['output']>;
  createServiceJob?: Maybe<Scalars['String']['output']>;
  createServiceWithTemplate?: Maybe<Scalars['String']['output']>;
  createSkill: SkillUploadUrls;
  createSkillWithTemplate?: Maybe<Skill>;
  createStripeCustomerPortalSession: StripePortalSession;
  createUMAP: Scalars['String']['output'];
  createVolume: Scalars['String']['output'];
  createVolumeWithTemplate?: Maybe<Scalars['String']['output']>;
  createWorkspace: Scalars['String']['output'];
  createWorkspaceWithTemplate?: Maybe<TemplateReturn>;
  deleteAPIKey?: Maybe<Scalars['Boolean']['output']>;
  deleteAnalytics: Scalars['Boolean']['output'];
  deleteAnnotation: Scalars['Boolean']['output'];
  deleteAnnotationMap: Scalars['Boolean']['output'];
  deleteChannel?: Maybe<Scalars['Boolean']['output']>;
  deleteChannelEditor: ChannelEditorDeleteResponse;
  deleteDataset?: Maybe<Scalars['Boolean']['output']>;
  deleteEditor?: Maybe<Scalars['Boolean']['output']>;
  deleteGANDataset?: Maybe<Scalars['Boolean']['output']>;
  deleteGANModel?: Maybe<Scalars['Boolean']['output']>;
  deleteGraph?: Maybe<Scalars['Boolean']['output']>;
  deleteInpaint: Scalars['Boolean']['output'];
  deleteLLMPrompt: Scalars['Boolean']['output'];
  deleteMLInference: Scalars['Boolean']['output'];
  deleteMLModel: Scalars['Boolean']['output'];
  /** @deprecated Support for deleteManagedChannel has ended, please upgrade your client. */
  deleteManagedChannel?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for deleteManagedGAN has ended, please upgrade your client. */
  deleteManagedGAN?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for deleteManagedMap has ended, please upgrade your client. */
  deleteManagedMap: Scalars['Boolean']['output'];
  /** @deprecated Support for deleteManagedVolume has ended, please upgrade your client. */
  deleteManagedVolume?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an MCP server configuration. */
  deleteMcpServer?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  deletePersistentService?: Maybe<Scalars['Boolean']['output']>;
  deletePersistentServiceJob?: Maybe<Scalars['Boolean']['output']>;
  deletePreview?: Maybe<Scalars['Boolean']['output']>;
  deleteRemoteDevelopment: DeleteRemoteSessionResponse;
  deleteSSHKey: Scalars['Boolean']['output'];
  deleteSecret?: Maybe<Scalars['Boolean']['output']>;
  deleteService?: Maybe<Scalars['Boolean']['output']>;
  deleteServiceJob?: Maybe<Scalars['Boolean']['output']>;
  deleteSkill?: Maybe<Scalars['Boolean']['output']>;
  deleteUMAP: Scalars['Boolean']['output'];
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  deleteVolume?: Maybe<Scalars['Boolean']['output']>;
  deleteVolumeData: Array<Maybe<Scalars['String']['output']>>;
  deleteWorkspace: Scalars['String']['output'];
  deployChannel: ECRDeployment;
  /** @deprecated Support for deployManagedChannel has ended, please upgrade your client. */
  deployManagedChannel: ECRDeployment;
  deployService?: Maybe<ECRDeployment>;
  downloadAnnotation: Scalars['String']['output'];
  downloadAnnotationMap: Scalars['String']['output'];
  downloadDataset?: Maybe<Scalars['String']['output']>;
  downloadDatasetFile?: Maybe<Scalars['String']['output']>;
  downloadGANModel: Scalars['String']['output'];
  downloadGraph?: Maybe<Scalars['String']['output']>;
  downloadMLInference: Scalars['String']['output'];
  downloadMLModel: Scalars['String']['output'];
  /** @deprecated Support for downloadManagedGAN has ended, please upgrade your client. */
  downloadManagedGAN: Scalars['String']['output'];
  /** @deprecated Support for downloadManagedMap has ended, please upgrade your client. */
  downloadManagedMap: Scalars['String']['output'];
  duplicateGraph?: Maybe<Scalars['String']['output']>;
  duplicateWorkspace: Scalars['String']['output'];
  editAnalytics: Scalars['Boolean']['output'];
  editAnnotation: Scalars['Boolean']['output'];
  editAnnotationMap: Scalars['Boolean']['output'];
  editChannel?: Maybe<Scalars['Boolean']['output']>;
  editDataset?: Maybe<Scalars['Boolean']['output']>;
  editDefaultGraph?: Maybe<Scalars['Boolean']['output']>;
  editEditor?: Maybe<Scalars['Boolean']['output']>;
  editGANModel?: Maybe<Scalars['Boolean']['output']>;
  editGraph?: Maybe<Scalars['Boolean']['output']>;
  editMLInference: Scalars['Boolean']['output'];
  editMLModel: Scalars['Boolean']['output'];
  /** @deprecated Support for editManagedChannel has ended, please upgrade your client. */
  editManagedChannel?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for editManagedGAN has ended, please upgrade your client. */
  editManagedGAN?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for editManagedMap has ended, please upgrade your client. */
  editManagedMap: Scalars['Boolean']['output'];
  /** @deprecated Support for editManagedVolume has ended, please upgrade your client. */
  editManagedVolume?: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing MCP server configuration. */
  editMcpServer?: Maybe<McpServer>;
  editMember?: Maybe<Scalars['Boolean']['output']>;
  editOrganization?: Maybe<Scalars['Boolean']['output']>;
  editOrganizationRules?: Maybe<Scalars['Boolean']['output']>;
  editSecret?: Maybe<Scalars['Boolean']['output']>;
  editService?: Maybe<Scalars['Boolean']['output']>;
  editServiceRules?: Maybe<Scalars['Boolean']['output']>;
  editSkill?: Maybe<Scalars['Boolean']['output']>;
  editUMAP: Scalars['Boolean']['output'];
  editUser?: Maybe<Scalars['Boolean']['output']>;
  editUserRules?: Maybe<Scalars['Boolean']['output']>;
  editVolume?: Maybe<Scalars['Boolean']['output']>;
  editVolumeData?: Maybe<Scalars['Boolean']['output']>;
  editWorkspace: Scalars['String']['output'];
  editWorkspaceRules?: Maybe<Scalars['Boolean']['output']>;
  editWorkspaceThumbnail: Scalars['String']['output'];
  initializeUser?: Maybe<Scalars['Boolean']['output']>;
  inviteChannelEditor: Scalars['Boolean']['output'];
  inviteRemoteDevelopment: Scalars['Boolean']['output'];
  mountVolumes?: Maybe<VolumeCredentials>;
  mountWorkspaces?: Maybe<WorkspaceCredentials>;
  pingPreview?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for putVolumeDataV2 has ended, please upgrade your client. */
  putVolumeDataV2: UploadVolumeDataResponse;
  /** @deprecated Support for putVolumeDataV2Finalizer has ended, please upgrade your client. */
  putVolumeDataV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  registerAgentStudioUser?: Maybe<Scalars['Boolean']['output']>;
  removeEditorMembers?: Maybe<Scalars['Boolean']['output']>;
  removeMember?: Maybe<Scalars['Boolean']['output']>;
  removeWorkspaceMembers?: Maybe<Scalars['Boolean']['output']>;
  removeWorkspacePersistentServices?: Maybe<Scalars['Boolean']['output']>;
  removeWorkspaceServices?: Maybe<Scalars['Boolean']['output']>;
  removeWorkspaceVolumes?: Maybe<Scalars['Boolean']['output']>;
  replaceSkillPackage: SkillUploadUrls;
  resendVerificationEmail?: Maybe<Scalars['Boolean']['output']>;
  restartPersistentService?: Maybe<Scalars['Boolean']['output']>;
  setChannelGraph?: Maybe<Scalars['Boolean']['output']>;
  setDefaultLLMModel?: Maybe<Scalars['Boolean']['output']>;
  setUserPreference?: Maybe<Scalars['Boolean']['output']>;
  setWorkspaceSkillEnabled: SetWorkspaceSkillEnabledResult;
  signIn?: Maybe<UserCredentials>;
  startChannelEditor: ChannelEditorMutationResponse;
  startEditor?: Maybe<Scalars['Boolean']['output']>;
  startPersistentService?: Maybe<Scalars['Boolean']['output']>;
  startRemoteDevelopment: UpdatedRemoteDevelopmentResponse;
  stopChannelEditor: ChannelEditorMutationResponse;
  stopEditor?: Maybe<Scalars['Boolean']['output']>;
  stopPersistentService?: Maybe<Scalars['Boolean']['output']>;
  stopRemoteDevelopment: UpdatedRemoteDevelopmentResponse;
  /**
   * Toggle a workspace-level override for an inherited (org/user) MCP config.
   * If no override exists, creates one (disabling the config). If one exists, removes it (re-enabling).
   * Returns true if the config is now overridden (disabled), false if the override was removed (enabled).
   */
  toggleWorkspaceMcpServerOverride?: Maybe<Scalars['Boolean']['output']>;
  toggleWorkspaceSkillOverride?: Maybe<Scalars['Boolean']['output']>;
  transferWorkspace: Scalars['Boolean']['output'];
  updateChannelEditorUsers: Scalars['Boolean']['output'];
  updateEditor?: Maybe<Scalars['Boolean']['output']>;
  updatePersistentService?: Maybe<Scalars['Boolean']['output']>;
  updateServiceJob?: Maybe<Scalars['Boolean']['output']>;
  upgradeTemplateWorkspace?: Maybe<Scalars['Boolean']['output']>;
  uploadAnnotationMap: UploadAnnotationMapResponse;
  uploadAnnotationMapFinalizer: Scalars['Boolean']['output'];
  uploadChannelDocumentation?: Maybe<Array<Maybe<ChannelDocumentationUpload>>>;
  uploadDataset: UploadDatasetResponse;
  uploadDatasetFinalizer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for uploadDatasetV2 has ended, please upgrade your client. */
  uploadDatasetV2: UploadDatasetResponse;
  /** @deprecated Support for uploadDatasetV2Finalizer has ended, please upgrade your client. */
  uploadDatasetV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadGANModel: UploadGANResponse;
  uploadGANModelFinalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadGraph: Scalars['String']['output'];
  uploadMLModel: UploadMLModelResponse;
  uploadMLModelFinalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadVolumeData: UploadVolumeDataResponse;
  uploadVolumeDataFinalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadVolumeDataThumbnail: UploadVolumeDataThumbnailResponse;
  validateGraph?: Maybe<Array<Maybe<GraphValidationError>>>;
};


export type MutationaddEditorMembersArgs = {
  editorId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationaddMemberArgs = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationaddWorkspaceMembersArgs = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationaddWorkspacePersistentServicesArgs = {
  persistentServiceIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationaddWorkspaceServicesArgs = {
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationaddWorkspaceVolumesArgs = {
  volumeIds: Array<InputMaybe<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcancelAllPersistentServiceJobsArgs = {
  editorId?: InputMaybe<Scalars['String']['input']>;
  persistentServiceId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcancelPersistentServiceJobArgs = {
  psJobId: Scalars['String']['input'];
};


export type MutationclearDatasetJobsArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcloneWorkspaceWithTemplateArgs = {
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationcompleteSkillUploadArgs = {
  parts: Array<InputMaybe<MultipartInput>>;
  skillId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationcreateAPIKeyArgs = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateAnalyticsArgs = {
  datasetId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateAnnotationArgs = {
  datasetId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateChannelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateChannelEditorArgs = {
  channelId: Scalars['String']['input'];
  channelVersion?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  storageSizeGb?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationcreateChannelFromTemplateArgs = {
  instanceType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  storageSizeGb?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['String']['input'];
};


export type MutationcreateDatasetArgs = {
  compressDataset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  instanceType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  runs?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateEditorArgs = {
  autoDeleteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoDeleteTimeoutDays?: InputMaybe<Scalars['Int']['input']>;
  autoStopCpuThreshold?: InputMaybe<Scalars['Int']['input']>;
  autoStopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoStopTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  storageSize?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateFeedbackArgs = {
  description: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['String']['input']>>;
  summary: Scalars['String']['input'];
};


export type MutationcreateGANDatasetArgs = {
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateGraphArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateInpaintArgs = {
  destination?: InputMaybe<Scalars['String']['input']>;
  dilation?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputType?: InputMaybe<InpaintInputType>;
  location: Scalars['String']['input'];
  outputType?: InputMaybe<InpaintOutputType>;
  volumeId: Scalars['String']['input'];
};


export type MutationcreateLLMPromptArgs = {
  baseChannel: Scalars['String']['input'];
  nodeName: Scalars['String']['input'];
  nodeType: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationcreateMLInferenceArgs = {
  datasetId: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateMLModelArgs = {
  architectureId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateManagedChannelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateManagedGANV2Args = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateManagedGANV2FinalizerArgs = {
  key: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateManagedMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateManagedVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateMcpServerArgs = {
  config: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scopeType: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateMcpWithTemplateArgs = {
  mcpServerId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scopeType: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateMixedDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreatePersistentServiceArgs = {
  concurrentRequests?: InputMaybe<Scalars['Int']['input']>;
  healthCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  healthCheckEndpoint?: InputMaybe<Scalars['String']['input']>;
  healthCheckFailureThreshold?: InputMaybe<Scalars['Int']['input']>;
  healthCheckIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  healthCheckPort?: InputMaybe<Scalars['Int']['input']>;
  healthCheckTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  idleShutdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  maxQueueSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serverTimeout?: InputMaybe<Scalars['Int']['input']>;
  serviceId: Scalars['String']['input'];
  serviceTimeout?: InputMaybe<Scalars['Int']['input']>;
  startupPayload?: InputMaybe<Scalars['String']['input']>;
  startupScript?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreatePersistentServiceJobArgs = {
  editorId?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  persistentServiceId: Scalars['String']['input'];
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
  workspaceVolume?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreatePreviewArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateRemoteDevelopmentArgs = {
  channelId: Scalars['String']['input'];
  channelVersion?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationcreateSSHKeyArgs = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationcreateSecretArgs = {
  includeInAllWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
  workspaceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateServiceArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  editorId?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  serviceTypeId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateServiceJobArgs = {
  editorId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  logfile?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateServiceWithTemplateArgs = {
  organizationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


export type MutationcreateSkillArgs = {
  config?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scopeType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateSkillWithTemplateArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scopeType: Scalars['String']['input'];
  skillId: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateStripeCustomerPortalSessionArgs = {
  organizationId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationcreateUMAPArgs = {
  datasetIds: Array<InputMaybe<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  samples: Array<InputMaybe<Scalars['Int']['input']>>;
  seed?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateVolumeWithTemplateArgs = {
  organizationId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationcreateWorkspaceArgs = {
  channelIds: Array<InputMaybe<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  objective?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  volumeIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationcreateWorkspaceWithTemplateArgs = {
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationdeleteAPIKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationdeleteAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteAnnotationMapArgs = {
  mapId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteChannelArgs = {
  channelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteChannelEditorArgs = {
  editorId: Scalars['String']['input'];
};


export type MutationdeleteDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteEditorArgs = {
  editorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteGANDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteGANModelArgs = {
  modelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteInpaintArgs = {
  inpaintId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteLLMPromptArgs = {
  promptId: Scalars['String']['input'];
};


export type MutationdeleteMLInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteMLModelArgs = {
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteManagedChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type MutationdeleteManagedGANArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationdeleteManagedMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationdeleteManagedVolumeArgs = {
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteMcpServerArgs = {
  mcpServerId: Scalars['String']['input'];
};


export type MutationdeleteOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationdeletePersistentServiceArgs = {
  persistentServiceId: Scalars['String']['input'];
};


export type MutationdeletePersistentServiceJobArgs = {
  psJobId: Scalars['String']['input'];
};


export type MutationdeletePreviewArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
};


export type MutationdeleteSSHKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationdeleteSecretArgs = {
  secretId: Scalars['String']['input'];
};


export type MutationdeleteServiceArgs = {
  serviceId: Scalars['String']['input'];
};


export type MutationdeleteServiceJobArgs = {
  serviceJobId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteSkillArgs = {
  skillId: Scalars['String']['input'];
};


export type MutationdeleteUMAPArgs = {
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteVolumeArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteVolumeDataArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteWorkspaceArgs = {
  workspaceId: Scalars['String']['input'];
};


export type MutationdeployChannelArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  interface?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationdeployManagedChannelArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  interface?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationdeployServiceArgs = {
  serviceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdownloadAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadAnnotationMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationdownloadDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadDatasetFileArgs = {
  datasetId: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadGANModelArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationdownloadGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadMLInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadMLModelArgs = {
  checkpoint?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadManagedGANArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationdownloadManagedMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationduplicateGraphArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationduplicateWorkspaceArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditAnnotationMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditChannelArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditDatasetArgs = {
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  showJob?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditDefaultGraphArgs = {
  channelId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationeditEditorArgs = {
  autoDeleteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoDeleteTimeoutDays?: InputMaybe<Scalars['Int']['input']>;
  autoStopCpuThreshold?: InputMaybe<Scalars['Int']['input']>;
  autoStopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoStopTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  editorId?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditGANModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditGraphArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditMLInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditMLModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditManagedChannelArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditManagedGANArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditManagedMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditManagedVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationeditMcpServerArgs = {
  config?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  mcpServerId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditMemberArgs = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};


export type MutationeditOrganizationArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationeditOrganizationRulesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditSecretArgs = {
  includeInAllWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
  secretId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditServiceArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditServiceRulesArgs = {
  rules?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditSkillArgs = {
  config?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skillId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditUMAPArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationeditUserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationeditUserRulesArgs = {
  rules?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationeditVolumeDataArgs = {
  key: Scalars['String']['input'];
  source: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationeditWorkspaceArgs = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ganIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mapIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditWorkspaceRulesArgs = {
  rules?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationeditWorkspaceThumbnailArgs = {
  thumbnail: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationinitializeUserArgs = {
  email: Scalars['String']['input'];
  organizationName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationinviteChannelEditorArgs = {
  editorId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationinviteRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationmountVolumesArgs = {
  volumes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationmountWorkspacesArgs = {
  workspaces: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationpingPreviewArgs = {
  channelId: Scalars['String']['input'];
};


export type MutationputVolumeDataV2Args = {
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationputVolumeDataV2FinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  volumeId: Scalars['String']['input'];
};


export type MutationregisterAgentStudioUserArgs = {
  cliFlow?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  magicLinkRedirectUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationremoveEditorMembersArgs = {
  editorId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationremoveMemberArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationremoveWorkspaceMembersArgs = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationremoveWorkspacePersistentServicesArgs = {
  persistentServiceIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationremoveWorkspaceServicesArgs = {
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationremoveWorkspaceVolumesArgs = {
  volumeIds: Array<InputMaybe<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationreplaceSkillPackageArgs = {
  size: Scalars['Int']['input'];
  skillId: Scalars['String']['input'];
};


export type MutationresendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationrestartPersistentServiceArgs = {
  persistentServiceId: Scalars['String']['input'];
};


export type MutationsetChannelGraphArgs = {
  channelId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationsetDefaultLLMModelArgs = {
  modelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationsetUserPreferenceArgs = {
  preference: Scalars['String']['input'];
};


export type MutationsetWorkspaceSkillEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  skillId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationstartChannelEditorArgs = {
  editorId: Scalars['String']['input'];
};


export type MutationstartEditorArgs = {
  editorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationstartPersistentServiceArgs = {
  persistentServiceId: Scalars['String']['input'];
};


export type MutationstartRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
};


export type MutationstopChannelEditorArgs = {
  editorId: Scalars['String']['input'];
};


export type MutationstopEditorArgs = {
  editorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationstopPersistentServiceArgs = {
  persistentServiceId: Scalars['String']['input'];
};


export type MutationstopRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
};


export type MutationtoggleWorkspaceMcpServerOverrideArgs = {
  mcpServerId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationtoggleWorkspaceSkillOverrideArgs = {
  skillId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationtransferWorkspaceArgs = {
  email: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationupdateChannelEditorUsersArgs = {
  editorId: Scalars['String']['input'];
  users: Array<Scalars['String']['input']>;
};


export type MutationupdateEditorArgs = {
  editorId: Scalars['String']['input'];
};


export type MutationupdatePersistentServiceArgs = {
  ami?: InputMaybe<Scalars['String']['input']>;
  concurrentRequests?: InputMaybe<Scalars['Int']['input']>;
  healthCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  healthCheckEndpoint?: InputMaybe<Scalars['String']['input']>;
  healthCheckFailureThreshold?: InputMaybe<Scalars['Int']['input']>;
  healthCheckIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  healthCheckPort?: InputMaybe<Scalars['Int']['input']>;
  healthCheckTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  idleShutdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  maxQueueSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  persistentServiceId: Scalars['String']['input'];
  serverTimeout?: InputMaybe<Scalars['Int']['input']>;
  serviceTimeout?: InputMaybe<Scalars['Int']['input']>;
  startupPayload?: InputMaybe<Scalars['String']['input']>;
  startupScript?: InputMaybe<Scalars['String']['input']>;
  upgradeToLatestVersion?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationupdateServiceJobArgs = {
  currentStep?: InputMaybe<Scalars['Int']['input']>;
  logfile?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Float']['input']>;
  serviceJobId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  totalSteps?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationupgradeTemplateWorkspaceArgs = {
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadAnnotationMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationuploadAnnotationMapFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId: Scalars['String']['input'];
};


export type MutationuploadChannelDocumentationArgs = {
  channelId: Scalars['String']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationuploadDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadDatasetFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadDatasetV2Args = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadDatasetV2FinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadGANModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationuploadGANModelFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadGraphArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadMLModelArgs = {
  architectureId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadMLModelFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadVolumeDataArgs = {
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationuploadVolumeDataFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadVolumeDataThumbnailArgs = {
  key: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationvalidateGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type NodeDocumentation = {
  __typename?: 'NodeDocumentation';
  documentation: Scalars['String']['output'];
  nodeClass: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type OldUMAP = {
  __typename?: 'OldUMAP';
  datasets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  results?: Maybe<OldUMAPResult>;
  samples?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  seed?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OldUMAPDatasets = {
  __typename?: 'OldUMAPDatasets';
  datasetId?: Maybe<Scalars['String']['output']>;
  datasetName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<OldUMAPPoints>;
};

export type OldUMAPPoints = {
  __typename?: 'OldUMAPPoints';
  image?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Scalars['String']['output']>;
  z?: Maybe<Scalars['String']['output']>;
};

export type OldUMAPResult = {
  __typename?: 'OldUMAPResult';
  datasets?: Maybe<OldUMAPDatasets>;
  featureSize?: Maybe<Scalars['String']['output']>;
  featuresize?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  expirationDate?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  serviceOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationAdmin = {
  __typename?: 'OrganizationAdmin';
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  limit: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  units: Scalars['String']['output'];
  usage: Scalars['Float']['output'];
};

export type OrganizationUsageHistory = {
  __typename?: 'OrganizationUsageHistory';
  compute?: Maybe<ComputeUsage>;
  credit?: Maybe<Scalars['Float']['output']>;
  credits?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  runningServers?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<StorageUsage>;
  tokens?: Maybe<TokenUsage>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalServers?: Maybe<Scalars['Int']['output']>;
};

export type PersistentService = {
  __typename?: 'PersistentService';
  ami?: Maybe<Scalars['String']['output']>;
  concurrentRequests: Scalars['Int']['output'];
  consecutiveHealthFailures: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  healthCheckEnabled: Scalars['Boolean']['output'];
  healthCheckEndpoint?: Maybe<Scalars['String']['output']>;
  healthCheckFailureThreshold: Scalars['Int']['output'];
  healthCheckIntervalSeconds: Scalars['Int']['output'];
  healthCheckPort?: Maybe<Scalars['Int']['output']>;
  healthCheckTimeoutSeconds: Scalars['Int']['output'];
  idleShutdownEnabled: Scalars['Boolean']['output'];
  instanceId?: Maybe<Scalars['String']['output']>;
  instancePort: Scalars['Int']['output'];
  instancePublicIp?: Maybe<Scalars['String']['output']>;
  instanceType: Scalars['String']['output'];
  lastHealthCheck?: Maybe<Scalars['String']['output']>;
  lastRequestAt?: Maybe<Scalars['String']['output']>;
  maxQueueSize: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  persistentServiceId: Scalars['String']['output'];
  serverTimeout?: Maybe<Scalars['Int']['output']>;
  serviceId: Scalars['String']['output'];
  serviceRules?: Maybe<Scalars['String']['output']>;
  serviceSchema?: Maybe<Scalars['String']['output']>;
  serviceTimeout?: Maybe<Scalars['Int']['output']>;
  serviceVersion?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  startupPayload?: Maybe<Scalars['String']['output']>;
  startupScript?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  stoppedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type PersistentServiceJob = {
  __typename?: 'PersistentServiceJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorStack?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  logfile?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['String']['output']>;
  persistentServiceId: Scalars['String']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  psJobId: Scalars['String']['output'];
  queuePosition?: Maybe<Scalars['Int']['output']>;
  queuedAt?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalSteps?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workspaceId: Scalars['String']['output'];
  workspaceVolume?: Maybe<Scalars['String']['output']>;
};

export type PersistentServiceJobSearchDetail = {
  __typename?: 'PersistentServiceJobSearchDetail';
  persistentServices?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type PersistentServiceJobsFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  persistentServices?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type PlatformSetting = {
  __typename?: 'PlatformSetting';
  setting?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Preview = {
  __typename?: 'Preview';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  previewId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type PreviewLog = {
  __typename?: 'PreviewLog';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  previewId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAPIKeyContext: APIKey;
  getAPIKeys: Array<Maybe<APIKey>>;
  getAnalytics: Array<Maybe<Analytics>>;
  getAnalyticsLog: AnalyticsLog;
  getAnalyticsSearchDetail: AnalyticsSearchDetail;
  getAnalyticsTypes: Array<Maybe<Scalars['String']['output']>>;
  getAnnotationFormats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAnnotationLog: AnnotationLog;
  getAnnotationMaps: Array<Maybe<AnnotationMap>>;
  getAnnotationMapsSearchDetail: AnnotationMapSearchDetail;
  getAnnotations: Array<Maybe<Annotation>>;
  getAnnotationsSearchDetail: AnnotationSearchDetail;
  getBanner: Banner;
  getChannelDeployment?: Maybe<ChannelDeployment>;
  getChannelDocumentation: Scalars['String']['output'];
  getChannelEditor: ChannelEditor;
  getChannelEditors: Array<Maybe<ChannelEditor>>;
  getChannelSchema: Scalars['String']['output'];
  getChannels?: Maybe<Array<Maybe<Channel>>>;
  getChannelsSearchDetail?: Maybe<ChannelSearchDetail>;
  getContentCodes?: Maybe<Array<Maybe<ContentCode>>>;
  getCurrentUser?: Maybe<User>;
  getDatasetDirectories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDatasetFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDatasetImage?: Maybe<RunData>;
  getDatasetJobs?: Maybe<Array<Maybe<DatasetJob>>>;
  getDatasetJobsSearchDetail?: Maybe<DatasetJobSearchDetail>;
  getDatasetLog?: Maybe<DatasetLog>;
  getDatasetMetrics?: Maybe<DatasetMetrics>;
  getDatasetRuns?: Maybe<Array<Maybe<DatasetRun>>>;
  getDatasetThumbnails: Array<Maybe<Scalars['String']['output']>>;
  getDatasets?: Maybe<Array<Maybe<Dataset>>>;
  getDatasetsSearchDetail?: Maybe<DatasetSearchDetail>;
  getDefaultGraph: Scalars['String']['output'];
  getDefaultLLMModel?: Maybe<LLMModel>;
  getEditorCost?: Maybe<EditorCost>;
  getEditorImages?: Maybe<Array<Maybe<EditorImage>>>;
  getEditors?: Maybe<Array<Maybe<Editor>>>;
  getEditorsSearchDetail?: Maybe<EditorSearchDetail>;
  getGANDatasetLog: GANDatasetLog;
  getGANDatasets: Array<Maybe<GANDataset>>;
  getGANModels: Array<Maybe<GANModel>>;
  getGANModelsSearchDetail: GANModelSearchDetail;
  getGraphs?: Maybe<Array<Maybe<Graph>>>;
  getGraphsSearchDetail?: Maybe<GraphSearchDetail>;
  getImageAnnotation?: Maybe<RunData>;
  getImageInference: ImageInference;
  getImageMask?: Maybe<RunData>;
  getImageMetadata?: Maybe<RunData>;
  getInpaintFormats?: Maybe<Array<Maybe<InpaintFormat>>>;
  getInpaintLog: InpaintLog;
  getInpaints: Array<Maybe<Inpaint>>;
  getInstanceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getInstanceTypesSearchDetail?: Maybe<InstanceTypeSearchDetail>;
  getInstanceTypesWithDetails?: Maybe<Array<Maybe<InstanceTypeDetails>>>;
  getInvitations?: Maybe<Array<Maybe<Invitation>>>;
  getLLMBaseChannels: Array<Maybe<Scalars['String']['output']>>;
  getLLMChannelNodeTypes: Array<Maybe<LLMChannelNodeTypes>>;
  getLLMModels?: Maybe<Array<Maybe<LLMModel>>>;
  getLLMResponse: LLMResponse;
  getMLArchitectures?: Maybe<Array<Maybe<MLArchitecture>>>;
  getMLInferenceLog: MLInferenceLog;
  getMLInferenceMetrics: Scalars['String']['output'];
  getMLInferences: Array<Maybe<MLInference>>;
  getMLInferencesSearchDetail: MLInferenceSearchDetail;
  getMLModelLog: MLModelLog;
  getMLModels: Array<Maybe<MLModel>>;
  getMLModelsSearchDetail: MLModelSearchDetail;
  /** @deprecated Support for getManagedChannels has ended, please upgrade your client. */
  getManagedChannels: Array<Maybe<Channel>>;
  /** @deprecated Support for getManagedGANs has ended, please upgrade your client. */
  getManagedGANs: Array<Maybe<GANModel>>;
  /** @deprecated Support for getManagedVolumes has ended, please upgrade your client. */
  getManagedVolumes: Array<Maybe<Volume>>;
  /**
   * Unified resolver for fetching MCP servers.
   *
   * Modes:
   * - 'organization': Returns servers scoped to the specified organization (requires organizationId)
   * - 'workspace': Returns servers scoped to the specified workspace (requires workspaceId)
   * - 'user': Returns servers scoped to the authenticated user
   * - 'aggregated': Returns combined servers with priority override (User > Workspace > Org),
   *                 only enabled servers, aggregated by name (requires workspaceId)
   */
  getMcpServers?: Maybe<Array<Maybe<McpServer>>>;
  /** Get full details of a marketplace MCP template. */
  getMcpTemplateDetails?: Maybe<McpTemplateDetails>;
  /** List published marketplace MCP templates (hidden=false, status=ready). */
  getMcpTemplates?: Maybe<Array<Maybe<McpTemplate>>>;
  getMembers?: Maybe<Array<Maybe<Member>>>;
  getNodeDocumentation: NodeDocumentation;
  getOrganizationRules?: Maybe<Scalars['String']['output']>;
  getOrganizationSettings?: Maybe<Array<Maybe<OrganizationSetting>>>;
  getOrganizationUsageHistory?: Maybe<Array<Maybe<OrganizationUsageHistory>>>;
  getOrganizations: Array<Maybe<Organization>>;
  getPersistentServiceJobs?: Maybe<Array<Maybe<PersistentServiceJob>>>;
  getPersistentServiceJobsSearchDetail?: Maybe<PersistentServiceJobSearchDetail>;
  getPersistentServices?: Maybe<Array<Maybe<PersistentService>>>;
  getPlatformRules?: Maybe<Scalars['String']['output']>;
  getPlatformSettings: Array<Maybe<PlatformSetting>>;
  getPreview?: Maybe<Preview>;
  getPreviewLog?: Maybe<PreviewLog>;
  getRuleTemplateDetails?: Maybe<RuleTemplateDetail>;
  getRuleTemplates?: Maybe<Array<Maybe<RuleTemplate>>>;
  getSDKCompatibility: SDKCompatibility;
  getSSHKeys: Array<Maybe<SSHKey>>;
  getSecrets?: Maybe<Array<Maybe<Secret>>>;
  getServiceDeployment?: Maybe<ServiceDeployment>;
  getServiceJobLogs?: Maybe<Array<Maybe<ServiceLog>>>;
  getServiceJobs?: Maybe<Array<Maybe<ServiceJob>>>;
  getServiceRules?: Maybe<Scalars['String']['output']>;
  getServiceTemplateDetails?: Maybe<ServiceTemplateDetail>;
  getServiceTemplates?: Maybe<Array<Maybe<ServiceTemplate>>>;
  getServiceTypes?: Maybe<Array<Maybe<ServiceType>>>;
  getServices?: Maybe<Array<Maybe<Service>>>;
  /**
   * Get services with pagination support. Returns a connection type with nextCursor
   * for fetching additional pages. Recommended for large datasets.
   */
  getServicesConnection?: Maybe<ServiceConnection>;
  getServicesJobsSearchDetail?: Maybe<ServiceJobSearchDetail>;
  getServicesSearchDetail?: Maybe<ServiceSearchDetail>;
  getSkillTemplateDetails?: Maybe<SkillTemplateDetails>;
  getSkillTemplates?: Maybe<Array<Maybe<SkillTemplate>>>;
  getSkills: Array<Maybe<Skill>>;
  getStripeCustomerDetails?: Maybe<StripeCustomerDetails>;
  getStripeSetupIntent?: Maybe<StripeSetupIntent>;
  getTemplateDetails?: Maybe<WorkspaceTemplateDetail>;
  getTemplates?: Maybe<Array<Maybe<WorkspaceTemplate>>>;
  getUMAPLog?: Maybe<UMAPLog>;
  getUMAPPoint: UMAPImages;
  getUMAPs: Array<Maybe<UMAP>>;
  getUMAPsSearchDetail: UMAPSearchDetail;
  getUserRules?: Maybe<Scalars['String']['output']>;
  getVolumeData: Array<Maybe<VolumeData>>;
  getVolumeDataSearchDetail: VolumeDataSearchDetail;
  getVolumeTemplateDetails?: Maybe<VolumeTemplateDetail>;
  getVolumeTemplates?: Maybe<Array<Maybe<VolumeTemplate>>>;
  getVolumes?: Maybe<Array<Maybe<Volume>>>;
  getVolumesSearchDetail?: Maybe<VolumeSearchDetail>;
  /**
   * Get all MCP server overrides for a workspace.
   * Returns the list of org/user MCP configs that have been disabled for this workspace.
   */
  getWorkspaceMcpServerOverrides?: Maybe<Array<Maybe<WorkspaceMcpServerOverride>>>;
  getWorkspaceRules?: Maybe<Scalars['String']['output']>;
  getWorkspaceServiceCredentials?: Maybe<ServiceCredentials>;
  getWorkspaceSettings?: Maybe<Array<Maybe<WorkspaceSetting>>>;
  getWorkspaceSkillOverrides?: Maybe<Array<Maybe<WorkspaceSkillOverride>>>;
  getWorkspaceTemplateDetails?: Maybe<WorkspaceTemplateDetail>;
  getWorkspaceTemplates?: Maybe<Array<Maybe<WorkspaceTemplate>>>;
  getWorkspaces?: Maybe<Array<Maybe<Workspace>>>;
  getWorkspacesSearchDetail?: Maybe<WorkspaceSearchDetail>;
  helloAnalytics: Scalars['String']['output'];
  helloAnnotations: Scalars['String']['output'];
  helloCore: Scalars['String']['output'];
  helloGAN: Scalars['String']['output'];
  helloInpaint: Scalars['String']['output'];
  helloLLM: Scalars['String']['output'];
  helloServices: Scalars['String']['output'];
  helloUMAP: Scalars['String']['output'];
  listChannelTemplates: Array<Maybe<ChannelTemplate>>;
  listRemoteDevelopment: Array<Maybe<RemoteDevelopment>>;
  validateContentCode?: Maybe<Scalars['Boolean']['output']>;
};


export type QuerygetAPIKeyContextArgs = {
  apiKey: Scalars['String']['input'];
};


export type QuerygetAPIKeysArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetAnalyticsArgs = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnalyticsLogArgs = {
  analyticsId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnalyticsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnnotationLogArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnnotationMapsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetAnnotationMapsSearchDetailArgs = {
  filters?: InputMaybe<AnnotationMapFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetAnnotationsArgs = {
  annotationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnnotationsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetChannelDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QuerygetChannelDocumentationArgs = {
  channelId: Scalars['String']['input'];
};


export type QuerygetChannelEditorArgs = {
  editorId: Scalars['String']['input'];
};


export type QuerygetChannelEditorsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetChannelSchemaArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetChannelsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetChannelsSearchDetailArgs = {
  filters?: InputMaybe<ChannelFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDatasetDirectoriesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetFilesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetImageArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDatasetJobsSearchDetailArgs = {
  filters?: InputMaybe<DatasetJobFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDatasetLogArgs = {
  datasetId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetMetricsArgs = {
  datasetId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetRunsArgs = {
  datasetId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetThumbnailsArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetsSearchDetailArgs = {
  filters?: InputMaybe<DatasetFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDefaultGraphArgs = {
  channelId: Scalars['String']['input'];
};


export type QuerygetDefaultLLMModelArgs = {
  organizationId: Scalars['String']['input'];
};


export type QuerygetEditorCostArgs = {
  editorId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetEditorImagesArgs = {
  architecture?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerygetEditorsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  editorId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<EditorsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetEditorsSearchDetailArgs = {
  filters?: InputMaybe<EditorsFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetGANDatasetLogArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetGANDatasetsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  gandatasetId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetGANModelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GANModelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetGANModelsSearchDetailArgs = {
  filters?: InputMaybe<GANModelFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetGraphsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GraphFilter>;
  graphId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetGraphsSearchDetailArgs = {
  filters?: InputMaybe<GraphFilter>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageAnnotationArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageInferenceArgs = {
  filename: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageMaskArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageMetadataArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetInpaintLogArgs = {
  inpaintId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type QuerygetInpaintsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  inpaintId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  volumeId: Scalars['String']['input'];
};


export type QuerygetInstanceTypesSearchDetailArgs = {
  filters?: InputMaybe<InstanceTypesFilter>;
};


export type QuerygetInstanceTypesWithDetailsArgs = {
  filters?: InputMaybe<InstanceTypesFilter>;
  sort?: InputMaybe<Sort>;
};


export type QuerygetInvitationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetLLMResponseArgs = {
  promptId: Scalars['String']['input'];
};


export type QuerygetMLInferenceLogArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLInferenceMetricsArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLInferencesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
  inferenceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLInferencesSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLModelLogArgs = {
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLModelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLModelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLModelsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLModelFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetManagedChannelsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QuerygetManagedGANsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QuerygetManagedVolumesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetMcpServersArgs = {
  mode: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetMcpTemplateDetailsArgs = {
  mcpServerId: Scalars['String']['input'];
};


export type QuerygetMcpTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetMembersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetNodeDocumentationArgs = {
  channelId: Scalars['String']['input'];
  nodeClass: Scalars['String']['input'];
};


export type QuerygetOrganizationRulesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetOrganizationSettingsArgs = {
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetOrganizationUsageHistoryArgs = {
  organizationId: Scalars['String']['input'];
  records?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerygetOrganizationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetPersistentServiceJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  editorId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PersistentServiceJobsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  persistentServiceId?: InputMaybe<Scalars['String']['input']>;
  psJobId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetPersistentServiceJobsSearchDetailArgs = {
  filters?: InputMaybe<PersistentServiceJobsFilter>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetPersistentServicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  persistentServiceId?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetPreviewArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetPreviewLogArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetRuleTemplateDetailsArgs = {
  ruleId: Scalars['String']['input'];
};


export type QuerygetRuleTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  ruleType?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetSDKCompatibilityArgs = {
  anatools: Scalars['String']['input'];
  os: Scalars['String']['input'];
  python: Scalars['String']['input'];
};


export type QuerygetSecretsArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServiceDeploymentArgs = {
  deploymentId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServiceJobLogsArgs = {
  serviceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServiceJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  editorId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ServiceJobsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  serviceJobId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetServiceRulesArgs = {
  serviceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServiceTemplateDetailsArgs = {
  serviceId: Scalars['String']['input'];
};


export type QuerygetServiceTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ServicesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServicesConnectionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ServicesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServicesJobsSearchDetailArgs = {
  filters?: InputMaybe<ServiceJobsFilter>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetServicesSearchDetailArgs = {
  filters?: InputMaybe<ServicesFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetSkillTemplateDetailsArgs = {
  skillId: Scalars['String']['input'];
};


export type QuerygetSkillTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetSkillsArgs = {
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetStripeCustomerDetailsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QuerygetStripeSetupIntentArgs = {
  organizationId: Scalars['String']['input'];
};


export type QuerygetTemplateDetailsArgs = {
  templateId: Scalars['String']['input'];
};


export type QuerygetTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetUMAPLogArgs = {
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetUMAPPointArgs = {
  datasetId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetUMAPsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UMAPFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  umapId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetUMAPsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UMAPFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetVolumeDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeDataFilter>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Sort>;
  volumeId: Scalars['String']['input'];
};


export type QuerygetVolumeDataSearchDetailArgs = {
  dir?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeDataFilter>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  volumeId: Scalars['String']['input'];
};


export type QuerygetVolumeTemplateDetailsArgs = {
  volumeId: Scalars['String']['input'];
};


export type QuerygetVolumeTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetVolumesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  serviceVolumes?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Sort>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetVolumesSearchDetailArgs = {
  filters?: InputMaybe<VolumeFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetWorkspaceMcpServerOverridesArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QuerygetWorkspaceRulesArgs = {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetWorkspaceServiceCredentialsArgs = {
  serviceId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetWorkspaceSettingsArgs = {
  setting?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetWorkspaceSkillOverridesArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QuerygetWorkspaceTemplateDetailsArgs = {
  templateId: Scalars['String']['input'];
};


export type QuerygetWorkspaceTemplatesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetWorkspacesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetWorkspacesSearchDetailArgs = {
  filters?: InputMaybe<WorkspaceFilter>;
  organizationId: Scalars['String']['input'];
};


export type QuerylistRemoteDevelopmentArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryvalidateContentCodeArgs = {
  code: Scalars['String']['input'];
};

export type RemoteDevelopment = {
  __typename?: 'RemoteDevelopment';
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  editorSessionId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  instanceType?: Maybe<Scalars['String']['output']>;
  nodePortResponse?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  sshPort?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RemoteDevelopmentStatus = {
  __typename?: 'RemoteDevelopmentStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
};

export type ResourceSource = {
  __typename?: 'ResourceSource';
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceVersion?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum RoleType {
  admin = 'admin',
  member = 'member'
}

export type RuleTemplate = {
  __typename?: 'RuleTemplate';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type RuleTemplateDetail = {
  __typename?: 'RuleTemplateDetail';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type RunData = {
  __typename?: 'RunData';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  datasetId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type SDKCompatibility = {
  __typename?: 'SDKCompatibility';
  message?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SSHKey = {
  __typename?: 'SSHKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SearchDetail = {
  __typename?: 'SearchDetail';
  display?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Secret = {
  __typename?: 'Secret';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  includeInAllWorkspaces?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Organization ID (set when scope='organization' or 'workspace') */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Scope type: 'organization', 'workspace', or 'user' */
  scope?: Maybe<Scalars['String']['output']>;
  secretId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  /** Workspace ID (set when scope='workspace') */
  workspaceId?: Maybe<Scalars['String']['output']>;
  workspaceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Service = {
  __typename?: 'Service';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  editorId?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Parent service ID (only for persistent services - references the base service) */
  parentServiceId?: Maybe<Scalars['String']['output']>;
  /** Persistent service ID (only for persistent services) */
  persistentServiceId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  /** Type of service: SERVICE, MARKETPLACE, or PERSISTENT_SERVICE */
  serviceType?: Maybe<ServiceTypeEnum>;
  state?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Service URL (only for persistent services when running) */
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * Connection type for paginated service queries.
 * Includes services and a cursor for fetching the next page.
 */
export type ServiceConnection = {
  __typename?: 'ServiceConnection';
  /** Cursor to fetch the next page. Null if no more results. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** List of services in this page */
  services: Array<Maybe<Service>>;
  /** Total count of services matching the query (if available) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServiceCredentials = {
  __typename?: 'ServiceCredentials';
  ecrEndpoint: Scalars['String']['output'];
  ecrPassword: Scalars['String']['output'];
  services?: Maybe<Array<Maybe<ServiceImage>>>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type ServiceDeployment = {
  __typename?: 'ServiceDeployment';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deploymentId?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ServiceDeploymentStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ServiceDeploymentStatus = {
  __typename?: 'ServiceDeploymentStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type ServiceImage = {
  __typename?: 'ServiceImage';
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  sha?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type ServiceJob = {
  __typename?: 'ServiceJob';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  editorId?: Maybe<Scalars['String']['output']>;
  logfile?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceJobId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalSteps?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ServiceJobSearchDetail = {
  __typename?: 'ServiceJobSearchDetail';
  services?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type ServiceJobsFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  services?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type ServiceLog = {
  __typename?: 'ServiceLog';
  logs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serviceId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type ServiceSearchDetail = {
  __typename?: 'ServiceSearchDetail';
  serviceTypes?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type ServiceTemplate = {
  __typename?: 'ServiceTemplate';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalServiceId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ServiceTemplateDetail = {
  __typename?: 'ServiceTemplateDetail';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  demoVideo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  keyFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  license?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalServiceId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ServiceType = {
  __typename?: 'ServiceType';
  description?: Maybe<Scalars['String']['output']>;
  execs?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceTypeId?: Maybe<Scalars['String']['output']>;
};

/** Service type discriminator */
export enum ServiceTypeEnum {
  MARKETPLACE = 'MARKETPLACE',
  PERSISTENT_SERVICE = 'PERSISTENT_SERVICE',
  SERVICE = 'SERVICE'
}

export type ServicesFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  /** Filter by service types (defaults to all types if not specified) */
  serviceTypes?: InputMaybe<Array<InputMaybe<ServiceTypeEnum>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type SessionCredentials = {
  __typename?: 'SessionCredentials';
  accesskey: Scalars['String']['output'];
  accesskeyid: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  sessiontoken: Scalars['String']['output'];
};

export type SetWorkspaceSkillEnabledResult = {
  __typename?: 'SetWorkspaceSkillEnabledResult';
  message: Scalars['String']['output'];
  skill?: Maybe<Skill>;
  success: Scalars['Boolean']['output'];
};

export type Skill = {
  __typename?: 'Skill';
  config?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  effectiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
  skillId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};


export type SkilleffectiveEnabledArgs = {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type SkillTemplate = {
  __typename?: 'SkillTemplate';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalSkillId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  skillId?: Maybe<Scalars['String']['output']>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SkillTemplateDetails = {
  __typename?: 'SkillTemplateDetails';
  category?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  demoVideo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  keyFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  license?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalSkillId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  skillId?: Maybe<Scalars['String']['output']>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SkillUploadUrls = {
  __typename?: 'SkillUploadUrls';
  partSize: Scalars['Int']['output'];
  s3Url: Scalars['String']['output'];
  skillId: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  urls: Array<Scalars['String']['output']>;
};

export type Sort = {
  column: Scalars['String']['input'];
  direction: Scalars['String']['input'];
};

export type StorageTypeUsage = {
  __typename?: 'StorageTypeUsage';
  cost?: Maybe<Scalars['Float']['output']>;
  storageType?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type StorageUsage = {
  __typename?: 'StorageUsage';
  byStorageType?: Maybe<Array<Maybe<StorageTypeUsage>>>;
  byUser?: Maybe<Array<Maybe<UserUsage>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type StripeCardDetails = {
  __typename?: 'StripeCardDetails';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export type StripeCustomerDetails = {
  __typename?: 'StripeCustomerDetails';
  autoPayEnabled: Scalars['Boolean']['output'];
  invoices: StripeInvoiceGroup;
  paymentMethods: Array<StripePaymentMethod>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amountDue: Scalars['Int']['output'];
  amountPaid: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type StripeInvoiceGroup = {
  __typename?: 'StripeInvoiceGroup';
  open: Array<StripeInvoice>;
  paid: Array<StripeInvoice>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  card?: Maybe<StripeCardDetails>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type StripePortalSession = {
  __typename?: 'StripePortalSession';
  url: Scalars['String']['output'];
};

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  clientSecret: Scalars['String']['output'];
  setupIntentId: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  graphDeleted?: Maybe<Scalars['Boolean']['output']>;
  graphUpdates?: Maybe<GraphUpdateReponse>;
};


export type SubscriptiongraphDeletedArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type SubscriptiongraphUpdatesArgs = {
  graphId: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type TemplateReturn = {
  __typename?: 'TemplateReturn';
  editorId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type TokenUsage = {
  __typename?: 'TokenUsage';
  byModel?: Maybe<Array<Maybe<ModelTokenUsage>>>;
  byUser?: Maybe<Array<Maybe<UserTokenUsage>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type UMAP = {
  __typename?: 'UMAP';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasets: Array<Maybe<UMAPDataset>>;
  name: Scalars['String']['output'];
  results?: Maybe<Scalars['String']['output']>;
  samples: Array<Maybe<Scalars['Int']['output']>>;
  seed: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  umapId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type UMAPDataset = {
  __typename?: 'UMAPDataset';
  dataset?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
};

export type UMAPFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type UMAPImages = {
  __typename?: 'UMAPImages';
  heatmap4?: Maybe<Scalars['String']['output']>;
  heatmap8?: Maybe<Scalars['String']['output']>;
  heatmap16?: Maybe<Scalars['String']['output']>;
  heatmap32?: Maybe<Scalars['String']['output']>;
  heatmap64?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
};

export type UMAPLog = {
  __typename?: 'UMAPLog';
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  umapId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type UMAPPoints = {
  __typename?: 'UMAPPoints';
  image?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type UMAPSearchDetail = {
  __typename?: 'UMAPSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type UpdatedRemoteDevelopmentResponse = {
  __typename?: 'UpdatedRemoteDevelopmentResponse';
  editorSessionId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type UploadAnnotationMapResponse = {
  __typename?: 'UploadAnnotationMapResponse';
  key: Scalars['String']['output'];
  mapId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadDatasetResponse = {
  __typename?: 'UploadDatasetResponse';
  datasetId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadFields = {
  __typename?: 'UploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type UploadGANResponse = {
  __typename?: 'UploadGANResponse';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadMLModelResponse = {
  __typename?: 'UploadMLModelResponse';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadVolumeDataResponse = {
  __typename?: 'UploadVolumeDataResponse';
  key: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  volumeId: Scalars['String']['output'];
};

export type UploadVolumeDataThumbnailResponse = {
  __typename?: 'UploadVolumeDataThumbnailResponse';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preference?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserCredentials = {
  __typename?: 'UserCredentials';
  expires: Scalars['Int']['output'];
  idtoken: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type UserTokenUsage = {
  __typename?: 'UserTokenUsage';
  completionTokens?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  promptTokens?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type UserUsage = {
  __typename?: 'UserUsage';
  cost?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['Float']['output']>;
};

export type Volume = {
  __typename?: 'Volume';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  marketplace?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  /** @deprecated Support for organizations has ended, please upgrade your client. */
  organizations?: Maybe<Array<Maybe<VolumeOrganization>>>;
  permission: Scalars['String']['output'];
  sanitizedName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<Maybe<ResourceSource>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  volumeId: Scalars['String']['output'];
  workspaceVolume?: Maybe<Scalars['Boolean']['output']>;
};

export type VolumeCredentials = {
  __typename?: 'VolumeCredentials';
  credentials: SessionCredentials;
  keys: Array<Maybe<Scalars['String']['output']>>;
  rw: Array<Maybe<Scalars['String']['output']>>;
};

export type VolumeData = {
  __typename?: 'VolumeData';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VolumeDataFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  fileFormats?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  fileTypes?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  size?: InputMaybe<Array<InputMaybe<FloatComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type VolumeDataSearchDetail = {
  __typename?: 'VolumeDataSearchDetail';
  fileFormats?: Maybe<Array<Maybe<SearchDetail>>>;
  fileTypes?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type VolumeFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type VolumeOrganization = {
  __typename?: 'VolumeOrganization';
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type VolumeSearchDetail = {
  __typename?: 'VolumeSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type VolumeTemplate = {
  __typename?: 'VolumeTemplate';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalVolumeId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  volumeId?: Maybe<Scalars['String']['output']>;
};

export type VolumeTemplateDetail = {
  __typename?: 'VolumeTemplateDetail';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  demoVideo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  keyFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  license?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalVolumeId?: Maybe<Scalars['String']['output']>;
  sanitizedName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  volumeId?: Maybe<Scalars['String']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  previewThumbnail?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  template?: Maybe<WorkspaceTemplateInfo>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  visibility?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceCredentials = {
  __typename?: 'WorkspaceCredentials';
  credentials: SessionCredentials;
  keys: Array<Maybe<Scalars['String']['output']>>;
  rw: Array<Maybe<Scalars['String']['output']>>;
};

export type WorkspaceFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

/**
 * Represents an override that disables an inherited (org/user) MCP config
 * for a specific workspace. Row present = disabled; row absent = inherited.
 */
export type WorkspaceMcpServerOverride = {
  __typename?: 'WorkspaceMcpServerOverride';
  /** When the override was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Who created the override */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The MCP server config being overridden (disabled) */
  mcpServerId: Scalars['String']['output'];
  /** The workspace where this override applies */
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceSearchDetail = {
  __typename?: 'WorkspaceSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type WorkspaceSetting = {
  __typename?: 'WorkspaceSetting';
  limit: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  units: Scalars['String']['output'];
  usage: Scalars['Float']['output'];
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceSkillOverride = {
  __typename?: 'WorkspaceSkillOverride';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  skillId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceTemplate = {
  __typename?: 'WorkspaceTemplate';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  keyFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  license?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templateId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceTemplateDetail = {
  __typename?: 'WorkspaceTemplateDetail';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  demoVideo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  keyFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  license?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templateId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceTemplateInfo = {
  __typename?: 'WorkspaceTemplateInfo';
  templateId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CreateRemoteSessionGetOrgChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRemoteSessionGetOrgChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, instanceType?: string | null, name: string, organizationId: string, state?: string | null, version?: string | null } | null> | null };

export type GetServerMembersDataQueryVariables = Exact<{
  editorId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServerMembersDataQuery = { __typename?: 'Query', getEditors?: Array<{ __typename?: 'Editor', editorId?: string | null, workspaceId?: string | null, createdBy?: string | null, users?: Array<string | null> | null, visibility?: string | null } | null> | null };

export type GetAvailableServicesForTransferQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ServicesFilter>;
}>;


export type GetAvailableServicesForTransferQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', name?: string | null, serviceId?: string | null, serviceType?: ServiceTypeEnum | null, persistentServiceId?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetAvailableServicesForTransferSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAvailableServicesForTransferSearchDetailQuery = { __typename?: 'Query', getServicesSearchDetail?: { __typename?: 'ServiceSearchDetail', serviceTypes?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null } | null };

export type GetInstanceTypesSearchDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstanceTypesSearchDetailQuery = { __typename?: 'Query', getInstanceTypesSearchDetail?: { __typename?: 'InstanceTypeSearchDetail', workloadTypes?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, gpuTypes?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, cpuCount?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, ramGB?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, vramGB?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetAvailableInstanceTypesWithDetailsQueryVariables = Exact<{
  filters?: InputMaybe<InstanceTypesFilter>;
}>;


export type GetAvailableInstanceTypesWithDetailsQuery = { __typename?: 'Query', getInstanceTypesWithDetails?: Array<{ __typename?: 'InstanceTypeDetails', instanceType: string, workloadType: string, cpuCount: number, cpuClockSpeed?: number | null, gpuType?: string | null, ramGB: number, vramGB?: number | null, gpuAvailable: boolean, preferred: boolean, hourlyPrice?: number | null } | null> | null };

export type GetEditVolumeDetailsQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
}>;


export type GetEditVolumeDetailsQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string, description: string, permission: string, tags?: Array<string | null> | null } | null> | null };

export type GetDeleteWorkspaceModalDataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetDeleteWorkspaceModalDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, name: string, createdBy?: string | null, users?: Array<string | null> | null } | null> | null };

export type GetDuplicateWorkspaceModalDataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetDuplicateWorkspaceModalDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, description?: string | null, name: string, objective?: string | null, tags?: Array<string | null> | null } | null> | null, getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string, workspaceVolume?: boolean | null } | null> | null, getServices?: Array<{ __typename?: 'Service', serviceId?: string | null, name?: string | null } | null> | null };

export type GetEditWorkspaceDetailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetEditWorkspaceDetailsQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, name: string, description?: string | null, objective?: string | null, tags?: Array<string | null> | null, visibility?: string | null } | null> | null };

export type GetManageWorkspaceMembersDataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetManageWorkspaceMembersDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, createdBy?: string | null, users?: Array<string | null> | null, visibility?: string | null } | null> | null };

export type GetTransferWorkspaceModalDataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetTransferWorkspaceModalDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, name: string, users?: Array<string | null> | null } | null> | null };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { __typename?: 'Query', getTemplates?: Array<{ __typename?: 'WorkspaceTemplate', description?: string | null, index?: number | null, name?: string | null, organization?: string | null, tags?: Array<string | null> | null, thumbnail?: string | null, templateId?: string | null, version?: number | null } | null> | null };

export type GetWorkspaceTemplateVersionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceTemplateVersionQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, template?: { __typename?: 'WorkspaceTemplateInfo', templateId?: string | null, version?: number | null } | null } | null> | null };

export type GetOrganizationServicesNameListQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  sort?: InputMaybe<Sort>;
}>;


export type GetOrganizationServicesNameListQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', name?: string | null, serviceId?: string | null, serviceType?: ServiceTypeEnum | null, persistentServiceId?: string | null } | null> | null };

export type GetOrganizationVolumesNameListQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationVolumesNameListQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', name: string, volumeId: string } | null> | null };

export type GetAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', result?: string | null } | null> };

export type GetAnalyticsTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticsTypesQuery = { __typename?: 'Query', getAnalyticsTypes: Array<string | null> };

export type GetAnalyticsLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsLogQuery = { __typename?: 'Query', getAnalyticsLog: { __typename?: 'AnalyticsLog', log?: string | null } };

export type GetAnnotationFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnnotationFormatsQuery = { __typename?: 'Query', getAnnotationFormats?: Array<string | null> | null };

export type GetAnnotationMapsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
}>;


export type GetAnnotationMapsQuery = { __typename?: 'Query', getAnnotationMaps: Array<{ __typename?: 'AnnotationMap', description?: string | null, mapId: string, name: string, organization: string, createdAt?: string | null, organizationId: string, updatedAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetAnnotationLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  annotationId: Scalars['String']['input'];
}>;


export type GetAnnotationLogQuery = { __typename?: 'Query', getAnnotationLog: { __typename?: 'AnnotationLog', log?: string | null } };

export type GetChannelDocumentationQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type GetChannelDocumentationQuery = { __typename?: 'Query', getChannelDocumentation: string };

export type GetChannelNodeDocumentationQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  nodeClass: Scalars['String']['input'];
}>;


export type GetChannelNodeDocumentationQuery = { __typename?: 'Query', getNodeDocumentation: { __typename?: 'NodeDocumentation', documentation: string, preview?: string | null, thumbnail?: string | null } };

export type GetDatasetRunsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetRunsQuery = { __typename?: 'Query', getDatasetRuns?: Array<{ __typename?: 'DatasetRun', runId?: string | null, workspaceId?: string | null, datasetId?: string | null, channelId?: string | null, startTime?: string | null, endTime?: string | null, state?: string | null, run?: number | null } | null> | null, getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, name?: string | null } | null> | null };

export type GetDatasetLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
}>;


export type GetDatasetLogQuery = { __typename?: 'Query', getDatasetLog?: { __typename?: 'DatasetLog', log?: string | null } | null };

export type GetDatasetImageQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetDatasetImageQuery = { __typename?: 'Query', getDatasetImage?: { __typename?: 'RunData', data?: Array<string | null> | null } | null };

export type GetDatasetQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, files?: number | null, name: string, runs?: number | null } | null> | null };

export type GetWorkspaceDatasetsListQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetWorkspaceDatasetsListQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, name: string } | null> | null };

export type GetGANModelsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GANModelFilter>;
}>;


export type GetGANModelsQuery = { __typename?: 'Query', getGANModels: Array<{ __typename?: 'GANModel', organizationId: string, modelId: string, description?: string | null, flags?: string | null, name: string, organization: string, createdAt?: string | null, updatedAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetGANDatasetLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetGANDatasetLogQuery = { __typename?: 'Query', getGANDatasetLog: { __typename?: 'GANDatasetLog', log?: string | null } };

export type GetInpaintFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInpaintFormatsQuery = { __typename?: 'Query', getInpaintFormats?: Array<{ __typename?: 'InpaintFormat', name: string, value: string, info?: string | null } | null> | null };

export type GetInpaintsQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInpaintsQuery = { __typename?: 'Query', getInpaints: Array<{ __typename?: 'Inpaint', volumeId: string, inpaintId: string, status: string, location: string, destination?: string | null, inputType?: InpaintInputType | null, outputType?: InpaintOutputType | null, dilation?: number | null, createdBy?: string | null, createdAt?: string | null, updatedBy?: string | null, updatedAt?: string | null } | null> };

export type GetInpaintLogQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type GetInpaintLogQuery = { __typename?: 'Query', getInpaintLog: { __typename?: 'InpaintLog', log?: string | null } };

export type GetInvitationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetInvitationsQuery = { __typename?: 'Query', getInvitations?: Array<{ __typename?: 'Invitation', email?: string | null, organizationId?: string | null, role?: RoleType | null, updatedAt?: string | null } | null> | null };

export type GetMcpServersQueryVariables = Exact<{
  mode: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMcpServersQuery = { __typename?: 'Query', getMcpServers?: Array<{ __typename?: 'McpServer', mcpServerId: string, scopeType: string, organizationId?: string | null, workspaceId?: string | null, userId?: string | null, name: string, description?: string | null, config: string, enabled?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetWorkspaceMcpServerOverridesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceMcpServerOverridesQuery = { __typename?: 'Query', getWorkspaceMcpServerOverrides?: Array<{ __typename?: 'WorkspaceMcpServerOverride', workspaceId: string, mcpServerId: string, createdAt?: string | null, createdBy?: string | null } | null> | null };

export type GetMembersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMembersQuery = { __typename?: 'Query', getMembers?: Array<{ __typename?: 'Member', userId: string, email: string, name: string, role: RoleType } | null> | null };

export type GetMLInferenceLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMLInferenceLogQuery = { __typename?: 'Query', getMLInferenceLog: { __typename?: 'MLInferenceLog', workspaceId: string, inferenceId: string, status: string, log?: string | null } };

export type GetMLInferenceMetricsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMLInferenceMetricsQuery = { __typename?: 'Query', getMLInferenceMetrics: string };

export type GetMLArchitecturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMLArchitecturesQuery = { __typename?: 'Query', getMLArchitectures?: Array<{ __typename?: 'MLArchitecture', architectureId?: string | null, name?: string | null, description?: string | null, annotations?: string | null, hyperparameters?: Array<{ __typename?: 'Hyperparameter', name: string, field: string, type: string, description?: string | null, default?: string | null, min?: number | null, max?: number | null, step?: number | null, options?: Array<string | null> | null } | null> | null } | null> | null };

export type GetMLModelQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMLModelQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', architecture: string, architectureId: string, checkpoints?: Array<string | null> | null, dataset: string, datasetId: string, description?: string | null, metrics?: string | null, modelId: string, name: string, parameters?: string | null, status?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMLModelLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMLModelLogQuery = { __typename?: 'Query', getMLModelLog: { __typename?: 'MLModelLog', log?: string | null } };

export type AddMemberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember?: boolean | null };

export type AddWorkspaceMembersMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AddWorkspaceMembersMutation = { __typename?: 'Mutation', addWorkspaceMembers: boolean };

export type AddWorkspacePersistentServicesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  persistentServiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddWorkspacePersistentServicesMutation = { __typename?: 'Mutation', addWorkspacePersistentServices?: boolean | null };

export type AddWorkspaceServicesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AddWorkspaceServicesMutation = { __typename?: 'Mutation', addWorkspaceServices?: boolean | null };

export type AddWorkspaceVolumesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  volumeIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AddWorkspaceVolumesMutation = { __typename?: 'Mutation', addWorkspaceVolumes?: boolean | null };

export type ClearDatasetJobsMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClearDatasetJobsMutation = { __typename?: 'Mutation', clearDatasetJobs?: boolean | null };

export type CompleteSkillUploadMutationVariables = Exact<{
  skillId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  parts: Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>;
}>;


export type CompleteSkillUploadMutation = { __typename?: 'Mutation', completeSkillUpload?: boolean | null };

export type CreateAPIKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAPIKeyMutation = { __typename?: 'Mutation', createAPIKey: string };

export type CreateAnalyticsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAnalyticsMutation = { __typename?: 'Mutation', createAnalytics: string };

export type CreateAnnotationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAnnotationMutation = { __typename?: 'Mutation', createAnnotation: string };

export type CreateChannelMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', createChannel: string };

export type CreateDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  runs?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDatasetMutation = { __typename?: 'Mutation', createDataset?: string | null };

export type CreateEditorMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  storageSize?: InputMaybe<Scalars['Int']['input']>;
  autoStopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoStopCpuThreshold?: InputMaybe<Scalars['Int']['input']>;
  autoStopTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoDeleteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoDeleteTimeoutDays?: InputMaybe<Scalars['Int']['input']>;
  autoUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEditorMutation = { __typename?: 'Mutation', createEditor?: string | null };

export type CreateFeedbackMutationVariables = Exact<{
  summary: Scalars['String']['input'];
  description: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'Feedback', feedbackId: string, uploads?: Array<{ __typename?: 'FeedbackUpload', key?: string | null, url?: string | null } | null> | null } };

export type CreateGANDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateGANDatasetMutation = { __typename?: 'Mutation', createGANDataset: string };

export type CreateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateGraphMutation = { __typename?: 'Mutation', createGraph: string };

export type CreateInpaintMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  location: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  destination?: InputMaybe<Scalars['String']['input']>;
  dilation?: InputMaybe<Scalars['Int']['input']>;
  inputType?: InputMaybe<InpaintInputType>;
  outputType?: InputMaybe<InpaintOutputType>;
}>;


export type CreateInpaintMutation = { __typename?: 'Mutation', createInpaint: string };

export type CreateMcpWithTemplateMutationVariables = Exact<{
  mcpServerId: Scalars['String']['input'];
  scopeType: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMcpWithTemplateMutation = { __typename?: 'Mutation', createMcpWithTemplate?: { __typename?: 'McpServer', mcpServerId: string, scopeType: string, organizationId?: string | null, workspaceId?: string | null, userId?: string | null } | null };

export type CreateMcpServerMutationVariables = Exact<{
  scopeType: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMcpServerMutation = { __typename?: 'Mutation', createMcpServer?: { __typename?: 'McpServer', config: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, enabled?: boolean | null, mcpServerId: string, name: string, organizationId?: string | null, scopeType: string, updatedAt?: string | null, updatedBy?: string | null, userId?: string | null, workspaceId?: string | null } | null };

export type CreateMLInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMLInferenceMutation = { __typename?: 'Mutation', createMLInference: string };

export type CreateMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  architectureId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMLModelMutation = { __typename?: 'Mutation', createMLModel: string };

export type CreateMixedDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMixedDatasetMutation = { __typename?: 'Mutation', createMixedDataset: string };

export type CreatePreviewMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type CreatePreviewMutation = { __typename?: 'Mutation', createPreview: string };

export type CreateRemoteDevelopmentMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  channelVersion?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateRemoteDevelopmentMutation = { __typename?: 'Mutation', createRemoteDevelopment: { __typename?: 'RemoteDevelopment', editorSessionId: string, editorUrl: string } };

export type CreateSecretMutationVariables = Exact<{
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  includeInAllWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSecretMutation = { __typename?: 'Mutation', createSecret?: boolean | null };

export type CreateServiceMutationVariables = Exact<{
  serviceTypeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService?: string | null };

export type CreateServiceWithTemplateMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
}>;


export type CreateServiceWithTemplateMutation = { __typename?: 'Mutation', createServiceWithTemplate?: string | null };

export type CreateSkillWithTemplateMutationVariables = Exact<{
  skillId: Scalars['String']['input'];
  scopeType: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSkillWithTemplateMutation = { __typename?: 'Mutation', createSkillWithTemplate?: { __typename?: 'Skill', skillId: string, scopeType: string, organizationId?: string | null, workspaceId?: string | null, userId?: string | null } | null };

export type CreateSkillMutationVariables = Exact<{
  scopeType: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
}>;


export type CreateSkillMutation = { __typename?: 'Mutation', createSkill: { __typename?: 'SkillUploadUrls', skillId: string, uploadId: string, partSize: number, urls: Array<string>, s3Url: string } };

export type CreateSSHKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type CreateSSHKeyMutation = { __typename?: 'Mutation', createSSHKey: boolean };

export type CreateStripeCustomerPortalSessionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
}>;


export type CreateStripeCustomerPortalSessionMutation = { __typename?: 'Mutation', createStripeCustomerPortalSession: { __typename?: 'StripePortalSession', url: string } };

export type CreateUMAPMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  samples: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateUMAPMutation = { __typename?: 'Mutation', createUMAP: string };

export type CreateVolumeMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateVolumeMutation = { __typename?: 'Mutation', createVolume: string };

export type CreateVolumeWithTemplateMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
}>;


export type CreateVolumeWithTemplateMutation = { __typename?: 'Mutation', createVolumeWithTemplate?: string | null };

export type CreateWorkspaceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  channelIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  volumeIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace: string };

export type CreateWorkspaceWithTemplateMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
}>;


export type CreateWorkspaceWithTemplateMutation = { __typename?: 'Mutation', createWorkspaceWithTemplate?: { __typename?: 'TemplateReturn', editorId?: string | null, url?: string | null, workspaceId?: string | null } | null };

export type DeleteAPIKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteAPIKeyMutation = { __typename?: 'Mutation', deleteAPIKey?: boolean | null };

export type DeleteAnalyticsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type DeleteAnalyticsMutation = { __typename?: 'Mutation', deleteAnalytics: boolean };

export type DeleteAnnotationMutationVariables = Exact<{
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteAnnotationMutation = { __typename?: 'Mutation', deleteAnnotation: boolean };

export type DeleteAnnotationMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAnnotationMapMutation = { __typename?: 'Mutation', deleteAnnotationMap: boolean };

export type DeleteChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteChannelMutation = { __typename?: 'Mutation', deleteChannel?: boolean | null };

export type DeleteDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteDatasetMutation = { __typename?: 'Mutation', deleteDataset?: boolean | null };

export type DeleteEditorMutationVariables = Exact<{
  editorId: Scalars['String']['input'];
}>;


export type DeleteEditorMutation = { __typename?: 'Mutation', deleteEditor?: boolean | null };

export type DeleteGANDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type DeleteGANDatasetMutation = { __typename?: 'Mutation', deleteGANDataset?: boolean | null };

export type DeleteGANModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteGANModelMutation = { __typename?: 'Mutation', deleteGANModel?: boolean | null };

export type DeleteGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteGraphMutation = { __typename?: 'Mutation', deleteGraph?: boolean | null };

export type DeleteInpaintMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type DeleteInpaintMutation = { __typename?: 'Mutation', deleteInpaint: boolean };

export type DeleteMcpServerMutationVariables = Exact<{
  mcpServerId: Scalars['String']['input'];
}>;


export type DeleteMcpServerMutation = { __typename?: 'Mutation', deleteMcpServer?: boolean | null };

export type DeleteMLInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type DeleteMLInferenceMutation = { __typename?: 'Mutation', deleteMLInference: boolean };

export type DeleteMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type DeleteMLModelMutation = { __typename?: 'Mutation', deleteMLModel: boolean };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: boolean | null };

export type DeleteRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type DeleteRemoteDevelopmentMutation = { __typename?: 'Mutation', deleteRemoteDevelopment: { __typename?: 'DeleteRemoteSessionResponse', editorSessionId: string } };

export type DeleteSecretMutationVariables = Exact<{
  secretId: Scalars['String']['input'];
}>;


export type DeleteSecretMutation = { __typename?: 'Mutation', deleteSecret?: boolean | null };

export type DeleteServiceMutationVariables = Exact<{
  serviceId: Scalars['String']['input'];
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', deleteService?: boolean | null };

export type DeleteSkillMutationVariables = Exact<{
  skillId: Scalars['String']['input'];
}>;


export type DeleteSkillMutation = { __typename?: 'Mutation', deleteSkill?: boolean | null };

export type DeleteSSHKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteSSHKeyMutation = { __typename?: 'Mutation', deleteSSHKey: boolean };

export type DeleteUMAPMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
}>;


export type DeleteUMAPMutation = { __typename?: 'Mutation', deleteUMAP: boolean };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: boolean | null };

export type DeleteVolumeMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteVolumeMutation = { __typename?: 'Mutation', deleteVolume?: boolean | null };

export type DeleteVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type DeleteVolumeDataMutation = { __typename?: 'Mutation', deleteVolumeData: Array<string | null> };

export type DeleteWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace: string };

export type DownloadAnnotationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  annotationId: Scalars['String']['input'];
}>;


export type DownloadAnnotationMutation = { __typename?: 'Mutation', downloadAnnotation: string };

export type DownloadAnnotationMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
}>;


export type DownloadAnnotationMapMutation = { __typename?: 'Mutation', downloadAnnotationMap: string };

export type DownloadDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type DownloadDatasetMutation = { __typename?: 'Mutation', downloadDataset?: string | null };

export type DownloadGANModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type DownloadGANModelMutation = { __typename?: 'Mutation', downloadGANModel: string };

export type DownloadGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type DownloadGraphMutation = { __typename?: 'Mutation', downloadGraph?: string | null };

export type DownloadMLInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type DownloadMLInferenceMutation = { __typename?: 'Mutation', downloadMLInference: string };

export type DownloadMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  checkpoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadMLModelMutation = { __typename?: 'Mutation', downloadMLModel: string };

export type DuplicateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DuplicateGraphMutation = { __typename?: 'Mutation', duplicateGraph?: string | null };

export type DuplicateWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DuplicateWorkspaceMutation = { __typename?: 'Mutation', duplicateWorkspace: string };

export type EditAnnotationMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditAnnotationMapMutation = { __typename?: 'Mutation', editAnnotationMap: boolean };

export type EditChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditChannelMutation = { __typename?: 'Mutation', editChannel?: boolean | null };

export type EditDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  showJob?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditDatasetMutation = { __typename?: 'Mutation', editDataset?: boolean | null };

export type EditEditorMutationVariables = Exact<{
  editorId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  autoStopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoStopCpuThreshold?: InputMaybe<Scalars['Int']['input']>;
  autoStopTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoDeleteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoDeleteTimeoutDays?: InputMaybe<Scalars['Int']['input']>;
  autoUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditEditorMutation = { __typename?: 'Mutation', editEditor?: boolean | null };

export type AddEditorMembersMutationVariables = Exact<{
  editorId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AddEditorMembersMutation = { __typename?: 'Mutation', addEditorMembers: boolean };

export type RemoveEditorMembersMutationVariables = Exact<{
  editorId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveEditorMembersMutation = { __typename?: 'Mutation', removeEditorMembers?: boolean | null };

export type EditGANModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditGANModelMutation = { __typename?: 'Mutation', editGANModel?: boolean | null };

export type EditGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditGraphMutation = { __typename?: 'Mutation', editGraph?: boolean | null };

export type EditMcpServerMutationVariables = Exact<{
  mcpServerId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditMcpServerMutation = { __typename?: 'Mutation', editMcpServer?: { __typename?: 'McpServer', config: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, enabled?: boolean | null, mcpServerId: string, name: string, organizationId?: string | null, scopeType: string, updatedAt?: string | null, updatedBy?: string | null, userId?: string | null, workspaceId?: string | null } | null };

export type EditMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditMLModelMutation = { __typename?: 'Mutation', editMLModel: boolean };

export type EditMemberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type EditMemberMutation = { __typename?: 'Mutation', editMember?: boolean | null };

export type EditOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization?: boolean | null };

export type EditOrganizationRulesMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditOrganizationRulesMutation = { __typename?: 'Mutation', editOrganizationRules?: boolean | null };

export type EditSecretMutationVariables = Exact<{
  secretId: Scalars['String']['input'];
  workspaceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  includeInAllWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditSecretMutation = { __typename?: 'Mutation', editSecret?: boolean | null };

export type EditServiceMutationVariables = Exact<{
  serviceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditServiceMutation = { __typename?: 'Mutation', editService?: boolean | null };

export type EditServiceRulesMutationVariables = Exact<{
  serviceId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditServiceRulesMutation = { __typename?: 'Mutation', editServiceRules?: boolean | null };

export type EditSkillMutationVariables = Exact<{
  skillId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditSkillMutation = { __typename?: 'Mutation', editSkill?: boolean | null };

export type EditUMAPMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditUMAPMutation = { __typename?: 'Mutation', editUMAP: boolean };

export type EditUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser?: boolean | null };

export type EditUserRulesMutationVariables = Exact<{
  rules?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditUserRulesMutation = { __typename?: 'Mutation', editUserRules?: boolean | null };

export type EditVolumeMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditVolumeMutation = { __typename?: 'Mutation', editVolume?: boolean | null };

export type EditVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  source: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type EditVolumeDataMutation = { __typename?: 'Mutation', editVolumeData?: boolean | null };

export type EditWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ganIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  mapIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditWorkspaceMutation = { __typename?: 'Mutation', editWorkspace: string };

export type EditWorkspaceRulesMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditWorkspaceRulesMutation = { __typename?: 'Mutation', editWorkspaceRules?: boolean | null };

export type EditWorkspaceThumbnailMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  thumbnail: Scalars['String']['input'];
}>;


export type EditWorkspaceThumbnailMutation = { __typename?: 'Mutation', editWorkspaceThumbnail: string };

export type InviteRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type InviteRemoteDevelopmentMutation = { __typename?: 'Mutation', inviteRemoteDevelopment: boolean };

export type PingPreviewMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type PingPreviewMutation = { __typename?: 'Mutation', pingPreview?: boolean | null };

export type RegisterAgentStudioUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  cliFlow?: InputMaybe<Scalars['Boolean']['input']>;
  magicLinkRedirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterAgentStudioUserMutation = { __typename?: 'Mutation', registerAgentStudioUser?: boolean | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember?: boolean | null };

export type RemoveWorkspaceMembersMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveWorkspaceMembersMutation = { __typename?: 'Mutation', removeWorkspaceMembers?: boolean | null };

export type RemoveWorkspaceServicesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type RemoveWorkspaceServicesMutation = { __typename?: 'Mutation', removeWorkspaceServices?: boolean | null };

export type RemoveWorkspacePersistentServicesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  persistentServiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveWorkspacePersistentServicesMutation = { __typename?: 'Mutation', removeWorkspacePersistentServices?: boolean | null };

export type RemoveWorkspaceVolumesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  volumeIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveWorkspaceVolumesMutation = { __typename?: 'Mutation', removeWorkspaceVolumes?: boolean | null };

export type ReplaceSkillPackageMutationVariables = Exact<{
  skillId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
}>;


export type ReplaceSkillPackageMutation = { __typename?: 'Mutation', replaceSkillPackage: { __typename?: 'SkillUploadUrls', skillId: string, uploadId: string, partSize: number, urls: Array<string>, s3Url: string } };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail?: boolean | null };

export type SetUserPreferenceMutationVariables = Exact<{
  preference: Scalars['String']['input'];
}>;


export type SetUserPreferenceMutation = { __typename?: 'Mutation', setUserPreference?: boolean | null };

export type StartEditorMutationVariables = Exact<{
  editorId: Scalars['String']['input'];
}>;


export type StartEditorMutation = { __typename?: 'Mutation', startEditor?: boolean | null };

export type StartRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type StartRemoteDevelopmentMutation = { __typename?: 'Mutation', startRemoteDevelopment: { __typename?: 'UpdatedRemoteDevelopmentResponse', editorSessionId: string, editorUrl: string } };

export type StopEditorMutationVariables = Exact<{
  editorId: Scalars['String']['input'];
}>;


export type StopEditorMutation = { __typename?: 'Mutation', stopEditor?: boolean | null };

export type StopRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type StopRemoteDevelopmentMutation = { __typename?: 'Mutation', stopRemoteDevelopment: { __typename?: 'UpdatedRemoteDevelopmentResponse', editorSessionId: string, editorUrl: string } };

export type ToggleWorkspaceMcpServerOverrideMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mcpServerId: Scalars['String']['input'];
}>;


export type ToggleWorkspaceMcpServerOverrideMutation = { __typename?: 'Mutation', toggleWorkspaceMcpServerOverride?: boolean | null };

export type ToggleWorkspaceSkillOverrideMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  skillId: Scalars['String']['input'];
}>;


export type ToggleWorkspaceSkillOverrideMutation = { __typename?: 'Mutation', toggleWorkspaceSkillOverride?: boolean | null };

export type TransferWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type TransferWorkspaceMutation = { __typename?: 'Mutation', transferWorkspace: boolean };

export type UpgradeTemplateWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type UpgradeTemplateWorkspaceMutation = { __typename?: 'Mutation', upgradeTemplateWorkspace?: boolean | null };

export type UploadAnnotationMapMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadAnnotationMapMutation = { __typename?: 'Mutation', uploadAnnotationMap: { __typename?: 'UploadAnnotationMapResponse', mapId: string, key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadAnnotationMapFinalizerMutationVariables = Exact<{
  uploadId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadAnnotationMapFinalizerMutation = { __typename?: 'Mutation', uploadAnnotationMapFinalizer: boolean };

export type UploadDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadDatasetMutation = { __typename?: 'Mutation', uploadDataset: { __typename?: 'UploadDatasetResponse', datasetId: string, key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadDatasetFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadDatasetFinalizerMutation = { __typename?: 'Mutation', uploadDatasetFinalizer?: boolean | null };

export type UploadGANModelMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadGANModelMutation = { __typename?: 'Mutation', uploadGANModel: { __typename?: 'UploadGANResponse', key: string, modelId: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadGANModelFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadGANModelFinalizerMutation = { __typename?: 'Mutation', uploadGANModelFinalizer?: boolean | null };

export type UploadMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  architectureId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  parameters?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadMLModelMutation = { __typename?: 'Mutation', uploadMLModel: { __typename?: 'UploadMLModelResponse', key: string, modelId: string, uploadId?: string | null, partSize?: number | null, urls?: Array<string | null> | null } };

export type UploadMLModelFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadMLModelFinalizerMutation = { __typename?: 'Mutation', uploadMLModelFinalizer?: boolean | null };

export type UploadVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
}>;


export type UploadVolumeDataMutation = { __typename?: 'Mutation', uploadVolumeData: { __typename?: 'UploadVolumeDataResponse', key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null, volumeId: string } };

export type UploadVolumeDataFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadVolumeDataFinalizerMutation = { __typename?: 'Mutation', uploadVolumeDataFinalizer?: boolean | null };

export type UploadVolumeDataThumbnailMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type UploadVolumeDataThumbnailMutation = { __typename?: 'Mutation', uploadVolumeDataThumbnail: { __typename?: 'UploadVolumeDataThumbnailResponse', key: string, url: string } };

export type ValidateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type ValidateGraphMutation = { __typename?: 'Mutation', validateGraph?: Array<{ __typename?: 'GraphValidationError', node?: string | null, input?: string | null, errorMessage?: string | null, type?: string | null } | null> | null };

export type GetOrganizationsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', name: string, role?: string | null, organizationId: string, expirationDate?: string | null, expired?: boolean | null, plan?: string | null, serviceOnly?: boolean | null } | null> };

export type GetOrganizationSettingsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', getOrganizationSettings?: Array<{ __typename?: 'OrganizationSetting', organizationId: string, setting: string, limit: string, usage: number, units: string } | null> | null };

export type GetOrganizationsNamesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsNamesListQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', name: string, organizationId: string } | null> };

export type GetDatasetThumbnailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetThumbnailsQuery = { __typename?: 'Query', getDatasetThumbnails: Array<string | null> };

export type ValidateContentCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidateContentCodeQuery = { __typename?: 'Query', validateContentCode?: boolean | null };

export type GetRemoteDevelopmentSessionsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRemoteDevelopmentSessionsQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopment', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, editorSessionId: string, editorUrl: string, instanceType?: string | null, organization?: string | null, organizationId?: string | null, sshPort?: number | null, startedAt?: string | null, updatedAt?: string | null, updatedBy?: string | null, users?: Array<string | null> | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null } | null> };

export type GetRemoteDevelopmentSessionsForChannelsTableQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRemoteDevelopmentSessionsForChannelsTableQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopment', channel: string, channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null } | null> };

export type GetOrganizationRulesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationRulesQuery = { __typename?: 'Query', getOrganizationRules?: string | null };

export type GetServiceRulesQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
}>;


export type GetServiceRulesQuery = { __typename?: 'Query', getServiceRules?: string | null };

export type GetUserRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRulesQuery = { __typename?: 'Query', getUserRules?: string | null };

export type GetWorkspaceRulesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceRulesQuery = { __typename?: 'Query', getWorkspaceRules?: string | null };

export type GetPlatformRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformRulesQuery = { __typename?: 'Query', getPlatformRules?: string | null };

export type GetSecretsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSecretsQuery = { __typename?: 'Query', getSecrets?: Array<{ __typename?: 'Secret', secretId?: string | null, organizationId?: string | null, name?: string | null, workspaceIds?: Array<string | null> | null, includeInAllWorkspaces?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetSkillsQueryVariables = Exact<{
  mode?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSkillsQuery = { __typename?: 'Query', getSkills: Array<{ __typename?: 'Skill', skillId: string, scopeType: string, organizationId?: string | null, workspaceId?: string | null, userId?: string | null, name: string, description?: string | null, s3Url?: string | null, version?: string | null, config?: string | null, enabled?: boolean | null, deleted?: boolean | null, createdAt?: string | null, updatedAt?: string | null, createdBy?: string | null, updatedBy?: string | null } | null> };

export type GetWorkspaceSkillOverridesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceSkillOverridesQuery = { __typename?: 'Query', getWorkspaceSkillOverrides?: Array<{ __typename?: 'WorkspaceSkillOverride', workspaceId: string, skillId: string, createdAt?: string | null, createdBy?: string | null } | null> | null };

export type GetUMAPLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
}>;


export type GetUMAPLogQuery = { __typename?: 'Query', getUMAPLog?: { __typename?: 'UMAPLog', umapId: string, workspaceId: string, state: string, log?: string | null } | null };

export type GetUMAPQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUMAPQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, results?: string | null, samples: Array<number | null>, seed: string, status: string, tags?: Array<string | null> | null, umapId: string, workspaceId: string, datasets: Array<{ __typename?: 'UMAPDataset', datasetId?: string | null, dataset?: string | null } | null> } | null> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', getCurrentUser?: { __typename?: 'User', userId: string, email: string, name: string, preference?: string | null } | null };

export type GetVolumesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<VolumeFilter>;
  sort?: InputMaybe<Sort>;
}>;


export type GetVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', name: string, size?: string | null, volumeId: string, updatedAt?: string | null, updatedBy?: string | null, createdAt?: string | null, permission: string, description: string, organization: string, organizationId: string, tags?: Array<string | null> | null } | null> | null };

export type GetVolumeDataQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  dir?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<VolumeDataFilter>;
  sort?: InputMaybe<Sort>;
}>;


export type GetVolumeDataQuery = { __typename?: 'Query', getVolumeData: Array<{ __typename?: 'VolumeData', url?: string | null, updatedAt?: string | null, thumbnailUrl?: string | null, previewUrl?: string | null, size?: number | null, key?: string | null, hash?: string | null } | null> };

export type GetVolumesNamesListQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
}>;


export type GetVolumesNamesListQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetVolumeDataSearchDetailQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  dir?: InputMaybe<Scalars['String']['input']>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<VolumeDataFilter>;
}>;


export type GetVolumeDataSearchDetailQuery = { __typename?: 'Query', getVolumeDataSearchDetail: { __typename?: 'VolumeDataSearchDetail', fileFormats?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, fileTypes?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null } };

export type GetVolumeDetailsVolumeDataQueryVariables = Exact<{
  volumeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVolumeDetailsVolumeDataQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string, permission: string } | null> | null };

export type GetAvailableVolumesForTransferQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<VolumeFilter>;
}>;


export type GetAvailableVolumesForTransferQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', name: string, size?: string | null, volumeId: string, description: string, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetAvailableVolumesForTransferSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAvailableVolumesForTransferSearchDetailQuery = { __typename?: 'Query', getVolumesSearchDetail?: { __typename?: 'VolumeSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null } | null };

export type GetWorkspacesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, organizationId: string, organization?: string | null, name: string, createdAt?: string | null, updatedAt?: string | null, previewThumbnail?: string | null, status?: string | null, description?: string | null, tags?: Array<string | null> | null, visibility?: string | null } | null> | null };

export type GetWorkspacesNameListQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesNameListQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, workspaceId: string } | null> | null };

export type GetWorkspaceSettingsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceSettingsQuery = { __typename?: 'Query', getWorkspaceSettings?: Array<{ __typename?: 'WorkspaceSetting', workspaceId: string, setting: string, limit: string, usage: number, units: string } | null> | null };

export type GetWorkspaceNameQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceNameQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, workspaceId: string } | null> | null };

export type GetWorkspaceContextDataQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceContextDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', description?: string | null, name: string, organizationId: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string, createdBy?: string | null } | null> | null };

export type GetServiceOnlyServiceDetailsQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
}>;


export type GetServiceOnlyServiceDetailsQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', createdAt?: string | null, createdBy?: string | null, name?: string | null, description?: string | null, instance?: string | null, serviceId?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: string | null, updatedBy?: string | null, serviceType?: ServiceTypeEnum | null } | null> | null };

export type GetAnnotationTypeQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  annotationId: Scalars['String']['input'];
}>;


export type GetAnnotationTypeQuery = { __typename?: 'Query', getAnnotations: Array<{ __typename?: 'Annotation', annotationId: string, format: string } | null> };

export type GetGANDatasetNameQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  ganDatasetId: Scalars['String']['input'];
}>;


export type GetGANDatasetNameQuery = { __typename?: 'Query', getGANDatasets: Array<{ __typename?: 'GANDataset', datasetId: string, name?: string | null } | null> };

export type GetDatasetJobsNameQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetJobsNameQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, name?: string | null } | null> | null };

export type GetAnalyticsNameQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsNameQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', dataset: string, type: string, analyticsId: string } | null> };

export type GetMLInferenceNameQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMLInferenceNameQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', dataset: string, model: string, inferenceId: string } | null> };

export type GetMLModelNameQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMLModelNameQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', name: string, modelId: string } | null> };

export type GetUmapNameQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUmapNameQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, umapId: string } | null> };

export type GetInpaintLogNamesQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type GetInpaintLogNamesQuery = { __typename?: 'Query', getInpaints: Array<{ __typename?: 'Inpaint', inpaintId: string, location: string } | null>, getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetOrganizationJobsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, workspaceId?: string | null, name?: string | null, runs?: number | null, status?: string | null, createdAt?: string | null, estimatedEndAt?: string | null } | null> | null };

export type GetWorkspacesSearchDetailQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesSearchDetailQuery = { __typename?: 'Query', getWorkspacesSearchDetail?: { __typename?: 'WorkspaceSearchDetail', channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetChannelsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelsSearchDetailQuery = { __typename?: 'Query', getChannelsSearchDetail?: { __typename?: 'ChannelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetVolumesSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeFilter>;
}>;


export type GetVolumesSearchDetailQuery = { __typename?: 'Query', getVolumesSearchDetail?: { __typename?: 'VolumeSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetAnnotationMapsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
}>;


export type GetAnnotationMapsSearchDetailQuery = { __typename?: 'Query', getAnnotationMapsSearchDetail: { __typename?: 'AnnotationMapSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetGANModelsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GANModelFilter>;
}>;


export type GetGANModelsSearchDetailQuery = { __typename?: 'Query', getGANModelsSearchDetail: { __typename?: 'GANModelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type ChannelTableRowSessionFragmentFragment = { __typename?: 'RemoteDevelopment', editorSessionId: string, editorUrl: string, channelId: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null };

export type ChannelTableRowChannelFragmentFragment = { __typename?: 'Channel', channelId: string, description: string, documentation?: boolean | null, name: string, organization: string, organizationId: string, updatedAt?: string | null, instanceType?: string | null, state?: string | null, tags?: Array<string | null> | null, version?: string | null };

export type ChannelTableRowDropdownSessionFragmentFragment = { __typename?: 'RemoteDevelopment', channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null };

export type ChannelTableRowDropdownChannelFragmentFragment = { __typename?: 'Channel', name: string, channelId: string, organizationId: string, description: string, instanceType?: string | null, state?: string | null, tags?: Array<string | null> | null, version?: string | null };

export type GetChannelDataForEditQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type GetChannelDataForEditQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, volumes?: Array<string | null> | null, timeout?: number | null } | null> | null };

export type GetOrganizationRemoteDevelopmentSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationRemoteDevelopmentSessionsQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopment', channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null } | null> };

export type GetOrganizationChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, description: string, documentation?: boolean | null, name: string, organization: string, organizationId: string, updatedAt?: string | null, instanceType?: string | null, state?: string | null, tags?: Array<string | null> | null, version?: string | null } | null> | null };

export type RemoteSessionOptionsFragmentFragment = { __typename?: 'RemoteDevelopment', channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null };

export type RemoteSessionStatusFragmentFragment = { __typename?: 'RemoteDevelopment', editorSessionId: string, editorUrl: string, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null };

export type GetWorkspaceTableWorkspaceChannelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceTableWorkspaceChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type GetContentCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentCodesQuery = { __typename?: 'Query', getContentCodes?: Array<{ __typename?: 'ContentCode', code: string, name: string, description: string, thumbnail?: string | null, link?: string | null, featured: boolean, contactUs: boolean, expiresAt?: string | null } | null> | null };

export type GetWorkspaceTemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceTemplatesQuery = { __typename?: 'Query', getWorkspaceTemplates?: Array<{ __typename?: 'WorkspaceTemplate', templateId?: string | null, name?: string | null, description?: string | null, thumbnail?: string | null, category?: string | null, index?: number | null } | null> | null };

export type GetWorkspaceTemplateDetailsQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type GetWorkspaceTemplateDetailsQuery = { __typename?: 'Query', getTemplateDetails?: { __typename?: 'WorkspaceTemplateDetail', templateId?: string | null, demoVideo?: string | null, documentation?: string | null, keyFeatures?: Array<string | null> | null, license?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: number | null, organization?: string | null } | null };

export type GetServiceTemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceTemplatesQuery = { __typename?: 'Query', getServiceTemplates?: Array<{ __typename?: 'ServiceTemplate', serviceId?: string | null, name?: string | null, description?: string | null, thumbnail?: string | null, category?: string | null, index?: number | null } | null> | null };

export type GetServiceTemplateDetailsQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
}>;


export type GetServiceTemplateDetailsQuery = { __typename?: 'Query', getServiceTemplateDetails?: { __typename?: 'ServiceTemplateDetail', serviceId?: string | null, demoVideo?: string | null, documentation?: string | null, keyFeatures?: Array<string | null> | null, license?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: number | null, organization?: string | null } | null };

export type GetVolumeTemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVolumeTemplatesQuery = { __typename?: 'Query', getVolumeTemplates?: Array<{ __typename?: 'VolumeTemplate', volumeId?: string | null, name?: string | null, description?: string | null, thumbnail?: string | null, category?: string | null, index?: number | null } | null> | null };

export type GetVolumeTemplateDetailsQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
}>;


export type GetVolumeTemplateDetailsQuery = { __typename?: 'Query', getVolumeTemplateDetails?: { __typename?: 'VolumeTemplateDetail', volumeId?: string | null, demoVideo?: string | null, documentation?: string | null, keyFeatures?: Array<string | null> | null, license?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: number | null, organization?: string | null } | null };

export type GetRuleTemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  ruleType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRuleTemplatesQuery = { __typename?: 'Query', getRuleTemplates?: Array<{ __typename?: 'RuleTemplate', ruleId?: string | null, name?: string | null, description?: string | null, category?: string | null, index?: number | null } | null> | null };

export type GetRuleTemplateDetailsQueryVariables = Exact<{
  ruleId: Scalars['String']['input'];
}>;


export type GetRuleTemplateDetailsQuery = { __typename?: 'Query', getRuleTemplateDetails?: { __typename?: 'RuleTemplateDetail', ruleId?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: number | null, organization?: string | null, rules?: string | null } | null };

export type GetSkillTemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSkillTemplatesQuery = { __typename?: 'Query', getSkillTemplates?: Array<{ __typename?: 'SkillTemplate', skillId?: string | null, name?: string | null, description?: string | null, thumbnail?: string | null, category?: string | null, index?: number | null } | null> | null };

export type GetSkillTemplateDetailsQueryVariables = Exact<{
  skillId: Scalars['String']['input'];
}>;


export type GetSkillTemplateDetailsQuery = { __typename?: 'Query', getSkillTemplateDetails?: { __typename?: 'SkillTemplateDetails', skillId?: string | null, demoVideo?: string | null, documentation?: string | null, keyFeatures?: Array<string | null> | null, license?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: number | null, skillVersion?: string | null, organization?: string | null } | null };

export type GetMcpTemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMcpTemplatesQuery = { __typename?: 'Query', getMcpTemplates?: Array<{ __typename?: 'McpTemplate', mcpServerId?: string | null, name?: string | null, description?: string | null, thumbnail?: string | null, category?: string | null, index?: number | null } | null> | null };

export type GetMcpTemplateDetailsQueryVariables = Exact<{
  mcpServerId: Scalars['String']['input'];
}>;


export type GetMcpTemplateDetailsQuery = { __typename?: 'Query', getMcpTemplateDetails?: { __typename?: 'McpTemplateDetails', mcpServerId?: string | null, demoVideo?: string | null, documentation?: string | null, keyFeatures?: Array<string | null> | null, license?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, version?: number | null, organization?: string | null } | null };

export type GetServicesOnlyOrganizationServersQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
}>;


export type GetServicesOnlyOrganizationServersQuery = { __typename?: 'Query', getEditors?: Array<{ __typename?: 'Editor', editorId?: string | null, instanceType?: string | null, serverPath?: string | null, sshPort?: string | null, url?: string | null, workspaceId?: string | null, workspace?: string | null, name?: string | null, status?: { __typename?: 'EditorStatus', state?: string | null, message?: string | null } | null } | null> | null };

export type GetServerQueryVariables = Exact<{
  editorId: Scalars['String']['input'];
}>;


export type GetServerQuery = { __typename?: 'Query', getEditors?: Array<{ __typename?: 'Editor', editorId?: string | null, url?: string | null, serverPath?: string | null } | null> | null };

export type GetOrganizationEditorsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<EditorsFilter>;
  sort?: InputMaybe<Sort>;
}>;


export type GetOrganizationEditorsQuery = { __typename?: 'Query', getEditors?: Array<{ __typename?: 'Editor', editorId?: string | null, name?: string | null, workspaceId?: string | null, workspace?: string | null, instanceType?: string | null, url?: string | null, sshPort?: string | null, serverPath?: string | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, startedAt?: string | null, autoStopEnabled?: boolean | null, autoStopCpuThreshold?: number | null, autoStopTimeoutMinutes?: number | null, autoDeleteEnabled?: boolean | null, autoDeleteTimeoutDays?: number | null, autoUpdateEnabled?: boolean | null, deleteAfter?: string | null, visibility?: string | null, users?: Array<string | null> | null, status?: { __typename?: 'EditorStatus', state?: string | null, message?: string | null } | null } | null> | null };

export type GetOrganizationEditorsSearchDetailQueryVariables = Exact<{
  filters?: InputMaybe<EditorsFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationEditorsSearchDetailQuery = { __typename?: 'Query', getEditorsSearchDetail?: { __typename?: 'EditorSearchDetail', status?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetServiceOnlyServiceVolumesQueryVariables = Exact<{
  serviceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceOnlyServiceVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', size?: string | null, name: string, description: string, volumeId: string, workspaceVolume?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetServiceOnlyWorkspaceDetailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetServiceOnlyWorkspaceDetailsQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, name: string, description?: string | null, objective?: string | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, users?: Array<string | null> | null, visibility?: string | null } | null> | null };

export type GetWorkspaceMembersQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceMembersQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, users?: Array<string | null> | null } | null> | null };

export type GetServiceOnlyWorkspaceServicesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceOnlyWorkspaceServicesQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', type?: string | null, name?: string | null, serviceId?: string | null, serviceType?: ServiceTypeEnum | null, description?: string | null, persistentServiceId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetServiceOnlyWorkspaceVolumesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  serviceVolumes?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetServiceOnlyWorkspaceVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', size?: string | null, name: string, description: string, volumeId: string, workspaceVolume?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetWorkspaceServersQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceServersQuery = { __typename?: 'Query', getEditors?: Array<{ __typename?: 'Editor', editorId?: string | null, name?: string | null, url?: string | null, sshPort?: string | null, serverPath?: string | null, instanceType?: string | null, createdAt?: string | null, createdBy?: string | null, storageSize?: number | null, startedAt?: string | null, autoStopEnabled?: boolean | null, autoStopCpuThreshold?: number | null, autoStopTimeoutMinutes?: number | null, autoDeleteEnabled?: boolean | null, autoDeleteTimeoutDays?: number | null, autoUpdateEnabled?: boolean | null, deleteAfter?: string | null, visibility?: string | null, users?: Array<string | null> | null, status?: { __typename?: 'EditorStatus', state?: string | null, message?: string | null } | null } | null> | null };

export type GetServiceOnlyOrganizationWorkspacesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetServiceOnlyOrganizationWorkspacesQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', createdAt?: string | null, createdBy?: string | null, name: string, organizationId: string, status?: string | null, updatedAt?: string | null, workspaceId: string, visibility?: string | null, template?: { __typename?: 'WorkspaceTemplateInfo', templateId?: string | null, version?: number | null } | null } | null> | null };

export type GetWorkspaceResourcesCountsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceResourcesCountsQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', serviceId?: string | null, name?: string | null } | null> | null, getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string, workspaceVolume?: boolean | null } | null> | null, getEditors?: Array<{ __typename?: 'Editor', editorId?: string | null, name?: string | null, url?: string | null, sshPort?: string | null, serverPath?: string | null, instanceType?: string | null, createdAt?: string | null, autoStopEnabled?: boolean | null, autoStopCpuThreshold?: number | null, autoStopTimeoutMinutes?: number | null, autoDeleteEnabled?: boolean | null, autoDeleteTimeoutDays?: number | null, autoUpdateEnabled?: boolean | null, deleteAfter?: string | null, status?: { __typename?: 'EditorStatus', state?: string | null, message?: string | null } | null } | null> | null, getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, users?: Array<string | null> | null } | null> | null };

export type GetStripeCustomerDetailsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetStripeCustomerDetailsQuery = { __typename?: 'Query', getStripeCustomerDetails?: { __typename?: 'StripeCustomerDetails', autoPayEnabled: boolean, paymentMethods: Array<{ __typename?: 'StripePaymentMethod', id: string, type: string, isDefault: boolean, card?: { __typename?: 'StripeCardDetails', brand: string, last4: string, expMonth: number, expYear: number } | null }>, invoices: { __typename?: 'StripeInvoiceGroup', open: Array<{ __typename?: 'StripeInvoice', id: string, number?: string | null, status: string, amountDue: number, amountPaid: number, currency: string, created: number, hostedInvoiceUrl?: string | null, invoicePdf?: string | null }>, paid: Array<{ __typename?: 'StripeInvoice', id: string, number?: string | null, status: string, amountDue: number, amountPaid: number, currency: string, created: number, hostedInvoiceUrl?: string | null, invoicePdf?: string | null }> } } | null };

export type GetOrganizationUsageHistoryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  records?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrganizationUsageHistoryQuery = { __typename?: 'Query', getOrganizationUsageHistory?: Array<{ __typename?: 'OrganizationUsageHistory', credit?: number | null, credits?: number | null, totalServers?: number | null, runningServers?: number | null, endDate?: string | null, startDate?: string | null, totalCost?: number | null, compute?: { __typename?: 'ComputeUsage', cost?: number | null, usage?: number | null, units?: string | null, byInstance?: Array<{ __typename?: 'InstanceTypeUsage', instanceType?: string | null, usage?: number | null, cost?: number | null, units?: string | null } | null> | null, byUser?: Array<{ __typename?: 'UserUsage', email?: string | null, usage?: number | null, cost?: number | null, units?: string | null } | null> | null } | null, storage?: { __typename?: 'StorageUsage', cost?: number | null, usage?: number | null, units?: string | null, byStorageType?: Array<{ __typename?: 'StorageTypeUsage', storageType?: string | null, usage?: number | null, cost?: number | null, units?: string | null } | null> | null, byUser?: Array<{ __typename?: 'UserUsage', email?: string | null, usage?: number | null, cost?: number | null, units?: string | null } | null> | null } | null, tokens?: { __typename?: 'TokenUsage', cost?: number | null, usage?: number | null, units?: string | null, byModel?: Array<{ __typename?: 'ModelTokenUsage', model?: string | null, promptTokens?: number | null, completionTokens?: number | null, usage?: number | null, cost?: number | null, units?: string | null } | null> | null, byUser?: Array<{ __typename?: 'UserTokenUsage', email?: string | null, promptTokens?: number | null, completionTokens?: number | null, usage?: number | null, cost?: number | null, units?: string | null } | null> | null } | null } | null> | null };

export type GetOrganizationInvitationsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationInvitationsQuery = { __typename?: 'Query', getInvitations?: Array<{ __typename?: 'Invitation', createdAt?: string | null, email?: string | null, organizationId?: string | null, role?: RoleType | null } | null> | null };

export type GetAPIKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAPIKeysQuery = { __typename?: 'Query', getAPIKeys: Array<{ __typename?: 'APIKey', createdAt?: string | null, expiresAt?: string | null, name: string, organizationId?: string | null, scope: string, workspaceId?: string | null } | null> };

export type GetSSHKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSSHKeysQuery = { __typename?: 'Query', getSSHKeys: Array<{ __typename?: 'SSHKey', name?: string | null, key?: string | null, createdAt?: string | null } | null> };

export type GetOrganizationServicesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ServicesFilter>;
  sort?: InputMaybe<Sort>;
}>;


export type GetOrganizationServicesQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', createdAt?: string | null, createdBy?: string | null, name?: string | null, serviceId?: string | null, serviceType?: ServiceTypeEnum | null, instance?: string | null, updatedAt?: string | null, tags?: Array<string | null> | null, description?: string | null } | null> | null };

export type GetOrganizationServicesSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ServicesFilter>;
}>;


export type GetOrganizationServicesSearchDetailQuery = { __typename?: 'Query', getServicesSearchDetail?: { __typename?: 'ServiceSearchDetail', serviceTypes?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null } | null };

export type GetDatasetRunsCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetRunsCountQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, runs?: number | null } | null> | null };

export type GetWorkspaceAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
}>;


export type GetWorkspaceAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, createdAt?: string | null, createdBy?: string | null, dataset: string, datasetId: string, result?: string | null, status: string, tags?: Array<string | null> | null, type: string, workspaceId: string } | null> };

export type GetAnalyticsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<AnalyticsFilter>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnalyticsSearchDetailQuery = { __typename?: 'Query', getAnalyticsSearchDetail: { __typename?: 'AnalyticsSearchDetail', status?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceUMAPsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<UMAPFilter>;
}>;


export type GetWorkspaceUMAPsQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', createdAt?: string | null, createdBy?: string | null, name: string, results?: string | null, samples: Array<number | null>, seed: string, status: string, tags?: Array<string | null> | null, umapId: string, workspaceId: string, datasets: Array<{ __typename?: 'UMAPDataset', dataset?: string | null, datasetId?: string | null } | null> } | null> };

export type GetUMAPsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UMAPFilter>;
}>;


export type GetUMAPsSearchDetailQuery = { __typename?: 'Query', getUMAPsSearchDetail: { __typename?: 'UMAPSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceMLModelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MLModelFilter>;
}>;


export type GetWorkspaceMLModelsQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', architecture: string, architectureId: string, checkpoints?: Array<string | null> | null, classes?: Array<string | null> | null, createdBy?: string | null, createdAt?: string | null, dataset: string, datasetId: string, description?: string | null, map?: string | null, mapId?: string | null, metrics?: string | null, modelId: string, name: string, parameters?: string | null, status?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMLModelsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLModelFilter>;
}>;


export type GetMLModelsSearchDetailQuery = { __typename?: 'Query', getMLModelsSearchDetail: { __typename?: 'MLModelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, architectures?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceMLInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
}>;


export type GetWorkspaceMLInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', datasetId: string, dataset: string, map?: string | null, mapId?: string | null, metrics?: string | null, model: string, modelId: string, status?: string | null, inferenceId: string, workspaceId: string, createdBy?: string | null, createdAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMLInferencesSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
}>;


export type GetMLInferencesSearchDetailQuery = { __typename?: 'Query', getMLInferencesSearchDetail: { __typename?: 'MLInferenceSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, architectures?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetMLModelInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMLModelInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', datasetId: string, dataset: string, model: string, modelId: string, status?: string | null, inferenceId: string, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetFilesCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetFilesCountQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, files?: number | null } | null> | null };

export type GetAddGraphAvailableChannelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetAddGraphAvailableChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type GraphUpdatedSubscriptionVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
}>;


export type GraphUpdatedSubscription = { __typename?: 'Subscription', graphUpdates?: { __typename?: 'GraphUpdateReponse', name?: string | null, description?: string | null, graphId: string, graph?: string | null } | null };

export type GetGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetGraphMetadataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraphMetadataQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, description?: string | null, graphId: string, name: string, previewId?: string | null, readOnly?: boolean | null, showPreview?: boolean | null, tags?: Array<string | null> | null, workspaceId: string, updatedAt?: string | null } | null> | null };

export type GetPreviewQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type GetPreviewQuery = { __typename?: 'Query', getPreview?: { __typename?: 'Preview', status?: string | null, previewId: string, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null };

export type GetGraphLastUpdatedQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraphLastUpdatedQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', graphId: string, updatedAt?: string | null } | null> | null };

export type GetChannelSchemaQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelSchemaQuery = { __typename?: 'Query', getChannelSchema: string };

export type GetPreviewLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type GetPreviewLogQuery = { __typename?: 'Query', getPreviewLog?: { __typename?: 'PreviewLog', log?: string | null, previewId: string, status?: string | null } | null };

export type GetGraphsWithFiltersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<GraphFilter>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGraphsWithFiltersQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetGraphsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<GraphFilter>;
}>;


export type GetGraphsSearchDetailQuery = { __typename?: 'Query', getGraphsSearchDetail?: { __typename?: 'GraphSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetJobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
}>;


export type GetJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', name?: string | null, datasetId?: string | null, status?: string | null, priority?: number | null, graphId?: string | null, channelId?: string | null, workspaceId?: string | null, averageRuntime?: string | null, instancesQueued?: number | null, instancesRunning?: number | null, instancesStarting?: number | null, runsSuccess?: number | null, runsTimeout?: number | null, seed?: number | null, runsRunning?: number | null, runsFailed?: number | null, runsCancelled?: number | null, runs?: number | null, runsStarting?: number | null, runsQueued?: number | null, updatedAt?: string | null, estimatedEndAt?: string | null, createdBy?: string | null, createdAt?: string | null, channel?: string | null } | null> | null };

export type GetStagedGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GraphFilter>;
}>;


export type GetStagedGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, workspaceId: string, updatedAt?: string | null } | null> | null };

export type GetDatasetJobsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
}>;


export type GetDatasetJobsSearchDetailQuery = { __typename?: 'Query', getDatasetJobsSearchDetail?: { __typename?: 'DatasetJobSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, type?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetGraphThumbnailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetGraphThumbnailsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', graphId: string, thumbnail?: string | null } | null> | null };

export type GetWorkspaceThumbnailQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceThumbnailQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, previewThumbnail?: string | null } | null> | null };

export type GetRecentJobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetRecentJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', createdAt?: string | null, datasetId?: string | null, estimatedEndAt?: string | null, name?: string | null, status?: string | null } | null> | null };

export type GetRecentGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRecentGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetRecentDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetRecentDatasetsQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', createdAt?: string | null, datasetId?: string | null, name: string, runs?: number | null } | null> | null };

export type GetWorkspaceResourcesAvailableChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesAvailableChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type GetWorkspaceResourcesWorkspaceChannelsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesWorkspaceChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type GetWorkspaceResourcesAvailableVolumesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesAvailableVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetWorkspaceResourcesWorkspaceVolumesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesWorkspaceVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetAnalyticForDownloadQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticForDownloadQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, dataset: string, result?: string | null } | null> };

export type GetDatasetImageFilenamesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDatasetImageFilenamesQuery = { __typename?: 'Query', getDatasetFiles?: Array<string | null> | null };

export type GetImageInferenceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetImageInferenceQuery = { __typename?: 'Query', getImageInference: { __typename?: 'ImageInference', image?: string | null, inferences?: Array<{ __typename?: 'Inference', bbox?: Array<number | null> | null, class?: number | null, className?: string | null, confidence?: string | null } | null> | null } };

export type GetImageAnnotationQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetImageAnnotationQuery = { __typename?: 'Query', getImageAnnotation?: { __typename?: 'RunData', data?: Array<string | null> | null, datasetId?: string | null, filename?: string | null } | null };

export type GetDatasetsForMixQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDatasetsForMixQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', classes?: Array<string | null> | null, datasetId?: string | null, files?: number | null, name: string } | null> | null };

export type GetDatasetDetailsAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, datasetId: string, status: string, tags?: Array<string | null> | null, type: string, workspaceId: string } | null> };

export type GetAnnotationsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnnotationsQuery = { __typename?: 'Query', getAnnotations: Array<{ __typename?: 'Annotation', annotationId: string, datasetId: string, format: string, map?: string | null, status?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, workspaceId: string } | null> };

export type GetDatasetDetailsGANDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsGANDatasetsQuery = { __typename?: 'Query', getGANDatasets: Array<{ __typename?: 'GANDataset', datasetId: string, description?: string | null, model: string, name?: string | null, parentId: string, status: string, tags?: Array<string | null> | null, updatedAt: string, workspaceId: string } | null> };

export type GetDatasetDetailsUMAPsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsUMAPsQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, status: string, tags?: Array<string | null> | null, umapId: string } | null> };

export type GetDatasetInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', inferenceId: string, dataset: string, datasetId: string, modelId: string, model: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetModelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetModelsQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', modelId: string, name: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetsWithFilterQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetDatasetsWithFilterQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', channel?: string | null, channelId?: string | null, classes?: Array<string | null> | null, createdAt?: string | null, createdBy?: string | null, datasetId?: string | null, description?: string | null, files?: number | null, graphId?: string | null, name: string, runs?: number | null, seed?: string | null, size?: number | null, source?: string | null, status?: string | null, tags?: Array<string | null> | null, type?: string | null } | null> | null };

export type GetDatasetsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetDatasetsSearchDetailQuery = { __typename?: 'Query', getDatasetsSearchDetail?: { __typename?: 'DatasetSearchDetail', channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, type?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetAvailableChannelsForNewWorkspaceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetAvailableChannelsForNewWorkspaceQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export const RemoteSessionOptionsFragmentFragmentDoc = gql`
    fragment RemoteSessionOptionsFragment on RemoteDevelopment {
  channelId
  editorSessionId
  editorUrl
  sshPort
  status {
    state
  }
}
    `;
export const ChannelTableRowDropdownSessionFragmentFragmentDoc = gql`
    fragment ChannelTableRowDropdownSessionFragment on RemoteDevelopment {
  ...RemoteSessionOptionsFragment
}
    ${RemoteSessionOptionsFragmentFragmentDoc}`;
export const RemoteSessionStatusFragmentFragmentDoc = gql`
    fragment RemoteSessionStatusFragment on RemoteDevelopment {
  editorSessionId
  editorUrl
  status {
    state
    message
  }
}
    `;
export const ChannelTableRowSessionFragmentFragmentDoc = gql`
    fragment ChannelTableRowSessionFragment on RemoteDevelopment {
  ...ChannelTableRowDropdownSessionFragment
  ...RemoteSessionStatusFragment
}
    ${ChannelTableRowDropdownSessionFragmentFragmentDoc}
${RemoteSessionStatusFragmentFragmentDoc}`;
export const ChannelTableRowDropdownChannelFragmentFragmentDoc = gql`
    fragment ChannelTableRowDropdownChannelFragment on Channel {
  name
  channelId
  organizationId
  description
  instanceType
  state
  tags
  version
}
    `;
export const ChannelTableRowChannelFragmentFragmentDoc = gql`
    fragment ChannelTableRowChannelFragment on Channel {
  channelId
  description
  documentation
  name
  organization
  organizationId
  updatedAt
  ...ChannelTableRowDropdownChannelFragment
}
    ${ChannelTableRowDropdownChannelFragmentFragmentDoc}`;
export const CreateRemoteSessionGetOrgChannelsDocument = gql`
    query CreateRemoteSessionGetOrgChannels($organizationId: String) {
  getChannels(organizationId: $organizationId) {
    channelId
    instanceType
    name
    organizationId
    state
    version
  }
}
    `;

/**
 * __useCreateRemoteSessionGetOrgChannelsQuery__
 *
 * To run a query within a React component, call `useCreateRemoteSessionGetOrgChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateRemoteSessionGetOrgChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateRemoteSessionGetOrgChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateRemoteSessionGetOrgChannelsQuery(baseOptions?: Apollo.QueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>(CreateRemoteSessionGetOrgChannelsDocument, options);
      }
export function useCreateRemoteSessionGetOrgChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>(CreateRemoteSessionGetOrgChannelsDocument, options);
        }
// @ts-ignore
export function useCreateRemoteSessionGetOrgChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>;
export function useCreateRemoteSessionGetOrgChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<CreateRemoteSessionGetOrgChannelsQuery | undefined, CreateRemoteSessionGetOrgChannelsQueryVariables>;
export function useCreateRemoteSessionGetOrgChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>(CreateRemoteSessionGetOrgChannelsDocument, options);
        }
export type CreateRemoteSessionGetOrgChannelsQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetOrgChannelsQuery>;
export type CreateRemoteSessionGetOrgChannelsLazyQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetOrgChannelsLazyQuery>;
export type CreateRemoteSessionGetOrgChannelsSuspenseQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetOrgChannelsSuspenseQuery>;
export type CreateRemoteSessionGetOrgChannelsQueryResult = Apollo.QueryResult<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>;
export const GetServerMembersDataDocument = gql`
    query GetServerMembersData($editorId: String) {
  getEditors(editorId: $editorId) {
    editorId
    workspaceId
    createdBy
    users
    visibility
  }
}
    `;

/**
 * __useGetServerMembersDataQuery__
 *
 * To run a query within a React component, call `useGetServerMembersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerMembersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerMembersDataQuery({
 *   variables: {
 *      editorId: // value for 'editorId'
 *   },
 * });
 */
export function useGetServerMembersDataQuery(baseOptions?: Apollo.QueryHookOptions<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>(GetServerMembersDataDocument, options);
      }
export function useGetServerMembersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>(GetServerMembersDataDocument, options);
        }
// @ts-ignore
export function useGetServerMembersDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>;
export function useGetServerMembersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetServerMembersDataQuery | undefined, GetServerMembersDataQueryVariables>;
export function useGetServerMembersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>(GetServerMembersDataDocument, options);
        }
export type GetServerMembersDataQueryHookResult = ReturnType<typeof useGetServerMembersDataQuery>;
export type GetServerMembersDataLazyQueryHookResult = ReturnType<typeof useGetServerMembersDataLazyQuery>;
export type GetServerMembersDataSuspenseQueryHookResult = ReturnType<typeof useGetServerMembersDataSuspenseQuery>;
export type GetServerMembersDataQueryResult = Apollo.QueryResult<GetServerMembersDataQuery, GetServerMembersDataQueryVariables>;
export const GetAvailableServicesForTransferDocument = gql`
    query GetAvailableServicesForTransfer($organizationId: String, $cursor: String, $limit: Int, $filters: ServicesFilter) {
  getServices(
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    serviceId
    serviceType
    persistentServiceId
    description
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAvailableServicesForTransferQuery__
 *
 * To run a query within a React component, call `useGetAvailableServicesForTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableServicesForTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableServicesForTransferQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAvailableServicesForTransferQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>(GetAvailableServicesForTransferDocument, options);
      }
export function useGetAvailableServicesForTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>(GetAvailableServicesForTransferDocument, options);
        }
// @ts-ignore
export function useGetAvailableServicesForTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>;
export function useGetAvailableServicesForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableServicesForTransferQuery | undefined, GetAvailableServicesForTransferQueryVariables>;
export function useGetAvailableServicesForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>(GetAvailableServicesForTransferDocument, options);
        }
export type GetAvailableServicesForTransferQueryHookResult = ReturnType<typeof useGetAvailableServicesForTransferQuery>;
export type GetAvailableServicesForTransferLazyQueryHookResult = ReturnType<typeof useGetAvailableServicesForTransferLazyQuery>;
export type GetAvailableServicesForTransferSuspenseQueryHookResult = ReturnType<typeof useGetAvailableServicesForTransferSuspenseQuery>;
export type GetAvailableServicesForTransferQueryResult = Apollo.QueryResult<GetAvailableServicesForTransferQuery, GetAvailableServicesForTransferQueryVariables>;
export const GetAvailableServicesForTransferSearchDetailDocument = gql`
    query GetAvailableServicesForTransferSearchDetail($organizationId: String) {
  getServicesSearchDetail(organizationId: $organizationId) {
    serviceTypes {
      display
      value
    }
  }
}
    `;

/**
 * __useGetAvailableServicesForTransferSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAvailableServicesForTransferSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableServicesForTransferSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableServicesForTransferSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAvailableServicesForTransferSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>(GetAvailableServicesForTransferSearchDetailDocument, options);
      }
export function useGetAvailableServicesForTransferSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>(GetAvailableServicesForTransferSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetAvailableServicesForTransferSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>;
export function useGetAvailableServicesForTransferSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableServicesForTransferSearchDetailQuery | undefined, GetAvailableServicesForTransferSearchDetailQueryVariables>;
export function useGetAvailableServicesForTransferSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>(GetAvailableServicesForTransferSearchDetailDocument, options);
        }
export type GetAvailableServicesForTransferSearchDetailQueryHookResult = ReturnType<typeof useGetAvailableServicesForTransferSearchDetailQuery>;
export type GetAvailableServicesForTransferSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAvailableServicesForTransferSearchDetailLazyQuery>;
export type GetAvailableServicesForTransferSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetAvailableServicesForTransferSearchDetailSuspenseQuery>;
export type GetAvailableServicesForTransferSearchDetailQueryResult = Apollo.QueryResult<GetAvailableServicesForTransferSearchDetailQuery, GetAvailableServicesForTransferSearchDetailQueryVariables>;
export const GetInstanceTypesSearchDetailDocument = gql`
    query GetInstanceTypesSearchDetail {
  getInstanceTypesSearchDetail {
    workloadTypes {
      value
      display
    }
    gpuTypes {
      value
      display
    }
    cpuCount {
      value
      display
    }
    ramGB {
      value
      display
    }
    vramGB {
      value
      display
    }
  }
}
    `;

/**
 * __useGetInstanceTypesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetInstanceTypesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstanceTypesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstanceTypesSearchDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstanceTypesSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>(GetInstanceTypesSearchDetailDocument, options);
      }
export function useGetInstanceTypesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>(GetInstanceTypesSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetInstanceTypesSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>;
export function useGetInstanceTypesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetInstanceTypesSearchDetailQuery | undefined, GetInstanceTypesSearchDetailQueryVariables>;
export function useGetInstanceTypesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>(GetInstanceTypesSearchDetailDocument, options);
        }
export type GetInstanceTypesSearchDetailQueryHookResult = ReturnType<typeof useGetInstanceTypesSearchDetailQuery>;
export type GetInstanceTypesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetInstanceTypesSearchDetailLazyQuery>;
export type GetInstanceTypesSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetInstanceTypesSearchDetailSuspenseQuery>;
export type GetInstanceTypesSearchDetailQueryResult = Apollo.QueryResult<GetInstanceTypesSearchDetailQuery, GetInstanceTypesSearchDetailQueryVariables>;
export const GetAvailableInstanceTypesWithDetailsDocument = gql`
    query GetAvailableInstanceTypesWithDetails($filters: InstanceTypesFilter) {
  getInstanceTypesWithDetails(filters: $filters) {
    instanceType
    workloadType
    cpuCount
    cpuClockSpeed
    gpuType
    ramGB
    vramGB
    gpuAvailable
    preferred
    hourlyPrice
  }
}
    `;

/**
 * __useGetAvailableInstanceTypesWithDetailsQuery__
 *
 * To run a query within a React component, call `useGetAvailableInstanceTypesWithDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableInstanceTypesWithDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableInstanceTypesWithDetailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAvailableInstanceTypesWithDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>(GetAvailableInstanceTypesWithDetailsDocument, options);
      }
export function useGetAvailableInstanceTypesWithDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>(GetAvailableInstanceTypesWithDetailsDocument, options);
        }
// @ts-ignore
export function useGetAvailableInstanceTypesWithDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>;
export function useGetAvailableInstanceTypesWithDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableInstanceTypesWithDetailsQuery | undefined, GetAvailableInstanceTypesWithDetailsQueryVariables>;
export function useGetAvailableInstanceTypesWithDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>(GetAvailableInstanceTypesWithDetailsDocument, options);
        }
export type GetAvailableInstanceTypesWithDetailsQueryHookResult = ReturnType<typeof useGetAvailableInstanceTypesWithDetailsQuery>;
export type GetAvailableInstanceTypesWithDetailsLazyQueryHookResult = ReturnType<typeof useGetAvailableInstanceTypesWithDetailsLazyQuery>;
export type GetAvailableInstanceTypesWithDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableInstanceTypesWithDetailsSuspenseQuery>;
export type GetAvailableInstanceTypesWithDetailsQueryResult = Apollo.QueryResult<GetAvailableInstanceTypesWithDetailsQuery, GetAvailableInstanceTypesWithDetailsQueryVariables>;
export const GetEditVolumeDetailsDocument = gql`
    query GetEditVolumeDetails($volumeId: String!) {
  getVolumes(volumeId: $volumeId) {
    volumeId
    name
    description
    permission
    tags
  }
}
    `;

/**
 * __useGetEditVolumeDetailsQuery__
 *
 * To run a query within a React component, call `useGetEditVolumeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditVolumeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditVolumeDetailsQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useGetEditVolumeDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables> & ({ variables: GetEditVolumeDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>(GetEditVolumeDetailsDocument, options);
      }
export function useGetEditVolumeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>(GetEditVolumeDetailsDocument, options);
        }
// @ts-ignore
export function useGetEditVolumeDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>;
export function useGetEditVolumeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEditVolumeDetailsQuery | undefined, GetEditVolumeDetailsQueryVariables>;
export function useGetEditVolumeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>(GetEditVolumeDetailsDocument, options);
        }
export type GetEditVolumeDetailsQueryHookResult = ReturnType<typeof useGetEditVolumeDetailsQuery>;
export type GetEditVolumeDetailsLazyQueryHookResult = ReturnType<typeof useGetEditVolumeDetailsLazyQuery>;
export type GetEditVolumeDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEditVolumeDetailsSuspenseQuery>;
export type GetEditVolumeDetailsQueryResult = Apollo.QueryResult<GetEditVolumeDetailsQuery, GetEditVolumeDetailsQueryVariables>;
export const GetDeleteWorkspaceModalDataDocument = gql`
    query GetDeleteWorkspaceModalData($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    name
    createdBy
    users
  }
}
    `;

/**
 * __useGetDeleteWorkspaceModalDataQuery__
 *
 * To run a query within a React component, call `useGetDeleteWorkspaceModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeleteWorkspaceModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeleteWorkspaceModalDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDeleteWorkspaceModalDataQuery(baseOptions: Apollo.QueryHookOptions<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables> & ({ variables: GetDeleteWorkspaceModalDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>(GetDeleteWorkspaceModalDataDocument, options);
      }
export function useGetDeleteWorkspaceModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>(GetDeleteWorkspaceModalDataDocument, options);
        }
// @ts-ignore
export function useGetDeleteWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>;
export function useGetDeleteWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeleteWorkspaceModalDataQuery | undefined, GetDeleteWorkspaceModalDataQueryVariables>;
export function useGetDeleteWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>(GetDeleteWorkspaceModalDataDocument, options);
        }
export type GetDeleteWorkspaceModalDataQueryHookResult = ReturnType<typeof useGetDeleteWorkspaceModalDataQuery>;
export type GetDeleteWorkspaceModalDataLazyQueryHookResult = ReturnType<typeof useGetDeleteWorkspaceModalDataLazyQuery>;
export type GetDeleteWorkspaceModalDataSuspenseQueryHookResult = ReturnType<typeof useGetDeleteWorkspaceModalDataSuspenseQuery>;
export type GetDeleteWorkspaceModalDataQueryResult = Apollo.QueryResult<GetDeleteWorkspaceModalDataQuery, GetDeleteWorkspaceModalDataQueryVariables>;
export const GetDuplicateWorkspaceModalDataDocument = gql`
    query GetDuplicateWorkspaceModalData($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    description
    name
    objective
    tags
  }
  getVolumes(workspaceId: $workspaceId) {
    volumeId
    name
    workspaceVolume
  }
  getServices(workspaceId: $workspaceId) {
    serviceId
    name
  }
}
    `;

/**
 * __useGetDuplicateWorkspaceModalDataQuery__
 *
 * To run a query within a React component, call `useGetDuplicateWorkspaceModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateWorkspaceModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateWorkspaceModalDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDuplicateWorkspaceModalDataQuery(baseOptions: Apollo.QueryHookOptions<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables> & ({ variables: GetDuplicateWorkspaceModalDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>(GetDuplicateWorkspaceModalDataDocument, options);
      }
export function useGetDuplicateWorkspaceModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>(GetDuplicateWorkspaceModalDataDocument, options);
        }
// @ts-ignore
export function useGetDuplicateWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>;
export function useGetDuplicateWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDuplicateWorkspaceModalDataQuery | undefined, GetDuplicateWorkspaceModalDataQueryVariables>;
export function useGetDuplicateWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>(GetDuplicateWorkspaceModalDataDocument, options);
        }
export type GetDuplicateWorkspaceModalDataQueryHookResult = ReturnType<typeof useGetDuplicateWorkspaceModalDataQuery>;
export type GetDuplicateWorkspaceModalDataLazyQueryHookResult = ReturnType<typeof useGetDuplicateWorkspaceModalDataLazyQuery>;
export type GetDuplicateWorkspaceModalDataSuspenseQueryHookResult = ReturnType<typeof useGetDuplicateWorkspaceModalDataSuspenseQuery>;
export type GetDuplicateWorkspaceModalDataQueryResult = Apollo.QueryResult<GetDuplicateWorkspaceModalDataQuery, GetDuplicateWorkspaceModalDataQueryVariables>;
export const GetEditWorkspaceDetailsDocument = gql`
    query GetEditWorkspaceDetails($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    name
    description
    objective
    tags
    visibility
  }
}
    `;

/**
 * __useGetEditWorkspaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetEditWorkspaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditWorkspaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditWorkspaceDetailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEditWorkspaceDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables> & ({ variables: GetEditWorkspaceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>(GetEditWorkspaceDetailsDocument, options);
      }
export function useGetEditWorkspaceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>(GetEditWorkspaceDetailsDocument, options);
        }
// @ts-ignore
export function useGetEditWorkspaceDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>;
export function useGetEditWorkspaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEditWorkspaceDetailsQuery | undefined, GetEditWorkspaceDetailsQueryVariables>;
export function useGetEditWorkspaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>(GetEditWorkspaceDetailsDocument, options);
        }
export type GetEditWorkspaceDetailsQueryHookResult = ReturnType<typeof useGetEditWorkspaceDetailsQuery>;
export type GetEditWorkspaceDetailsLazyQueryHookResult = ReturnType<typeof useGetEditWorkspaceDetailsLazyQuery>;
export type GetEditWorkspaceDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEditWorkspaceDetailsSuspenseQuery>;
export type GetEditWorkspaceDetailsQueryResult = Apollo.QueryResult<GetEditWorkspaceDetailsQuery, GetEditWorkspaceDetailsQueryVariables>;
export const GetManageWorkspaceMembersDataDocument = gql`
    query GetManageWorkspaceMembersData($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    createdBy
    users
    visibility
  }
}
    `;

/**
 * __useGetManageWorkspaceMembersDataQuery__
 *
 * To run a query within a React component, call `useGetManageWorkspaceMembersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageWorkspaceMembersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageWorkspaceMembersDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetManageWorkspaceMembersDataQuery(baseOptions: Apollo.QueryHookOptions<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables> & ({ variables: GetManageWorkspaceMembersDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>(GetManageWorkspaceMembersDataDocument, options);
      }
export function useGetManageWorkspaceMembersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>(GetManageWorkspaceMembersDataDocument, options);
        }
// @ts-ignore
export function useGetManageWorkspaceMembersDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>;
export function useGetManageWorkspaceMembersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetManageWorkspaceMembersDataQuery | undefined, GetManageWorkspaceMembersDataQueryVariables>;
export function useGetManageWorkspaceMembersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>(GetManageWorkspaceMembersDataDocument, options);
        }
export type GetManageWorkspaceMembersDataQueryHookResult = ReturnType<typeof useGetManageWorkspaceMembersDataQuery>;
export type GetManageWorkspaceMembersDataLazyQueryHookResult = ReturnType<typeof useGetManageWorkspaceMembersDataLazyQuery>;
export type GetManageWorkspaceMembersDataSuspenseQueryHookResult = ReturnType<typeof useGetManageWorkspaceMembersDataSuspenseQuery>;
export type GetManageWorkspaceMembersDataQueryResult = Apollo.QueryResult<GetManageWorkspaceMembersDataQuery, GetManageWorkspaceMembersDataQueryVariables>;
export const GetTransferWorkspaceModalDataDocument = gql`
    query GetTransferWorkspaceModalData($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    name
    users
  }
}
    `;

/**
 * __useGetTransferWorkspaceModalDataQuery__
 *
 * To run a query within a React component, call `useGetTransferWorkspaceModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferWorkspaceModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferWorkspaceModalDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetTransferWorkspaceModalDataQuery(baseOptions: Apollo.QueryHookOptions<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables> & ({ variables: GetTransferWorkspaceModalDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>(GetTransferWorkspaceModalDataDocument, options);
      }
export function useGetTransferWorkspaceModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>(GetTransferWorkspaceModalDataDocument, options);
        }
// @ts-ignore
export function useGetTransferWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>;
export function useGetTransferWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferWorkspaceModalDataQuery | undefined, GetTransferWorkspaceModalDataQueryVariables>;
export function useGetTransferWorkspaceModalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>(GetTransferWorkspaceModalDataDocument, options);
        }
export type GetTransferWorkspaceModalDataQueryHookResult = ReturnType<typeof useGetTransferWorkspaceModalDataQuery>;
export type GetTransferWorkspaceModalDataLazyQueryHookResult = ReturnType<typeof useGetTransferWorkspaceModalDataLazyQuery>;
export type GetTransferWorkspaceModalDataSuspenseQueryHookResult = ReturnType<typeof useGetTransferWorkspaceModalDataSuspenseQuery>;
export type GetTransferWorkspaceModalDataQueryResult = Apollo.QueryResult<GetTransferWorkspaceModalDataQuery, GetTransferWorkspaceModalDataQueryVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates {
  getTemplates {
    description
    index
    name
    organization
    tags
    thumbnail
    templateId
    version
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
// @ts-ignore
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplatesQuery | undefined, GetTemplatesQueryVariables>;
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetTemplatesSuspenseQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetWorkspaceTemplateVersionDocument = gql`
    query GetWorkspaceTemplateVersion($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    template {
      templateId
      version
    }
  }
}
    `;

/**
 * __useGetWorkspaceTemplateVersionQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTemplateVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTemplateVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTemplateVersionQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceTemplateVersionQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables> & ({ variables: GetWorkspaceTemplateVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>(GetWorkspaceTemplateVersionDocument, options);
      }
export function useGetWorkspaceTemplateVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>(GetWorkspaceTemplateVersionDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceTemplateVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>;
export function useGetWorkspaceTemplateVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTemplateVersionQuery | undefined, GetWorkspaceTemplateVersionQueryVariables>;
export function useGetWorkspaceTemplateVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>(GetWorkspaceTemplateVersionDocument, options);
        }
export type GetWorkspaceTemplateVersionQueryHookResult = ReturnType<typeof useGetWorkspaceTemplateVersionQuery>;
export type GetWorkspaceTemplateVersionLazyQueryHookResult = ReturnType<typeof useGetWorkspaceTemplateVersionLazyQuery>;
export type GetWorkspaceTemplateVersionSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceTemplateVersionSuspenseQuery>;
export type GetWorkspaceTemplateVersionQueryResult = Apollo.QueryResult<GetWorkspaceTemplateVersionQuery, GetWorkspaceTemplateVersionQueryVariables>;
export const GetOrganizationServicesNameListDocument = gql`
    query GetOrganizationServicesNameList($organizationId: String!, $sort: Sort) {
  getServices(organizationId: $organizationId, sort: $sort) {
    name
    serviceId
    serviceType
    persistentServiceId
  }
}
    `;

/**
 * __useGetOrganizationServicesNameListQuery__
 *
 * To run a query within a React component, call `useGetOrganizationServicesNameListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationServicesNameListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationServicesNameListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationServicesNameListQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables> & ({ variables: GetOrganizationServicesNameListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>(GetOrganizationServicesNameListDocument, options);
      }
export function useGetOrganizationServicesNameListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>(GetOrganizationServicesNameListDocument, options);
        }
// @ts-ignore
export function useGetOrganizationServicesNameListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>;
export function useGetOrganizationServicesNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationServicesNameListQuery | undefined, GetOrganizationServicesNameListQueryVariables>;
export function useGetOrganizationServicesNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>(GetOrganizationServicesNameListDocument, options);
        }
export type GetOrganizationServicesNameListQueryHookResult = ReturnType<typeof useGetOrganizationServicesNameListQuery>;
export type GetOrganizationServicesNameListLazyQueryHookResult = ReturnType<typeof useGetOrganizationServicesNameListLazyQuery>;
export type GetOrganizationServicesNameListSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationServicesNameListSuspenseQuery>;
export type GetOrganizationServicesNameListQueryResult = Apollo.QueryResult<GetOrganizationServicesNameListQuery, GetOrganizationServicesNameListQueryVariables>;
export const GetOrganizationVolumesNameListDocument = gql`
    query GetOrganizationVolumesNameList($organizationId: String!) {
  getVolumes(organizationId: $organizationId) {
    name
    volumeId
  }
}
    `;

/**
 * __useGetOrganizationVolumesNameListQuery__
 *
 * To run a query within a React component, call `useGetOrganizationVolumesNameListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationVolumesNameListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationVolumesNameListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationVolumesNameListQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables> & ({ variables: GetOrganizationVolumesNameListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>(GetOrganizationVolumesNameListDocument, options);
      }
export function useGetOrganizationVolumesNameListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>(GetOrganizationVolumesNameListDocument, options);
        }
// @ts-ignore
export function useGetOrganizationVolumesNameListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>;
export function useGetOrganizationVolumesNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationVolumesNameListQuery | undefined, GetOrganizationVolumesNameListQueryVariables>;
export function useGetOrganizationVolumesNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>(GetOrganizationVolumesNameListDocument, options);
        }
export type GetOrganizationVolumesNameListQueryHookResult = ReturnType<typeof useGetOrganizationVolumesNameListQuery>;
export type GetOrganizationVolumesNameListLazyQueryHookResult = ReturnType<typeof useGetOrganizationVolumesNameListLazyQuery>;
export type GetOrganizationVolumesNameListSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationVolumesNameListSuspenseQuery>;
export type GetOrganizationVolumesNameListQueryResult = Apollo.QueryResult<GetOrganizationVolumesNameListQuery, GetOrganizationVolumesNameListQueryVariables>;
export const GetAnalyticsDocument = gql`
    query GetAnalytics($workspaceId: String!, $analyticsId: String!) {
  getAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    result
  }
}
    `;

/**
 * __useGetAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables> & ({ variables: GetAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
      }
export function useGetAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsQuery, GetAnalyticsQueryVariables>;
export function useGetAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsQuery | undefined, GetAnalyticsQueryVariables>;
export function useGetAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
        }
export type GetAnalyticsQueryHookResult = ReturnType<typeof useGetAnalyticsQuery>;
export type GetAnalyticsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLazyQuery>;
export type GetAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsSuspenseQuery>;
export type GetAnalyticsQueryResult = Apollo.QueryResult<GetAnalyticsQuery, GetAnalyticsQueryVariables>;
export const GetAnalyticsTypesDocument = gql`
    query GetAnalyticsTypes {
  getAnalyticsTypes
}
    `;

/**
 * __useGetAnalyticsTypesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalyticsTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
      }
export function useGetAnalyticsTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>;
export function useGetAnalyticsTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsTypesQuery | undefined, GetAnalyticsTypesQueryVariables>;
export function useGetAnalyticsTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
        }
export type GetAnalyticsTypesQueryHookResult = ReturnType<typeof useGetAnalyticsTypesQuery>;
export type GetAnalyticsTypesLazyQueryHookResult = ReturnType<typeof useGetAnalyticsTypesLazyQuery>;
export type GetAnalyticsTypesSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsTypesSuspenseQuery>;
export type GetAnalyticsTypesQueryResult = Apollo.QueryResult<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>;
export const GetAnalyticsLogDocument = gql`
    query GetAnalyticsLog($workspaceId: String!, $analyticsId: String!) {
  getAnalyticsLog(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    log
  }
}
    `;

/**
 * __useGetAnalyticsLogQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsLogQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables> & ({ variables: GetAnalyticsLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
      }
export function useGetAnalyticsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>;
export function useGetAnalyticsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsLogQuery | undefined, GetAnalyticsLogQueryVariables>;
export function useGetAnalyticsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
        }
export type GetAnalyticsLogQueryHookResult = ReturnType<typeof useGetAnalyticsLogQuery>;
export type GetAnalyticsLogLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLogLazyQuery>;
export type GetAnalyticsLogSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsLogSuspenseQuery>;
export type GetAnalyticsLogQueryResult = Apollo.QueryResult<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>;
export const GetAnnotationFormatsDocument = gql`
    query GetAnnotationFormats {
  getAnnotationFormats
}
    `;

/**
 * __useGetAnnotationFormatsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnotationFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
      }
export function useGetAnnotationFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
        }
// @ts-ignore
export function useGetAnnotationFormatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>;
export function useGetAnnotationFormatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationFormatsQuery | undefined, GetAnnotationFormatsQueryVariables>;
export function useGetAnnotationFormatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
        }
export type GetAnnotationFormatsQueryHookResult = ReturnType<typeof useGetAnnotationFormatsQuery>;
export type GetAnnotationFormatsLazyQueryHookResult = ReturnType<typeof useGetAnnotationFormatsLazyQuery>;
export type GetAnnotationFormatsSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationFormatsSuspenseQuery>;
export type GetAnnotationFormatsQueryResult = Apollo.QueryResult<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>;
export const GetAnnotationMapsDocument = gql`
    query GetAnnotationMaps($organizationId: String, $workspaceId: String, $mapId: String, $cursor: String, $limit: Int, $filters: AnnotationMapFilter) {
  getAnnotationMaps(
    organizationId: $organizationId
    workspaceId: $workspaceId
    mapId: $mapId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    description
    mapId
    name
    organization
    createdAt
    organizationId
    updatedAt
    tags
  }
}
    `;

/**
 * __useGetAnnotationMapsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationMapsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      mapId: // value for 'mapId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAnnotationMapsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
      }
export function useGetAnnotationMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
        }
// @ts-ignore
export function useGetAnnotationMapsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>;
export function useGetAnnotationMapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationMapsQuery | undefined, GetAnnotationMapsQueryVariables>;
export function useGetAnnotationMapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
        }
export type GetAnnotationMapsQueryHookResult = ReturnType<typeof useGetAnnotationMapsQuery>;
export type GetAnnotationMapsLazyQueryHookResult = ReturnType<typeof useGetAnnotationMapsLazyQuery>;
export type GetAnnotationMapsSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationMapsSuspenseQuery>;
export type GetAnnotationMapsQueryResult = Apollo.QueryResult<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>;
export const GetAnnotationLogDocument = gql`
    query GetAnnotationLog($workspaceId: String!, $annotationId: String!) {
  getAnnotationLog(workspaceId: $workspaceId, annotationId: $annotationId) {
    log
  }
}
    `;

/**
 * __useGetAnnotationLogQuery__
 *
 * To run a query within a React component, call `useGetAnnotationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useGetAnnotationLogQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables> & ({ variables: GetAnnotationLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
      }
export function useGetAnnotationLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
        }
// @ts-ignore
export function useGetAnnotationLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>;
export function useGetAnnotationLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationLogQuery | undefined, GetAnnotationLogQueryVariables>;
export function useGetAnnotationLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
        }
export type GetAnnotationLogQueryHookResult = ReturnType<typeof useGetAnnotationLogQuery>;
export type GetAnnotationLogLazyQueryHookResult = ReturnType<typeof useGetAnnotationLogLazyQuery>;
export type GetAnnotationLogSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationLogSuspenseQuery>;
export type GetAnnotationLogQueryResult = Apollo.QueryResult<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>;
export const GetChannelDocumentationDocument = gql`
    query GetChannelDocumentation($channelId: String!) {
  getChannelDocumentation(channelId: $channelId)
}
    `;

/**
 * __useGetChannelDocumentationQuery__
 *
 * To run a query within a React component, call `useGetChannelDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelDocumentationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables> & ({ variables: GetChannelDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
      }
export function useGetChannelDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
        }
// @ts-ignore
export function useGetChannelDocumentationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>;
export function useGetChannelDocumentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelDocumentationQuery | undefined, GetChannelDocumentationQueryVariables>;
export function useGetChannelDocumentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
        }
export type GetChannelDocumentationQueryHookResult = ReturnType<typeof useGetChannelDocumentationQuery>;
export type GetChannelDocumentationLazyQueryHookResult = ReturnType<typeof useGetChannelDocumentationLazyQuery>;
export type GetChannelDocumentationSuspenseQueryHookResult = ReturnType<typeof useGetChannelDocumentationSuspenseQuery>;
export type GetChannelDocumentationQueryResult = Apollo.QueryResult<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>;
export const GetChannelNodeDocumentationDocument = gql`
    query GetChannelNodeDocumentation($channelId: String!, $nodeClass: String!) {
  getNodeDocumentation(channelId: $channelId, nodeClass: $nodeClass) {
    documentation
    preview
    thumbnail
  }
}
    `;

/**
 * __useGetChannelNodeDocumentationQuery__
 *
 * To run a query within a React component, call `useGetChannelNodeDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelNodeDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelNodeDocumentationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      nodeClass: // value for 'nodeClass'
 *   },
 * });
 */
export function useGetChannelNodeDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables> & ({ variables: GetChannelNodeDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
      }
export function useGetChannelNodeDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
        }
// @ts-ignore
export function useGetChannelNodeDocumentationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>;
export function useGetChannelNodeDocumentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelNodeDocumentationQuery | undefined, GetChannelNodeDocumentationQueryVariables>;
export function useGetChannelNodeDocumentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
        }
export type GetChannelNodeDocumentationQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationQuery>;
export type GetChannelNodeDocumentationLazyQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationLazyQuery>;
export type GetChannelNodeDocumentationSuspenseQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationSuspenseQuery>;
export type GetChannelNodeDocumentationQueryResult = Apollo.QueryResult<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>;
export const GetDatasetRunsDocument = gql`
    query GetDatasetRuns($workspaceId: String!, $datasetId: String!, $state: String) {
  getDatasetRuns(workspaceId: $workspaceId, datasetId: $datasetId, state: $state) {
    runId
    workspaceId
    datasetId
    channelId
    startTime
    endTime
    state
    run
  }
  getDatasetJobs(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetDatasetRunsQuery__
 *
 * To run a query within a React component, call `useGetDatasetRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetRunsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDatasetRunsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables> & ({ variables: GetDatasetRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
      }
export function useGetDatasetRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
        }
// @ts-ignore
export function useGetDatasetRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>;
export function useGetDatasetRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetRunsQuery | undefined, GetDatasetRunsQueryVariables>;
export function useGetDatasetRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
        }
export type GetDatasetRunsQueryHookResult = ReturnType<typeof useGetDatasetRunsQuery>;
export type GetDatasetRunsLazyQueryHookResult = ReturnType<typeof useGetDatasetRunsLazyQuery>;
export type GetDatasetRunsSuspenseQueryHookResult = ReturnType<typeof useGetDatasetRunsSuspenseQuery>;
export type GetDatasetRunsQueryResult = Apollo.QueryResult<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>;
export const GetDatasetLogDocument = gql`
    query GetDatasetLog($workspaceId: String!, $datasetId: String!, $runId: String!) {
  getDatasetLog(workspaceId: $workspaceId, datasetId: $datasetId, runId: $runId) {
    log
  }
}
    `;

/**
 * __useGetDatasetLogQuery__
 *
 * To run a query within a React component, call `useGetDatasetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetDatasetLogQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables> & ({ variables: GetDatasetLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
      }
export function useGetDatasetLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
        }
// @ts-ignore
export function useGetDatasetLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetLogQuery, GetDatasetLogQueryVariables>;
export function useGetDatasetLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetLogQuery | undefined, GetDatasetLogQueryVariables>;
export function useGetDatasetLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
        }
export type GetDatasetLogQueryHookResult = ReturnType<typeof useGetDatasetLogQuery>;
export type GetDatasetLogLazyQueryHookResult = ReturnType<typeof useGetDatasetLogLazyQuery>;
export type GetDatasetLogSuspenseQueryHookResult = ReturnType<typeof useGetDatasetLogSuspenseQuery>;
export type GetDatasetLogQueryResult = Apollo.QueryResult<GetDatasetLogQuery, GetDatasetLogQueryVariables>;
export const GetDatasetImageDocument = gql`
    query GetDatasetImage($workspaceId: String!, $datasetId: String!, $filename: String!) {
  getDatasetImage(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filename: $filename
  ) {
    data
  }
}
    `;

/**
 * __useGetDatasetImageQuery__
 *
 * To run a query within a React component, call `useGetDatasetImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetImageQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetDatasetImageQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables> & ({ variables: GetDatasetImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
      }
export function useGetDatasetImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
        }
// @ts-ignore
export function useGetDatasetImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetImageQuery, GetDatasetImageQueryVariables>;
export function useGetDatasetImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetImageQuery | undefined, GetDatasetImageQueryVariables>;
export function useGetDatasetImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
        }
export type GetDatasetImageQueryHookResult = ReturnType<typeof useGetDatasetImageQuery>;
export type GetDatasetImageLazyQueryHookResult = ReturnType<typeof useGetDatasetImageLazyQuery>;
export type GetDatasetImageSuspenseQueryHookResult = ReturnType<typeof useGetDatasetImageSuspenseQuery>;
export type GetDatasetImageQueryResult = Apollo.QueryResult<GetDatasetImageQuery, GetDatasetImageQueryVariables>;
export const GetDatasetDocument = gql`
    query GetDataset($workspaceId: String!, $datasetId: String) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    files
    name
    runs
  }
}
    `;

/**
 * __useGetDatasetQuery__
 *
 * To run a query within a React component, call `useGetDatasetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables> & ({ variables: GetDatasetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
      }
export function useGetDatasetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
        }
// @ts-ignore
export function useGetDatasetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetQuery, GetDatasetQueryVariables>;
export function useGetDatasetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetQuery | undefined, GetDatasetQueryVariables>;
export function useGetDatasetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
        }
export type GetDatasetQueryHookResult = ReturnType<typeof useGetDatasetQuery>;
export type GetDatasetLazyQueryHookResult = ReturnType<typeof useGetDatasetLazyQuery>;
export type GetDatasetSuspenseQueryHookResult = ReturnType<typeof useGetDatasetSuspenseQuery>;
export type GetDatasetQueryResult = Apollo.QueryResult<GetDatasetQuery, GetDatasetQueryVariables>;
export const GetWorkspaceDatasetsListDocument = gql`
    query GetWorkspaceDatasetsList($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetFilter) {
  getDatasets(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetWorkspaceDatasetsListQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceDatasetsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceDatasetsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceDatasetsListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceDatasetsListQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables> & ({ variables: GetWorkspaceDatasetsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>(GetWorkspaceDatasetsListDocument, options);
      }
export function useGetWorkspaceDatasetsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>(GetWorkspaceDatasetsListDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceDatasetsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>;
export function useGetWorkspaceDatasetsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceDatasetsListQuery | undefined, GetWorkspaceDatasetsListQueryVariables>;
export function useGetWorkspaceDatasetsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>(GetWorkspaceDatasetsListDocument, options);
        }
export type GetWorkspaceDatasetsListQueryHookResult = ReturnType<typeof useGetWorkspaceDatasetsListQuery>;
export type GetWorkspaceDatasetsListLazyQueryHookResult = ReturnType<typeof useGetWorkspaceDatasetsListLazyQuery>;
export type GetWorkspaceDatasetsListSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceDatasetsListSuspenseQuery>;
export type GetWorkspaceDatasetsListQueryResult = Apollo.QueryResult<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>;
export const GetGANModelsDocument = gql`
    query GetGANModels($workspaceId: String, $modelId: String, $organizationId: String, $cursor: String, $limit: Int, $filters: GANModelFilter) {
  getGANModels(
    workspaceId: $workspaceId
    modelId: $modelId
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    organizationId
    modelId
    description
    flags
    name
    organization
    createdAt
    updatedAt
    tags
  }
}
    `;

/**
 * __useGetGANModelsQuery__
 *
 * To run a query within a React component, call `useGetGANModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGANModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANModelsQuery, GetGANModelsQueryVariables>(GetGANModelsDocument, options);
      }
export function useGetGANModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANModelsQuery, GetGANModelsQueryVariables>(GetGANModelsDocument, options);
        }
// @ts-ignore
export function useGetGANModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANModelsQuery, GetGANModelsQueryVariables>;
export function useGetGANModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANModelsQuery | undefined, GetGANModelsQueryVariables>;
export function useGetGANModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGANModelsQuery, GetGANModelsQueryVariables>(GetGANModelsDocument, options);
        }
export type GetGANModelsQueryHookResult = ReturnType<typeof useGetGANModelsQuery>;
export type GetGANModelsLazyQueryHookResult = ReturnType<typeof useGetGANModelsLazyQuery>;
export type GetGANModelsSuspenseQueryHookResult = ReturnType<typeof useGetGANModelsSuspenseQuery>;
export type GetGANModelsQueryResult = Apollo.QueryResult<GetGANModelsQuery, GetGANModelsQueryVariables>;
export const GetGANDatasetLogDocument = gql`
    query GetGANDatasetLog($workspaceId: String!, $datasetId: String!) {
  getGANDatasetLog(workspaceId: $workspaceId, datasetId: $datasetId) {
    log
  }
}
    `;

/**
 * __useGetGANDatasetLogQuery__
 *
 * To run a query within a React component, call `useGetGANDatasetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANDatasetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANDatasetLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetGANDatasetLogQuery(baseOptions: Apollo.QueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables> & ({ variables: GetGANDatasetLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>(GetGANDatasetLogDocument, options);
      }
export function useGetGANDatasetLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>(GetGANDatasetLogDocument, options);
        }
// @ts-ignore
export function useGetGANDatasetLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>;
export function useGetGANDatasetLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANDatasetLogQuery | undefined, GetGANDatasetLogQueryVariables>;
export function useGetGANDatasetLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>(GetGANDatasetLogDocument, options);
        }
export type GetGANDatasetLogQueryHookResult = ReturnType<typeof useGetGANDatasetLogQuery>;
export type GetGANDatasetLogLazyQueryHookResult = ReturnType<typeof useGetGANDatasetLogLazyQuery>;
export type GetGANDatasetLogSuspenseQueryHookResult = ReturnType<typeof useGetGANDatasetLogSuspenseQuery>;
export type GetGANDatasetLogQueryResult = Apollo.QueryResult<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>;
export const GetInpaintFormatsDocument = gql`
    query GetInpaintFormats {
  getInpaintFormats {
    name
    value
    info
  }
}
    `;

/**
 * __useGetInpaintFormatsQuery__
 *
 * To run a query within a React component, call `useGetInpaintFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInpaintFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
      }
export function useGetInpaintFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
        }
// @ts-ignore
export function useGetInpaintFormatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>;
export function useGetInpaintFormatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintFormatsQuery | undefined, GetInpaintFormatsQueryVariables>;
export function useGetInpaintFormatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
        }
export type GetInpaintFormatsQueryHookResult = ReturnType<typeof useGetInpaintFormatsQuery>;
export type GetInpaintFormatsLazyQueryHookResult = ReturnType<typeof useGetInpaintFormatsLazyQuery>;
export type GetInpaintFormatsSuspenseQueryHookResult = ReturnType<typeof useGetInpaintFormatsSuspenseQuery>;
export type GetInpaintFormatsQueryResult = Apollo.QueryResult<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>;
export const GetInpaintsDocument = gql`
    query GetInpaints($volumeId: String!, $cursor: String, $limit: Int) {
  getInpaints(volumeId: $volumeId, cursor: $cursor, limit: $limit) {
    volumeId
    inpaintId
    status
    location
    destination
    inputType
    outputType
    dilation
    createdBy
    createdAt
    updatedBy
    updatedAt
  }
}
    `;

/**
 * __useGetInpaintsQuery__
 *
 * To run a query within a React component, call `useGetInpaintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintsQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInpaintsQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables> & ({ variables: GetInpaintsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
      }
export function useGetInpaintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
        }
// @ts-ignore
export function useGetInpaintsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintsQuery, GetInpaintsQueryVariables>;
export function useGetInpaintsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintsQuery | undefined, GetInpaintsQueryVariables>;
export function useGetInpaintsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
        }
export type GetInpaintsQueryHookResult = ReturnType<typeof useGetInpaintsQuery>;
export type GetInpaintsLazyQueryHookResult = ReturnType<typeof useGetInpaintsLazyQuery>;
export type GetInpaintsSuspenseQueryHookResult = ReturnType<typeof useGetInpaintsSuspenseQuery>;
export type GetInpaintsQueryResult = Apollo.QueryResult<GetInpaintsQuery, GetInpaintsQueryVariables>;
export const GetInpaintLogDocument = gql`
    query GetInpaintLog($volumeId: String!, $inpaintId: String!) {
  getInpaintLog(volumeId: $volumeId, inpaintId: $inpaintId) {
    log
  }
}
    `;

/**
 * __useGetInpaintLogQuery__
 *
 * To run a query within a React component, call `useGetInpaintLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintLogQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useGetInpaintLogQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables> & ({ variables: GetInpaintLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
      }
export function useGetInpaintLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
        }
// @ts-ignore
export function useGetInpaintLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintLogQuery, GetInpaintLogQueryVariables>;
export function useGetInpaintLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintLogQuery | undefined, GetInpaintLogQueryVariables>;
export function useGetInpaintLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
        }
export type GetInpaintLogQueryHookResult = ReturnType<typeof useGetInpaintLogQuery>;
export type GetInpaintLogLazyQueryHookResult = ReturnType<typeof useGetInpaintLogLazyQuery>;
export type GetInpaintLogSuspenseQueryHookResult = ReturnType<typeof useGetInpaintLogSuspenseQuery>;
export type GetInpaintLogQueryResult = Apollo.QueryResult<GetInpaintLogQuery, GetInpaintLogQueryVariables>;
export const GetInvitationsDocument = gql`
    query GetInvitations($organizationId: String!) {
  getInvitations(organizationId: $organizationId) {
    email
    organizationId
    role
    updatedAt
  }
}
    `;

/**
 * __useGetInvitationsQuery__
 *
 * To run a query within a React component, call `useGetInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables> & ({ variables: GetInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
      }
export function useGetInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
// @ts-ignore
export function useGetInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;
export function useGetInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationsQuery | undefined, GetInvitationsQueryVariables>;
export function useGetInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
export type GetInvitationsQueryHookResult = ReturnType<typeof useGetInvitationsQuery>;
export type GetInvitationsLazyQueryHookResult = ReturnType<typeof useGetInvitationsLazyQuery>;
export type GetInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetInvitationsSuspenseQuery>;
export type GetInvitationsQueryResult = Apollo.QueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const GetMcpServersDocument = gql`
    query GetMcpServers($mode: String!, $organizationId: String, $workspaceId: String) {
  getMcpServers(
    mode: $mode
    organizationId: $organizationId
    workspaceId: $workspaceId
  ) {
    mcpServerId
    scopeType
    organizationId
    workspaceId
    userId
    name
    description
    config
    enabled
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMcpServersQuery__
 *
 * To run a query within a React component, call `useGetMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpServersQuery({
 *   variables: {
 *      mode: // value for 'mode'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetMcpServersQuery(baseOptions: Apollo.QueryHookOptions<GetMcpServersQuery, GetMcpServersQueryVariables> & ({ variables: GetMcpServersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMcpServersQuery, GetMcpServersQueryVariables>(GetMcpServersDocument, options);
      }
export function useGetMcpServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMcpServersQuery, GetMcpServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMcpServersQuery, GetMcpServersQueryVariables>(GetMcpServersDocument, options);
        }
// @ts-ignore
export function useGetMcpServersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMcpServersQuery, GetMcpServersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpServersQuery, GetMcpServersQueryVariables>;
export function useGetMcpServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpServersQuery, GetMcpServersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpServersQuery | undefined, GetMcpServersQueryVariables>;
export function useGetMcpServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpServersQuery, GetMcpServersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMcpServersQuery, GetMcpServersQueryVariables>(GetMcpServersDocument, options);
        }
export type GetMcpServersQueryHookResult = ReturnType<typeof useGetMcpServersQuery>;
export type GetMcpServersLazyQueryHookResult = ReturnType<typeof useGetMcpServersLazyQuery>;
export type GetMcpServersSuspenseQueryHookResult = ReturnType<typeof useGetMcpServersSuspenseQuery>;
export type GetMcpServersQueryResult = Apollo.QueryResult<GetMcpServersQuery, GetMcpServersQueryVariables>;
export const GetWorkspaceMcpServerOverridesDocument = gql`
    query GetWorkspaceMcpServerOverrides($workspaceId: String!) {
  getWorkspaceMcpServerOverrides(workspaceId: $workspaceId) {
    workspaceId
    mcpServerId
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetWorkspaceMcpServerOverridesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMcpServerOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMcpServerOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMcpServerOverridesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMcpServerOverridesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables> & ({ variables: GetWorkspaceMcpServerOverridesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>(GetWorkspaceMcpServerOverridesDocument, options);
      }
export function useGetWorkspaceMcpServerOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>(GetWorkspaceMcpServerOverridesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceMcpServerOverridesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>;
export function useGetWorkspaceMcpServerOverridesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMcpServerOverridesQuery | undefined, GetWorkspaceMcpServerOverridesQueryVariables>;
export function useGetWorkspaceMcpServerOverridesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>(GetWorkspaceMcpServerOverridesDocument, options);
        }
export type GetWorkspaceMcpServerOverridesQueryHookResult = ReturnType<typeof useGetWorkspaceMcpServerOverridesQuery>;
export type GetWorkspaceMcpServerOverridesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMcpServerOverridesLazyQuery>;
export type GetWorkspaceMcpServerOverridesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceMcpServerOverridesSuspenseQuery>;
export type GetWorkspaceMcpServerOverridesQueryResult = Apollo.QueryResult<GetWorkspaceMcpServerOverridesQuery, GetWorkspaceMcpServerOverridesQueryVariables>;
export const GetMembersDocument = gql`
    query GetMembers($organizationId: String!, $limit: Int, $cursor: String) {
  getMembers(organizationId: $organizationId, limit: $limit, cursor: $cursor) {
    userId
    email
    name
    role
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables> & ({ variables: GetMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
// @ts-ignore
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMembersQuery, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMembersQuery | undefined, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersSuspenseQueryHookResult = ReturnType<typeof useGetMembersSuspenseQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetMLInferenceLogDocument = gql`
    query GetMLInferenceLog($workspaceId: String!, $inferenceId: String!) {
  getMLInferenceLog(workspaceId: $workspaceId, inferenceId: $inferenceId) {
    workspaceId
    inferenceId
    status
    log
  }
}
    `;

/**
 * __useGetMLInferenceLogQuery__
 *
 * To run a query within a React component, call `useGetMLInferenceLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferenceLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferenceLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMLInferenceLogQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables> & ({ variables: GetMLInferenceLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>(GetMLInferenceLogDocument, options);
      }
export function useGetMLInferenceLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>(GetMLInferenceLogDocument, options);
        }
// @ts-ignore
export function useGetMLInferenceLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>;
export function useGetMLInferenceLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferenceLogQuery | undefined, GetMLInferenceLogQueryVariables>;
export function useGetMLInferenceLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>(GetMLInferenceLogDocument, options);
        }
export type GetMLInferenceLogQueryHookResult = ReturnType<typeof useGetMLInferenceLogQuery>;
export type GetMLInferenceLogLazyQueryHookResult = ReturnType<typeof useGetMLInferenceLogLazyQuery>;
export type GetMLInferenceLogSuspenseQueryHookResult = ReturnType<typeof useGetMLInferenceLogSuspenseQuery>;
export type GetMLInferenceLogQueryResult = Apollo.QueryResult<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>;
export const GetMLInferenceMetricsDocument = gql`
    query GetMLInferenceMetrics($workspaceId: String!, $inferenceId: String!) {
  getMLInferenceMetrics(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;

/**
 * __useGetMLInferenceMetricsQuery__
 *
 * To run a query within a React component, call `useGetMLInferenceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferenceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferenceMetricsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMLInferenceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables> & ({ variables: GetMLInferenceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>(GetMLInferenceMetricsDocument, options);
      }
export function useGetMLInferenceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>(GetMLInferenceMetricsDocument, options);
        }
// @ts-ignore
export function useGetMLInferenceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>;
export function useGetMLInferenceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferenceMetricsQuery | undefined, GetMLInferenceMetricsQueryVariables>;
export function useGetMLInferenceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>(GetMLInferenceMetricsDocument, options);
        }
export type GetMLInferenceMetricsQueryHookResult = ReturnType<typeof useGetMLInferenceMetricsQuery>;
export type GetMLInferenceMetricsLazyQueryHookResult = ReturnType<typeof useGetMLInferenceMetricsLazyQuery>;
export type GetMLInferenceMetricsSuspenseQueryHookResult = ReturnType<typeof useGetMLInferenceMetricsSuspenseQuery>;
export type GetMLInferenceMetricsQueryResult = Apollo.QueryResult<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>;
export const GetMLArchitecturesDocument = gql`
    query GetMLArchitectures {
  getMLArchitectures {
    architectureId
    name
    description
    annotations
    hyperparameters {
      name
      field
      type
      description
      default
      min
      max
      step
      options
    }
  }
}
    `;

/**
 * __useGetMLArchitecturesQuery__
 *
 * To run a query within a React component, call `useGetMLArchitecturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLArchitecturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLArchitecturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMLArchitecturesQuery(baseOptions?: Apollo.QueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>(GetMLArchitecturesDocument, options);
      }
export function useGetMLArchitecturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>(GetMLArchitecturesDocument, options);
        }
// @ts-ignore
export function useGetMLArchitecturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>;
export function useGetMLArchitecturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLArchitecturesQuery | undefined, GetMLArchitecturesQueryVariables>;
export function useGetMLArchitecturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>(GetMLArchitecturesDocument, options);
        }
export type GetMLArchitecturesQueryHookResult = ReturnType<typeof useGetMLArchitecturesQuery>;
export type GetMLArchitecturesLazyQueryHookResult = ReturnType<typeof useGetMLArchitecturesLazyQuery>;
export type GetMLArchitecturesSuspenseQueryHookResult = ReturnType<typeof useGetMLArchitecturesSuspenseQuery>;
export type GetMLArchitecturesQueryResult = Apollo.QueryResult<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>;
export const GetMLModelDocument = gql`
    query GetMLModel($workspaceId: String!, $modelId: String!) {
  getMLModels(workspaceId: $workspaceId, modelId: $modelId) {
    architecture
    architectureId
    checkpoints
    dataset
    datasetId
    description
    metrics
    modelId
    name
    parameters
    status
    tags
  }
}
    `;

/**
 * __useGetMLModelQuery__
 *
 * To run a query within a React component, call `useGetMLModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables> & ({ variables: GetMLModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelQuery, GetMLModelQueryVariables>(GetMLModelDocument, options);
      }
export function useGetMLModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelQuery, GetMLModelQueryVariables>(GetMLModelDocument, options);
        }
// @ts-ignore
export function useGetMLModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelQuery, GetMLModelQueryVariables>;
export function useGetMLModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelQuery | undefined, GetMLModelQueryVariables>;
export function useGetMLModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLModelQuery, GetMLModelQueryVariables>(GetMLModelDocument, options);
        }
export type GetMLModelQueryHookResult = ReturnType<typeof useGetMLModelQuery>;
export type GetMLModelLazyQueryHookResult = ReturnType<typeof useGetMLModelLazyQuery>;
export type GetMLModelSuspenseQueryHookResult = ReturnType<typeof useGetMLModelSuspenseQuery>;
export type GetMLModelQueryResult = Apollo.QueryResult<GetMLModelQuery, GetMLModelQueryVariables>;
export const GetMLModelLogDocument = gql`
    query GetMLModelLog($workspaceId: String!, $modelId: String!) {
  getMLModelLog(workspaceId: $workspaceId, modelId: $modelId) {
    log
  }
}
    `;

/**
 * __useGetMLModelLogQuery__
 *
 * To run a query within a React component, call `useGetMLModelLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelLogQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables> & ({ variables: GetMLModelLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelLogQuery, GetMLModelLogQueryVariables>(GetMLModelLogDocument, options);
      }
export function useGetMLModelLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelLogQuery, GetMLModelLogQueryVariables>(GetMLModelLogDocument, options);
        }
// @ts-ignore
export function useGetMLModelLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelLogQuery, GetMLModelLogQueryVariables>;
export function useGetMLModelLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelLogQuery | undefined, GetMLModelLogQueryVariables>;
export function useGetMLModelLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLModelLogQuery, GetMLModelLogQueryVariables>(GetMLModelLogDocument, options);
        }
export type GetMLModelLogQueryHookResult = ReturnType<typeof useGetMLModelLogQuery>;
export type GetMLModelLogLazyQueryHookResult = ReturnType<typeof useGetMLModelLogLazyQuery>;
export type GetMLModelLogSuspenseQueryHookResult = ReturnType<typeof useGetMLModelLogSuspenseQuery>;
export type GetMLModelLogQueryResult = Apollo.QueryResult<GetMLModelLogQuery, GetMLModelLogQueryVariables>;
export const AddMemberDocument = gql`
    mutation AddMember($organizationId: String, $email: String!, $role: String) {
  addMember(organizationId: $organizationId, email: $email, role: $role)
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const AddWorkspaceMembersDocument = gql`
    mutation AddWorkspaceMembers($workspaceId: String!, $emails: [String]!) {
  addWorkspaceMembers(workspaceId: $workspaceId, emails: $emails)
}
    `;
export type AddWorkspaceMembersMutationFn = Apollo.MutationFunction<AddWorkspaceMembersMutation, AddWorkspaceMembersMutationVariables>;

/**
 * __useAddWorkspaceMembersMutation__
 *
 * To run a mutation, you first call `useAddWorkspaceMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkspaceMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkspaceMembersMutation, { data, loading, error }] = useAddWorkspaceMembersMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useAddWorkspaceMembersMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkspaceMembersMutation, AddWorkspaceMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkspaceMembersMutation, AddWorkspaceMembersMutationVariables>(AddWorkspaceMembersDocument, options);
      }
export type AddWorkspaceMembersMutationHookResult = ReturnType<typeof useAddWorkspaceMembersMutation>;
export type AddWorkspaceMembersMutationResult = Apollo.MutationResult<AddWorkspaceMembersMutation>;
export type AddWorkspaceMembersMutationOptions = Apollo.BaseMutationOptions<AddWorkspaceMembersMutation, AddWorkspaceMembersMutationVariables>;
export const AddWorkspacePersistentServicesDocument = gql`
    mutation AddWorkspacePersistentServices($workspaceId: String!, $persistentServiceIds: [String!]!) {
  addWorkspacePersistentServices(
    workspaceId: $workspaceId
    persistentServiceIds: $persistentServiceIds
  )
}
    `;
export type AddWorkspacePersistentServicesMutationFn = Apollo.MutationFunction<AddWorkspacePersistentServicesMutation, AddWorkspacePersistentServicesMutationVariables>;

/**
 * __useAddWorkspacePersistentServicesMutation__
 *
 * To run a mutation, you first call `useAddWorkspacePersistentServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkspacePersistentServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkspacePersistentServicesMutation, { data, loading, error }] = useAddWorkspacePersistentServicesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      persistentServiceIds: // value for 'persistentServiceIds'
 *   },
 * });
 */
export function useAddWorkspacePersistentServicesMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkspacePersistentServicesMutation, AddWorkspacePersistentServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkspacePersistentServicesMutation, AddWorkspacePersistentServicesMutationVariables>(AddWorkspacePersistentServicesDocument, options);
      }
export type AddWorkspacePersistentServicesMutationHookResult = ReturnType<typeof useAddWorkspacePersistentServicesMutation>;
export type AddWorkspacePersistentServicesMutationResult = Apollo.MutationResult<AddWorkspacePersistentServicesMutation>;
export type AddWorkspacePersistentServicesMutationOptions = Apollo.BaseMutationOptions<AddWorkspacePersistentServicesMutation, AddWorkspacePersistentServicesMutationVariables>;
export const AddWorkspaceServicesDocument = gql`
    mutation AddWorkspaceServices($workspaceId: String!, $serviceIds: [String]) {
  addWorkspaceServices(workspaceId: $workspaceId, serviceIds: $serviceIds)
}
    `;
export type AddWorkspaceServicesMutationFn = Apollo.MutationFunction<AddWorkspaceServicesMutation, AddWorkspaceServicesMutationVariables>;

/**
 * __useAddWorkspaceServicesMutation__
 *
 * To run a mutation, you first call `useAddWorkspaceServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkspaceServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkspaceServicesMutation, { data, loading, error }] = useAddWorkspaceServicesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useAddWorkspaceServicesMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkspaceServicesMutation, AddWorkspaceServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkspaceServicesMutation, AddWorkspaceServicesMutationVariables>(AddWorkspaceServicesDocument, options);
      }
export type AddWorkspaceServicesMutationHookResult = ReturnType<typeof useAddWorkspaceServicesMutation>;
export type AddWorkspaceServicesMutationResult = Apollo.MutationResult<AddWorkspaceServicesMutation>;
export type AddWorkspaceServicesMutationOptions = Apollo.BaseMutationOptions<AddWorkspaceServicesMutation, AddWorkspaceServicesMutationVariables>;
export const AddWorkspaceVolumesDocument = gql`
    mutation AddWorkspaceVolumes($workspaceId: String!, $volumeIds: [String]!) {
  addWorkspaceVolumes(workspaceId: $workspaceId, volumeIds: $volumeIds)
}
    `;
export type AddWorkspaceVolumesMutationFn = Apollo.MutationFunction<AddWorkspaceVolumesMutation, AddWorkspaceVolumesMutationVariables>;

/**
 * __useAddWorkspaceVolumesMutation__
 *
 * To run a mutation, you first call `useAddWorkspaceVolumesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkspaceVolumesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkspaceVolumesMutation, { data, loading, error }] = useAddWorkspaceVolumesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      volumeIds: // value for 'volumeIds'
 *   },
 * });
 */
export function useAddWorkspaceVolumesMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkspaceVolumesMutation, AddWorkspaceVolumesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkspaceVolumesMutation, AddWorkspaceVolumesMutationVariables>(AddWorkspaceVolumesDocument, options);
      }
export type AddWorkspaceVolumesMutationHookResult = ReturnType<typeof useAddWorkspaceVolumesMutation>;
export type AddWorkspaceVolumesMutationResult = Apollo.MutationResult<AddWorkspaceVolumesMutation>;
export type AddWorkspaceVolumesMutationOptions = Apollo.BaseMutationOptions<AddWorkspaceVolumesMutation, AddWorkspaceVolumesMutationVariables>;
export const ClearDatasetJobsDocument = gql`
    mutation ClearDatasetJobs($organizationId: String, $workspaceId: String, $datasetId: String) {
  clearDatasetJobs(
    organizationId: $organizationId
    workspaceId: $workspaceId
    datasetId: $datasetId
  )
}
    `;
export type ClearDatasetJobsMutationFn = Apollo.MutationFunction<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>;

/**
 * __useClearDatasetJobsMutation__
 *
 * To run a mutation, you first call `useClearDatasetJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDatasetJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDatasetJobsMutation, { data, loading, error }] = useClearDatasetJobsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useClearDatasetJobsMutation(baseOptions?: Apollo.MutationHookOptions<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>(ClearDatasetJobsDocument, options);
      }
export type ClearDatasetJobsMutationHookResult = ReturnType<typeof useClearDatasetJobsMutation>;
export type ClearDatasetJobsMutationResult = Apollo.MutationResult<ClearDatasetJobsMutation>;
export type ClearDatasetJobsMutationOptions = Apollo.BaseMutationOptions<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>;
export const CompleteSkillUploadDocument = gql`
    mutation CompleteSkillUpload($skillId: String!, $uploadId: String!, $parts: [MultipartInput]!) {
  completeSkillUpload(skillId: $skillId, uploadId: $uploadId, parts: $parts)
}
    `;
export type CompleteSkillUploadMutationFn = Apollo.MutationFunction<CompleteSkillUploadMutation, CompleteSkillUploadMutationVariables>;

/**
 * __useCompleteSkillUploadMutation__
 *
 * To run a mutation, you first call `useCompleteSkillUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSkillUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSkillUploadMutation, { data, loading, error }] = useCompleteSkillUploadMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useCompleteSkillUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSkillUploadMutation, CompleteSkillUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSkillUploadMutation, CompleteSkillUploadMutationVariables>(CompleteSkillUploadDocument, options);
      }
export type CompleteSkillUploadMutationHookResult = ReturnType<typeof useCompleteSkillUploadMutation>;
export type CompleteSkillUploadMutationResult = Apollo.MutationResult<CompleteSkillUploadMutation>;
export type CompleteSkillUploadMutationOptions = Apollo.BaseMutationOptions<CompleteSkillUploadMutation, CompleteSkillUploadMutationVariables>;
export const CreateAPIKeyDocument = gql`
    mutation CreateAPIKey($name: String!, $scope: String, $organizationId: String, $workspaceId: String, $expiresAt: String) {
  createAPIKey(
    name: $name
    scope: $scope
    organizationId: $organizationId
    workspaceId: $workspaceId
    expiresAt: $expiresAt
  )
}
    `;
export type CreateAPIKeyMutationFn = Apollo.MutationFunction<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>;

/**
 * __useCreateAPIKeyMutation__
 *
 * To run a mutation, you first call `useCreateAPIKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAPIKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateAPIKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      scope: // value for 'scope'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateAPIKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>(CreateAPIKeyDocument, options);
      }
export type CreateAPIKeyMutationHookResult = ReturnType<typeof useCreateAPIKeyMutation>;
export type CreateAPIKeyMutationResult = Apollo.MutationResult<CreateAPIKeyMutation>;
export type CreateAPIKeyMutationOptions = Apollo.BaseMutationOptions<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>;
export const CreateAnalyticsDocument = gql`
    mutation CreateAnalytics($workspaceId: String!, $datasetId: String!, $type: String!, $tags: [String]) {
  createAnalytics(
    workspaceId: $workspaceId
    datasetId: $datasetId
    type: $type
    tags: $tags
  )
}
    `;
export type CreateAnalyticsMutationFn = Apollo.MutationFunction<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>;

/**
 * __useCreateAnalyticsMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticsMutation, { data, loading, error }] = useCreateAnalyticsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      type: // value for 'type'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>(CreateAnalyticsDocument, options);
      }
export type CreateAnalyticsMutationHookResult = ReturnType<typeof useCreateAnalyticsMutation>;
export type CreateAnalyticsMutationResult = Apollo.MutationResult<CreateAnalyticsMutation>;
export type CreateAnalyticsMutationOptions = Apollo.BaseMutationOptions<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>;
export const CreateAnnotationDocument = gql`
    mutation CreateAnnotation($workspaceId: String!, $datasetId: String!, $format: String!, $mapId: String, $tags: [String]) {
  createAnnotation(
    workspaceId: $workspaceId
    datasetId: $datasetId
    format: $format
    mapId: $mapId
    tags: $tags
  )
}
    `;
export type CreateAnnotationMutationFn = Apollo.MutationFunction<CreateAnnotationMutation, CreateAnnotationMutationVariables>;

/**
 * __useCreateAnnotationMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationMutation, { data, loading, error }] = useCreateAnnotationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      format: // value for 'format'
 *      mapId: // value for 'mapId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnotationMutation, CreateAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnotationMutation, CreateAnnotationMutationVariables>(CreateAnnotationDocument, options);
      }
export type CreateAnnotationMutationHookResult = ReturnType<typeof useCreateAnnotationMutation>;
export type CreateAnnotationMutationResult = Apollo.MutationResult<CreateAnnotationMutation>;
export type CreateAnnotationMutationOptions = Apollo.BaseMutationOptions<CreateAnnotationMutation, CreateAnnotationMutationVariables>;
export const CreateChannelDocument = gql`
    mutation CreateChannel($organizationId: String!, $name: String!, $description: String, $volumes: [String], $instance: String, $timeout: Int, $interfaceVersion: Int, $tags: [String]) {
  createChannel(
    organizationId: $organizationId
    name: $name
    description: $description
    volumes: $volumes
    instance: $instance
    timeout: $timeout
    interfaceVersion: $interfaceVersion
    tags: $tags
  )
}
    `;
export type CreateChannelMutationFn = Apollo.MutationFunction<CreateChannelMutation, CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      volumes: // value for 'volumes'
 *      instance: // value for 'instance'
 *      timeout: // value for 'timeout'
 *      interfaceVersion: // value for 'interfaceVersion'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMutation, CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<CreateChannelMutation, CreateChannelMutationVariables>;
export const CreateDatasetDocument = gql`
    mutation CreateDataset($workspaceId: String!, $graphId: String!, $name: String!, $description: String, $runs: Int, $priority: Int, $seed: Int, $tags: [String], $instanceType: String) {
  createDataset(
    workspaceId: $workspaceId
    graphId: $graphId
    name: $name
    description: $description
    runs: $runs
    priority: $priority
    seed: $seed
    tags: $tags
    instanceType: $instanceType
  )
}
    `;
export type CreateDatasetMutationFn = Apollo.MutationFunction<CreateDatasetMutation, CreateDatasetMutationVariables>;

/**
 * __useCreateDatasetMutation__
 *
 * To run a mutation, you first call `useCreateDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatasetMutation, { data, loading, error }] = useCreateDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      runs: // value for 'runs'
 *      priority: // value for 'priority'
 *      seed: // value for 'seed'
 *      tags: // value for 'tags'
 *      instanceType: // value for 'instanceType'
 *   },
 * });
 */
export function useCreateDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDatasetMutation, CreateDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDatasetMutation, CreateDatasetMutationVariables>(CreateDatasetDocument, options);
      }
export type CreateDatasetMutationHookResult = ReturnType<typeof useCreateDatasetMutation>;
export type CreateDatasetMutationResult = Apollo.MutationResult<CreateDatasetMutation>;
export type CreateDatasetMutationOptions = Apollo.BaseMutationOptions<CreateDatasetMutation, CreateDatasetMutationVariables>;
export const CreateEditorDocument = gql`
    mutation CreateEditor($organizationId: String!, $workspaceId: String, $instance: String, $name: String, $storageSize: Int, $autoStopEnabled: Boolean, $autoStopCpuThreshold: Int, $autoStopTimeoutMinutes: Int, $autoDeleteEnabled: Boolean, $autoDeleteTimeoutDays: Int, $autoUpdateEnabled: Boolean, $visibility: String) {
  createEditor(
    organizationId: $organizationId
    workspaceId: $workspaceId
    instance: $instance
    name: $name
    storageSize: $storageSize
    autoStopEnabled: $autoStopEnabled
    autoStopCpuThreshold: $autoStopCpuThreshold
    autoStopTimeoutMinutes: $autoStopTimeoutMinutes
    autoDeleteEnabled: $autoDeleteEnabled
    autoDeleteTimeoutDays: $autoDeleteTimeoutDays
    autoUpdateEnabled: $autoUpdateEnabled
    visibility: $visibility
  )
}
    `;
export type CreateEditorMutationFn = Apollo.MutationFunction<CreateEditorMutation, CreateEditorMutationVariables>;

/**
 * __useCreateEditorMutation__
 *
 * To run a mutation, you first call `useCreateEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEditorMutation, { data, loading, error }] = useCreateEditorMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      instance: // value for 'instance'
 *      name: // value for 'name'
 *      storageSize: // value for 'storageSize'
 *      autoStopEnabled: // value for 'autoStopEnabled'
 *      autoStopCpuThreshold: // value for 'autoStopCpuThreshold'
 *      autoStopTimeoutMinutes: // value for 'autoStopTimeoutMinutes'
 *      autoDeleteEnabled: // value for 'autoDeleteEnabled'
 *      autoDeleteTimeoutDays: // value for 'autoDeleteTimeoutDays'
 *      autoUpdateEnabled: // value for 'autoUpdateEnabled'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useCreateEditorMutation(baseOptions?: Apollo.MutationHookOptions<CreateEditorMutation, CreateEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEditorMutation, CreateEditorMutationVariables>(CreateEditorDocument, options);
      }
export type CreateEditorMutationHookResult = ReturnType<typeof useCreateEditorMutation>;
export type CreateEditorMutationResult = Apollo.MutationResult<CreateEditorMutation>;
export type CreateEditorMutationOptions = Apollo.BaseMutationOptions<CreateEditorMutation, CreateEditorMutationVariables>;
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($summary: String!, $description: String!, $files: [String]!) {
  createFeedback(summary: $summary, description: $description, files: $files) {
    feedbackId
    uploads {
      key
      url
    }
  }
}
    `;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      summary: // value for 'summary'
 *      description: // value for 'description'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const CreateGANDatasetDocument = gql`
    mutation CreateGANDataset($workspaceId: String!, $datasetId: String!, $modelId: String!, $name: String!, $description: String, $tags: [String]) {
  createGANDataset(
    workspaceId: $workspaceId
    datasetId: $datasetId
    modelId: $modelId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type CreateGANDatasetMutationFn = Apollo.MutationFunction<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>;

/**
 * __useCreateGANDatasetMutation__
 *
 * To run a mutation, you first call `useCreateGANDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGANDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGanDatasetMutation, { data, loading, error }] = useCreateGANDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateGANDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>(CreateGANDatasetDocument, options);
      }
export type CreateGANDatasetMutationHookResult = ReturnType<typeof useCreateGANDatasetMutation>;
export type CreateGANDatasetMutationResult = Apollo.MutationResult<CreateGANDatasetMutation>;
export type CreateGANDatasetMutationOptions = Apollo.BaseMutationOptions<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>;
export const CreateGraphDocument = gql`
    mutation CreateGraph($workspaceId: String!, $channelId: String!, $graph: String!, $name: String!, $description: String, $staged: Boolean, $tags: [String]) {
  createGraph(
    workspaceId: $workspaceId
    channelId: $channelId
    graph: $graph
    name: $name
    description: $description
    staged: $staged
    tags: $tags
  )
}
    `;
export type CreateGraphMutationFn = Apollo.MutationFunction<CreateGraphMutation, CreateGraphMutationVariables>;

/**
 * __useCreateGraphMutation__
 *
 * To run a mutation, you first call `useCreateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGraphMutation, { data, loading, error }] = useCreateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      channelId: // value for 'channelId'
 *      graph: // value for 'graph'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      staged: // value for 'staged'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateGraphMutation(baseOptions?: Apollo.MutationHookOptions<CreateGraphMutation, CreateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGraphMutation, CreateGraphMutationVariables>(CreateGraphDocument, options);
      }
export type CreateGraphMutationHookResult = ReturnType<typeof useCreateGraphMutation>;
export type CreateGraphMutationResult = Apollo.MutationResult<CreateGraphMutation>;
export type CreateGraphMutationOptions = Apollo.BaseMutationOptions<CreateGraphMutation, CreateGraphMutationVariables>;
export const CreateInpaintDocument = gql`
    mutation CreateInpaint($volumeId: String!, $location: String!, $files: [String], $destination: String, $dilation: Int, $inputType: InpaintInputType, $outputType: InpaintOutputType) {
  createInpaint(
    volumeId: $volumeId
    location: $location
    files: $files
    destination: $destination
    dilation: $dilation
    inputType: $inputType
    outputType: $outputType
  )
}
    `;
export type CreateInpaintMutationFn = Apollo.MutationFunction<CreateInpaintMutation, CreateInpaintMutationVariables>;

/**
 * __useCreateInpaintMutation__
 *
 * To run a mutation, you first call `useCreateInpaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInpaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInpaintMutation, { data, loading, error }] = useCreateInpaintMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      location: // value for 'location'
 *      files: // value for 'files'
 *      destination: // value for 'destination'
 *      dilation: // value for 'dilation'
 *      inputType: // value for 'inputType'
 *      outputType: // value for 'outputType'
 *   },
 * });
 */
export function useCreateInpaintMutation(baseOptions?: Apollo.MutationHookOptions<CreateInpaintMutation, CreateInpaintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInpaintMutation, CreateInpaintMutationVariables>(CreateInpaintDocument, options);
      }
export type CreateInpaintMutationHookResult = ReturnType<typeof useCreateInpaintMutation>;
export type CreateInpaintMutationResult = Apollo.MutationResult<CreateInpaintMutation>;
export type CreateInpaintMutationOptions = Apollo.BaseMutationOptions<CreateInpaintMutation, CreateInpaintMutationVariables>;
export const CreateMcpWithTemplateDocument = gql`
    mutation CreateMcpWithTemplate($mcpServerId: String!, $scopeType: String!, $organizationId: String, $workspaceId: String) {
  createMcpWithTemplate(
    mcpServerId: $mcpServerId
    scopeType: $scopeType
    organizationId: $organizationId
    workspaceId: $workspaceId
  ) {
    mcpServerId
    scopeType
    organizationId
    workspaceId
    userId
  }
}
    `;
export type CreateMcpWithTemplateMutationFn = Apollo.MutationFunction<CreateMcpWithTemplateMutation, CreateMcpWithTemplateMutationVariables>;

/**
 * __useCreateMcpWithTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMcpWithTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcpWithTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcpWithTemplateMutation, { data, loading, error }] = useCreateMcpWithTemplateMutation({
 *   variables: {
 *      mcpServerId: // value for 'mcpServerId'
 *      scopeType: // value for 'scopeType'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateMcpWithTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMcpWithTemplateMutation, CreateMcpWithTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMcpWithTemplateMutation, CreateMcpWithTemplateMutationVariables>(CreateMcpWithTemplateDocument, options);
      }
export type CreateMcpWithTemplateMutationHookResult = ReturnType<typeof useCreateMcpWithTemplateMutation>;
export type CreateMcpWithTemplateMutationResult = Apollo.MutationResult<CreateMcpWithTemplateMutation>;
export type CreateMcpWithTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMcpWithTemplateMutation, CreateMcpWithTemplateMutationVariables>;
export const CreateMcpServerDocument = gql`
    mutation CreateMcpServer($scopeType: String!, $organizationId: String, $workspaceId: String, $name: String!, $description: String, $config: String!, $enabled: Boolean) {
  createMcpServer(
    scopeType: $scopeType
    organizationId: $organizationId
    workspaceId: $workspaceId
    name: $name
    description: $description
    config: $config
    enabled: $enabled
  ) {
    config
    createdAt
    createdBy
    description
    enabled
    mcpServerId
    name
    organizationId
    scopeType
    updatedAt
    updatedBy
    userId
    workspaceId
  }
}
    `;
export type CreateMcpServerMutationFn = Apollo.MutationFunction<CreateMcpServerMutation, CreateMcpServerMutationVariables>;

/**
 * __useCreateMcpServerMutation__
 *
 * To run a mutation, you first call `useCreateMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcpServerMutation, { data, loading, error }] = useCreateMcpServerMutation({
 *   variables: {
 *      scopeType: // value for 'scopeType'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      config: // value for 'config'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useCreateMcpServerMutation(baseOptions?: Apollo.MutationHookOptions<CreateMcpServerMutation, CreateMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMcpServerMutation, CreateMcpServerMutationVariables>(CreateMcpServerDocument, options);
      }
export type CreateMcpServerMutationHookResult = ReturnType<typeof useCreateMcpServerMutation>;
export type CreateMcpServerMutationResult = Apollo.MutationResult<CreateMcpServerMutation>;
export type CreateMcpServerMutationOptions = Apollo.BaseMutationOptions<CreateMcpServerMutation, CreateMcpServerMutationVariables>;
export const CreateMLInferenceDocument = gql`
    mutation CreateMLInference($workspaceId: String!, $datasetId: String!, $modelId: String!, $mapId: String, $tags: [String]) {
  createMLInference(
    workspaceId: $workspaceId
    datasetId: $datasetId
    modelId: $modelId
    mapId: $mapId
    tags: $tags
  )
}
    `;
export type CreateMLInferenceMutationFn = Apollo.MutationFunction<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>;

/**
 * __useCreateMLInferenceMutation__
 *
 * To run a mutation, you first call `useCreateMLInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMLInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMlInferenceMutation, { data, loading, error }] = useCreateMLInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      modelId: // value for 'modelId'
 *      mapId: // value for 'mapId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMLInferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>(CreateMLInferenceDocument, options);
      }
export type CreateMLInferenceMutationHookResult = ReturnType<typeof useCreateMLInferenceMutation>;
export type CreateMLInferenceMutationResult = Apollo.MutationResult<CreateMLInferenceMutation>;
export type CreateMLInferenceMutationOptions = Apollo.BaseMutationOptions<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>;
export const CreateMLModelDocument = gql`
    mutation CreateMLModel($workspaceId: String!, $datasetId: String!, $architectureId: String!, $name: String, $description: String, $parameters: String, $tags: [String]) {
  createMLModel(
    workspaceId: $workspaceId
    datasetId: $datasetId
    architectureId: $architectureId
    name: $name
    description: $description
    parameters: $parameters
    tags: $tags
  )
}
    `;
export type CreateMLModelMutationFn = Apollo.MutationFunction<CreateMLModelMutation, CreateMLModelMutationVariables>;

/**
 * __useCreateMLModelMutation__
 *
 * To run a mutation, you first call `useCreateMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMlModelMutation, { data, loading, error }] = useCreateMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      architectureId: // value for 'architectureId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      parameters: // value for 'parameters'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMLModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateMLModelMutation, CreateMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMLModelMutation, CreateMLModelMutationVariables>(CreateMLModelDocument, options);
      }
export type CreateMLModelMutationHookResult = ReturnType<typeof useCreateMLModelMutation>;
export type CreateMLModelMutationResult = Apollo.MutationResult<CreateMLModelMutation>;
export type CreateMLModelMutationOptions = Apollo.BaseMutationOptions<CreateMLModelMutation, CreateMLModelMutationVariables>;
export const CreateMixedDatasetDocument = gql`
    mutation CreateMixedDataset($workspaceId: String!, $name: String!, $parameters: String!, $description: String, $seed: Int, $tags: [String]) {
  createMixedDataset(
    workspaceId: $workspaceId
    name: $name
    parameters: $parameters
    description: $description
    seed: $seed
    tags: $tags
  )
}
    `;
export type CreateMixedDatasetMutationFn = Apollo.MutationFunction<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>;

/**
 * __useCreateMixedDatasetMutation__
 *
 * To run a mutation, you first call `useCreateMixedDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMixedDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMixedDatasetMutation, { data, loading, error }] = useCreateMixedDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      parameters: // value for 'parameters'
 *      description: // value for 'description'
 *      seed: // value for 'seed'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMixedDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>(CreateMixedDatasetDocument, options);
      }
export type CreateMixedDatasetMutationHookResult = ReturnType<typeof useCreateMixedDatasetMutation>;
export type CreateMixedDatasetMutationResult = Apollo.MutationResult<CreateMixedDatasetMutation>;
export type CreateMixedDatasetMutationOptions = Apollo.BaseMutationOptions<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>;
export const CreatePreviewDocument = gql`
    mutation CreatePreview($workspaceId: String!, $graphId: String!) {
  createPreview(workspaceId: $workspaceId, graphId: $graphId)
}
    `;
export type CreatePreviewMutationFn = Apollo.MutationFunction<CreatePreviewMutation, CreatePreviewMutationVariables>;

/**
 * __useCreatePreviewMutation__
 *
 * To run a mutation, you first call `useCreatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewMutation, { data, loading, error }] = useCreatePreviewMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useCreatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreviewMutation, CreatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreviewMutation, CreatePreviewMutationVariables>(CreatePreviewDocument, options);
      }
export type CreatePreviewMutationHookResult = ReturnType<typeof useCreatePreviewMutation>;
export type CreatePreviewMutationResult = Apollo.MutationResult<CreatePreviewMutation>;
export type CreatePreviewMutationOptions = Apollo.BaseMutationOptions<CreatePreviewMutation, CreatePreviewMutationVariables>;
export const CreateRemoteDevelopmentDocument = gql`
    mutation CreateRemoteDevelopment($channelId: String!, $channelVersion: String, $instanceType: String, $version: Int) {
  createRemoteDevelopment(
    channelId: $channelId
    channelVersion: $channelVersion
    instanceType: $instanceType
    version: $version
  ) {
    editorSessionId
    editorUrl
  }
}
    `;
export type CreateRemoteDevelopmentMutationFn = Apollo.MutationFunction<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>;

/**
 * __useCreateRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useCreateRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRemoteDevelopmentMutation, { data, loading, error }] = useCreateRemoteDevelopmentMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      channelVersion: // value for 'channelVersion'
 *      instanceType: // value for 'instanceType'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useCreateRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>(CreateRemoteDevelopmentDocument, options);
      }
export type CreateRemoteDevelopmentMutationHookResult = ReturnType<typeof useCreateRemoteDevelopmentMutation>;
export type CreateRemoteDevelopmentMutationResult = Apollo.MutationResult<CreateRemoteDevelopmentMutation>;
export type CreateRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>;
export const CreateSecretDocument = gql`
    mutation CreateSecret($name: String!, $value: String!, $organizationId: String, $workspaceIds: [String], $includeInAllWorkspaces: Boolean) {
  createSecret(
    name: $name
    value: $value
    organizationId: $organizationId
    workspaceIds: $workspaceIds
    includeInAllWorkspaces: $includeInAllWorkspaces
  )
}
    `;
export type CreateSecretMutationFn = Apollo.MutationFunction<CreateSecretMutation, CreateSecretMutationVariables>;

/**
 * __useCreateSecretMutation__
 *
 * To run a mutation, you first call `useCreateSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSecretMutation, { data, loading, error }] = useCreateSecretMutation({
 *   variables: {
 *      name: // value for 'name'
 *      value: // value for 'value'
 *      organizationId: // value for 'organizationId'
 *      workspaceIds: // value for 'workspaceIds'
 *      includeInAllWorkspaces: // value for 'includeInAllWorkspaces'
 *   },
 * });
 */
export function useCreateSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateSecretMutation, CreateSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSecretMutation, CreateSecretMutationVariables>(CreateSecretDocument, options);
      }
export type CreateSecretMutationHookResult = ReturnType<typeof useCreateSecretMutation>;
export type CreateSecretMutationResult = Apollo.MutationResult<CreateSecretMutation>;
export type CreateSecretMutationOptions = Apollo.BaseMutationOptions<CreateSecretMutation, CreateSecretMutationVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($serviceTypeId: String!, $name: String!, $organizationId: String, $description: String, $instance: String, $volumes: [String], $tags: [String]) {
  createService(
    serviceTypeId: $serviceTypeId
    name: $name
    organizationId: $organizationId
    description: $description
    instance: $instance
    volumes: $volumes
    tags: $tags
  )
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      serviceTypeId: // value for 'serviceTypeId'
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      description: // value for 'description'
 *      instance: // value for 'instance'
 *      volumes: // value for 'volumes'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const CreateServiceWithTemplateDocument = gql`
    mutation CreateServiceWithTemplate($organizationId: String!, $serviceId: String!) {
  createServiceWithTemplate(
    organizationId: $organizationId
    serviceId: $serviceId
  )
}
    `;
export type CreateServiceWithTemplateMutationFn = Apollo.MutationFunction<CreateServiceWithTemplateMutation, CreateServiceWithTemplateMutationVariables>;

/**
 * __useCreateServiceWithTemplateMutation__
 *
 * To run a mutation, you first call `useCreateServiceWithTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceWithTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceWithTemplateMutation, { data, loading, error }] = useCreateServiceWithTemplateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useCreateServiceWithTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceWithTemplateMutation, CreateServiceWithTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceWithTemplateMutation, CreateServiceWithTemplateMutationVariables>(CreateServiceWithTemplateDocument, options);
      }
export type CreateServiceWithTemplateMutationHookResult = ReturnType<typeof useCreateServiceWithTemplateMutation>;
export type CreateServiceWithTemplateMutationResult = Apollo.MutationResult<CreateServiceWithTemplateMutation>;
export type CreateServiceWithTemplateMutationOptions = Apollo.BaseMutationOptions<CreateServiceWithTemplateMutation, CreateServiceWithTemplateMutationVariables>;
export const CreateSkillWithTemplateDocument = gql`
    mutation CreateSkillWithTemplate($skillId: String!, $scopeType: String!, $organizationId: String, $workspaceId: String) {
  createSkillWithTemplate(
    skillId: $skillId
    scopeType: $scopeType
    organizationId: $organizationId
    workspaceId: $workspaceId
  ) {
    skillId
    scopeType
    organizationId
    workspaceId
    userId
  }
}
    `;
export type CreateSkillWithTemplateMutationFn = Apollo.MutationFunction<CreateSkillWithTemplateMutation, CreateSkillWithTemplateMutationVariables>;

/**
 * __useCreateSkillWithTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSkillWithTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillWithTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillWithTemplateMutation, { data, loading, error }] = useCreateSkillWithTemplateMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      scopeType: // value for 'scopeType'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateSkillWithTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkillWithTemplateMutation, CreateSkillWithTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkillWithTemplateMutation, CreateSkillWithTemplateMutationVariables>(CreateSkillWithTemplateDocument, options);
      }
export type CreateSkillWithTemplateMutationHookResult = ReturnType<typeof useCreateSkillWithTemplateMutation>;
export type CreateSkillWithTemplateMutationResult = Apollo.MutationResult<CreateSkillWithTemplateMutation>;
export type CreateSkillWithTemplateMutationOptions = Apollo.BaseMutationOptions<CreateSkillWithTemplateMutation, CreateSkillWithTemplateMutationVariables>;
export const CreateSkillDocument = gql`
    mutation CreateSkill($scopeType: String!, $organizationId: String, $workspaceId: String, $name: String!, $description: String, $version: String, $config: String, $size: Int!) {
  createSkill(
    scopeType: $scopeType
    organizationId: $organizationId
    workspaceId: $workspaceId
    name: $name
    description: $description
    version: $version
    config: $config
    size: $size
  ) {
    skillId
    uploadId
    partSize
    urls
    s3Url
  }
}
    `;
export type CreateSkillMutationFn = Apollo.MutationFunction<CreateSkillMutation, CreateSkillMutationVariables>;

/**
 * __useCreateSkillMutation__
 *
 * To run a mutation, you first call `useCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillMutation, { data, loading, error }] = useCreateSkillMutation({
 *   variables: {
 *      scopeType: // value for 'scopeType'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      version: // value for 'version'
 *      config: // value for 'config'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useCreateSkillMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkillMutation, CreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkillMutation, CreateSkillMutationVariables>(CreateSkillDocument, options);
      }
export type CreateSkillMutationHookResult = ReturnType<typeof useCreateSkillMutation>;
export type CreateSkillMutationResult = Apollo.MutationResult<CreateSkillMutation>;
export type CreateSkillMutationOptions = Apollo.BaseMutationOptions<CreateSkillMutation, CreateSkillMutationVariables>;
export const CreateSSHKeyDocument = gql`
    mutation CreateSSHKey($name: String!, $key: String!) {
  createSSHKey(name: $name, key: $key)
}
    `;
export type CreateSSHKeyMutationFn = Apollo.MutationFunction<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>;

/**
 * __useCreateSSHKeyMutation__
 *
 * To run a mutation, you first call `useCreateSSHKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSSHKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSshKeyMutation, { data, loading, error }] = useCreateSSHKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCreateSSHKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>(CreateSSHKeyDocument, options);
      }
export type CreateSSHKeyMutationHookResult = ReturnType<typeof useCreateSSHKeyMutation>;
export type CreateSSHKeyMutationResult = Apollo.MutationResult<CreateSSHKeyMutation>;
export type CreateSSHKeyMutationOptions = Apollo.BaseMutationOptions<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>;
export const CreateStripeCustomerPortalSessionDocument = gql`
    mutation CreateStripeCustomerPortalSession($organizationId: String!, $returnUrl: String!) {
  createStripeCustomerPortalSession(
    organizationId: $organizationId
    returnUrl: $returnUrl
  ) {
    url
  }
}
    `;
export type CreateStripeCustomerPortalSessionMutationFn = Apollo.MutationFunction<CreateStripeCustomerPortalSessionMutation, CreateStripeCustomerPortalSessionMutationVariables>;

/**
 * __useCreateStripeCustomerPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripeCustomerPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCustomerPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCustomerPortalSessionMutation, { data, loading, error }] = useCreateStripeCustomerPortalSessionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreateStripeCustomerPortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeCustomerPortalSessionMutation, CreateStripeCustomerPortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCustomerPortalSessionMutation, CreateStripeCustomerPortalSessionMutationVariables>(CreateStripeCustomerPortalSessionDocument, options);
      }
export type CreateStripeCustomerPortalSessionMutationHookResult = ReturnType<typeof useCreateStripeCustomerPortalSessionMutation>;
export type CreateStripeCustomerPortalSessionMutationResult = Apollo.MutationResult<CreateStripeCustomerPortalSessionMutation>;
export type CreateStripeCustomerPortalSessionMutationOptions = Apollo.BaseMutationOptions<CreateStripeCustomerPortalSessionMutation, CreateStripeCustomerPortalSessionMutationVariables>;
export const CreateUMAPDocument = gql`
    mutation CreateUMAP($workspaceId: String!, $datasetIds: [String]!, $samples: [Int]!, $seed: String, $name: String, $description: String, $tags: [String]) {
  createUMAP(
    workspaceId: $workspaceId
    datasetIds: $datasetIds
    samples: $samples
    seed: $seed
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type CreateUMAPMutationFn = Apollo.MutationFunction<CreateUMAPMutation, CreateUMAPMutationVariables>;

/**
 * __useCreateUMAPMutation__
 *
 * To run a mutation, you first call `useCreateUMAPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUMAPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUmapMutation, { data, loading, error }] = useCreateUMAPMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetIds: // value for 'datasetIds'
 *      samples: // value for 'samples'
 *      seed: // value for 'seed'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateUMAPMutation(baseOptions?: Apollo.MutationHookOptions<CreateUMAPMutation, CreateUMAPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUMAPMutation, CreateUMAPMutationVariables>(CreateUMAPDocument, options);
      }
export type CreateUMAPMutationHookResult = ReturnType<typeof useCreateUMAPMutation>;
export type CreateUMAPMutationResult = Apollo.MutationResult<CreateUMAPMutation>;
export type CreateUMAPMutationOptions = Apollo.BaseMutationOptions<CreateUMAPMutation, CreateUMAPMutationVariables>;
export const CreateVolumeDocument = gql`
    mutation CreateVolume($organizationId: String!, $name: String!, $description: String, $permission: String, $tags: [String]) {
  createVolume(
    organizationId: $organizationId
    name: $name
    description: $description
    permission: $permission
    tags: $tags
  )
}
    `;
export type CreateVolumeMutationFn = Apollo.MutationFunction<CreateVolumeMutation, CreateVolumeMutationVariables>;

/**
 * __useCreateVolumeMutation__
 *
 * To run a mutation, you first call `useCreateVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVolumeMutation, { data, loading, error }] = useCreateVolumeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      permission: // value for 'permission'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateVolumeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVolumeMutation, CreateVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVolumeMutation, CreateVolumeMutationVariables>(CreateVolumeDocument, options);
      }
export type CreateVolumeMutationHookResult = ReturnType<typeof useCreateVolumeMutation>;
export type CreateVolumeMutationResult = Apollo.MutationResult<CreateVolumeMutation>;
export type CreateVolumeMutationOptions = Apollo.BaseMutationOptions<CreateVolumeMutation, CreateVolumeMutationVariables>;
export const CreateVolumeWithTemplateDocument = gql`
    mutation CreateVolumeWithTemplate($organizationId: String!, $volumeId: String!) {
  createVolumeWithTemplate(organizationId: $organizationId, volumeId: $volumeId)
}
    `;
export type CreateVolumeWithTemplateMutationFn = Apollo.MutationFunction<CreateVolumeWithTemplateMutation, CreateVolumeWithTemplateMutationVariables>;

/**
 * __useCreateVolumeWithTemplateMutation__
 *
 * To run a mutation, you first call `useCreateVolumeWithTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVolumeWithTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVolumeWithTemplateMutation, { data, loading, error }] = useCreateVolumeWithTemplateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useCreateVolumeWithTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateVolumeWithTemplateMutation, CreateVolumeWithTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVolumeWithTemplateMutation, CreateVolumeWithTemplateMutationVariables>(CreateVolumeWithTemplateDocument, options);
      }
export type CreateVolumeWithTemplateMutationHookResult = ReturnType<typeof useCreateVolumeWithTemplateMutation>;
export type CreateVolumeWithTemplateMutationResult = Apollo.MutationResult<CreateVolumeWithTemplateMutation>;
export type CreateVolumeWithTemplateMutationOptions = Apollo.BaseMutationOptions<CreateVolumeWithTemplateMutation, CreateVolumeWithTemplateMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation CreateWorkspace($organizationId: String!, $name: String!, $description: String, $objective: String, $channelIds: [String]!, $volumeIds: [String]!, $code: String, $tags: [String], $instance: String, $visibility: String) {
  createWorkspace(
    organizationId: $organizationId
    name: $name
    description: $description
    objective: $objective
    channelIds: $channelIds
    volumeIds: $volumeIds
    code: $code
    tags: $tags
    instance: $instance
    visibility: $visibility
  )
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      objective: // value for 'objective'
 *      channelIds: // value for 'channelIds'
 *      volumeIds: // value for 'volumeIds'
 *      code: // value for 'code'
 *      tags: // value for 'tags'
 *      instance: // value for 'instance'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const CreateWorkspaceWithTemplateDocument = gql`
    mutation CreateWorkspaceWithTemplate($organizationId: String!, $templateId: String!) {
  createWorkspaceWithTemplate(
    organizationId: $organizationId
    templateId: $templateId
  ) {
    editorId
    url
    workspaceId
  }
}
    `;
export type CreateWorkspaceWithTemplateMutationFn = Apollo.MutationFunction<CreateWorkspaceWithTemplateMutation, CreateWorkspaceWithTemplateMutationVariables>;

/**
 * __useCreateWorkspaceWithTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceWithTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceWithTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceWithTemplateMutation, { data, loading, error }] = useCreateWorkspaceWithTemplateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCreateWorkspaceWithTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceWithTemplateMutation, CreateWorkspaceWithTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceWithTemplateMutation, CreateWorkspaceWithTemplateMutationVariables>(CreateWorkspaceWithTemplateDocument, options);
      }
export type CreateWorkspaceWithTemplateMutationHookResult = ReturnType<typeof useCreateWorkspaceWithTemplateMutation>;
export type CreateWorkspaceWithTemplateMutationResult = Apollo.MutationResult<CreateWorkspaceWithTemplateMutation>;
export type CreateWorkspaceWithTemplateMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceWithTemplateMutation, CreateWorkspaceWithTemplateMutationVariables>;
export const DeleteAPIKeyDocument = gql`
    mutation DeleteAPIKey($name: String!) {
  deleteAPIKey(name: $name)
}
    `;
export type DeleteAPIKeyMutationFn = Apollo.MutationFunction<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>;

/**
 * __useDeleteAPIKeyMutation__
 *
 * To run a mutation, you first call `useDeleteAPIKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAPIKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteAPIKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAPIKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>(DeleteAPIKeyDocument, options);
      }
export type DeleteAPIKeyMutationHookResult = ReturnType<typeof useDeleteAPIKeyMutation>;
export type DeleteAPIKeyMutationResult = Apollo.MutationResult<DeleteAPIKeyMutation>;
export type DeleteAPIKeyMutationOptions = Apollo.BaseMutationOptions<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>;
export const DeleteAnalyticsDocument = gql`
    mutation DeleteAnalytics($workspaceId: String!, $analyticsId: String!) {
  deleteAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId)
}
    `;
export type DeleteAnalyticsMutationFn = Apollo.MutationFunction<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>;

/**
 * __useDeleteAnalyticsMutation__
 *
 * To run a mutation, you first call `useDeleteAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalyticsMutation, { data, loading, error }] = useDeleteAnalyticsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useDeleteAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>(DeleteAnalyticsDocument, options);
      }
export type DeleteAnalyticsMutationHookResult = ReturnType<typeof useDeleteAnalyticsMutation>;
export type DeleteAnalyticsMutationResult = Apollo.MutationResult<DeleteAnalyticsMutation>;
export type DeleteAnalyticsMutationOptions = Apollo.BaseMutationOptions<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>;
export const DeleteAnnotationDocument = gql`
    mutation DeleteAnnotation($annotationId: String!, $workspaceId: String!) {
  deleteAnnotation(annotationId: $annotationId, workspaceId: $workspaceId)
}
    `;
export type DeleteAnnotationMutationFn = Apollo.MutationFunction<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>;

/**
 * __useDeleteAnnotationMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMutation, { data, loading, error }] = useDeleteAnnotationMutation({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>(DeleteAnnotationDocument, options);
      }
export type DeleteAnnotationMutationHookResult = ReturnType<typeof useDeleteAnnotationMutation>;
export type DeleteAnnotationMutationResult = Apollo.MutationResult<DeleteAnnotationMutation>;
export type DeleteAnnotationMutationOptions = Apollo.BaseMutationOptions<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>;
export const DeleteAnnotationMapDocument = gql`
    mutation DeleteAnnotationMap($mapId: String!, $organizationId: String) {
  deleteAnnotationMap(mapId: $mapId, organizationId: $organizationId)
}
    `;
export type DeleteAnnotationMapMutationFn = Apollo.MutationFunction<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>;

/**
 * __useDeleteAnnotationMapMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMapMutation, { data, loading, error }] = useDeleteAnnotationMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>(DeleteAnnotationMapDocument, options);
      }
export type DeleteAnnotationMapMutationHookResult = ReturnType<typeof useDeleteAnnotationMapMutation>;
export type DeleteAnnotationMapMutationResult = Apollo.MutationResult<DeleteAnnotationMapMutation>;
export type DeleteAnnotationMapMutationOptions = Apollo.BaseMutationOptions<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>;
export const DeleteChannelDocument = gql`
    mutation DeleteChannel($channelId: String!, $organizationId: String) {
  deleteChannel(channelId: $channelId, organizationId: $organizationId)
}
    `;
export type DeleteChannelMutationFn = Apollo.MutationFunction<DeleteChannelMutation, DeleteChannelMutationVariables>;

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelMutation, DeleteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelMutation, DeleteChannelMutationVariables>(DeleteChannelDocument, options);
      }
export type DeleteChannelMutationHookResult = ReturnType<typeof useDeleteChannelMutation>;
export type DeleteChannelMutationResult = Apollo.MutationResult<DeleteChannelMutation>;
export type DeleteChannelMutationOptions = Apollo.BaseMutationOptions<DeleteChannelMutation, DeleteChannelMutationVariables>;
export const DeleteDatasetDocument = gql`
    mutation DeleteDataset($datasetId: String!, $workspaceId: String!) {
  deleteDataset(datasetId: $datasetId, workspaceId: $workspaceId)
}
    `;
export type DeleteDatasetMutationFn = Apollo.MutationFunction<DeleteDatasetMutation, DeleteDatasetMutationVariables>;

/**
 * __useDeleteDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatasetMutation, { data, loading, error }] = useDeleteDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatasetMutation, DeleteDatasetMutationVariables>(DeleteDatasetDocument, options);
      }
export type DeleteDatasetMutationHookResult = ReturnType<typeof useDeleteDatasetMutation>;
export type DeleteDatasetMutationResult = Apollo.MutationResult<DeleteDatasetMutation>;
export type DeleteDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>;
export const DeleteEditorDocument = gql`
    mutation DeleteEditor($editorId: String!) {
  deleteEditor(editorId: $editorId)
}
    `;
export type DeleteEditorMutationFn = Apollo.MutationFunction<DeleteEditorMutation, DeleteEditorMutationVariables>;

/**
 * __useDeleteEditorMutation__
 *
 * To run a mutation, you first call `useDeleteEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEditorMutation, { data, loading, error }] = useDeleteEditorMutation({
 *   variables: {
 *      editorId: // value for 'editorId'
 *   },
 * });
 */
export function useDeleteEditorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEditorMutation, DeleteEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEditorMutation, DeleteEditorMutationVariables>(DeleteEditorDocument, options);
      }
export type DeleteEditorMutationHookResult = ReturnType<typeof useDeleteEditorMutation>;
export type DeleteEditorMutationResult = Apollo.MutationResult<DeleteEditorMutation>;
export type DeleteEditorMutationOptions = Apollo.BaseMutationOptions<DeleteEditorMutation, DeleteEditorMutationVariables>;
export const DeleteGANDatasetDocument = gql`
    mutation DeleteGANDataset($workspaceId: String!, $datasetId: String!) {
  deleteGANDataset(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;
export type DeleteGANDatasetMutationFn = Apollo.MutationFunction<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>;

/**
 * __useDeleteGANDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteGANDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGANDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGanDatasetMutation, { data, loading, error }] = useDeleteGANDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDeleteGANDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>(DeleteGANDatasetDocument, options);
      }
export type DeleteGANDatasetMutationHookResult = ReturnType<typeof useDeleteGANDatasetMutation>;
export type DeleteGANDatasetMutationResult = Apollo.MutationResult<DeleteGANDatasetMutation>;
export type DeleteGANDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>;
export const DeleteGANModelDocument = gql`
    mutation DeleteGANModel($modelId: String!, $organizationId: String) {
  deleteGANModel(modelId: $modelId, organizationId: $organizationId)
}
    `;
export type DeleteGANModelMutationFn = Apollo.MutationFunction<DeleteGANModelMutation, DeleteGANModelMutationVariables>;

/**
 * __useDeleteGANModelMutation__
 *
 * To run a mutation, you first call `useDeleteGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGanModelMutation, { data, loading, error }] = useDeleteGANModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteGANModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGANModelMutation, DeleteGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGANModelMutation, DeleteGANModelMutationVariables>(DeleteGANModelDocument, options);
      }
export type DeleteGANModelMutationHookResult = ReturnType<typeof useDeleteGANModelMutation>;
export type DeleteGANModelMutationResult = Apollo.MutationResult<DeleteGANModelMutation>;
export type DeleteGANModelMutationOptions = Apollo.BaseMutationOptions<DeleteGANModelMutation, DeleteGANModelMutationVariables>;
export const DeleteGraphDocument = gql`
    mutation DeleteGraph($graphId: String!, $workspaceId: String!) {
  deleteGraph(graphId: $graphId, workspaceId: $workspaceId)
}
    `;
export type DeleteGraphMutationFn = Apollo.MutationFunction<DeleteGraphMutation, DeleteGraphMutationVariables>;

/**
 * __useDeleteGraphMutation__
 *
 * To run a mutation, you first call `useDeleteGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraphMutation, { data, loading, error }] = useDeleteGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteGraphMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGraphMutation, DeleteGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGraphMutation, DeleteGraphMutationVariables>(DeleteGraphDocument, options);
      }
export type DeleteGraphMutationHookResult = ReturnType<typeof useDeleteGraphMutation>;
export type DeleteGraphMutationResult = Apollo.MutationResult<DeleteGraphMutation>;
export type DeleteGraphMutationOptions = Apollo.BaseMutationOptions<DeleteGraphMutation, DeleteGraphMutationVariables>;
export const DeleteInpaintDocument = gql`
    mutation DeleteInpaint($volumeId: String!, $inpaintId: String!) {
  deleteInpaint(volumeId: $volumeId, inpaintId: $inpaintId)
}
    `;
export type DeleteInpaintMutationFn = Apollo.MutationFunction<DeleteInpaintMutation, DeleteInpaintMutationVariables>;

/**
 * __useDeleteInpaintMutation__
 *
 * To run a mutation, you first call `useDeleteInpaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInpaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInpaintMutation, { data, loading, error }] = useDeleteInpaintMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useDeleteInpaintMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInpaintMutation, DeleteInpaintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInpaintMutation, DeleteInpaintMutationVariables>(DeleteInpaintDocument, options);
      }
export type DeleteInpaintMutationHookResult = ReturnType<typeof useDeleteInpaintMutation>;
export type DeleteInpaintMutationResult = Apollo.MutationResult<DeleteInpaintMutation>;
export type DeleteInpaintMutationOptions = Apollo.BaseMutationOptions<DeleteInpaintMutation, DeleteInpaintMutationVariables>;
export const DeleteMcpServerDocument = gql`
    mutation DeleteMcpServer($mcpServerId: String!) {
  deleteMcpServer(mcpServerId: $mcpServerId)
}
    `;
export type DeleteMcpServerMutationFn = Apollo.MutationFunction<DeleteMcpServerMutation, DeleteMcpServerMutationVariables>;

/**
 * __useDeleteMcpServerMutation__
 *
 * To run a mutation, you first call `useDeleteMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMcpServerMutation, { data, loading, error }] = useDeleteMcpServerMutation({
 *   variables: {
 *      mcpServerId: // value for 'mcpServerId'
 *   },
 * });
 */
export function useDeleteMcpServerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMcpServerMutation, DeleteMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMcpServerMutation, DeleteMcpServerMutationVariables>(DeleteMcpServerDocument, options);
      }
export type DeleteMcpServerMutationHookResult = ReturnType<typeof useDeleteMcpServerMutation>;
export type DeleteMcpServerMutationResult = Apollo.MutationResult<DeleteMcpServerMutation>;
export type DeleteMcpServerMutationOptions = Apollo.BaseMutationOptions<DeleteMcpServerMutation, DeleteMcpServerMutationVariables>;
export const DeleteMLInferenceDocument = gql`
    mutation DeleteMLInference($workspaceId: String!, $inferenceId: String!) {
  deleteMLInference(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;
export type DeleteMLInferenceMutationFn = Apollo.MutationFunction<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>;

/**
 * __useDeleteMLInferenceMutation__
 *
 * To run a mutation, you first call `useDeleteMLInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMLInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMlInferenceMutation, { data, loading, error }] = useDeleteMLInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useDeleteMLInferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>(DeleteMLInferenceDocument, options);
      }
export type DeleteMLInferenceMutationHookResult = ReturnType<typeof useDeleteMLInferenceMutation>;
export type DeleteMLInferenceMutationResult = Apollo.MutationResult<DeleteMLInferenceMutation>;
export type DeleteMLInferenceMutationOptions = Apollo.BaseMutationOptions<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>;
export const DeleteMLModelDocument = gql`
    mutation DeleteMLModel($workspaceId: String!, $modelId: String!) {
  deleteMLModel(workspaceId: $workspaceId, modelId: $modelId)
}
    `;
export type DeleteMLModelMutationFn = Apollo.MutationFunction<DeleteMLModelMutation, DeleteMLModelMutationVariables>;

/**
 * __useDeleteMLModelMutation__
 *
 * To run a mutation, you first call `useDeleteMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMlModelMutation, { data, loading, error }] = useDeleteMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDeleteMLModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMLModelMutation, DeleteMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMLModelMutation, DeleteMLModelMutationVariables>(DeleteMLModelDocument, options);
      }
export type DeleteMLModelMutationHookResult = ReturnType<typeof useDeleteMLModelMutation>;
export type DeleteMLModelMutationResult = Apollo.MutationResult<DeleteMLModelMutation>;
export type DeleteMLModelMutationOptions = Apollo.BaseMutationOptions<DeleteMLModelMutation, DeleteMLModelMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($organizationId: String!) {
  deleteOrganization(organizationId: $organizationId)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const DeleteRemoteDevelopmentDocument = gql`
    mutation DeleteRemoteDevelopment($editorSessionId: String!) {
  deleteRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
  }
}
    `;
export type DeleteRemoteDevelopmentMutationFn = Apollo.MutationFunction<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>;

/**
 * __useDeleteRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useDeleteRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRemoteDevelopmentMutation, { data, loading, error }] = useDeleteRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useDeleteRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>(DeleteRemoteDevelopmentDocument, options);
      }
export type DeleteRemoteDevelopmentMutationHookResult = ReturnType<typeof useDeleteRemoteDevelopmentMutation>;
export type DeleteRemoteDevelopmentMutationResult = Apollo.MutationResult<DeleteRemoteDevelopmentMutation>;
export type DeleteRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>;
export const DeleteSecretDocument = gql`
    mutation DeleteSecret($secretId: String!) {
  deleteSecret(secretId: $secretId)
}
    `;
export type DeleteSecretMutationFn = Apollo.MutationFunction<DeleteSecretMutation, DeleteSecretMutationVariables>;

/**
 * __useDeleteSecretMutation__
 *
 * To run a mutation, you first call `useDeleteSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSecretMutation, { data, loading, error }] = useDeleteSecretMutation({
 *   variables: {
 *      secretId: // value for 'secretId'
 *   },
 * });
 */
export function useDeleteSecretMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSecretMutation, DeleteSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSecretMutation, DeleteSecretMutationVariables>(DeleteSecretDocument, options);
      }
export type DeleteSecretMutationHookResult = ReturnType<typeof useDeleteSecretMutation>;
export type DeleteSecretMutationResult = Apollo.MutationResult<DeleteSecretMutation>;
export type DeleteSecretMutationOptions = Apollo.BaseMutationOptions<DeleteSecretMutation, DeleteSecretMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation DeleteService($serviceId: String!) {
  deleteService(serviceId: $serviceId)
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const DeleteSkillDocument = gql`
    mutation DeleteSkill($skillId: String!) {
  deleteSkill(skillId: $skillId)
}
    `;
export type DeleteSkillMutationFn = Apollo.MutationFunction<DeleteSkillMutation, DeleteSkillMutationVariables>;

/**
 * __useDeleteSkillMutation__
 *
 * To run a mutation, you first call `useDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillMutation, { data, loading, error }] = useDeleteSkillMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useDeleteSkillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillMutation, DeleteSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillMutation, DeleteSkillMutationVariables>(DeleteSkillDocument, options);
      }
export type DeleteSkillMutationHookResult = ReturnType<typeof useDeleteSkillMutation>;
export type DeleteSkillMutationResult = Apollo.MutationResult<DeleteSkillMutation>;
export type DeleteSkillMutationOptions = Apollo.BaseMutationOptions<DeleteSkillMutation, DeleteSkillMutationVariables>;
export const DeleteSSHKeyDocument = gql`
    mutation DeleteSSHKey($name: String!) {
  deleteSSHKey(name: $name)
}
    `;
export type DeleteSSHKeyMutationFn = Apollo.MutationFunction<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>;

/**
 * __useDeleteSSHKeyMutation__
 *
 * To run a mutation, you first call `useDeleteSSHKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSSHKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSshKeyMutation, { data, loading, error }] = useDeleteSSHKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteSSHKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>(DeleteSSHKeyDocument, options);
      }
export type DeleteSSHKeyMutationHookResult = ReturnType<typeof useDeleteSSHKeyMutation>;
export type DeleteSSHKeyMutationResult = Apollo.MutationResult<DeleteSSHKeyMutation>;
export type DeleteSSHKeyMutationOptions = Apollo.BaseMutationOptions<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>;
export const DeleteUMAPDocument = gql`
    mutation DeleteUMAP($workspaceId: String!, $umapId: String!) {
  deleteUMAP(workspaceId: $workspaceId, umapId: $umapId)
}
    `;
export type DeleteUMAPMutationFn = Apollo.MutationFunction<DeleteUMAPMutation, DeleteUMAPMutationVariables>;

/**
 * __useDeleteUMAPMutation__
 *
 * To run a mutation, you first call `useDeleteUMAPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUMAPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUmapMutation, { data, loading, error }] = useDeleteUMAPMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useDeleteUMAPMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUMAPMutation, DeleteUMAPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUMAPMutation, DeleteUMAPMutationVariables>(DeleteUMAPDocument, options);
      }
export type DeleteUMAPMutationHookResult = ReturnType<typeof useDeleteUMAPMutation>;
export type DeleteUMAPMutationResult = Apollo.MutationResult<DeleteUMAPMutation>;
export type DeleteUMAPMutationOptions = Apollo.BaseMutationOptions<DeleteUMAPMutation, DeleteUMAPMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser {
  deleteUser
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteVolumeDocument = gql`
    mutation DeleteVolume($volumeId: String!, $organizationId: String) {
  deleteVolume(volumeId: $volumeId, organizationId: $organizationId)
}
    `;
export type DeleteVolumeMutationFn = Apollo.MutationFunction<DeleteVolumeMutation, DeleteVolumeMutationVariables>;

/**
 * __useDeleteVolumeMutation__
 *
 * To run a mutation, you first call `useDeleteVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolumeMutation, { data, loading, error }] = useDeleteVolumeMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteVolumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVolumeMutation, DeleteVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVolumeMutation, DeleteVolumeMutationVariables>(DeleteVolumeDocument, options);
      }
export type DeleteVolumeMutationHookResult = ReturnType<typeof useDeleteVolumeMutation>;
export type DeleteVolumeMutationResult = Apollo.MutationResult<DeleteVolumeMutation>;
export type DeleteVolumeMutationOptions = Apollo.BaseMutationOptions<DeleteVolumeMutation, DeleteVolumeMutationVariables>;
export const DeleteVolumeDataDocument = gql`
    mutation DeleteVolumeData($volumeId: String!, $key: String!) {
  deleteVolumeData(volumeId: $volumeId, key: $key)
}
    `;
export type DeleteVolumeDataMutationFn = Apollo.MutationFunction<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>;

/**
 * __useDeleteVolumeDataMutation__
 *
 * To run a mutation, you first call `useDeleteVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolumeDataMutation, { data, loading, error }] = useDeleteVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>(DeleteVolumeDataDocument, options);
      }
export type DeleteVolumeDataMutationHookResult = ReturnType<typeof useDeleteVolumeDataMutation>;
export type DeleteVolumeDataMutationResult = Apollo.MutationResult<DeleteVolumeDataMutation>;
export type DeleteVolumeDataMutationOptions = Apollo.BaseMutationOptions<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation DeleteWorkspace($workspaceId: String!) {
  deleteWorkspace(workspaceId: $workspaceId)
}
    `;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const DownloadAnnotationDocument = gql`
    mutation DownloadAnnotation($workspaceId: String!, $annotationId: String!) {
  downloadAnnotation(workspaceId: $workspaceId, annotationId: $annotationId)
}
    `;
export type DownloadAnnotationMutationFn = Apollo.MutationFunction<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>;

/**
 * __useDownloadAnnotationMutation__
 *
 * To run a mutation, you first call `useDownloadAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAnnotationMutation, { data, loading, error }] = useDownloadAnnotationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useDownloadAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>(DownloadAnnotationDocument, options);
      }
export type DownloadAnnotationMutationHookResult = ReturnType<typeof useDownloadAnnotationMutation>;
export type DownloadAnnotationMutationResult = Apollo.MutationResult<DownloadAnnotationMutation>;
export type DownloadAnnotationMutationOptions = Apollo.BaseMutationOptions<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>;
export const DownloadAnnotationMapDocument = gql`
    mutation DownloadAnnotationMap($mapId: String!) {
  downloadAnnotationMap(mapId: $mapId)
}
    `;
export type DownloadAnnotationMapMutationFn = Apollo.MutationFunction<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>;

/**
 * __useDownloadAnnotationMapMutation__
 *
 * To run a mutation, you first call `useDownloadAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAnnotationMapMutation, { data, loading, error }] = useDownloadAnnotationMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *   },
 * });
 */
export function useDownloadAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>(DownloadAnnotationMapDocument, options);
      }
export type DownloadAnnotationMapMutationHookResult = ReturnType<typeof useDownloadAnnotationMapMutation>;
export type DownloadAnnotationMapMutationResult = Apollo.MutationResult<DownloadAnnotationMapMutation>;
export type DownloadAnnotationMapMutationOptions = Apollo.BaseMutationOptions<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>;
export const DownloadDatasetDocument = gql`
    mutation DownloadDataset($workspaceId: String!, $datasetId: String!) {
  downloadDataset(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;
export type DownloadDatasetMutationFn = Apollo.MutationFunction<DownloadDatasetMutation, DownloadDatasetMutationVariables>;

/**
 * __useDownloadDatasetMutation__
 *
 * To run a mutation, you first call `useDownloadDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDatasetMutation, { data, loading, error }] = useDownloadDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDownloadDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DownloadDatasetMutation, DownloadDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadDatasetMutation, DownloadDatasetMutationVariables>(DownloadDatasetDocument, options);
      }
export type DownloadDatasetMutationHookResult = ReturnType<typeof useDownloadDatasetMutation>;
export type DownloadDatasetMutationResult = Apollo.MutationResult<DownloadDatasetMutation>;
export type DownloadDatasetMutationOptions = Apollo.BaseMutationOptions<DownloadDatasetMutation, DownloadDatasetMutationVariables>;
export const DownloadGANModelDocument = gql`
    mutation DownloadGANModel($modelId: String!) {
  downloadGANModel(modelId: $modelId)
}
    `;
export type DownloadGANModelMutationFn = Apollo.MutationFunction<DownloadGANModelMutation, DownloadGANModelMutationVariables>;

/**
 * __useDownloadGANModelMutation__
 *
 * To run a mutation, you first call `useDownloadGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGanModelMutation, { data, loading, error }] = useDownloadGANModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDownloadGANModelMutation(baseOptions?: Apollo.MutationHookOptions<DownloadGANModelMutation, DownloadGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGANModelMutation, DownloadGANModelMutationVariables>(DownloadGANModelDocument, options);
      }
export type DownloadGANModelMutationHookResult = ReturnType<typeof useDownloadGANModelMutation>;
export type DownloadGANModelMutationResult = Apollo.MutationResult<DownloadGANModelMutation>;
export type DownloadGANModelMutationOptions = Apollo.BaseMutationOptions<DownloadGANModelMutation, DownloadGANModelMutationVariables>;
export const DownloadGraphDocument = gql`
    mutation DownloadGraph($workspaceId: String!, $graphId: String!) {
  downloadGraph(workspaceId: $workspaceId, graphId: $graphId)
}
    `;
export type DownloadGraphMutationFn = Apollo.MutationFunction<DownloadGraphMutation, DownloadGraphMutationVariables>;

/**
 * __useDownloadGraphMutation__
 *
 * To run a mutation, you first call `useDownloadGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGraphMutation, { data, loading, error }] = useDownloadGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useDownloadGraphMutation(baseOptions?: Apollo.MutationHookOptions<DownloadGraphMutation, DownloadGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGraphMutation, DownloadGraphMutationVariables>(DownloadGraphDocument, options);
      }
export type DownloadGraphMutationHookResult = ReturnType<typeof useDownloadGraphMutation>;
export type DownloadGraphMutationResult = Apollo.MutationResult<DownloadGraphMutation>;
export type DownloadGraphMutationOptions = Apollo.BaseMutationOptions<DownloadGraphMutation, DownloadGraphMutationVariables>;
export const DownloadMLInferenceDocument = gql`
    mutation DownloadMLInference($workspaceId: String!, $inferenceId: String!) {
  downloadMLInference(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;
export type DownloadMLInferenceMutationFn = Apollo.MutationFunction<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>;

/**
 * __useDownloadMLInferenceMutation__
 *
 * To run a mutation, you first call `useDownloadMLInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMLInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMlInferenceMutation, { data, loading, error }] = useDownloadMLInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useDownloadMLInferenceMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>(DownloadMLInferenceDocument, options);
      }
export type DownloadMLInferenceMutationHookResult = ReturnType<typeof useDownloadMLInferenceMutation>;
export type DownloadMLInferenceMutationResult = Apollo.MutationResult<DownloadMLInferenceMutation>;
export type DownloadMLInferenceMutationOptions = Apollo.BaseMutationOptions<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>;
export const DownloadMLModelDocument = gql`
    mutation DownloadMLModel($workspaceId: String!, $modelId: String!, $checkpoint: String) {
  downloadMLModel(
    workspaceId: $workspaceId
    modelId: $modelId
    checkpoint: $checkpoint
  )
}
    `;
export type DownloadMLModelMutationFn = Apollo.MutationFunction<DownloadMLModelMutation, DownloadMLModelMutationVariables>;

/**
 * __useDownloadMLModelMutation__
 *
 * To run a mutation, you first call `useDownloadMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMlModelMutation, { data, loading, error }] = useDownloadMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      checkpoint: // value for 'checkpoint'
 *   },
 * });
 */
export function useDownloadMLModelMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMLModelMutation, DownloadMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMLModelMutation, DownloadMLModelMutationVariables>(DownloadMLModelDocument, options);
      }
export type DownloadMLModelMutationHookResult = ReturnType<typeof useDownloadMLModelMutation>;
export type DownloadMLModelMutationResult = Apollo.MutationResult<DownloadMLModelMutation>;
export type DownloadMLModelMutationOptions = Apollo.BaseMutationOptions<DownloadMLModelMutation, DownloadMLModelMutationVariables>;
export const DuplicateGraphDocument = gql`
    mutation DuplicateGraph($workspaceId: String!, $graphId: String!, $name: String, $description: String, $tags: [String]) {
  duplicateGraph(
    workspaceId: $workspaceId
    graphId: $graphId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type DuplicateGraphMutationFn = Apollo.MutationFunction<DuplicateGraphMutation, DuplicateGraphMutationVariables>;

/**
 * __useDuplicateGraphMutation__
 *
 * To run a mutation, you first call `useDuplicateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateGraphMutation, { data, loading, error }] = useDuplicateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDuplicateGraphMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateGraphMutation, DuplicateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateGraphMutation, DuplicateGraphMutationVariables>(DuplicateGraphDocument, options);
      }
export type DuplicateGraphMutationHookResult = ReturnType<typeof useDuplicateGraphMutation>;
export type DuplicateGraphMutationResult = Apollo.MutationResult<DuplicateGraphMutation>;
export type DuplicateGraphMutationOptions = Apollo.BaseMutationOptions<DuplicateGraphMutation, DuplicateGraphMutationVariables>;
export const DuplicateWorkspaceDocument = gql`
    mutation DuplicateWorkspace($workspaceId: String!, $name: String, $description: String, $objective: String, $tags: [String], $serviceIds: [String], $volumeIds: [String]) {
  duplicateWorkspace(
    workspaceId: $workspaceId
    name: $name
    description: $description
    objective: $objective
    tags: $tags
    serviceIds: $serviceIds
    volumeIds: $volumeIds
  )
}
    `;
export type DuplicateWorkspaceMutationFn = Apollo.MutationFunction<DuplicateWorkspaceMutation, DuplicateWorkspaceMutationVariables>;

/**
 * __useDuplicateWorkspaceMutation__
 *
 * To run a mutation, you first call `useDuplicateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateWorkspaceMutation, { data, loading, error }] = useDuplicateWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      objective: // value for 'objective'
 *      tags: // value for 'tags'
 *      serviceIds: // value for 'serviceIds'
 *      volumeIds: // value for 'volumeIds'
 *   },
 * });
 */
export function useDuplicateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateWorkspaceMutation, DuplicateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateWorkspaceMutation, DuplicateWorkspaceMutationVariables>(DuplicateWorkspaceDocument, options);
      }
export type DuplicateWorkspaceMutationHookResult = ReturnType<typeof useDuplicateWorkspaceMutation>;
export type DuplicateWorkspaceMutationResult = Apollo.MutationResult<DuplicateWorkspaceMutation>;
export type DuplicateWorkspaceMutationOptions = Apollo.BaseMutationOptions<DuplicateWorkspaceMutation, DuplicateWorkspaceMutationVariables>;
export const EditAnnotationMapDocument = gql`
    mutation EditAnnotationMap($mapId: String!, $name: String, $description: String, $tags: [String]) {
  editAnnotationMap(
    mapId: $mapId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditAnnotationMapMutationFn = Apollo.MutationFunction<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>;

/**
 * __useEditAnnotationMapMutation__
 *
 * To run a mutation, you first call `useEditAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAnnotationMapMutation, { data, loading, error }] = useEditAnnotationMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>(EditAnnotationMapDocument, options);
      }
export type EditAnnotationMapMutationHookResult = ReturnType<typeof useEditAnnotationMapMutation>;
export type EditAnnotationMapMutationResult = Apollo.MutationResult<EditAnnotationMapMutation>;
export type EditAnnotationMapMutationOptions = Apollo.BaseMutationOptions<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>;
export const EditChannelDocument = gql`
    mutation EditChannel($channelId: String!, $name: String, $description: String, $volumes: [String], $instance: String, $timeout: Int, $status: String, $interfaceVersion: Int, $preview: Boolean, $tags: [String]) {
  editChannel(
    channelId: $channelId
    name: $name
    description: $description
    volumes: $volumes
    instance: $instance
    timeout: $timeout
    status: $status
    interfaceVersion: $interfaceVersion
    preview: $preview
    tags: $tags
  )
}
    `;
export type EditChannelMutationFn = Apollo.MutationFunction<EditChannelMutation, EditChannelMutationVariables>;

/**
 * __useEditChannelMutation__
 *
 * To run a mutation, you first call `useEditChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChannelMutation, { data, loading, error }] = useEditChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      volumes: // value for 'volumes'
 *      instance: // value for 'instance'
 *      timeout: // value for 'timeout'
 *      status: // value for 'status'
 *      interfaceVersion: // value for 'interfaceVersion'
 *      preview: // value for 'preview'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditChannelMutation(baseOptions?: Apollo.MutationHookOptions<EditChannelMutation, EditChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditChannelMutation, EditChannelMutationVariables>(EditChannelDocument, options);
      }
export type EditChannelMutationHookResult = ReturnType<typeof useEditChannelMutation>;
export type EditChannelMutationResult = Apollo.MutationResult<EditChannelMutation>;
export type EditChannelMutationOptions = Apollo.BaseMutationOptions<EditChannelMutation, EditChannelMutationVariables>;
export const EditDatasetDocument = gql`
    mutation EditDataset($workspaceId: String!, $datasetId: String!, $name: String, $description: String, $showJob: Boolean, $pause: Boolean, $priority: Int, $tags: [String]) {
  editDataset(
    workspaceId: $workspaceId
    datasetId: $datasetId
    name: $name
    description: $description
    showJob: $showJob
    pause: $pause
    priority: $priority
    tags: $tags
  )
}
    `;
export type EditDatasetMutationFn = Apollo.MutationFunction<EditDatasetMutation, EditDatasetMutationVariables>;

/**
 * __useEditDatasetMutation__
 *
 * To run a mutation, you first call `useEditDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDatasetMutation, { data, loading, error }] = useEditDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      showJob: // value for 'showJob'
 *      pause: // value for 'pause'
 *      priority: // value for 'priority'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditDatasetMutation(baseOptions?: Apollo.MutationHookOptions<EditDatasetMutation, EditDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDatasetMutation, EditDatasetMutationVariables>(EditDatasetDocument, options);
      }
export type EditDatasetMutationHookResult = ReturnType<typeof useEditDatasetMutation>;
export type EditDatasetMutationResult = Apollo.MutationResult<EditDatasetMutation>;
export type EditDatasetMutationOptions = Apollo.BaseMutationOptions<EditDatasetMutation, EditDatasetMutationVariables>;
export const EditEditorDocument = gql`
    mutation EditEditor($editorId: String, $name: String, $instanceType: String, $autoStopEnabled: Boolean, $autoStopCpuThreshold: Int, $autoStopTimeoutMinutes: Int, $autoDeleteEnabled: Boolean, $autoDeleteTimeoutDays: Int, $autoUpdateEnabled: Boolean, $visibility: String) {
  editEditor(
    editorId: $editorId
    name: $name
    instanceType: $instanceType
    autoStopEnabled: $autoStopEnabled
    autoStopCpuThreshold: $autoStopCpuThreshold
    autoStopTimeoutMinutes: $autoStopTimeoutMinutes
    autoDeleteEnabled: $autoDeleteEnabled
    autoDeleteTimeoutDays: $autoDeleteTimeoutDays
    autoUpdateEnabled: $autoUpdateEnabled
    visibility: $visibility
  )
}
    `;
export type EditEditorMutationFn = Apollo.MutationFunction<EditEditorMutation, EditEditorMutationVariables>;

/**
 * __useEditEditorMutation__
 *
 * To run a mutation, you first call `useEditEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEditorMutation, { data, loading, error }] = useEditEditorMutation({
 *   variables: {
 *      editorId: // value for 'editorId'
 *      name: // value for 'name'
 *      instanceType: // value for 'instanceType'
 *      autoStopEnabled: // value for 'autoStopEnabled'
 *      autoStopCpuThreshold: // value for 'autoStopCpuThreshold'
 *      autoStopTimeoutMinutes: // value for 'autoStopTimeoutMinutes'
 *      autoDeleteEnabled: // value for 'autoDeleteEnabled'
 *      autoDeleteTimeoutDays: // value for 'autoDeleteTimeoutDays'
 *      autoUpdateEnabled: // value for 'autoUpdateEnabled'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useEditEditorMutation(baseOptions?: Apollo.MutationHookOptions<EditEditorMutation, EditEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEditorMutation, EditEditorMutationVariables>(EditEditorDocument, options);
      }
export type EditEditorMutationHookResult = ReturnType<typeof useEditEditorMutation>;
export type EditEditorMutationResult = Apollo.MutationResult<EditEditorMutation>;
export type EditEditorMutationOptions = Apollo.BaseMutationOptions<EditEditorMutation, EditEditorMutationVariables>;
export const AddEditorMembersDocument = gql`
    mutation AddEditorMembers($editorId: String!, $emails: [String]!) {
  addEditorMembers(editorId: $editorId, emails: $emails)
}
    `;
export type AddEditorMembersMutationFn = Apollo.MutationFunction<AddEditorMembersMutation, AddEditorMembersMutationVariables>;

/**
 * __useAddEditorMembersMutation__
 *
 * To run a mutation, you first call `useAddEditorMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditorMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditorMembersMutation, { data, loading, error }] = useAddEditorMembersMutation({
 *   variables: {
 *      editorId: // value for 'editorId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useAddEditorMembersMutation(baseOptions?: Apollo.MutationHookOptions<AddEditorMembersMutation, AddEditorMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditorMembersMutation, AddEditorMembersMutationVariables>(AddEditorMembersDocument, options);
      }
export type AddEditorMembersMutationHookResult = ReturnType<typeof useAddEditorMembersMutation>;
export type AddEditorMembersMutationResult = Apollo.MutationResult<AddEditorMembersMutation>;
export type AddEditorMembersMutationOptions = Apollo.BaseMutationOptions<AddEditorMembersMutation, AddEditorMembersMutationVariables>;
export const RemoveEditorMembersDocument = gql`
    mutation RemoveEditorMembers($editorId: String!, $emails: [String]!) {
  removeEditorMembers(editorId: $editorId, emails: $emails)
}
    `;
export type RemoveEditorMembersMutationFn = Apollo.MutationFunction<RemoveEditorMembersMutation, RemoveEditorMembersMutationVariables>;

/**
 * __useRemoveEditorMembersMutation__
 *
 * To run a mutation, you first call `useRemoveEditorMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEditorMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEditorMembersMutation, { data, loading, error }] = useRemoveEditorMembersMutation({
 *   variables: {
 *      editorId: // value for 'editorId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useRemoveEditorMembersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEditorMembersMutation, RemoveEditorMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEditorMembersMutation, RemoveEditorMembersMutationVariables>(RemoveEditorMembersDocument, options);
      }
export type RemoveEditorMembersMutationHookResult = ReturnType<typeof useRemoveEditorMembersMutation>;
export type RemoveEditorMembersMutationResult = Apollo.MutationResult<RemoveEditorMembersMutation>;
export type RemoveEditorMembersMutationOptions = Apollo.BaseMutationOptions<RemoveEditorMembersMutation, RemoveEditorMembersMutationVariables>;
export const EditGANModelDocument = gql`
    mutation EditGANModel($modelId: String!, $name: String, $description: String, $flags: String, $tags: [String]) {
  editGANModel(
    modelId: $modelId
    name: $name
    description: $description
    flags: $flags
    tags: $tags
  )
}
    `;
export type EditGANModelMutationFn = Apollo.MutationFunction<EditGANModelMutation, EditGANModelMutationVariables>;

/**
 * __useEditGANModelMutation__
 *
 * To run a mutation, you first call `useEditGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGanModelMutation, { data, loading, error }] = useEditGANModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      flags: // value for 'flags'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditGANModelMutation(baseOptions?: Apollo.MutationHookOptions<EditGANModelMutation, EditGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGANModelMutation, EditGANModelMutationVariables>(EditGANModelDocument, options);
      }
export type EditGANModelMutationHookResult = ReturnType<typeof useEditGANModelMutation>;
export type EditGANModelMutationResult = Apollo.MutationResult<EditGANModelMutation>;
export type EditGANModelMutationOptions = Apollo.BaseMutationOptions<EditGANModelMutation, EditGANModelMutationVariables>;
export const EditGraphDocument = gql`
    mutation EditGraph($workspaceId: String!, $graphId: String!, $name: String, $description: String, $graph: String, $tags: [String]) {
  editGraph(
    workspaceId: $workspaceId
    graphId: $graphId
    name: $name
    description: $description
    graph: $graph
    tags: $tags
  )
}
    `;
export type EditGraphMutationFn = Apollo.MutationFunction<EditGraphMutation, EditGraphMutationVariables>;

/**
 * __useEditGraphMutation__
 *
 * To run a mutation, you first call `useEditGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGraphMutation, { data, loading, error }] = useEditGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      graph: // value for 'graph'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditGraphMutation(baseOptions?: Apollo.MutationHookOptions<EditGraphMutation, EditGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGraphMutation, EditGraphMutationVariables>(EditGraphDocument, options);
      }
export type EditGraphMutationHookResult = ReturnType<typeof useEditGraphMutation>;
export type EditGraphMutationResult = Apollo.MutationResult<EditGraphMutation>;
export type EditGraphMutationOptions = Apollo.BaseMutationOptions<EditGraphMutation, EditGraphMutationVariables>;
export const EditMcpServerDocument = gql`
    mutation EditMcpServer($mcpServerId: String!, $name: String, $description: String, $config: String, $enabled: Boolean) {
  editMcpServer(
    mcpServerId: $mcpServerId
    name: $name
    description: $description
    config: $config
    enabled: $enabled
  ) {
    config
    createdAt
    createdBy
    description
    enabled
    mcpServerId
    name
    organizationId
    scopeType
    updatedAt
    updatedBy
    userId
    workspaceId
  }
}
    `;
export type EditMcpServerMutationFn = Apollo.MutationFunction<EditMcpServerMutation, EditMcpServerMutationVariables>;

/**
 * __useEditMcpServerMutation__
 *
 * To run a mutation, you first call `useEditMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMcpServerMutation, { data, loading, error }] = useEditMcpServerMutation({
 *   variables: {
 *      mcpServerId: // value for 'mcpServerId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      config: // value for 'config'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEditMcpServerMutation(baseOptions?: Apollo.MutationHookOptions<EditMcpServerMutation, EditMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMcpServerMutation, EditMcpServerMutationVariables>(EditMcpServerDocument, options);
      }
export type EditMcpServerMutationHookResult = ReturnType<typeof useEditMcpServerMutation>;
export type EditMcpServerMutationResult = Apollo.MutationResult<EditMcpServerMutation>;
export type EditMcpServerMutationOptions = Apollo.BaseMutationOptions<EditMcpServerMutation, EditMcpServerMutationVariables>;
export const EditMLModelDocument = gql`
    mutation EditMLModel($workspaceId: String!, $modelId: String!, $name: String, $description: String, $tags: [String]) {
  editMLModel(
    workspaceId: $workspaceId
    modelId: $modelId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditMLModelMutationFn = Apollo.MutationFunction<EditMLModelMutation, EditMLModelMutationVariables>;

/**
 * __useEditMLModelMutation__
 *
 * To run a mutation, you first call `useEditMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMlModelMutation, { data, loading, error }] = useEditMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditMLModelMutation(baseOptions?: Apollo.MutationHookOptions<EditMLModelMutation, EditMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMLModelMutation, EditMLModelMutationVariables>(EditMLModelDocument, options);
      }
export type EditMLModelMutationHookResult = ReturnType<typeof useEditMLModelMutation>;
export type EditMLModelMutationResult = Apollo.MutationResult<EditMLModelMutation>;
export type EditMLModelMutationOptions = Apollo.BaseMutationOptions<EditMLModelMutation, EditMLModelMutationVariables>;
export const EditMemberDocument = gql`
    mutation EditMember($organizationId: String, $email: String!, $role: String!) {
  editMember(organizationId: $organizationId, email: $email, role: $role)
}
    `;
export type EditMemberMutationFn = Apollo.MutationFunction<EditMemberMutation, EditMemberMutationVariables>;

/**
 * __useEditMemberMutation__
 *
 * To run a mutation, you first call `useEditMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMemberMutation, { data, loading, error }] = useEditMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useEditMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditMemberMutation, EditMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMemberMutation, EditMemberMutationVariables>(EditMemberDocument, options);
      }
export type EditMemberMutationHookResult = ReturnType<typeof useEditMemberMutation>;
export type EditMemberMutationResult = Apollo.MutationResult<EditMemberMutation>;
export type EditMemberMutationOptions = Apollo.BaseMutationOptions<EditMemberMutation, EditMemberMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($organizationId: String!, $name: String!) {
  editOrganization(organizationId: $organizationId, name: $name)
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const EditOrganizationRulesDocument = gql`
    mutation EditOrganizationRules($organizationId: String, $rules: String) {
  editOrganizationRules(organizationId: $organizationId, rules: $rules)
}
    `;
export type EditOrganizationRulesMutationFn = Apollo.MutationFunction<EditOrganizationRulesMutation, EditOrganizationRulesMutationVariables>;

/**
 * __useEditOrganizationRulesMutation__
 *
 * To run a mutation, you first call `useEditOrganizationRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationRulesMutation, { data, loading, error }] = useEditOrganizationRulesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useEditOrganizationRulesMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationRulesMutation, EditOrganizationRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationRulesMutation, EditOrganizationRulesMutationVariables>(EditOrganizationRulesDocument, options);
      }
export type EditOrganizationRulesMutationHookResult = ReturnType<typeof useEditOrganizationRulesMutation>;
export type EditOrganizationRulesMutationResult = Apollo.MutationResult<EditOrganizationRulesMutation>;
export type EditOrganizationRulesMutationOptions = Apollo.BaseMutationOptions<EditOrganizationRulesMutation, EditOrganizationRulesMutationVariables>;
export const EditSecretDocument = gql`
    mutation EditSecret($secretId: String!, $workspaceIds: [String], $includeInAllWorkspaces: Boolean, $value: String) {
  editSecret(
    secretId: $secretId
    workspaceIds: $workspaceIds
    includeInAllWorkspaces: $includeInAllWorkspaces
    value: $value
  )
}
    `;
export type EditSecretMutationFn = Apollo.MutationFunction<EditSecretMutation, EditSecretMutationVariables>;

/**
 * __useEditSecretMutation__
 *
 * To run a mutation, you first call `useEditSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSecretMutation, { data, loading, error }] = useEditSecretMutation({
 *   variables: {
 *      secretId: // value for 'secretId'
 *      workspaceIds: // value for 'workspaceIds'
 *      includeInAllWorkspaces: // value for 'includeInAllWorkspaces'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useEditSecretMutation(baseOptions?: Apollo.MutationHookOptions<EditSecretMutation, EditSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSecretMutation, EditSecretMutationVariables>(EditSecretDocument, options);
      }
export type EditSecretMutationHookResult = ReturnType<typeof useEditSecretMutation>;
export type EditSecretMutationResult = Apollo.MutationResult<EditSecretMutation>;
export type EditSecretMutationOptions = Apollo.BaseMutationOptions<EditSecretMutation, EditSecretMutationVariables>;
export const EditServiceDocument = gql`
    mutation EditService($serviceId: String!, $name: String, $description: String, $instance: String, $volumes: [String], $tags: [String]) {
  editService(
    serviceId: $serviceId
    name: $name
    description: $description
    instance: $instance
    volumes: $volumes
    tags: $tags
  )
}
    `;
export type EditServiceMutationFn = Apollo.MutationFunction<EditServiceMutation, EditServiceMutationVariables>;

/**
 * __useEditServiceMutation__
 *
 * To run a mutation, you first call `useEditServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editServiceMutation, { data, loading, error }] = useEditServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      instance: // value for 'instance'
 *      volumes: // value for 'volumes'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditServiceMutation(baseOptions?: Apollo.MutationHookOptions<EditServiceMutation, EditServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditServiceMutation, EditServiceMutationVariables>(EditServiceDocument, options);
      }
export type EditServiceMutationHookResult = ReturnType<typeof useEditServiceMutation>;
export type EditServiceMutationResult = Apollo.MutationResult<EditServiceMutation>;
export type EditServiceMutationOptions = Apollo.BaseMutationOptions<EditServiceMutation, EditServiceMutationVariables>;
export const EditServiceRulesDocument = gql`
    mutation EditServiceRules($serviceId: String, $rules: String) {
  editServiceRules(serviceId: $serviceId, rules: $rules)
}
    `;
export type EditServiceRulesMutationFn = Apollo.MutationFunction<EditServiceRulesMutation, EditServiceRulesMutationVariables>;

/**
 * __useEditServiceRulesMutation__
 *
 * To run a mutation, you first call `useEditServiceRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editServiceRulesMutation, { data, loading, error }] = useEditServiceRulesMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useEditServiceRulesMutation(baseOptions?: Apollo.MutationHookOptions<EditServiceRulesMutation, EditServiceRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditServiceRulesMutation, EditServiceRulesMutationVariables>(EditServiceRulesDocument, options);
      }
export type EditServiceRulesMutationHookResult = ReturnType<typeof useEditServiceRulesMutation>;
export type EditServiceRulesMutationResult = Apollo.MutationResult<EditServiceRulesMutation>;
export type EditServiceRulesMutationOptions = Apollo.BaseMutationOptions<EditServiceRulesMutation, EditServiceRulesMutationVariables>;
export const EditSkillDocument = gql`
    mutation EditSkill($skillId: String!, $name: String, $description: String, $version: String, $config: String, $enabled: Boolean) {
  editSkill(
    skillId: $skillId
    name: $name
    description: $description
    version: $version
    config: $config
    enabled: $enabled
  )
}
    `;
export type EditSkillMutationFn = Apollo.MutationFunction<EditSkillMutation, EditSkillMutationVariables>;

/**
 * __useEditSkillMutation__
 *
 * To run a mutation, you first call `useEditSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillMutation, { data, loading, error }] = useEditSkillMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      version: // value for 'version'
 *      config: // value for 'config'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEditSkillMutation(baseOptions?: Apollo.MutationHookOptions<EditSkillMutation, EditSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSkillMutation, EditSkillMutationVariables>(EditSkillDocument, options);
      }
export type EditSkillMutationHookResult = ReturnType<typeof useEditSkillMutation>;
export type EditSkillMutationResult = Apollo.MutationResult<EditSkillMutation>;
export type EditSkillMutationOptions = Apollo.BaseMutationOptions<EditSkillMutation, EditSkillMutationVariables>;
export const EditUMAPDocument = gql`
    mutation EditUMAP($workspaceId: String!, $umapId: String!, $name: String!, $description: String, $tags: [String]) {
  editUMAP(
    workspaceId: $workspaceId
    umapId: $umapId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditUMAPMutationFn = Apollo.MutationFunction<EditUMAPMutation, EditUMAPMutationVariables>;

/**
 * __useEditUMAPMutation__
 *
 * To run a mutation, you first call `useEditUMAPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUMAPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUmapMutation, { data, loading, error }] = useEditUMAPMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditUMAPMutation(baseOptions?: Apollo.MutationHookOptions<EditUMAPMutation, EditUMAPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUMAPMutation, EditUMAPMutationVariables>(EditUMAPDocument, options);
      }
export type EditUMAPMutationHookResult = ReturnType<typeof useEditUMAPMutation>;
export type EditUMAPMutationResult = Apollo.MutationResult<EditUMAPMutation>;
export type EditUMAPMutationOptions = Apollo.BaseMutationOptions<EditUMAPMutation, EditUMAPMutationVariables>;
export const EditUserDocument = gql`
    mutation EditUser($email: String!, $name: String!) {
  editUser(email: $email, name: $name)
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const EditUserRulesDocument = gql`
    mutation EditUserRules($rules: String) {
  editUserRules(rules: $rules)
}
    `;
export type EditUserRulesMutationFn = Apollo.MutationFunction<EditUserRulesMutation, EditUserRulesMutationVariables>;

/**
 * __useEditUserRulesMutation__
 *
 * To run a mutation, you first call `useEditUserRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserRulesMutation, { data, loading, error }] = useEditUserRulesMutation({
 *   variables: {
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useEditUserRulesMutation(baseOptions?: Apollo.MutationHookOptions<EditUserRulesMutation, EditUserRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserRulesMutation, EditUserRulesMutationVariables>(EditUserRulesDocument, options);
      }
export type EditUserRulesMutationHookResult = ReturnType<typeof useEditUserRulesMutation>;
export type EditUserRulesMutationResult = Apollo.MutationResult<EditUserRulesMutation>;
export type EditUserRulesMutationOptions = Apollo.BaseMutationOptions<EditUserRulesMutation, EditUserRulesMutationVariables>;
export const EditVolumeDocument = gql`
    mutation EditVolume($volumeId: String!, $name: String, $description: String, $permission: String, $tags: [String]) {
  editVolume(
    volumeId: $volumeId
    name: $name
    description: $description
    permission: $permission
    tags: $tags
  )
}
    `;
export type EditVolumeMutationFn = Apollo.MutationFunction<EditVolumeMutation, EditVolumeMutationVariables>;

/**
 * __useEditVolumeMutation__
 *
 * To run a mutation, you first call `useEditVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVolumeMutation, { data, loading, error }] = useEditVolumeMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      permission: // value for 'permission'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditVolumeMutation(baseOptions?: Apollo.MutationHookOptions<EditVolumeMutation, EditVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVolumeMutation, EditVolumeMutationVariables>(EditVolumeDocument, options);
      }
export type EditVolumeMutationHookResult = ReturnType<typeof useEditVolumeMutation>;
export type EditVolumeMutationResult = Apollo.MutationResult<EditVolumeMutation>;
export type EditVolumeMutationOptions = Apollo.BaseMutationOptions<EditVolumeMutation, EditVolumeMutationVariables>;
export const EditVolumeDataDocument = gql`
    mutation EditVolumeData($volumeId: String!, $source: String!, $key: String!) {
  editVolumeData(volumeId: $volumeId, source: $source, key: $key)
}
    `;
export type EditVolumeDataMutationFn = Apollo.MutationFunction<EditVolumeDataMutation, EditVolumeDataMutationVariables>;

/**
 * __useEditVolumeDataMutation__
 *
 * To run a mutation, you first call `useEditVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVolumeDataMutation, { data, loading, error }] = useEditVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      source: // value for 'source'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useEditVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<EditVolumeDataMutation, EditVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVolumeDataMutation, EditVolumeDataMutationVariables>(EditVolumeDataDocument, options);
      }
export type EditVolumeDataMutationHookResult = ReturnType<typeof useEditVolumeDataMutation>;
export type EditVolumeDataMutationResult = Apollo.MutationResult<EditVolumeDataMutation>;
export type EditVolumeDataMutationOptions = Apollo.BaseMutationOptions<EditVolumeDataMutation, EditVolumeDataMutationVariables>;
export const EditWorkspaceDocument = gql`
    mutation EditWorkspace($workspaceId: String!, $name: String, $description: String, $objective: String, $channelIds: [String], $volumeIds: [String], $ganIds: [String], $mapIds: [String], $tags: [String], $visibility: String) {
  editWorkspace(
    workspaceId: $workspaceId
    name: $name
    description: $description
    objective: $objective
    channelIds: $channelIds
    volumeIds: $volumeIds
    ganIds: $ganIds
    mapIds: $mapIds
    tags: $tags
    visibility: $visibility
  )
}
    `;
export type EditWorkspaceMutationFn = Apollo.MutationFunction<EditWorkspaceMutation, EditWorkspaceMutationVariables>;

/**
 * __useEditWorkspaceMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceMutation, { data, loading, error }] = useEditWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      objective: // value for 'objective'
 *      channelIds: // value for 'channelIds'
 *      volumeIds: // value for 'volumeIds'
 *      ganIds: // value for 'ganIds'
 *      mapIds: // value for 'mapIds'
 *      tags: // value for 'tags'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useEditWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceMutation, EditWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceMutation, EditWorkspaceMutationVariables>(EditWorkspaceDocument, options);
      }
export type EditWorkspaceMutationHookResult = ReturnType<typeof useEditWorkspaceMutation>;
export type EditWorkspaceMutationResult = Apollo.MutationResult<EditWorkspaceMutation>;
export type EditWorkspaceMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceMutation, EditWorkspaceMutationVariables>;
export const EditWorkspaceRulesDocument = gql`
    mutation EditWorkspaceRules($workspaceId: String, $rules: String) {
  editWorkspaceRules(workspaceId: $workspaceId, rules: $rules)
}
    `;
export type EditWorkspaceRulesMutationFn = Apollo.MutationFunction<EditWorkspaceRulesMutation, EditWorkspaceRulesMutationVariables>;

/**
 * __useEditWorkspaceRulesMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceRulesMutation, { data, loading, error }] = useEditWorkspaceRulesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useEditWorkspaceRulesMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceRulesMutation, EditWorkspaceRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceRulesMutation, EditWorkspaceRulesMutationVariables>(EditWorkspaceRulesDocument, options);
      }
export type EditWorkspaceRulesMutationHookResult = ReturnType<typeof useEditWorkspaceRulesMutation>;
export type EditWorkspaceRulesMutationResult = Apollo.MutationResult<EditWorkspaceRulesMutation>;
export type EditWorkspaceRulesMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceRulesMutation, EditWorkspaceRulesMutationVariables>;
export const EditWorkspaceThumbnailDocument = gql`
    mutation EditWorkspaceThumbnail($workspaceId: String!, $thumbnail: String!) {
  editWorkspaceThumbnail(workspaceId: $workspaceId, thumbnail: $thumbnail)
}
    `;
export type EditWorkspaceThumbnailMutationFn = Apollo.MutationFunction<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>;

/**
 * __useEditWorkspaceThumbnailMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceThumbnailMutation, { data, loading, error }] = useEditWorkspaceThumbnailMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useEditWorkspaceThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>(EditWorkspaceThumbnailDocument, options);
      }
export type EditWorkspaceThumbnailMutationHookResult = ReturnType<typeof useEditWorkspaceThumbnailMutation>;
export type EditWorkspaceThumbnailMutationResult = Apollo.MutationResult<EditWorkspaceThumbnailMutation>;
export type EditWorkspaceThumbnailMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>;
export const InviteRemoteDevelopmentDocument = gql`
    mutation InviteRemoteDevelopment($editorSessionId: String!, $email: String!) {
  inviteRemoteDevelopment(editorSessionId: $editorSessionId, email: $email)
}
    `;
export type InviteRemoteDevelopmentMutationFn = Apollo.MutationFunction<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>;

/**
 * __useInviteRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useInviteRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteRemoteDevelopmentMutation, { data, loading, error }] = useInviteRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>(InviteRemoteDevelopmentDocument, options);
      }
export type InviteRemoteDevelopmentMutationHookResult = ReturnType<typeof useInviteRemoteDevelopmentMutation>;
export type InviteRemoteDevelopmentMutationResult = Apollo.MutationResult<InviteRemoteDevelopmentMutation>;
export type InviteRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>;
export const PingPreviewDocument = gql`
    mutation PingPreview($channelId: String!) {
  pingPreview(channelId: $channelId)
}
    `;
export type PingPreviewMutationFn = Apollo.MutationFunction<PingPreviewMutation, PingPreviewMutationVariables>;

/**
 * __usePingPreviewMutation__
 *
 * To run a mutation, you first call `usePingPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePingPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pingPreviewMutation, { data, loading, error }] = usePingPreviewMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePingPreviewMutation(baseOptions?: Apollo.MutationHookOptions<PingPreviewMutation, PingPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PingPreviewMutation, PingPreviewMutationVariables>(PingPreviewDocument, options);
      }
export type PingPreviewMutationHookResult = ReturnType<typeof usePingPreviewMutation>;
export type PingPreviewMutationResult = Apollo.MutationResult<PingPreviewMutation>;
export type PingPreviewMutationOptions = Apollo.BaseMutationOptions<PingPreviewMutation, PingPreviewMutationVariables>;
export const RegisterAgentStudioUserDocument = gql`
    mutation RegisterAgentStudioUser($name: String!, $email: String!, $password: String!, $organization: String, $loginUrl: String, $cliFlow: Boolean, $magicLinkRedirectUri: String) {
  registerAgentStudioUser(
    name: $name
    email: $email
    password: $password
    organization: $organization
    loginUrl: $loginUrl
    cliFlow: $cliFlow
    magicLinkRedirectUri: $magicLinkRedirectUri
  )
}
    `;
export type RegisterAgentStudioUserMutationFn = Apollo.MutationFunction<RegisterAgentStudioUserMutation, RegisterAgentStudioUserMutationVariables>;

/**
 * __useRegisterAgentStudioUserMutation__
 *
 * To run a mutation, you first call `useRegisterAgentStudioUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAgentStudioUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAgentStudioUserMutation, { data, loading, error }] = useRegisterAgentStudioUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      organization: // value for 'organization'
 *      loginUrl: // value for 'loginUrl'
 *      cliFlow: // value for 'cliFlow'
 *      magicLinkRedirectUri: // value for 'magicLinkRedirectUri'
 *   },
 * });
 */
export function useRegisterAgentStudioUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAgentStudioUserMutation, RegisterAgentStudioUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAgentStudioUserMutation, RegisterAgentStudioUserMutationVariables>(RegisterAgentStudioUserDocument, options);
      }
export type RegisterAgentStudioUserMutationHookResult = ReturnType<typeof useRegisterAgentStudioUserMutation>;
export type RegisterAgentStudioUserMutationResult = Apollo.MutationResult<RegisterAgentStudioUserMutation>;
export type RegisterAgentStudioUserMutationOptions = Apollo.BaseMutationOptions<RegisterAgentStudioUserMutation, RegisterAgentStudioUserMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: String, $email: String) {
  removeMember(organizationId: $organizationId, email: $email)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const RemoveWorkspaceMembersDocument = gql`
    mutation RemoveWorkspaceMembers($workspaceId: String!, $emails: [String]!) {
  removeWorkspaceMembers(workspaceId: $workspaceId, emails: $emails)
}
    `;
export type RemoveWorkspaceMembersMutationFn = Apollo.MutationFunction<RemoveWorkspaceMembersMutation, RemoveWorkspaceMembersMutationVariables>;

/**
 * __useRemoveWorkspaceMembersMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceMembersMutation, { data, loading, error }] = useRemoveWorkspaceMembersMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useRemoveWorkspaceMembersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkspaceMembersMutation, RemoveWorkspaceMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkspaceMembersMutation, RemoveWorkspaceMembersMutationVariables>(RemoveWorkspaceMembersDocument, options);
      }
export type RemoveWorkspaceMembersMutationHookResult = ReturnType<typeof useRemoveWorkspaceMembersMutation>;
export type RemoveWorkspaceMembersMutationResult = Apollo.MutationResult<RemoveWorkspaceMembersMutation>;
export type RemoveWorkspaceMembersMutationOptions = Apollo.BaseMutationOptions<RemoveWorkspaceMembersMutation, RemoveWorkspaceMembersMutationVariables>;
export const RemoveWorkspaceServicesDocument = gql`
    mutation RemoveWorkspaceServices($workspaceId: String!, $serviceIds: [String]) {
  removeWorkspaceServices(workspaceId: $workspaceId, serviceIds: $serviceIds)
}
    `;
export type RemoveWorkspaceServicesMutationFn = Apollo.MutationFunction<RemoveWorkspaceServicesMutation, RemoveWorkspaceServicesMutationVariables>;

/**
 * __useRemoveWorkspaceServicesMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceServicesMutation, { data, loading, error }] = useRemoveWorkspaceServicesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useRemoveWorkspaceServicesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkspaceServicesMutation, RemoveWorkspaceServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkspaceServicesMutation, RemoveWorkspaceServicesMutationVariables>(RemoveWorkspaceServicesDocument, options);
      }
export type RemoveWorkspaceServicesMutationHookResult = ReturnType<typeof useRemoveWorkspaceServicesMutation>;
export type RemoveWorkspaceServicesMutationResult = Apollo.MutationResult<RemoveWorkspaceServicesMutation>;
export type RemoveWorkspaceServicesMutationOptions = Apollo.BaseMutationOptions<RemoveWorkspaceServicesMutation, RemoveWorkspaceServicesMutationVariables>;
export const RemoveWorkspacePersistentServicesDocument = gql`
    mutation RemoveWorkspacePersistentServices($workspaceId: String!, $persistentServiceIds: [String!]!) {
  removeWorkspacePersistentServices(
    workspaceId: $workspaceId
    persistentServiceIds: $persistentServiceIds
  )
}
    `;
export type RemoveWorkspacePersistentServicesMutationFn = Apollo.MutationFunction<RemoveWorkspacePersistentServicesMutation, RemoveWorkspacePersistentServicesMutationVariables>;

/**
 * __useRemoveWorkspacePersistentServicesMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspacePersistentServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspacePersistentServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspacePersistentServicesMutation, { data, loading, error }] = useRemoveWorkspacePersistentServicesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      persistentServiceIds: // value for 'persistentServiceIds'
 *   },
 * });
 */
export function useRemoveWorkspacePersistentServicesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkspacePersistentServicesMutation, RemoveWorkspacePersistentServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkspacePersistentServicesMutation, RemoveWorkspacePersistentServicesMutationVariables>(RemoveWorkspacePersistentServicesDocument, options);
      }
export type RemoveWorkspacePersistentServicesMutationHookResult = ReturnType<typeof useRemoveWorkspacePersistentServicesMutation>;
export type RemoveWorkspacePersistentServicesMutationResult = Apollo.MutationResult<RemoveWorkspacePersistentServicesMutation>;
export type RemoveWorkspacePersistentServicesMutationOptions = Apollo.BaseMutationOptions<RemoveWorkspacePersistentServicesMutation, RemoveWorkspacePersistentServicesMutationVariables>;
export const RemoveWorkspaceVolumesDocument = gql`
    mutation RemoveWorkspaceVolumes($workspaceId: String!, $volumeIds: [String]!) {
  removeWorkspaceVolumes(workspaceId: $workspaceId, volumeIds: $volumeIds)
}
    `;
export type RemoveWorkspaceVolumesMutationFn = Apollo.MutationFunction<RemoveWorkspaceVolumesMutation, RemoveWorkspaceVolumesMutationVariables>;

/**
 * __useRemoveWorkspaceVolumesMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceVolumesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceVolumesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceVolumesMutation, { data, loading, error }] = useRemoveWorkspaceVolumesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      volumeIds: // value for 'volumeIds'
 *   },
 * });
 */
export function useRemoveWorkspaceVolumesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkspaceVolumesMutation, RemoveWorkspaceVolumesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkspaceVolumesMutation, RemoveWorkspaceVolumesMutationVariables>(RemoveWorkspaceVolumesDocument, options);
      }
export type RemoveWorkspaceVolumesMutationHookResult = ReturnType<typeof useRemoveWorkspaceVolumesMutation>;
export type RemoveWorkspaceVolumesMutationResult = Apollo.MutationResult<RemoveWorkspaceVolumesMutation>;
export type RemoveWorkspaceVolumesMutationOptions = Apollo.BaseMutationOptions<RemoveWorkspaceVolumesMutation, RemoveWorkspaceVolumesMutationVariables>;
export const ReplaceSkillPackageDocument = gql`
    mutation ReplaceSkillPackage($skillId: String!, $size: Int!) {
  replaceSkillPackage(skillId: $skillId, size: $size) {
    skillId
    uploadId
    partSize
    urls
    s3Url
  }
}
    `;
export type ReplaceSkillPackageMutationFn = Apollo.MutationFunction<ReplaceSkillPackageMutation, ReplaceSkillPackageMutationVariables>;

/**
 * __useReplaceSkillPackageMutation__
 *
 * To run a mutation, you first call `useReplaceSkillPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceSkillPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceSkillPackageMutation, { data, loading, error }] = useReplaceSkillPackageMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useReplaceSkillPackageMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceSkillPackageMutation, ReplaceSkillPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceSkillPackageMutation, ReplaceSkillPackageMutationVariables>(ReplaceSkillPackageDocument, options);
      }
export type ReplaceSkillPackageMutationHookResult = ReturnType<typeof useReplaceSkillPackageMutation>;
export type ReplaceSkillPackageMutationResult = Apollo.MutationResult<ReplaceSkillPackageMutation>;
export type ReplaceSkillPackageMutationOptions = Apollo.BaseMutationOptions<ReplaceSkillPackageMutation, ReplaceSkillPackageMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail($email: String!) {
  resendVerificationEmail(email: $email)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const SetUserPreferenceDocument = gql`
    mutation SetUserPreference($preference: String!) {
  setUserPreference(preference: $preference)
}
    `;
export type SetUserPreferenceMutationFn = Apollo.MutationFunction<SetUserPreferenceMutation, SetUserPreferenceMutationVariables>;

/**
 * __useSetUserPreferenceMutation__
 *
 * To run a mutation, you first call `useSetUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPreferenceMutation, { data, loading, error }] = useSetUserPreferenceMutation({
 *   variables: {
 *      preference: // value for 'preference'
 *   },
 * });
 */
export function useSetUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPreferenceMutation, SetUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPreferenceMutation, SetUserPreferenceMutationVariables>(SetUserPreferenceDocument, options);
      }
export type SetUserPreferenceMutationHookResult = ReturnType<typeof useSetUserPreferenceMutation>;
export type SetUserPreferenceMutationResult = Apollo.MutationResult<SetUserPreferenceMutation>;
export type SetUserPreferenceMutationOptions = Apollo.BaseMutationOptions<SetUserPreferenceMutation, SetUserPreferenceMutationVariables>;
export const StartEditorDocument = gql`
    mutation StartEditor($editorId: String!) {
  startEditor(editorId: $editorId)
}
    `;
export type StartEditorMutationFn = Apollo.MutationFunction<StartEditorMutation, StartEditorMutationVariables>;

/**
 * __useStartEditorMutation__
 *
 * To run a mutation, you first call `useStartEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEditorMutation, { data, loading, error }] = useStartEditorMutation({
 *   variables: {
 *      editorId: // value for 'editorId'
 *   },
 * });
 */
export function useStartEditorMutation(baseOptions?: Apollo.MutationHookOptions<StartEditorMutation, StartEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEditorMutation, StartEditorMutationVariables>(StartEditorDocument, options);
      }
export type StartEditorMutationHookResult = ReturnType<typeof useStartEditorMutation>;
export type StartEditorMutationResult = Apollo.MutationResult<StartEditorMutation>;
export type StartEditorMutationOptions = Apollo.BaseMutationOptions<StartEditorMutation, StartEditorMutationVariables>;
export const StartRemoteDevelopmentDocument = gql`
    mutation StartRemoteDevelopment($editorSessionId: String!) {
  startRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type StartRemoteDevelopmentMutationFn = Apollo.MutationFunction<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>;

/**
 * __useStartRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useStartRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRemoteDevelopmentMutation, { data, loading, error }] = useStartRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useStartRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>(StartRemoteDevelopmentDocument, options);
      }
export type StartRemoteDevelopmentMutationHookResult = ReturnType<typeof useStartRemoteDevelopmentMutation>;
export type StartRemoteDevelopmentMutationResult = Apollo.MutationResult<StartRemoteDevelopmentMutation>;
export type StartRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>;
export const StopEditorDocument = gql`
    mutation StopEditor($editorId: String!) {
  stopEditor(editorId: $editorId)
}
    `;
export type StopEditorMutationFn = Apollo.MutationFunction<StopEditorMutation, StopEditorMutationVariables>;

/**
 * __useStopEditorMutation__
 *
 * To run a mutation, you first call `useStopEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopEditorMutation, { data, loading, error }] = useStopEditorMutation({
 *   variables: {
 *      editorId: // value for 'editorId'
 *   },
 * });
 */
export function useStopEditorMutation(baseOptions?: Apollo.MutationHookOptions<StopEditorMutation, StopEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopEditorMutation, StopEditorMutationVariables>(StopEditorDocument, options);
      }
export type StopEditorMutationHookResult = ReturnType<typeof useStopEditorMutation>;
export type StopEditorMutationResult = Apollo.MutationResult<StopEditorMutation>;
export type StopEditorMutationOptions = Apollo.BaseMutationOptions<StopEditorMutation, StopEditorMutationVariables>;
export const StopRemoteDevelopmentDocument = gql`
    mutation StopRemoteDevelopment($editorSessionId: String!) {
  stopRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type StopRemoteDevelopmentMutationFn = Apollo.MutationFunction<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>;

/**
 * __useStopRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useStopRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRemoteDevelopmentMutation, { data, loading, error }] = useStopRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useStopRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>(StopRemoteDevelopmentDocument, options);
      }
export type StopRemoteDevelopmentMutationHookResult = ReturnType<typeof useStopRemoteDevelopmentMutation>;
export type StopRemoteDevelopmentMutationResult = Apollo.MutationResult<StopRemoteDevelopmentMutation>;
export type StopRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>;
export const ToggleWorkspaceMcpServerOverrideDocument = gql`
    mutation ToggleWorkspaceMcpServerOverride($workspaceId: String!, $mcpServerId: String!) {
  toggleWorkspaceMcpServerOverride(
    workspaceId: $workspaceId
    mcpServerId: $mcpServerId
  )
}
    `;
export type ToggleWorkspaceMcpServerOverrideMutationFn = Apollo.MutationFunction<ToggleWorkspaceMcpServerOverrideMutation, ToggleWorkspaceMcpServerOverrideMutationVariables>;

/**
 * __useToggleWorkspaceMcpServerOverrideMutation__
 *
 * To run a mutation, you first call `useToggleWorkspaceMcpServerOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkspaceMcpServerOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkspaceMcpServerOverrideMutation, { data, loading, error }] = useToggleWorkspaceMcpServerOverrideMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      mcpServerId: // value for 'mcpServerId'
 *   },
 * });
 */
export function useToggleWorkspaceMcpServerOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWorkspaceMcpServerOverrideMutation, ToggleWorkspaceMcpServerOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWorkspaceMcpServerOverrideMutation, ToggleWorkspaceMcpServerOverrideMutationVariables>(ToggleWorkspaceMcpServerOverrideDocument, options);
      }
export type ToggleWorkspaceMcpServerOverrideMutationHookResult = ReturnType<typeof useToggleWorkspaceMcpServerOverrideMutation>;
export type ToggleWorkspaceMcpServerOverrideMutationResult = Apollo.MutationResult<ToggleWorkspaceMcpServerOverrideMutation>;
export type ToggleWorkspaceMcpServerOverrideMutationOptions = Apollo.BaseMutationOptions<ToggleWorkspaceMcpServerOverrideMutation, ToggleWorkspaceMcpServerOverrideMutationVariables>;
export const ToggleWorkspaceSkillOverrideDocument = gql`
    mutation ToggleWorkspaceSkillOverride($workspaceId: String!, $skillId: String!) {
  toggleWorkspaceSkillOverride(workspaceId: $workspaceId, skillId: $skillId)
}
    `;
export type ToggleWorkspaceSkillOverrideMutationFn = Apollo.MutationFunction<ToggleWorkspaceSkillOverrideMutation, ToggleWorkspaceSkillOverrideMutationVariables>;

/**
 * __useToggleWorkspaceSkillOverrideMutation__
 *
 * To run a mutation, you first call `useToggleWorkspaceSkillOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkspaceSkillOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkspaceSkillOverrideMutation, { data, loading, error }] = useToggleWorkspaceSkillOverrideMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useToggleWorkspaceSkillOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWorkspaceSkillOverrideMutation, ToggleWorkspaceSkillOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWorkspaceSkillOverrideMutation, ToggleWorkspaceSkillOverrideMutationVariables>(ToggleWorkspaceSkillOverrideDocument, options);
      }
export type ToggleWorkspaceSkillOverrideMutationHookResult = ReturnType<typeof useToggleWorkspaceSkillOverrideMutation>;
export type ToggleWorkspaceSkillOverrideMutationResult = Apollo.MutationResult<ToggleWorkspaceSkillOverrideMutation>;
export type ToggleWorkspaceSkillOverrideMutationOptions = Apollo.BaseMutationOptions<ToggleWorkspaceSkillOverrideMutation, ToggleWorkspaceSkillOverrideMutationVariables>;
export const TransferWorkspaceDocument = gql`
    mutation TransferWorkspace($workspaceId: String!, $email: String!) {
  transferWorkspace(workspaceId: $workspaceId, email: $email)
}
    `;
export type TransferWorkspaceMutationFn = Apollo.MutationFunction<TransferWorkspaceMutation, TransferWorkspaceMutationVariables>;

/**
 * __useTransferWorkspaceMutation__
 *
 * To run a mutation, you first call `useTransferWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferWorkspaceMutation, { data, loading, error }] = useTransferWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useTransferWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<TransferWorkspaceMutation, TransferWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferWorkspaceMutation, TransferWorkspaceMutationVariables>(TransferWorkspaceDocument, options);
      }
export type TransferWorkspaceMutationHookResult = ReturnType<typeof useTransferWorkspaceMutation>;
export type TransferWorkspaceMutationResult = Apollo.MutationResult<TransferWorkspaceMutation>;
export type TransferWorkspaceMutationOptions = Apollo.BaseMutationOptions<TransferWorkspaceMutation, TransferWorkspaceMutationVariables>;
export const UpgradeTemplateWorkspaceDocument = gql`
    mutation UpgradeTemplateWorkspace($workspaceId: String!) {
  upgradeTemplateWorkspace(workspaceId: $workspaceId)
}
    `;
export type UpgradeTemplateWorkspaceMutationFn = Apollo.MutationFunction<UpgradeTemplateWorkspaceMutation, UpgradeTemplateWorkspaceMutationVariables>;

/**
 * __useUpgradeTemplateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpgradeTemplateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeTemplateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeTemplateWorkspaceMutation, { data, loading, error }] = useUpgradeTemplateWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpgradeTemplateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeTemplateWorkspaceMutation, UpgradeTemplateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeTemplateWorkspaceMutation, UpgradeTemplateWorkspaceMutationVariables>(UpgradeTemplateWorkspaceDocument, options);
      }
export type UpgradeTemplateWorkspaceMutationHookResult = ReturnType<typeof useUpgradeTemplateWorkspaceMutation>;
export type UpgradeTemplateWorkspaceMutationResult = Apollo.MutationResult<UpgradeTemplateWorkspaceMutation>;
export type UpgradeTemplateWorkspaceMutationOptions = Apollo.BaseMutationOptions<UpgradeTemplateWorkspaceMutation, UpgradeTemplateWorkspaceMutationVariables>;
export const UploadAnnotationMapDocument = gql`
    mutation UploadAnnotationMap($organizationId: String!, $name: String!, $size: Int!, $description: String, $tags: [String]) {
  uploadAnnotationMap(
    organizationId: $organizationId
    name: $name
    size: $size
    description: $description
    tags: $tags
  ) {
    mapId
    key
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadAnnotationMapMutationFn = Apollo.MutationFunction<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>;

/**
 * __useUploadAnnotationMapMutation__
 *
 * To run a mutation, you first call `useUploadAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAnnotationMapMutation, { data, loading, error }] = useUploadAnnotationMapMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>(UploadAnnotationMapDocument, options);
      }
export type UploadAnnotationMapMutationHookResult = ReturnType<typeof useUploadAnnotationMapMutation>;
export type UploadAnnotationMapMutationResult = Apollo.MutationResult<UploadAnnotationMapMutation>;
export type UploadAnnotationMapMutationOptions = Apollo.BaseMutationOptions<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>;
export const UploadAnnotationMapFinalizerDocument = gql`
    mutation UploadAnnotationMapFinalizer($uploadId: String!, $key: String!, $parts: [MultipartInput]) {
  uploadAnnotationMapFinalizer(uploadId: $uploadId, key: $key, parts: $parts)
}
    `;
export type UploadAnnotationMapFinalizerMutationFn = Apollo.MutationFunction<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>;

/**
 * __useUploadAnnotationMapFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadAnnotationMapFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAnnotationMapFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAnnotationMapFinalizerMutation, { data, loading, error }] = useUploadAnnotationMapFinalizerMutation({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *      key: // value for 'key'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadAnnotationMapFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>(UploadAnnotationMapFinalizerDocument, options);
      }
export type UploadAnnotationMapFinalizerMutationHookResult = ReturnType<typeof useUploadAnnotationMapFinalizerMutation>;
export type UploadAnnotationMapFinalizerMutationResult = Apollo.MutationResult<UploadAnnotationMapFinalizerMutation>;
export type UploadAnnotationMapFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>;
export const UploadDatasetDocument = gql`
    mutation UploadDataset($workspaceId: String!, $name: String!, $size: Float!, $description: String, $tags: [String]) {
  uploadDataset(
    workspaceId: $workspaceId
    name: $name
    size: $size
    description: $description
    tags: $tags
  ) {
    datasetId
    key
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadDatasetMutationFn = Apollo.MutationFunction<UploadDatasetMutation, UploadDatasetMutationVariables>;

/**
 * __useUploadDatasetMutation__
 *
 * To run a mutation, you first call `useUploadDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetMutation, { data, loading, error }] = useUploadDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadDatasetMutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetMutation, UploadDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetMutation, UploadDatasetMutationVariables>(UploadDatasetDocument, options);
      }
export type UploadDatasetMutationHookResult = ReturnType<typeof useUploadDatasetMutation>;
export type UploadDatasetMutationResult = Apollo.MutationResult<UploadDatasetMutation>;
export type UploadDatasetMutationOptions = Apollo.BaseMutationOptions<UploadDatasetMutation, UploadDatasetMutationVariables>;
export const UploadDatasetFinalizerDocument = gql`
    mutation UploadDatasetFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadDatasetFinalizer(uploadId: $uploadId, key: $key, parts: $parts)
}
    `;
export type UploadDatasetFinalizerMutationFn = Apollo.MutationFunction<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>;

/**
 * __useUploadDatasetFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadDatasetFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetFinalizerMutation, { data, loading, error }] = useUploadDatasetFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadDatasetFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>(UploadDatasetFinalizerDocument, options);
      }
export type UploadDatasetFinalizerMutationHookResult = ReturnType<typeof useUploadDatasetFinalizerMutation>;
export type UploadDatasetFinalizerMutationResult = Apollo.MutationResult<UploadDatasetFinalizerMutation>;
export type UploadDatasetFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>;
export const UploadGANModelDocument = gql`
    mutation UploadGANModel($organizationId: String!, $name: String!, $size: Float!, $description: String, $flags: String, $tags: [String]) {
  uploadGANModel(
    organizationId: $organizationId
    name: $name
    size: $size
    description: $description
    flags: $flags
    tags: $tags
  ) {
    key
    modelId
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadGANModelMutationFn = Apollo.MutationFunction<UploadGANModelMutation, UploadGANModelMutationVariables>;

/**
 * __useUploadGANModelMutation__
 *
 * To run a mutation, you first call `useUploadGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGanModelMutation, { data, loading, error }] = useUploadGANModelMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      flags: // value for 'flags'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadGANModelMutation(baseOptions?: Apollo.MutationHookOptions<UploadGANModelMutation, UploadGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadGANModelMutation, UploadGANModelMutationVariables>(UploadGANModelDocument, options);
      }
export type UploadGANModelMutationHookResult = ReturnType<typeof useUploadGANModelMutation>;
export type UploadGANModelMutationResult = Apollo.MutationResult<UploadGANModelMutation>;
export type UploadGANModelMutationOptions = Apollo.BaseMutationOptions<UploadGANModelMutation, UploadGANModelMutationVariables>;
export const UploadGANModelFinalizerDocument = gql`
    mutation UploadGANModelFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadGANModelFinalizer(key: $key, uploadId: $uploadId, parts: $parts)
}
    `;
export type UploadGANModelFinalizerMutationFn = Apollo.MutationFunction<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>;

/**
 * __useUploadGANModelFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadGANModelFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGANModelFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGanModelFinalizerMutation, { data, loading, error }] = useUploadGANModelFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadGANModelFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>(UploadGANModelFinalizerDocument, options);
      }
export type UploadGANModelFinalizerMutationHookResult = ReturnType<typeof useUploadGANModelFinalizerMutation>;
export type UploadGANModelFinalizerMutationResult = Apollo.MutationResult<UploadGANModelFinalizerMutation>;
export type UploadGANModelFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>;
export const UploadMLModelDocument = gql`
    mutation UploadMLModel($workspaceId: String!, $architectureId: String!, $name: String!, $size: Float!, $description: String, $tags: [String], $parameters: String) {
  uploadMLModel(
    workspaceId: $workspaceId
    architectureId: $architectureId
    name: $name
    size: $size
    description: $description
    tags: $tags
    parameters: $parameters
  ) {
    key
    modelId
    uploadId
    partSize
    urls
  }
}
    `;
export type UploadMLModelMutationFn = Apollo.MutationFunction<UploadMLModelMutation, UploadMLModelMutationVariables>;

/**
 * __useUploadMLModelMutation__
 *
 * To run a mutation, you first call `useUploadMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMlModelMutation, { data, loading, error }] = useUploadMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      architectureId: // value for 'architectureId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUploadMLModelMutation(baseOptions?: Apollo.MutationHookOptions<UploadMLModelMutation, UploadMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMLModelMutation, UploadMLModelMutationVariables>(UploadMLModelDocument, options);
      }
export type UploadMLModelMutationHookResult = ReturnType<typeof useUploadMLModelMutation>;
export type UploadMLModelMutationResult = Apollo.MutationResult<UploadMLModelMutation>;
export type UploadMLModelMutationOptions = Apollo.BaseMutationOptions<UploadMLModelMutation, UploadMLModelMutationVariables>;
export const UploadMLModelFinalizerDocument = gql`
    mutation UploadMLModelFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadMLModelFinalizer(key: $key, uploadId: $uploadId, parts: $parts)
}
    `;
export type UploadMLModelFinalizerMutationFn = Apollo.MutationFunction<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>;

/**
 * __useUploadMLModelFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadMLModelFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMLModelFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMlModelFinalizerMutation, { data, loading, error }] = useUploadMLModelFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadMLModelFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>(UploadMLModelFinalizerDocument, options);
      }
export type UploadMLModelFinalizerMutationHookResult = ReturnType<typeof useUploadMLModelFinalizerMutation>;
export type UploadMLModelFinalizerMutationResult = Apollo.MutationResult<UploadMLModelFinalizerMutation>;
export type UploadMLModelFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>;
export const UploadVolumeDataDocument = gql`
    mutation UploadVolumeData($volumeId: String!, $key: String!, $size: Float!) {
  uploadVolumeData(volumeId: $volumeId, key: $key, size: $size) {
    key
    partSize
    uploadId
    urls
    volumeId
  }
}
    `;
export type UploadVolumeDataMutationFn = Apollo.MutationFunction<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>;

/**
 * __useUploadVolumeDataMutation__
 *
 * To run a mutation, you first call `useUploadVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVolumeDataMutation, { data, loading, error }] = useUploadVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUploadVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>(UploadVolumeDataDocument, options);
      }
export type UploadVolumeDataMutationHookResult = ReturnType<typeof useUploadVolumeDataMutation>;
export type UploadVolumeDataMutationResult = Apollo.MutationResult<UploadVolumeDataMutation>;
export type UploadVolumeDataMutationOptions = Apollo.BaseMutationOptions<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>;
export const UploadVolumeDataFinalizerDocument = gql`
    mutation UploadVolumeDataFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadVolumeDataFinalizer(key: $key, uploadId: $uploadId, parts: $parts)
}
    `;
export type UploadVolumeDataFinalizerMutationFn = Apollo.MutationFunction<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>;

/**
 * __useUploadVolumeDataFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadVolumeDataFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVolumeDataFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVolumeDataFinalizerMutation, { data, loading, error }] = useUploadVolumeDataFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadVolumeDataFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>(UploadVolumeDataFinalizerDocument, options);
      }
export type UploadVolumeDataFinalizerMutationHookResult = ReturnType<typeof useUploadVolumeDataFinalizerMutation>;
export type UploadVolumeDataFinalizerMutationResult = Apollo.MutationResult<UploadVolumeDataFinalizerMutation>;
export type UploadVolumeDataFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>;
export const UploadVolumeDataThumbnailDocument = gql`
    mutation UploadVolumeDataThumbnail($volumeId: String!, $key: String!) {
  uploadVolumeDataThumbnail(volumeId: $volumeId, key: $key) {
    key
    url
  }
}
    `;
export type UploadVolumeDataThumbnailMutationFn = Apollo.MutationFunction<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>;

/**
 * __useUploadVolumeDataThumbnailMutation__
 *
 * To run a mutation, you first call `useUploadVolumeDataThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVolumeDataThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVolumeDataThumbnailMutation, { data, loading, error }] = useUploadVolumeDataThumbnailMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useUploadVolumeDataThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>(UploadVolumeDataThumbnailDocument, options);
      }
export type UploadVolumeDataThumbnailMutationHookResult = ReturnType<typeof useUploadVolumeDataThumbnailMutation>;
export type UploadVolumeDataThumbnailMutationResult = Apollo.MutationResult<UploadVolumeDataThumbnailMutation>;
export type UploadVolumeDataThumbnailMutationOptions = Apollo.BaseMutationOptions<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>;
export const ValidateGraphDocument = gql`
    mutation ValidateGraph($workspaceId: String!, $graphId: String!) {
  validateGraph(workspaceId: $workspaceId, graphId: $graphId) {
    node
    input
    errorMessage
    type
  }
}
    `;
export type ValidateGraphMutationFn = Apollo.MutationFunction<ValidateGraphMutation, ValidateGraphMutationVariables>;

/**
 * __useValidateGraphMutation__
 *
 * To run a mutation, you first call `useValidateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateGraphMutation, { data, loading, error }] = useValidateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useValidateGraphMutation(baseOptions?: Apollo.MutationHookOptions<ValidateGraphMutation, ValidateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateGraphMutation, ValidateGraphMutationVariables>(ValidateGraphDocument, options);
      }
export type ValidateGraphMutationHookResult = ReturnType<typeof useValidateGraphMutation>;
export type ValidateGraphMutationResult = Apollo.MutationResult<ValidateGraphMutation>;
export type ValidateGraphMutationOptions = Apollo.BaseMutationOptions<ValidateGraphMutation, ValidateGraphMutationVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($organizationId: String) {
  getOrganizations(organizationId: $organizationId) {
    name
    role
    organizationId
    expirationDate
    expired
    plan
    serviceOnly
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsQuery | undefined, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationSettingsDocument = gql`
    query GetOrganizationSettings($organizationId: String!, $setting: String) {
  getOrganizationSettings(organizationId: $organizationId, setting: $setting) {
    organizationId
    setting
    limit
    usage
    units
  }
}
    `;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables> & ({ variables: GetOrganizationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
      }
export function useGetOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export function useGetOrganizationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationSettingsQuery | undefined, GetOrganizationSettingsQueryVariables>;
export function useGetOrganizationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
export type GetOrganizationSettingsQueryHookResult = ReturnType<typeof useGetOrganizationSettingsQuery>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSettingsLazyQuery>;
export type GetOrganizationSettingsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSettingsSuspenseQuery>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetOrganizationsNamesListDocument = gql`
    query GetOrganizationsNamesList {
  getOrganizations {
    name
    organizationId
  }
}
    `;

/**
 * __useGetOrganizationsNamesListQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsNamesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsNamesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsNamesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsNamesListQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>(GetOrganizationsNamesListDocument, options);
      }
export function useGetOrganizationsNamesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>(GetOrganizationsNamesListDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsNamesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>;
export function useGetOrganizationsNamesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsNamesListQuery | undefined, GetOrganizationsNamesListQueryVariables>;
export function useGetOrganizationsNamesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>(GetOrganizationsNamesListDocument, options);
        }
export type GetOrganizationsNamesListQueryHookResult = ReturnType<typeof useGetOrganizationsNamesListQuery>;
export type GetOrganizationsNamesListLazyQueryHookResult = ReturnType<typeof useGetOrganizationsNamesListLazyQuery>;
export type GetOrganizationsNamesListSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsNamesListSuspenseQuery>;
export type GetOrganizationsNamesListQueryResult = Apollo.QueryResult<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>;
export const GetDatasetThumbnailsDocument = gql`
    query GetDatasetThumbnails($workspaceId: String!, $datasetId: String!) {
  getDatasetThumbnails(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;

/**
 * __useGetDatasetThumbnailsQuery__
 *
 * To run a query within a React component, call `useGetDatasetThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetThumbnailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetThumbnailsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables> & ({ variables: GetDatasetThumbnailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
      }
export function useGetDatasetThumbnailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
        }
// @ts-ignore
export function useGetDatasetThumbnailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>;
export function useGetDatasetThumbnailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetThumbnailsQuery | undefined, GetDatasetThumbnailsQueryVariables>;
export function useGetDatasetThumbnailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
        }
export type GetDatasetThumbnailsQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsQuery>;
export type GetDatasetThumbnailsLazyQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsLazyQuery>;
export type GetDatasetThumbnailsSuspenseQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsSuspenseQuery>;
export type GetDatasetThumbnailsQueryResult = Apollo.QueryResult<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>;
export const ValidateContentCodeDocument = gql`
    query ValidateContentCode($code: String!) {
  validateContentCode(code: $code)
}
    `;

/**
 * __useValidateContentCodeQuery__
 *
 * To run a query within a React component, call `useValidateContentCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateContentCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateContentCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateContentCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables> & ({ variables: ValidateContentCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
      }
export function useValidateContentCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
        }
// @ts-ignore
export function useValidateContentCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>;
export function useValidateContentCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateContentCodeQuery | undefined, ValidateContentCodeQueryVariables>;
export function useValidateContentCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
        }
export type ValidateContentCodeQueryHookResult = ReturnType<typeof useValidateContentCodeQuery>;
export type ValidateContentCodeLazyQueryHookResult = ReturnType<typeof useValidateContentCodeLazyQuery>;
export type ValidateContentCodeSuspenseQueryHookResult = ReturnType<typeof useValidateContentCodeSuspenseQuery>;
export type ValidateContentCodeQueryResult = Apollo.QueryResult<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>;
export const GetRemoteDevelopmentSessionsDocument = gql`
    query GetRemoteDevelopmentSessions($organizationId: String) {
  listRemoteDevelopment(organizationId: $organizationId) {
    channel
    channelId
    createdAt
    createdBy
    editorSessionId
    editorUrl
    instanceType
    organization
    organizationId
    sshPort
    startedAt
    status {
      state
      message
    }
    updatedAt
    updatedBy
    users
  }
}
    `;

/**
 * __useGetRemoteDevelopmentSessionsQuery__
 *
 * To run a query within a React component, call `useGetRemoteDevelopmentSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteDevelopmentSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteDevelopmentSessionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetRemoteDevelopmentSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
      }
export function useGetRemoteDevelopmentSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
        }
// @ts-ignore
export function useGetRemoteDevelopmentSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>;
export function useGetRemoteDevelopmentSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRemoteDevelopmentSessionsQuery | undefined, GetRemoteDevelopmentSessionsQueryVariables>;
export function useGetRemoteDevelopmentSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
        }
export type GetRemoteDevelopmentSessionsQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsQuery>;
export type GetRemoteDevelopmentSessionsLazyQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsLazyQuery>;
export type GetRemoteDevelopmentSessionsSuspenseQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsSuspenseQuery>;
export type GetRemoteDevelopmentSessionsQueryResult = Apollo.QueryResult<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>;
export const GetRemoteDevelopmentSessionsForChannelsTableDocument = gql`
    query GetRemoteDevelopmentSessionsForChannelsTable($organizationId: String) {
  listRemoteDevelopment(organizationId: $organizationId) {
    channel
    channelId
    editorSessionId
    editorUrl
    sshPort
    status {
      state
    }
  }
}
    `;

/**
 * __useGetRemoteDevelopmentSessionsForChannelsTableQuery__
 *
 * To run a query within a React component, call `useGetRemoteDevelopmentSessionsForChannelsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteDevelopmentSessionsForChannelsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteDevelopmentSessionsForChannelsTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetRemoteDevelopmentSessionsForChannelsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>(GetRemoteDevelopmentSessionsForChannelsTableDocument, options);
      }
export function useGetRemoteDevelopmentSessionsForChannelsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>(GetRemoteDevelopmentSessionsForChannelsTableDocument, options);
        }
// @ts-ignore
export function useGetRemoteDevelopmentSessionsForChannelsTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>): Apollo.UseSuspenseQueryResult<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>;
export function useGetRemoteDevelopmentSessionsForChannelsTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>): Apollo.UseSuspenseQueryResult<GetRemoteDevelopmentSessionsForChannelsTableQuery | undefined, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>;
export function useGetRemoteDevelopmentSessionsForChannelsTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>(GetRemoteDevelopmentSessionsForChannelsTableDocument, options);
        }
export type GetRemoteDevelopmentSessionsForChannelsTableQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsForChannelsTableQuery>;
export type GetRemoteDevelopmentSessionsForChannelsTableLazyQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsForChannelsTableLazyQuery>;
export type GetRemoteDevelopmentSessionsForChannelsTableSuspenseQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsForChannelsTableSuspenseQuery>;
export type GetRemoteDevelopmentSessionsForChannelsTableQueryResult = Apollo.QueryResult<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>;
export const GetOrganizationRulesDocument = gql`
    query GetOrganizationRules($organizationId: String!) {
  getOrganizationRules(organizationId: $organizationId)
}
    `;

/**
 * __useGetOrganizationRulesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRulesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationRulesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables> & ({ variables: GetOrganizationRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>(GetOrganizationRulesDocument, options);
      }
export function useGetOrganizationRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>(GetOrganizationRulesDocument, options);
        }
// @ts-ignore
export function useGetOrganizationRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>;
export function useGetOrganizationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationRulesQuery | undefined, GetOrganizationRulesQueryVariables>;
export function useGetOrganizationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>(GetOrganizationRulesDocument, options);
        }
export type GetOrganizationRulesQueryHookResult = ReturnType<typeof useGetOrganizationRulesQuery>;
export type GetOrganizationRulesLazyQueryHookResult = ReturnType<typeof useGetOrganizationRulesLazyQuery>;
export type GetOrganizationRulesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationRulesSuspenseQuery>;
export type GetOrganizationRulesQueryResult = Apollo.QueryResult<GetOrganizationRulesQuery, GetOrganizationRulesQueryVariables>;
export const GetServiceRulesDocument = gql`
    query GetServiceRules($serviceId: String!) {
  getServiceRules(serviceId: $serviceId)
}
    `;

/**
 * __useGetServiceRulesQuery__
 *
 * To run a query within a React component, call `useGetServiceRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRulesQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetServiceRulesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceRulesQuery, GetServiceRulesQueryVariables> & ({ variables: GetServiceRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRulesQuery, GetServiceRulesQueryVariables>(GetServiceRulesDocument, options);
      }
export function useGetServiceRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRulesQuery, GetServiceRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRulesQuery, GetServiceRulesQueryVariables>(GetServiceRulesDocument, options);
        }
// @ts-ignore
export function useGetServiceRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceRulesQuery, GetServiceRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRulesQuery, GetServiceRulesQueryVariables>;
export function useGetServiceRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRulesQuery, GetServiceRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRulesQuery | undefined, GetServiceRulesQueryVariables>;
export function useGetServiceRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRulesQuery, GetServiceRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRulesQuery, GetServiceRulesQueryVariables>(GetServiceRulesDocument, options);
        }
export type GetServiceRulesQueryHookResult = ReturnType<typeof useGetServiceRulesQuery>;
export type GetServiceRulesLazyQueryHookResult = ReturnType<typeof useGetServiceRulesLazyQuery>;
export type GetServiceRulesSuspenseQueryHookResult = ReturnType<typeof useGetServiceRulesSuspenseQuery>;
export type GetServiceRulesQueryResult = Apollo.QueryResult<GetServiceRulesQuery, GetServiceRulesQueryVariables>;
export const GetUserRulesDocument = gql`
    query GetUserRules {
  getUserRules
}
    `;

/**
 * __useGetUserRulesQuery__
 *
 * To run a query within a React component, call `useGetUserRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRulesQuery, GetUserRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRulesQuery, GetUserRulesQueryVariables>(GetUserRulesDocument, options);
      }
export function useGetUserRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRulesQuery, GetUserRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRulesQuery, GetUserRulesQueryVariables>(GetUserRulesDocument, options);
        }
// @ts-ignore
export function useGetUserRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserRulesQuery, GetUserRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRulesQuery, GetUserRulesQueryVariables>;
export function useGetUserRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRulesQuery, GetUserRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRulesQuery | undefined, GetUserRulesQueryVariables>;
export function useGetUserRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRulesQuery, GetUserRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRulesQuery, GetUserRulesQueryVariables>(GetUserRulesDocument, options);
        }
export type GetUserRulesQueryHookResult = ReturnType<typeof useGetUserRulesQuery>;
export type GetUserRulesLazyQueryHookResult = ReturnType<typeof useGetUserRulesLazyQuery>;
export type GetUserRulesSuspenseQueryHookResult = ReturnType<typeof useGetUserRulesSuspenseQuery>;
export type GetUserRulesQueryResult = Apollo.QueryResult<GetUserRulesQuery, GetUserRulesQueryVariables>;
export const GetWorkspaceRulesDocument = gql`
    query GetWorkspaceRules($workspaceId: String!) {
  getWorkspaceRules(workspaceId: $workspaceId)
}
    `;

/**
 * __useGetWorkspaceRulesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceRulesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceRulesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables> & ({ variables: GetWorkspaceRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>(GetWorkspaceRulesDocument, options);
      }
export function useGetWorkspaceRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>(GetWorkspaceRulesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>;
export function useGetWorkspaceRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceRulesQuery | undefined, GetWorkspaceRulesQueryVariables>;
export function useGetWorkspaceRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>(GetWorkspaceRulesDocument, options);
        }
export type GetWorkspaceRulesQueryHookResult = ReturnType<typeof useGetWorkspaceRulesQuery>;
export type GetWorkspaceRulesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceRulesLazyQuery>;
export type GetWorkspaceRulesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceRulesSuspenseQuery>;
export type GetWorkspaceRulesQueryResult = Apollo.QueryResult<GetWorkspaceRulesQuery, GetWorkspaceRulesQueryVariables>;
export const GetPlatformRulesDocument = gql`
    query GetPlatformRules {
  getPlatformRules
}
    `;

/**
 * __useGetPlatformRulesQuery__
 *
 * To run a query within a React component, call `useGetPlatformRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlatformRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>(GetPlatformRulesDocument, options);
      }
export function useGetPlatformRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>(GetPlatformRulesDocument, options);
        }
// @ts-ignore
export function useGetPlatformRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>;
export function useGetPlatformRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlatformRulesQuery | undefined, GetPlatformRulesQueryVariables>;
export function useGetPlatformRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>(GetPlatformRulesDocument, options);
        }
export type GetPlatformRulesQueryHookResult = ReturnType<typeof useGetPlatformRulesQuery>;
export type GetPlatformRulesLazyQueryHookResult = ReturnType<typeof useGetPlatformRulesLazyQuery>;
export type GetPlatformRulesSuspenseQueryHookResult = ReturnType<typeof useGetPlatformRulesSuspenseQuery>;
export type GetPlatformRulesQueryResult = Apollo.QueryResult<GetPlatformRulesQuery, GetPlatformRulesQueryVariables>;
export const GetSecretsDocument = gql`
    query GetSecrets($organizationId: String, $workspaceId: String) {
  getSecrets(organizationId: $organizationId, workspaceId: $workspaceId) {
    secretId
    organizationId
    name
    workspaceIds
    includeInAllWorkspaces
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSecretsQuery__
 *
 * To run a query within a React component, call `useGetSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecretsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetSecretsQuery(baseOptions?: Apollo.QueryHookOptions<GetSecretsQuery, GetSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSecretsQuery, GetSecretsQueryVariables>(GetSecretsDocument, options);
      }
export function useGetSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSecretsQuery, GetSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSecretsQuery, GetSecretsQueryVariables>(GetSecretsDocument, options);
        }
// @ts-ignore
export function useGetSecretsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSecretsQuery, GetSecretsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSecretsQuery, GetSecretsQueryVariables>;
export function useGetSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSecretsQuery, GetSecretsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSecretsQuery | undefined, GetSecretsQueryVariables>;
export function useGetSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSecretsQuery, GetSecretsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSecretsQuery, GetSecretsQueryVariables>(GetSecretsDocument, options);
        }
export type GetSecretsQueryHookResult = ReturnType<typeof useGetSecretsQuery>;
export type GetSecretsLazyQueryHookResult = ReturnType<typeof useGetSecretsLazyQuery>;
export type GetSecretsSuspenseQueryHookResult = ReturnType<typeof useGetSecretsSuspenseQuery>;
export type GetSecretsQueryResult = Apollo.QueryResult<GetSecretsQuery, GetSecretsQueryVariables>;
export const GetSkillsDocument = gql`
    query GetSkills($mode: String, $organizationId: String, $workspaceId: String, $scopeType: String, $name: String) {
  getSkills(
    mode: $mode
    organizationId: $organizationId
    workspaceId: $workspaceId
    scopeType: $scopeType
    name: $name
  ) {
    skillId
    scopeType
    organizationId
    workspaceId
    userId
    name
    description
    s3Url
    version
    config
    enabled
    deleted
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
    `;

/**
 * __useGetSkillsQuery__
 *
 * To run a query within a React component, call `useGetSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsQuery({
 *   variables: {
 *      mode: // value for 'mode'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      scopeType: // value for 'scopeType'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSkillsQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
      }
export function useGetSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
        }
// @ts-ignore
export function useGetSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSkillsQuery, GetSkillsQueryVariables>;
export function useGetSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSkillsQuery | undefined, GetSkillsQueryVariables>;
export function useGetSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
        }
export type GetSkillsQueryHookResult = ReturnType<typeof useGetSkillsQuery>;
export type GetSkillsLazyQueryHookResult = ReturnType<typeof useGetSkillsLazyQuery>;
export type GetSkillsSuspenseQueryHookResult = ReturnType<typeof useGetSkillsSuspenseQuery>;
export type GetSkillsQueryResult = Apollo.QueryResult<GetSkillsQuery, GetSkillsQueryVariables>;
export const GetWorkspaceSkillOverridesDocument = gql`
    query GetWorkspaceSkillOverrides($workspaceId: String!) {
  getWorkspaceSkillOverrides(workspaceId: $workspaceId) {
    workspaceId
    skillId
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetWorkspaceSkillOverridesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSkillOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSkillOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSkillOverridesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSkillOverridesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables> & ({ variables: GetWorkspaceSkillOverridesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>(GetWorkspaceSkillOverridesDocument, options);
      }
export function useGetWorkspaceSkillOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>(GetWorkspaceSkillOverridesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceSkillOverridesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>;
export function useGetWorkspaceSkillOverridesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceSkillOverridesQuery | undefined, GetWorkspaceSkillOverridesQueryVariables>;
export function useGetWorkspaceSkillOverridesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>(GetWorkspaceSkillOverridesDocument, options);
        }
export type GetWorkspaceSkillOverridesQueryHookResult = ReturnType<typeof useGetWorkspaceSkillOverridesQuery>;
export type GetWorkspaceSkillOverridesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSkillOverridesLazyQuery>;
export type GetWorkspaceSkillOverridesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSkillOverridesSuspenseQuery>;
export type GetWorkspaceSkillOverridesQueryResult = Apollo.QueryResult<GetWorkspaceSkillOverridesQuery, GetWorkspaceSkillOverridesQueryVariables>;
export const GetUMAPLogDocument = gql`
    query GetUMAPLog($workspaceId: String!, $umapId: String!) {
  getUMAPLog(workspaceId: $workspaceId, umapId: $umapId) {
    umapId
    workspaceId
    state
    log
  }
}
    `;

/**
 * __useGetUMAPLogQuery__
 *
 * To run a query within a React component, call `useGetUMAPLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUMAPLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUMAPLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUMAPLogQuery(baseOptions: Apollo.QueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables> & ({ variables: GetUMAPLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUMAPLogQuery, GetUMAPLogQueryVariables>(GetUMAPLogDocument, options);
      }
export function useGetUMAPLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUMAPLogQuery, GetUMAPLogQueryVariables>(GetUMAPLogDocument, options);
        }
// @ts-ignore
export function useGetUMAPLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetUMAPLogQuery, GetUMAPLogQueryVariables>;
export function useGetUMAPLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetUMAPLogQuery | undefined, GetUMAPLogQueryVariables>;
export function useGetUMAPLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUMAPLogQuery, GetUMAPLogQueryVariables>(GetUMAPLogDocument, options);
        }
export type GetUMAPLogQueryHookResult = ReturnType<typeof useGetUMAPLogQuery>;
export type GetUMAPLogLazyQueryHookResult = ReturnType<typeof useGetUMAPLogLazyQuery>;
export type GetUMAPLogSuspenseQueryHookResult = ReturnType<typeof useGetUMAPLogSuspenseQuery>;
export type GetUMAPLogQueryResult = Apollo.QueryResult<GetUMAPLogQuery, GetUMAPLogQueryVariables>;
export const GetUMAPDocument = gql`
    query GetUMAP($workspaceId: String!, $umapId: String) {
  getUMAPs(workspaceId: $workspaceId, umapId: $umapId) {
    datasets {
      datasetId
      dataset
    }
    name
    results
    samples
    seed
    status
    tags
    umapId
    workspaceId
  }
}
    `;

/**
 * __useGetUMAPQuery__
 *
 * To run a query within a React component, call `useGetUMAPQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUMAPQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUMAPQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUMAPQuery(baseOptions: Apollo.QueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables> & ({ variables: GetUMAPQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUMAPQuery, GetUMAPQueryVariables>(GetUMAPDocument, options);
      }
export function useGetUMAPLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUMAPQuery, GetUMAPQueryVariables>(GetUMAPDocument, options);
        }
// @ts-ignore
export function useGetUMAPSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables>): Apollo.UseSuspenseQueryResult<GetUMAPQuery, GetUMAPQueryVariables>;
export function useGetUMAPSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables>): Apollo.UseSuspenseQueryResult<GetUMAPQuery | undefined, GetUMAPQueryVariables>;
export function useGetUMAPSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUMAPQuery, GetUMAPQueryVariables>(GetUMAPDocument, options);
        }
export type GetUMAPQueryHookResult = ReturnType<typeof useGetUMAPQuery>;
export type GetUMAPLazyQueryHookResult = ReturnType<typeof useGetUMAPLazyQuery>;
export type GetUMAPSuspenseQueryHookResult = ReturnType<typeof useGetUMAPSuspenseQuery>;
export type GetUMAPQueryResult = Apollo.QueryResult<GetUMAPQuery, GetUMAPQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  getCurrentUser {
    userId
    email
    name
    preference
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetVolumesDocument = gql`
    query GetVolumes($organizationId: String, $volumeId: String, $workspaceId: String, $cursor: String, $limit: Int, $filters: VolumeFilter, $sort: Sort) {
  getVolumes(
    organizationId: $organizationId
    volumeId: $volumeId
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
    sort: $sort
  ) {
    name
    size
    volumeId
    updatedAt
    updatedBy
    createdAt
    permission
    description
    organization
    organizationId
    tags
  }
}
    `;

/**
 * __useGetVolumesQuery__
 *
 * To run a query within a React component, call `useGetVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      volumeId: // value for 'volumeId'
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
      }
export function useGetVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
        }
// @ts-ignore
export function useGetVolumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumesQuery, GetVolumesQueryVariables>;
export function useGetVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumesQuery | undefined, GetVolumesQueryVariables>;
export function useGetVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
        }
export type GetVolumesQueryHookResult = ReturnType<typeof useGetVolumesQuery>;
export type GetVolumesLazyQueryHookResult = ReturnType<typeof useGetVolumesLazyQuery>;
export type GetVolumesSuspenseQueryHookResult = ReturnType<typeof useGetVolumesSuspenseQuery>;
export type GetVolumesQueryResult = Apollo.QueryResult<GetVolumesQuery, GetVolumesQueryVariables>;
export const GetVolumeDataDocument = gql`
    query GetVolumeData($volumeId: String!, $dir: String, $keys: [String], $cursor: String, $limit: Int, $recursive: Boolean, $filters: VolumeDataFilter, $sort: Sort) {
  getVolumeData(
    volumeId: $volumeId
    keys: $keys
    dir: $dir
    cursor: $cursor
    limit: $limit
    recursive: $recursive
    filters: $filters
    sort: $sort
  ) {
    url
    updatedAt
    thumbnailUrl
    previewUrl
    size
    key
    hash
  }
}
    `;

/**
 * __useGetVolumeDataQuery__
 *
 * To run a query within a React component, call `useGetVolumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeDataQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      dir: // value for 'dir'
 *      keys: // value for 'keys'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      recursive: // value for 'recursive'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetVolumeDataQuery(baseOptions: Apollo.QueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables> & ({ variables: GetVolumeDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
      }
export function useGetVolumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
        }
// @ts-ignore
export function useGetVolumeDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeDataQuery, GetVolumeDataQueryVariables>;
export function useGetVolumeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeDataQuery | undefined, GetVolumeDataQueryVariables>;
export function useGetVolumeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
        }
export type GetVolumeDataQueryHookResult = ReturnType<typeof useGetVolumeDataQuery>;
export type GetVolumeDataLazyQueryHookResult = ReturnType<typeof useGetVolumeDataLazyQuery>;
export type GetVolumeDataSuspenseQueryHookResult = ReturnType<typeof useGetVolumeDataSuspenseQuery>;
export type GetVolumeDataQueryResult = Apollo.QueryResult<GetVolumeDataQuery, GetVolumeDataQueryVariables>;
export const GetVolumesNamesListDocument = gql`
    query GetVolumesNamesList($organizationId: String, $workspaceId: String, $limit: Int, $cursor: String, $sort: Sort) {
  getVolumes(
    organizationId: $organizationId
    workspaceId: $workspaceId
    limit: $limit
    cursor: $cursor
    sort: $sort
  ) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetVolumesNamesListQuery__
 *
 * To run a query within a React component, call `useGetVolumesNamesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesNamesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesNamesListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetVolumesNamesListQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>(GetVolumesNamesListDocument, options);
      }
export function useGetVolumesNamesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>(GetVolumesNamesListDocument, options);
        }
// @ts-ignore
export function useGetVolumesNamesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>;
export function useGetVolumesNamesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumesNamesListQuery | undefined, GetVolumesNamesListQueryVariables>;
export function useGetVolumesNamesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>(GetVolumesNamesListDocument, options);
        }
export type GetVolumesNamesListQueryHookResult = ReturnType<typeof useGetVolumesNamesListQuery>;
export type GetVolumesNamesListLazyQueryHookResult = ReturnType<typeof useGetVolumesNamesListLazyQuery>;
export type GetVolumesNamesListSuspenseQueryHookResult = ReturnType<typeof useGetVolumesNamesListSuspenseQuery>;
export type GetVolumesNamesListQueryResult = Apollo.QueryResult<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>;
export const GetVolumeDataSearchDetailDocument = gql`
    query GetVolumeDataSearchDetail($volumeId: String!, $dir: String, $recursive: Boolean, $filters: VolumeDataFilter) {
  getVolumeDataSearchDetail(
    volumeId: $volumeId
    dir: $dir
    recursive: $recursive
    filters: $filters
  ) {
    fileFormats {
      display
      value
    }
    fileTypes {
      display
      value
    }
    tags {
      display
      value
    }
    users {
      display
      value
    }
  }
}
    `;

/**
 * __useGetVolumeDataSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetVolumeDataSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeDataSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeDataSearchDetailQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      dir: // value for 'dir'
 *      recursive: // value for 'recursive'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVolumeDataSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables> & ({ variables: GetVolumeDataSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>(GetVolumeDataSearchDetailDocument, options);
      }
export function useGetVolumeDataSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>(GetVolumeDataSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetVolumeDataSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>;
export function useGetVolumeDataSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeDataSearchDetailQuery | undefined, GetVolumeDataSearchDetailQueryVariables>;
export function useGetVolumeDataSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>(GetVolumeDataSearchDetailDocument, options);
        }
export type GetVolumeDataSearchDetailQueryHookResult = ReturnType<typeof useGetVolumeDataSearchDetailQuery>;
export type GetVolumeDataSearchDetailLazyQueryHookResult = ReturnType<typeof useGetVolumeDataSearchDetailLazyQuery>;
export type GetVolumeDataSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetVolumeDataSearchDetailSuspenseQuery>;
export type GetVolumeDataSearchDetailQueryResult = Apollo.QueryResult<GetVolumeDataSearchDetailQuery, GetVolumeDataSearchDetailQueryVariables>;
export const GetVolumeDetailsVolumeDataDocument = gql`
    query GetVolumeDetailsVolumeData($volumeId: String) {
  getVolumes(volumeId: $volumeId) {
    volumeId
    name
    permission
  }
}
    `;

/**
 * __useGetVolumeDetailsVolumeDataQuery__
 *
 * To run a query within a React component, call `useGetVolumeDetailsVolumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeDetailsVolumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeDetailsVolumeDataQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useGetVolumeDetailsVolumeDataQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>(GetVolumeDetailsVolumeDataDocument, options);
      }
export function useGetVolumeDetailsVolumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>(GetVolumeDetailsVolumeDataDocument, options);
        }
// @ts-ignore
export function useGetVolumeDetailsVolumeDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>;
export function useGetVolumeDetailsVolumeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeDetailsVolumeDataQuery | undefined, GetVolumeDetailsVolumeDataQueryVariables>;
export function useGetVolumeDetailsVolumeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>(GetVolumeDetailsVolumeDataDocument, options);
        }
export type GetVolumeDetailsVolumeDataQueryHookResult = ReturnType<typeof useGetVolumeDetailsVolumeDataQuery>;
export type GetVolumeDetailsVolumeDataLazyQueryHookResult = ReturnType<typeof useGetVolumeDetailsVolumeDataLazyQuery>;
export type GetVolumeDetailsVolumeDataSuspenseQueryHookResult = ReturnType<typeof useGetVolumeDetailsVolumeDataSuspenseQuery>;
export type GetVolumeDetailsVolumeDataQueryResult = Apollo.QueryResult<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>;
export const GetAvailableVolumesForTransferDocument = gql`
    query GetAvailableVolumesForTransfer($organizationId: String, $cursor: String, $limit: Int, $filters: VolumeFilter) {
  getVolumes(
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    size
    volumeId
    description
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAvailableVolumesForTransferQuery__
 *
 * To run a query within a React component, call `useGetAvailableVolumesForTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableVolumesForTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableVolumesForTransferQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAvailableVolumesForTransferQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>(GetAvailableVolumesForTransferDocument, options);
      }
export function useGetAvailableVolumesForTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>(GetAvailableVolumesForTransferDocument, options);
        }
// @ts-ignore
export function useGetAvailableVolumesForTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>;
export function useGetAvailableVolumesForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableVolumesForTransferQuery | undefined, GetAvailableVolumesForTransferQueryVariables>;
export function useGetAvailableVolumesForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>(GetAvailableVolumesForTransferDocument, options);
        }
export type GetAvailableVolumesForTransferQueryHookResult = ReturnType<typeof useGetAvailableVolumesForTransferQuery>;
export type GetAvailableVolumesForTransferLazyQueryHookResult = ReturnType<typeof useGetAvailableVolumesForTransferLazyQuery>;
export type GetAvailableVolumesForTransferSuspenseQueryHookResult = ReturnType<typeof useGetAvailableVolumesForTransferSuspenseQuery>;
export type GetAvailableVolumesForTransferQueryResult = Apollo.QueryResult<GetAvailableVolumesForTransferQuery, GetAvailableVolumesForTransferQueryVariables>;
export const GetAvailableVolumesForTransferSearchDetailDocument = gql`
    query GetAvailableVolumesForTransferSearchDetail($organizationId: String) {
  getVolumesSearchDetail(organizationId: $organizationId) {
    tags {
      display
      value
    }
    users {
      display
      value
    }
  }
}
    `;

/**
 * __useGetAvailableVolumesForTransferSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAvailableVolumesForTransferSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableVolumesForTransferSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableVolumesForTransferSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAvailableVolumesForTransferSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>(GetAvailableVolumesForTransferSearchDetailDocument, options);
      }
export function useGetAvailableVolumesForTransferSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>(GetAvailableVolumesForTransferSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetAvailableVolumesForTransferSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>;
export function useGetAvailableVolumesForTransferSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableVolumesForTransferSearchDetailQuery | undefined, GetAvailableVolumesForTransferSearchDetailQueryVariables>;
export function useGetAvailableVolumesForTransferSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>(GetAvailableVolumesForTransferSearchDetailDocument, options);
        }
export type GetAvailableVolumesForTransferSearchDetailQueryHookResult = ReturnType<typeof useGetAvailableVolumesForTransferSearchDetailQuery>;
export type GetAvailableVolumesForTransferSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAvailableVolumesForTransferSearchDetailLazyQuery>;
export type GetAvailableVolumesForTransferSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetAvailableVolumesForTransferSearchDetailSuspenseQuery>;
export type GetAvailableVolumesForTransferSearchDetailQueryResult = Apollo.QueryResult<GetAvailableVolumesForTransferSearchDetailQuery, GetAvailableVolumesForTransferSearchDetailQueryVariables>;
export const GetWorkspacesDocument = gql`
    query GetWorkspaces($organizationId: String, $workspaceId: String, $limit: Int, $cursor: String, $filters: WorkspaceFilter) {
  getWorkspaces(
    organizationId: $organizationId
    workspaceId: $workspaceId
    limit: $limit
    cursor: $cursor
    filters: $filters
  ) {
    workspaceId
    organizationId
    organization
    name
    createdAt
    updatedAt
    previewThumbnail
    status
    description
    tags
    visibility
  }
}
    `;

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
      }
export function useGetWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
        }
// @ts-ignore
export function useGetWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspacesQuery, GetWorkspacesQueryVariables>;
export function useGetWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspacesQuery | undefined, GetWorkspacesQueryVariables>;
export function useGetWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
        }
export type GetWorkspacesQueryHookResult = ReturnType<typeof useGetWorkspacesQuery>;
export type GetWorkspacesLazyQueryHookResult = ReturnType<typeof useGetWorkspacesLazyQuery>;
export type GetWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacesSuspenseQuery>;
export type GetWorkspacesQueryResult = Apollo.QueryResult<GetWorkspacesQuery, GetWorkspacesQueryVariables>;
export const GetWorkspacesNameListDocument = gql`
    query GetWorkspacesNameList($organizationId: String, $limit: Int, $cursor: String, $filters: WorkspaceFilter) {
  getWorkspaces(
    organizationId: $organizationId
    limit: $limit
    cursor: $cursor
    filters: $filters
  ) {
    name
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspacesNameListQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesNameListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesNameListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesNameListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesNameListQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>(GetWorkspacesNameListDocument, options);
      }
export function useGetWorkspacesNameListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>(GetWorkspacesNameListDocument, options);
        }
// @ts-ignore
export function useGetWorkspacesNameListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>;
export function useGetWorkspacesNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspacesNameListQuery | undefined, GetWorkspacesNameListQueryVariables>;
export function useGetWorkspacesNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>(GetWorkspacesNameListDocument, options);
        }
export type GetWorkspacesNameListQueryHookResult = ReturnType<typeof useGetWorkspacesNameListQuery>;
export type GetWorkspacesNameListLazyQueryHookResult = ReturnType<typeof useGetWorkspacesNameListLazyQuery>;
export type GetWorkspacesNameListSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacesNameListSuspenseQuery>;
export type GetWorkspacesNameListQueryResult = Apollo.QueryResult<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>;
export const GetWorkspaceSettingsDocument = gql`
    query GetWorkspaceSettings($workspaceId: String!, $setting: String) {
  getWorkspaceSettings(workspaceId: $workspaceId, setting: $setting) {
    workspaceId
    setting
    limit
    usage
    units
  }
}
    `;

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables> & ({ variables: GetWorkspaceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
      }
export function useGetWorkspaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>;
export function useGetWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceSettingsQuery | undefined, GetWorkspaceSettingsQueryVariables>;
export function useGetWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
        }
export type GetWorkspaceSettingsQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsQuery>;
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsLazyQuery>;
export type GetWorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsSuspenseQuery>;
export type GetWorkspaceSettingsQueryResult = Apollo.QueryResult<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>;
export const GetWorkspaceNameDocument = gql`
    query GetWorkspaceName($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    name
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceNameQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceNameQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
      }
export function useGetWorkspaceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>;
export function useGetWorkspaceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceNameQuery | undefined, GetWorkspaceNameQueryVariables>;
export function useGetWorkspaceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
        }
export type GetWorkspaceNameQueryHookResult = ReturnType<typeof useGetWorkspaceNameQuery>;
export type GetWorkspaceNameLazyQueryHookResult = ReturnType<typeof useGetWorkspaceNameLazyQuery>;
export type GetWorkspaceNameSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceNameSuspenseQuery>;
export type GetWorkspaceNameQueryResult = Apollo.QueryResult<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>;
export const GetWorkspaceContextDataDocument = gql`
    query GetWorkspaceContextData($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    description
    name
    organizationId
    status
    tags
    workspaceId
    createdBy
  }
}
    `;

/**
 * __useGetWorkspaceContextDataQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceContextDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceContextDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceContextDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceContextDataQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>(GetWorkspaceContextDataDocument, options);
      }
export function useGetWorkspaceContextDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>(GetWorkspaceContextDataDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceContextDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>;
export function useGetWorkspaceContextDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceContextDataQuery | undefined, GetWorkspaceContextDataQueryVariables>;
export function useGetWorkspaceContextDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>(GetWorkspaceContextDataDocument, options);
        }
export type GetWorkspaceContextDataQueryHookResult = ReturnType<typeof useGetWorkspaceContextDataQuery>;
export type GetWorkspaceContextDataLazyQueryHookResult = ReturnType<typeof useGetWorkspaceContextDataLazyQuery>;
export type GetWorkspaceContextDataSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceContextDataSuspenseQuery>;
export type GetWorkspaceContextDataQueryResult = Apollo.QueryResult<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>;
export const GetServiceOnlyServiceDetailsDocument = gql`
    query GetServiceOnlyServiceDetails($serviceId: String!) {
  getServices(serviceId: $serviceId) {
    createdAt
    createdBy
    name
    description
    instance
    serviceId
    tags
    updatedAt
    version
    updatedBy
    serviceType
  }
}
    `;

/**
 * __useGetServiceOnlyServiceDetailsQuery__
 *
 * To run a query within a React component, call `useGetServiceOnlyServiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOnlyServiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOnlyServiceDetailsQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetServiceOnlyServiceDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables> & ({ variables: GetServiceOnlyServiceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>(GetServiceOnlyServiceDetailsDocument, options);
      }
export function useGetServiceOnlyServiceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>(GetServiceOnlyServiceDetailsDocument, options);
        }
// @ts-ignore
export function useGetServiceOnlyServiceDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>;
export function useGetServiceOnlyServiceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyServiceDetailsQuery | undefined, GetServiceOnlyServiceDetailsQueryVariables>;
export function useGetServiceOnlyServiceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>(GetServiceOnlyServiceDetailsDocument, options);
        }
export type GetServiceOnlyServiceDetailsQueryHookResult = ReturnType<typeof useGetServiceOnlyServiceDetailsQuery>;
export type GetServiceOnlyServiceDetailsLazyQueryHookResult = ReturnType<typeof useGetServiceOnlyServiceDetailsLazyQuery>;
export type GetServiceOnlyServiceDetailsSuspenseQueryHookResult = ReturnType<typeof useGetServiceOnlyServiceDetailsSuspenseQuery>;
export type GetServiceOnlyServiceDetailsQueryResult = Apollo.QueryResult<GetServiceOnlyServiceDetailsQuery, GetServiceOnlyServiceDetailsQueryVariables>;
export const GetAnnotationTypeDocument = gql`
    query GetAnnotationType($workspaceId: String!, $annotationId: String!) {
  getAnnotations(workspaceId: $workspaceId, annotationId: $annotationId) {
    annotationId
    format
  }
}
    `;

/**
 * __useGetAnnotationTypeQuery__
 *
 * To run a query within a React component, call `useGetAnnotationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationTypeQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useGetAnnotationTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables> & ({ variables: GetAnnotationTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>(GetAnnotationTypeDocument, options);
      }
export function useGetAnnotationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>(GetAnnotationTypeDocument, options);
        }
// @ts-ignore
export function useGetAnnotationTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>;
export function useGetAnnotationTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationTypeQuery | undefined, GetAnnotationTypeQueryVariables>;
export function useGetAnnotationTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>(GetAnnotationTypeDocument, options);
        }
export type GetAnnotationTypeQueryHookResult = ReturnType<typeof useGetAnnotationTypeQuery>;
export type GetAnnotationTypeLazyQueryHookResult = ReturnType<typeof useGetAnnotationTypeLazyQuery>;
export type GetAnnotationTypeSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationTypeSuspenseQuery>;
export type GetAnnotationTypeQueryResult = Apollo.QueryResult<GetAnnotationTypeQuery, GetAnnotationTypeQueryVariables>;
export const GetGANDatasetNameDocument = gql`
    query GetGANDatasetName($workspaceId: String!, $ganDatasetId: String!) {
  getGANDatasets(workspaceId: $workspaceId, datasetId: $ganDatasetId) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetGANDatasetNameQuery__
 *
 * To run a query within a React component, call `useGetGANDatasetNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANDatasetNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANDatasetNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      ganDatasetId: // value for 'ganDatasetId'
 *   },
 * });
 */
export function useGetGANDatasetNameQuery(baseOptions: Apollo.QueryHookOptions<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables> & ({ variables: GetGANDatasetNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>(GetGANDatasetNameDocument, options);
      }
export function useGetGANDatasetNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>(GetGANDatasetNameDocument, options);
        }
// @ts-ignore
export function useGetGANDatasetNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>;
export function useGetGANDatasetNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANDatasetNameQuery | undefined, GetGANDatasetNameQueryVariables>;
export function useGetGANDatasetNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>(GetGANDatasetNameDocument, options);
        }
export type GetGANDatasetNameQueryHookResult = ReturnType<typeof useGetGANDatasetNameQuery>;
export type GetGANDatasetNameLazyQueryHookResult = ReturnType<typeof useGetGANDatasetNameLazyQuery>;
export type GetGANDatasetNameSuspenseQueryHookResult = ReturnType<typeof useGetGANDatasetNameSuspenseQuery>;
export type GetGANDatasetNameQueryResult = Apollo.QueryResult<GetGANDatasetNameQuery, GetGANDatasetNameQueryVariables>;
export const GetDatasetJobsNameDocument = gql`
    query GetDatasetJobsName($workspaceId: String, $datasetId: String) {
  getDatasetJobs(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetDatasetJobsNameQuery__
 *
 * To run a query within a React component, call `useGetDatasetJobsNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetJobsNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetJobsNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetJobsNameQuery(baseOptions?: Apollo.QueryHookOptions<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>(GetDatasetJobsNameDocument, options);
      }
export function useGetDatasetJobsNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>(GetDatasetJobsNameDocument, options);
        }
// @ts-ignore
export function useGetDatasetJobsNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>;
export function useGetDatasetJobsNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetJobsNameQuery | undefined, GetDatasetJobsNameQueryVariables>;
export function useGetDatasetJobsNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>(GetDatasetJobsNameDocument, options);
        }
export type GetDatasetJobsNameQueryHookResult = ReturnType<typeof useGetDatasetJobsNameQuery>;
export type GetDatasetJobsNameLazyQueryHookResult = ReturnType<typeof useGetDatasetJobsNameLazyQuery>;
export type GetDatasetJobsNameSuspenseQueryHookResult = ReturnType<typeof useGetDatasetJobsNameSuspenseQuery>;
export type GetDatasetJobsNameQueryResult = Apollo.QueryResult<GetDatasetJobsNameQuery, GetDatasetJobsNameQueryVariables>;
export const GetAnalyticsNameDocument = gql`
    query GetAnalyticsName($workspaceId: String!, $analyticsId: String!) {
  getAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    dataset
    type
    analyticsId
  }
}
    `;

/**
 * __useGetAnalyticsNameQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsNameQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables> & ({ variables: GetAnalyticsNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>(GetAnalyticsNameDocument, options);
      }
export function useGetAnalyticsNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>(GetAnalyticsNameDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>;
export function useGetAnalyticsNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsNameQuery | undefined, GetAnalyticsNameQueryVariables>;
export function useGetAnalyticsNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>(GetAnalyticsNameDocument, options);
        }
export type GetAnalyticsNameQueryHookResult = ReturnType<typeof useGetAnalyticsNameQuery>;
export type GetAnalyticsNameLazyQueryHookResult = ReturnType<typeof useGetAnalyticsNameLazyQuery>;
export type GetAnalyticsNameSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsNameSuspenseQuery>;
export type GetAnalyticsNameQueryResult = Apollo.QueryResult<GetAnalyticsNameQuery, GetAnalyticsNameQueryVariables>;
export const GetMLInferenceNameDocument = gql`
    query GetMLInferenceName($workspaceId: String!, $inferenceId: String!) {
  getMLInferences(workspaceId: $workspaceId, inferenceId: $inferenceId) {
    dataset
    model
    inferenceId
  }
}
    `;

/**
 * __useGetMLInferenceNameQuery__
 *
 * To run a query within a React component, call `useGetMLInferenceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferenceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferenceNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMLInferenceNameQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables> & ({ variables: GetMLInferenceNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>(GetMLInferenceNameDocument, options);
      }
export function useGetMLInferenceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>(GetMLInferenceNameDocument, options);
        }
// @ts-ignore
export function useGetMLInferenceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>;
export function useGetMLInferenceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferenceNameQuery | undefined, GetMLInferenceNameQueryVariables>;
export function useGetMLInferenceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>(GetMLInferenceNameDocument, options);
        }
export type GetMLInferenceNameQueryHookResult = ReturnType<typeof useGetMLInferenceNameQuery>;
export type GetMLInferenceNameLazyQueryHookResult = ReturnType<typeof useGetMLInferenceNameLazyQuery>;
export type GetMLInferenceNameSuspenseQueryHookResult = ReturnType<typeof useGetMLInferenceNameSuspenseQuery>;
export type GetMLInferenceNameQueryResult = Apollo.QueryResult<GetMLInferenceNameQuery, GetMLInferenceNameQueryVariables>;
export const GetMLModelNameDocument = gql`
    query GetMLModelName($workspaceId: String!, $modelId: String!) {
  getMLModels(workspaceId: $workspaceId, modelId: $modelId) {
    name
    modelId
  }
}
    `;

/**
 * __useGetMLModelNameQuery__
 *
 * To run a query within a React component, call `useGetMLModelNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelNameQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelNameQuery, GetMLModelNameQueryVariables> & ({ variables: GetMLModelNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelNameQuery, GetMLModelNameQueryVariables>(GetMLModelNameDocument, options);
      }
export function useGetMLModelNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelNameQuery, GetMLModelNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelNameQuery, GetMLModelNameQueryVariables>(GetMLModelNameDocument, options);
        }
// @ts-ignore
export function useGetMLModelNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLModelNameQuery, GetMLModelNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelNameQuery, GetMLModelNameQueryVariables>;
export function useGetMLModelNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelNameQuery, GetMLModelNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelNameQuery | undefined, GetMLModelNameQueryVariables>;
export function useGetMLModelNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelNameQuery, GetMLModelNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLModelNameQuery, GetMLModelNameQueryVariables>(GetMLModelNameDocument, options);
        }
export type GetMLModelNameQueryHookResult = ReturnType<typeof useGetMLModelNameQuery>;
export type GetMLModelNameLazyQueryHookResult = ReturnType<typeof useGetMLModelNameLazyQuery>;
export type GetMLModelNameSuspenseQueryHookResult = ReturnType<typeof useGetMLModelNameSuspenseQuery>;
export type GetMLModelNameQueryResult = Apollo.QueryResult<GetMLModelNameQuery, GetMLModelNameQueryVariables>;
export const GetUmapNameDocument = gql`
    query GetUmapName($workspaceId: String!, $umapId: String) {
  getUMAPs(workspaceId: $workspaceId, umapId: $umapId) {
    name
    umapId
  }
}
    `;

/**
 * __useGetUmapNameQuery__
 *
 * To run a query within a React component, call `useGetUmapNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUmapNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUmapNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUmapNameQuery(baseOptions: Apollo.QueryHookOptions<GetUmapNameQuery, GetUmapNameQueryVariables> & ({ variables: GetUmapNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUmapNameQuery, GetUmapNameQueryVariables>(GetUmapNameDocument, options);
      }
export function useGetUmapNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUmapNameQuery, GetUmapNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUmapNameQuery, GetUmapNameQueryVariables>(GetUmapNameDocument, options);
        }
// @ts-ignore
export function useGetUmapNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUmapNameQuery, GetUmapNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetUmapNameQuery, GetUmapNameQueryVariables>;
export function useGetUmapNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUmapNameQuery, GetUmapNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetUmapNameQuery | undefined, GetUmapNameQueryVariables>;
export function useGetUmapNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUmapNameQuery, GetUmapNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUmapNameQuery, GetUmapNameQueryVariables>(GetUmapNameDocument, options);
        }
export type GetUmapNameQueryHookResult = ReturnType<typeof useGetUmapNameQuery>;
export type GetUmapNameLazyQueryHookResult = ReturnType<typeof useGetUmapNameLazyQuery>;
export type GetUmapNameSuspenseQueryHookResult = ReturnType<typeof useGetUmapNameSuspenseQuery>;
export type GetUmapNameQueryResult = Apollo.QueryResult<GetUmapNameQuery, GetUmapNameQueryVariables>;
export const GetInpaintLogNamesDocument = gql`
    query GetInpaintLogNames($volumeId: String!, $inpaintId: String!) {
  getInpaints(volumeId: $volumeId, inpaintId: $inpaintId) {
    inpaintId
    location
  }
  getVolumes(volumeId: $volumeId) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetInpaintLogNamesQuery__
 *
 * To run a query within a React component, call `useGetInpaintLogNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintLogNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintLogNamesQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useGetInpaintLogNamesQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables> & ({ variables: GetInpaintLogNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>(GetInpaintLogNamesDocument, options);
      }
export function useGetInpaintLogNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>(GetInpaintLogNamesDocument, options);
        }
// @ts-ignore
export function useGetInpaintLogNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>;
export function useGetInpaintLogNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInpaintLogNamesQuery | undefined, GetInpaintLogNamesQueryVariables>;
export function useGetInpaintLogNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>(GetInpaintLogNamesDocument, options);
        }
export type GetInpaintLogNamesQueryHookResult = ReturnType<typeof useGetInpaintLogNamesQuery>;
export type GetInpaintLogNamesLazyQueryHookResult = ReturnType<typeof useGetInpaintLogNamesLazyQuery>;
export type GetInpaintLogNamesSuspenseQueryHookResult = ReturnType<typeof useGetInpaintLogNamesSuspenseQuery>;
export type GetInpaintLogNamesQueryResult = Apollo.QueryResult<GetInpaintLogNamesQuery, GetInpaintLogNamesQueryVariables>;
export const GetOrganizationJobsDocument = gql`
    query GetOrganizationJobs($organizationId: String) {
  getDatasetJobs(organizationId: $organizationId) {
    datasetId
    workspaceId
    name
    runs
    status
    createdAt
    estimatedEndAt
  }
}
    `;

/**
 * __useGetOrganizationJobsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationJobsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
      }
export function useGetOrganizationJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>;
export function useGetOrganizationJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationJobsQuery | undefined, GetOrganizationJobsQueryVariables>;
export function useGetOrganizationJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
        }
export type GetOrganizationJobsQueryHookResult = ReturnType<typeof useGetOrganizationJobsQuery>;
export type GetOrganizationJobsLazyQueryHookResult = ReturnType<typeof useGetOrganizationJobsLazyQuery>;
export type GetOrganizationJobsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationJobsSuspenseQuery>;
export type GetOrganizationJobsQueryResult = Apollo.QueryResult<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>;
export const GetWorkspacesSearchDetailDocument = gql`
    query GetWorkspacesSearchDetail($organizationId: String!, $filters: WorkspaceFilter) {
  getWorkspacesSearchDetail(organizationId: $organizationId, filters: $filters) {
    channels {
      value
      display
    }
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetWorkspacesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables> & ({ variables: GetWorkspacesSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
      }
export function useGetWorkspacesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetWorkspacesSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>;
export function useGetWorkspacesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspacesSearchDetailQuery | undefined, GetWorkspacesSearchDetailQueryVariables>;
export function useGetWorkspacesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
        }
export type GetWorkspacesSearchDetailQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailQuery>;
export type GetWorkspacesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailLazyQuery>;
export type GetWorkspacesSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailSuspenseQuery>;
export type GetWorkspacesSearchDetailQueryResult = Apollo.QueryResult<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>;
export const GetChannelsSearchDetailDocument = gql`
    query GetChannelsSearchDetail($organizationId: String, $filters: ChannelFilter, $workspaceId: String) {
  getChannelsSearchDetail(
    organizationId: $organizationId
    filters: $filters
    workspaceId: $workspaceId
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetChannelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetChannelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetChannelsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
      }
export function useGetChannelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetChannelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>;
export function useGetChannelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelsSearchDetailQuery | undefined, GetChannelsSearchDetailQueryVariables>;
export function useGetChannelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
        }
export type GetChannelsSearchDetailQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailQuery>;
export type GetChannelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailLazyQuery>;
export type GetChannelsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailSuspenseQuery>;
export type GetChannelsSearchDetailQueryResult = Apollo.QueryResult<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>;
export const GetVolumesSearchDetailDocument = gql`
    query GetVolumesSearchDetail($organizationId: String, $workspaceId: String, $filters: VolumeFilter) {
  getVolumesSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetVolumesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetVolumesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVolumesSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
      }
export function useGetVolumesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetVolumesSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>;
export function useGetVolumesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumesSearchDetailQuery | undefined, GetVolumesSearchDetailQueryVariables>;
export function useGetVolumesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
        }
export type GetVolumesSearchDetailQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailQuery>;
export type GetVolumesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailLazyQuery>;
export type GetVolumesSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailSuspenseQuery>;
export type GetVolumesSearchDetailQueryResult = Apollo.QueryResult<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>;
export const GetAnnotationMapsSearchDetailDocument = gql`
    query GetAnnotationMapsSearchDetail($organizationId: String, $workspaceId: String, $filters: AnnotationMapFilter) {
  getAnnotationMapsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetAnnotationMapsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAnnotationMapsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationMapsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationMapsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAnnotationMapsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
      }
export function useGetAnnotationMapsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetAnnotationMapsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>;
export function useGetAnnotationMapsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationMapsSearchDetailQuery | undefined, GetAnnotationMapsSearchDetailQueryVariables>;
export function useGetAnnotationMapsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
        }
export type GetAnnotationMapsSearchDetailQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailQuery>;
export type GetAnnotationMapsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailLazyQuery>;
export type GetAnnotationMapsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailSuspenseQuery>;
export type GetAnnotationMapsSearchDetailQueryResult = Apollo.QueryResult<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>;
export const GetGANModelsSearchDetailDocument = gql`
    query GetGANModelsSearchDetail($organizationId: String, $workspaceId: String, $filters: GANModelFilter) {
  getGANModelsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetGANModelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetGANModelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANModelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANModelsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGANModelsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>(GetGANModelsSearchDetailDocument, options);
      }
export function useGetGANModelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>(GetGANModelsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetGANModelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>;
export function useGetGANModelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetGANModelsSearchDetailQuery | undefined, GetGANModelsSearchDetailQueryVariables>;
export function useGetGANModelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>(GetGANModelsSearchDetailDocument, options);
        }
export type GetGANModelsSearchDetailQueryHookResult = ReturnType<typeof useGetGANModelsSearchDetailQuery>;
export type GetGANModelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetGANModelsSearchDetailLazyQuery>;
export type GetGANModelsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetGANModelsSearchDetailSuspenseQuery>;
export type GetGANModelsSearchDetailQueryResult = Apollo.QueryResult<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>;
export const GetChannelDataForEditDocument = gql`
    query GetChannelDataForEdit($channelId: String!, $organizationId: String!) {
  getChannels(channelId: $channelId, organizationId: $organizationId) {
    channelId
    volumes
    timeout
  }
}
    `;

/**
 * __useGetChannelDataForEditQuery__
 *
 * To run a query within a React component, call `useGetChannelDataForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelDataForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelDataForEditQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetChannelDataForEditQuery(baseOptions: Apollo.QueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables> & ({ variables: GetChannelDataForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>(GetChannelDataForEditDocument, options);
      }
export function useGetChannelDataForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>(GetChannelDataForEditDocument, options);
        }
// @ts-ignore
export function useGetChannelDataForEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>;
export function useGetChannelDataForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelDataForEditQuery | undefined, GetChannelDataForEditQueryVariables>;
export function useGetChannelDataForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>(GetChannelDataForEditDocument, options);
        }
export type GetChannelDataForEditQueryHookResult = ReturnType<typeof useGetChannelDataForEditQuery>;
export type GetChannelDataForEditLazyQueryHookResult = ReturnType<typeof useGetChannelDataForEditLazyQuery>;
export type GetChannelDataForEditSuspenseQueryHookResult = ReturnType<typeof useGetChannelDataForEditSuspenseQuery>;
export type GetChannelDataForEditQueryResult = Apollo.QueryResult<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>;
export const GetOrganizationRemoteDevelopmentSessionsDocument = gql`
    query GetOrganizationRemoteDevelopmentSessions {
  listRemoteDevelopment {
    channelId
    ...ChannelTableRowSessionFragment
  }
}
    ${ChannelTableRowSessionFragmentFragmentDoc}`;

/**
 * __useGetOrganizationRemoteDevelopmentSessionsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRemoteDevelopmentSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRemoteDevelopmentSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRemoteDevelopmentSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationRemoteDevelopmentSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>(GetOrganizationRemoteDevelopmentSessionsDocument, options);
      }
export function useGetOrganizationRemoteDevelopmentSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>(GetOrganizationRemoteDevelopmentSessionsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationRemoteDevelopmentSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>;
export function useGetOrganizationRemoteDevelopmentSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationRemoteDevelopmentSessionsQuery | undefined, GetOrganizationRemoteDevelopmentSessionsQueryVariables>;
export function useGetOrganizationRemoteDevelopmentSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>(GetOrganizationRemoteDevelopmentSessionsDocument, options);
        }
export type GetOrganizationRemoteDevelopmentSessionsQueryHookResult = ReturnType<typeof useGetOrganizationRemoteDevelopmentSessionsQuery>;
export type GetOrganizationRemoteDevelopmentSessionsLazyQueryHookResult = ReturnType<typeof useGetOrganizationRemoteDevelopmentSessionsLazyQuery>;
export type GetOrganizationRemoteDevelopmentSessionsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationRemoteDevelopmentSessionsSuspenseQuery>;
export type GetOrganizationRemoteDevelopmentSessionsQueryResult = Apollo.QueryResult<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>;
export const GetOrganizationChannelsDocument = gql`
    query GetOrganizationChannels($organizationId: String, $filters: ChannelFilter, $limit: Int, $cursor: String) {
  getChannels(
    organizationId: $organizationId
    filters: $filters
    limit: $limit
    cursor: $cursor
  ) {
    channelId
    ...ChannelTableRowChannelFragment
  }
}
    ${ChannelTableRowChannelFragmentFragmentDoc}`;

/**
 * __useGetOrganizationChannelsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetOrganizationChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>(GetOrganizationChannelsDocument, options);
      }
export function useGetOrganizationChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>(GetOrganizationChannelsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>;
export function useGetOrganizationChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationChannelsQuery | undefined, GetOrganizationChannelsQueryVariables>;
export function useGetOrganizationChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>(GetOrganizationChannelsDocument, options);
        }
export type GetOrganizationChannelsQueryHookResult = ReturnType<typeof useGetOrganizationChannelsQuery>;
export type GetOrganizationChannelsLazyQueryHookResult = ReturnType<typeof useGetOrganizationChannelsLazyQuery>;
export type GetOrganizationChannelsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationChannelsSuspenseQuery>;
export type GetOrganizationChannelsQueryResult = Apollo.QueryResult<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>;
export const GetWorkspaceTableWorkspaceChannelsDocument = gql`
    query GetWorkspaceTableWorkspaceChannels($workspaceId: String!) {
  getChannels(workspaceId: $workspaceId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetWorkspaceTableWorkspaceChannelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTableWorkspaceChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTableWorkspaceChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTableWorkspaceChannelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceTableWorkspaceChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables> & ({ variables: GetWorkspaceTableWorkspaceChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>(GetWorkspaceTableWorkspaceChannelsDocument, options);
      }
export function useGetWorkspaceTableWorkspaceChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>(GetWorkspaceTableWorkspaceChannelsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceTableWorkspaceChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>;
export function useGetWorkspaceTableWorkspaceChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTableWorkspaceChannelsQuery | undefined, GetWorkspaceTableWorkspaceChannelsQueryVariables>;
export function useGetWorkspaceTableWorkspaceChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>(GetWorkspaceTableWorkspaceChannelsDocument, options);
        }
export type GetWorkspaceTableWorkspaceChannelsQueryHookResult = ReturnType<typeof useGetWorkspaceTableWorkspaceChannelsQuery>;
export type GetWorkspaceTableWorkspaceChannelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceTableWorkspaceChannelsLazyQuery>;
export type GetWorkspaceTableWorkspaceChannelsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceTableWorkspaceChannelsSuspenseQuery>;
export type GetWorkspaceTableWorkspaceChannelsQueryResult = Apollo.QueryResult<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>;
export const GetContentCodesDocument = gql`
    query GetContentCodes {
  getContentCodes {
    code
    name
    description
    thumbnail
    link
    featured
    contactUs
    expiresAt
  }
}
    `;

/**
 * __useGetContentCodesQuery__
 *
 * To run a query within a React component, call `useGetContentCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
      }
export function useGetContentCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
        }
// @ts-ignore
export function useGetContentCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentCodesQuery, GetContentCodesQueryVariables>;
export function useGetContentCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentCodesQuery | undefined, GetContentCodesQueryVariables>;
export function useGetContentCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
        }
export type GetContentCodesQueryHookResult = ReturnType<typeof useGetContentCodesQuery>;
export type GetContentCodesLazyQueryHookResult = ReturnType<typeof useGetContentCodesLazyQuery>;
export type GetContentCodesSuspenseQueryHookResult = ReturnType<typeof useGetContentCodesSuspenseQuery>;
export type GetContentCodesQueryResult = Apollo.QueryResult<GetContentCodesQuery, GetContentCodesQueryVariables>;
export const GetWorkspaceTemplatesDocument = gql`
    query GetWorkspaceTemplates($organizationId: String) {
  getWorkspaceTemplates(organizationId: $organizationId) {
    templateId
    name
    description
    thumbnail
    category
    index
  }
}
    `;

/**
 * __useGetWorkspaceTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkspaceTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>(GetWorkspaceTemplatesDocument, options);
      }
export function useGetWorkspaceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>(GetWorkspaceTemplatesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>;
export function useGetWorkspaceTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTemplatesQuery | undefined, GetWorkspaceTemplatesQueryVariables>;
export function useGetWorkspaceTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>(GetWorkspaceTemplatesDocument, options);
        }
export type GetWorkspaceTemplatesQueryHookResult = ReturnType<typeof useGetWorkspaceTemplatesQuery>;
export type GetWorkspaceTemplatesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceTemplatesLazyQuery>;
export type GetWorkspaceTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceTemplatesSuspenseQuery>;
export type GetWorkspaceTemplatesQueryResult = Apollo.QueryResult<GetWorkspaceTemplatesQuery, GetWorkspaceTemplatesQueryVariables>;
export const GetWorkspaceTemplateDetailsDocument = gql`
    query GetWorkspaceTemplateDetails($templateId: String!) {
  getTemplateDetails(templateId: $templateId) {
    templateId
    demoVideo
    documentation
    keyFeatures
    license
    tags
    updatedAt
    version
    organization
  }
}
    `;

/**
 * __useGetWorkspaceTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTemplateDetailsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetWorkspaceTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables> & ({ variables: GetWorkspaceTemplateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>(GetWorkspaceTemplateDetailsDocument, options);
      }
export function useGetWorkspaceTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>(GetWorkspaceTemplateDetailsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>;
export function useGetWorkspaceTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceTemplateDetailsQuery | undefined, GetWorkspaceTemplateDetailsQueryVariables>;
export function useGetWorkspaceTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>(GetWorkspaceTemplateDetailsDocument, options);
        }
export type GetWorkspaceTemplateDetailsQueryHookResult = ReturnType<typeof useGetWorkspaceTemplateDetailsQuery>;
export type GetWorkspaceTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceTemplateDetailsLazyQuery>;
export type GetWorkspaceTemplateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceTemplateDetailsSuspenseQuery>;
export type GetWorkspaceTemplateDetailsQueryResult = Apollo.QueryResult<GetWorkspaceTemplateDetailsQuery, GetWorkspaceTemplateDetailsQueryVariables>;
export const GetServiceTemplatesDocument = gql`
    query GetServiceTemplates($organizationId: String) {
  getServiceTemplates(organizationId: $organizationId) {
    serviceId
    name
    description
    thumbnail
    category
    index
  }
}
    `;

/**
 * __useGetServiceTemplatesQuery__
 *
 * To run a query within a React component, call `useGetServiceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetServiceTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>(GetServiceTemplatesDocument, options);
      }
export function useGetServiceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>(GetServiceTemplatesDocument, options);
        }
// @ts-ignore
export function useGetServiceTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>;
export function useGetServiceTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceTemplatesQuery | undefined, GetServiceTemplatesQueryVariables>;
export function useGetServiceTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>(GetServiceTemplatesDocument, options);
        }
export type GetServiceTemplatesQueryHookResult = ReturnType<typeof useGetServiceTemplatesQuery>;
export type GetServiceTemplatesLazyQueryHookResult = ReturnType<typeof useGetServiceTemplatesLazyQuery>;
export type GetServiceTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetServiceTemplatesSuspenseQuery>;
export type GetServiceTemplatesQueryResult = Apollo.QueryResult<GetServiceTemplatesQuery, GetServiceTemplatesQueryVariables>;
export const GetServiceTemplateDetailsDocument = gql`
    query GetServiceTemplateDetails($serviceId: String!) {
  getServiceTemplateDetails(serviceId: $serviceId) {
    serviceId
    demoVideo
    documentation
    keyFeatures
    license
    tags
    updatedAt
    version
    organization
  }
}
    `;

/**
 * __useGetServiceTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetServiceTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceTemplateDetailsQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetServiceTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables> & ({ variables: GetServiceTemplateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>(GetServiceTemplateDetailsDocument, options);
      }
export function useGetServiceTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>(GetServiceTemplateDetailsDocument, options);
        }
// @ts-ignore
export function useGetServiceTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>;
export function useGetServiceTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceTemplateDetailsQuery | undefined, GetServiceTemplateDetailsQueryVariables>;
export function useGetServiceTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>(GetServiceTemplateDetailsDocument, options);
        }
export type GetServiceTemplateDetailsQueryHookResult = ReturnType<typeof useGetServiceTemplateDetailsQuery>;
export type GetServiceTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetServiceTemplateDetailsLazyQuery>;
export type GetServiceTemplateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetServiceTemplateDetailsSuspenseQuery>;
export type GetServiceTemplateDetailsQueryResult = Apollo.QueryResult<GetServiceTemplateDetailsQuery, GetServiceTemplateDetailsQueryVariables>;
export const GetVolumeTemplatesDocument = gql`
    query GetVolumeTemplates($organizationId: String) {
  getVolumeTemplates(organizationId: $organizationId) {
    volumeId
    name
    description
    thumbnail
    category
    index
  }
}
    `;

/**
 * __useGetVolumeTemplatesQuery__
 *
 * To run a query within a React component, call `useGetVolumeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetVolumeTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>(GetVolumeTemplatesDocument, options);
      }
export function useGetVolumeTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>(GetVolumeTemplatesDocument, options);
        }
// @ts-ignore
export function useGetVolumeTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>;
export function useGetVolumeTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeTemplatesQuery | undefined, GetVolumeTemplatesQueryVariables>;
export function useGetVolumeTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>(GetVolumeTemplatesDocument, options);
        }
export type GetVolumeTemplatesQueryHookResult = ReturnType<typeof useGetVolumeTemplatesQuery>;
export type GetVolumeTemplatesLazyQueryHookResult = ReturnType<typeof useGetVolumeTemplatesLazyQuery>;
export type GetVolumeTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetVolumeTemplatesSuspenseQuery>;
export type GetVolumeTemplatesQueryResult = Apollo.QueryResult<GetVolumeTemplatesQuery, GetVolumeTemplatesQueryVariables>;
export const GetVolumeTemplateDetailsDocument = gql`
    query GetVolumeTemplateDetails($volumeId: String!) {
  getVolumeTemplateDetails(volumeId: $volumeId) {
    volumeId
    demoVideo
    documentation
    keyFeatures
    license
    tags
    updatedAt
    version
    organization
  }
}
    `;

/**
 * __useGetVolumeTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetVolumeTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeTemplateDetailsQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useGetVolumeTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables> & ({ variables: GetVolumeTemplateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>(GetVolumeTemplateDetailsDocument, options);
      }
export function useGetVolumeTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>(GetVolumeTemplateDetailsDocument, options);
        }
// @ts-ignore
export function useGetVolumeTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>;
export function useGetVolumeTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVolumeTemplateDetailsQuery | undefined, GetVolumeTemplateDetailsQueryVariables>;
export function useGetVolumeTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>(GetVolumeTemplateDetailsDocument, options);
        }
export type GetVolumeTemplateDetailsQueryHookResult = ReturnType<typeof useGetVolumeTemplateDetailsQuery>;
export type GetVolumeTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetVolumeTemplateDetailsLazyQuery>;
export type GetVolumeTemplateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetVolumeTemplateDetailsSuspenseQuery>;
export type GetVolumeTemplateDetailsQueryResult = Apollo.QueryResult<GetVolumeTemplateDetailsQuery, GetVolumeTemplateDetailsQueryVariables>;
export const GetRuleTemplatesDocument = gql`
    query GetRuleTemplates($organizationId: String, $ruleType: String) {
  getRuleTemplates(organizationId: $organizationId, ruleType: $ruleType) {
    ruleId
    name
    description
    category
    index
  }
}
    `;

/**
 * __useGetRuleTemplatesQuery__
 *
 * To run a query within a React component, call `useGetRuleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuleTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      ruleType: // value for 'ruleType'
 *   },
 * });
 */
export function useGetRuleTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>(GetRuleTemplatesDocument, options);
      }
export function useGetRuleTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>(GetRuleTemplatesDocument, options);
        }
// @ts-ignore
export function useGetRuleTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>;
export function useGetRuleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRuleTemplatesQuery | undefined, GetRuleTemplatesQueryVariables>;
export function useGetRuleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>(GetRuleTemplatesDocument, options);
        }
export type GetRuleTemplatesQueryHookResult = ReturnType<typeof useGetRuleTemplatesQuery>;
export type GetRuleTemplatesLazyQueryHookResult = ReturnType<typeof useGetRuleTemplatesLazyQuery>;
export type GetRuleTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetRuleTemplatesSuspenseQuery>;
export type GetRuleTemplatesQueryResult = Apollo.QueryResult<GetRuleTemplatesQuery, GetRuleTemplatesQueryVariables>;
export const GetRuleTemplateDetailsDocument = gql`
    query GetRuleTemplateDetails($ruleId: String!) {
  getRuleTemplateDetails(ruleId: $ruleId) {
    ruleId
    tags
    updatedAt
    version
    organization
    rules
  }
}
    `;

/**
 * __useGetRuleTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetRuleTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuleTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuleTemplateDetailsQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useGetRuleTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables> & ({ variables: GetRuleTemplateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>(GetRuleTemplateDetailsDocument, options);
      }
export function useGetRuleTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>(GetRuleTemplateDetailsDocument, options);
        }
// @ts-ignore
export function useGetRuleTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>;
export function useGetRuleTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRuleTemplateDetailsQuery | undefined, GetRuleTemplateDetailsQueryVariables>;
export function useGetRuleTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>(GetRuleTemplateDetailsDocument, options);
        }
export type GetRuleTemplateDetailsQueryHookResult = ReturnType<typeof useGetRuleTemplateDetailsQuery>;
export type GetRuleTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetRuleTemplateDetailsLazyQuery>;
export type GetRuleTemplateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetRuleTemplateDetailsSuspenseQuery>;
export type GetRuleTemplateDetailsQueryResult = Apollo.QueryResult<GetRuleTemplateDetailsQuery, GetRuleTemplateDetailsQueryVariables>;
export const GetSkillTemplatesDocument = gql`
    query GetSkillTemplates($organizationId: String) {
  getSkillTemplates(organizationId: $organizationId) {
    skillId
    name
    description
    thumbnail
    category
    index
  }
}
    `;

/**
 * __useGetSkillTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSkillTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSkillTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>(GetSkillTemplatesDocument, options);
      }
export function useGetSkillTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>(GetSkillTemplatesDocument, options);
        }
// @ts-ignore
export function useGetSkillTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>;
export function useGetSkillTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSkillTemplatesQuery | undefined, GetSkillTemplatesQueryVariables>;
export function useGetSkillTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>(GetSkillTemplatesDocument, options);
        }
export type GetSkillTemplatesQueryHookResult = ReturnType<typeof useGetSkillTemplatesQuery>;
export type GetSkillTemplatesLazyQueryHookResult = ReturnType<typeof useGetSkillTemplatesLazyQuery>;
export type GetSkillTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetSkillTemplatesSuspenseQuery>;
export type GetSkillTemplatesQueryResult = Apollo.QueryResult<GetSkillTemplatesQuery, GetSkillTemplatesQueryVariables>;
export const GetSkillTemplateDetailsDocument = gql`
    query GetSkillTemplateDetails($skillId: String!) {
  getSkillTemplateDetails(skillId: $skillId) {
    skillId
    demoVideo
    documentation
    keyFeatures
    license
    tags
    updatedAt
    version
    skillVersion
    organization
  }
}
    `;

/**
 * __useGetSkillTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetSkillTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillTemplateDetailsQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useGetSkillTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables> & ({ variables: GetSkillTemplateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>(GetSkillTemplateDetailsDocument, options);
      }
export function useGetSkillTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>(GetSkillTemplateDetailsDocument, options);
        }
// @ts-ignore
export function useGetSkillTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>;
export function useGetSkillTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSkillTemplateDetailsQuery | undefined, GetSkillTemplateDetailsQueryVariables>;
export function useGetSkillTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>(GetSkillTemplateDetailsDocument, options);
        }
export type GetSkillTemplateDetailsQueryHookResult = ReturnType<typeof useGetSkillTemplateDetailsQuery>;
export type GetSkillTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetSkillTemplateDetailsLazyQuery>;
export type GetSkillTemplateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSkillTemplateDetailsSuspenseQuery>;
export type GetSkillTemplateDetailsQueryResult = Apollo.QueryResult<GetSkillTemplateDetailsQuery, GetSkillTemplateDetailsQueryVariables>;
export const GetMcpTemplatesDocument = gql`
    query GetMcpTemplates($organizationId: String) {
  getMcpTemplates(organizationId: $organizationId) {
    mcpServerId
    name
    description
    thumbnail
    category
    index
  }
}
    `;

/**
 * __useGetMcpTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMcpTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetMcpTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>(GetMcpTemplatesDocument, options);
      }
export function useGetMcpTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>(GetMcpTemplatesDocument, options);
        }
// @ts-ignore
export function useGetMcpTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>;
export function useGetMcpTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpTemplatesQuery | undefined, GetMcpTemplatesQueryVariables>;
export function useGetMcpTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>(GetMcpTemplatesDocument, options);
        }
export type GetMcpTemplatesQueryHookResult = ReturnType<typeof useGetMcpTemplatesQuery>;
export type GetMcpTemplatesLazyQueryHookResult = ReturnType<typeof useGetMcpTemplatesLazyQuery>;
export type GetMcpTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMcpTemplatesSuspenseQuery>;
export type GetMcpTemplatesQueryResult = Apollo.QueryResult<GetMcpTemplatesQuery, GetMcpTemplatesQueryVariables>;
export const GetMcpTemplateDetailsDocument = gql`
    query GetMcpTemplateDetails($mcpServerId: String!) {
  getMcpTemplateDetails(mcpServerId: $mcpServerId) {
    mcpServerId
    demoVideo
    documentation
    keyFeatures
    license
    tags
    updatedAt
    version
    organization
  }
}
    `;

/**
 * __useGetMcpTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetMcpTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpTemplateDetailsQuery({
 *   variables: {
 *      mcpServerId: // value for 'mcpServerId'
 *   },
 * });
 */
export function useGetMcpTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables> & ({ variables: GetMcpTemplateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>(GetMcpTemplateDetailsDocument, options);
      }
export function useGetMcpTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>(GetMcpTemplateDetailsDocument, options);
        }
// @ts-ignore
export function useGetMcpTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>;
export function useGetMcpTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpTemplateDetailsQuery | undefined, GetMcpTemplateDetailsQueryVariables>;
export function useGetMcpTemplateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>(GetMcpTemplateDetailsDocument, options);
        }
export type GetMcpTemplateDetailsQueryHookResult = ReturnType<typeof useGetMcpTemplateDetailsQuery>;
export type GetMcpTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetMcpTemplateDetailsLazyQuery>;
export type GetMcpTemplateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetMcpTemplateDetailsSuspenseQuery>;
export type GetMcpTemplateDetailsQueryResult = Apollo.QueryResult<GetMcpTemplateDetailsQuery, GetMcpTemplateDetailsQueryVariables>;
export const GetServicesOnlyOrganizationServersDocument = gql`
    query GetServicesOnlyOrganizationServers($organizationId: String, $sort: Sort) {
  getEditors(organizationId: $organizationId, sort: $sort) {
    editorId
    instanceType
    serverPath
    status {
      state
      message
    }
    sshPort
    url
    workspaceId
    workspace
    name
  }
}
    `;

/**
 * __useGetServicesOnlyOrganizationServersQuery__
 *
 * To run a query within a React component, call `useGetServicesOnlyOrganizationServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesOnlyOrganizationServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesOnlyOrganizationServersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetServicesOnlyOrganizationServersQuery(baseOptions?: Apollo.QueryHookOptions<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>(GetServicesOnlyOrganizationServersDocument, options);
      }
export function useGetServicesOnlyOrganizationServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>(GetServicesOnlyOrganizationServersDocument, options);
        }
// @ts-ignore
export function useGetServicesOnlyOrganizationServersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>): Apollo.UseSuspenseQueryResult<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>;
export function useGetServicesOnlyOrganizationServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>): Apollo.UseSuspenseQueryResult<GetServicesOnlyOrganizationServersQuery | undefined, GetServicesOnlyOrganizationServersQueryVariables>;
export function useGetServicesOnlyOrganizationServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>(GetServicesOnlyOrganizationServersDocument, options);
        }
export type GetServicesOnlyOrganizationServersQueryHookResult = ReturnType<typeof useGetServicesOnlyOrganizationServersQuery>;
export type GetServicesOnlyOrganizationServersLazyQueryHookResult = ReturnType<typeof useGetServicesOnlyOrganizationServersLazyQuery>;
export type GetServicesOnlyOrganizationServersSuspenseQueryHookResult = ReturnType<typeof useGetServicesOnlyOrganizationServersSuspenseQuery>;
export type GetServicesOnlyOrganizationServersQueryResult = Apollo.QueryResult<GetServicesOnlyOrganizationServersQuery, GetServicesOnlyOrganizationServersQueryVariables>;
export const GetServerDocument = gql`
    query GetServer($editorId: String!) {
  getEditors(editorId: $editorId) {
    editorId
    url
    serverPath
  }
}
    `;

/**
 * __useGetServerQuery__
 *
 * To run a query within a React component, call `useGetServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerQuery({
 *   variables: {
 *      editorId: // value for 'editorId'
 *   },
 * });
 */
export function useGetServerQuery(baseOptions: Apollo.QueryHookOptions<GetServerQuery, GetServerQueryVariables> & ({ variables: GetServerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerQuery, GetServerQueryVariables>(GetServerDocument, options);
      }
export function useGetServerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerQuery, GetServerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerQuery, GetServerQueryVariables>(GetServerDocument, options);
        }
// @ts-ignore
export function useGetServerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServerQuery, GetServerQueryVariables>): Apollo.UseSuspenseQueryResult<GetServerQuery, GetServerQueryVariables>;
export function useGetServerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerQuery, GetServerQueryVariables>): Apollo.UseSuspenseQueryResult<GetServerQuery | undefined, GetServerQueryVariables>;
export function useGetServerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerQuery, GetServerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServerQuery, GetServerQueryVariables>(GetServerDocument, options);
        }
export type GetServerQueryHookResult = ReturnType<typeof useGetServerQuery>;
export type GetServerLazyQueryHookResult = ReturnType<typeof useGetServerLazyQuery>;
export type GetServerSuspenseQueryHookResult = ReturnType<typeof useGetServerSuspenseQuery>;
export type GetServerQueryResult = Apollo.QueryResult<GetServerQuery, GetServerQueryVariables>;
export const GetOrganizationEditorsDocument = gql`
    query GetOrganizationEditors($organizationId: String, $cursor: String, $limit: Int, $filters: EditorsFilter, $sort: Sort) {
  getEditors(
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
    sort: $sort
  ) {
    editorId
    name
    workspaceId
    workspace
    instanceType
    url
    sshPort
    serverPath
    status {
      state
      message
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    startedAt
    autoStopEnabled
    autoStopCpuThreshold
    autoStopTimeoutMinutes
    autoDeleteEnabled
    autoDeleteTimeoutDays
    autoUpdateEnabled
    deleteAfter
    visibility
    users
  }
}
    `;

/**
 * __useGetOrganizationEditorsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEditorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEditorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEditorsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationEditorsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>(GetOrganizationEditorsDocument, options);
      }
export function useGetOrganizationEditorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>(GetOrganizationEditorsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationEditorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>;
export function useGetOrganizationEditorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationEditorsQuery | undefined, GetOrganizationEditorsQueryVariables>;
export function useGetOrganizationEditorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>(GetOrganizationEditorsDocument, options);
        }
export type GetOrganizationEditorsQueryHookResult = ReturnType<typeof useGetOrganizationEditorsQuery>;
export type GetOrganizationEditorsLazyQueryHookResult = ReturnType<typeof useGetOrganizationEditorsLazyQuery>;
export type GetOrganizationEditorsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationEditorsSuspenseQuery>;
export type GetOrganizationEditorsQueryResult = Apollo.QueryResult<GetOrganizationEditorsQuery, GetOrganizationEditorsQueryVariables>;
export const GetOrganizationEditorsSearchDetailDocument = gql`
    query GetOrganizationEditorsSearchDetail($filters: EditorsFilter, $organizationId: String) {
  getEditorsSearchDetail(filters: $filters, organizationId: $organizationId) {
    status {
      display
      value
    }
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetOrganizationEditorsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEditorsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEditorsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEditorsSearchDetailQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationEditorsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>(GetOrganizationEditorsSearchDetailDocument, options);
      }
export function useGetOrganizationEditorsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>(GetOrganizationEditorsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetOrganizationEditorsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>;
export function useGetOrganizationEditorsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationEditorsSearchDetailQuery | undefined, GetOrganizationEditorsSearchDetailQueryVariables>;
export function useGetOrganizationEditorsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>(GetOrganizationEditorsSearchDetailDocument, options);
        }
export type GetOrganizationEditorsSearchDetailQueryHookResult = ReturnType<typeof useGetOrganizationEditorsSearchDetailQuery>;
export type GetOrganizationEditorsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetOrganizationEditorsSearchDetailLazyQuery>;
export type GetOrganizationEditorsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationEditorsSearchDetailSuspenseQuery>;
export type GetOrganizationEditorsSearchDetailQueryResult = Apollo.QueryResult<GetOrganizationEditorsSearchDetailQuery, GetOrganizationEditorsSearchDetailQueryVariables>;
export const GetServiceOnlyServiceVolumesDocument = gql`
    query GetServiceOnlyServiceVolumes($serviceId: String) {
  getVolumes(serviceId: $serviceId) {
    size
    name
    description
    volumeId
    workspaceVolume
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetServiceOnlyServiceVolumesQuery__
 *
 * To run a query within a React component, call `useGetServiceOnlyServiceVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOnlyServiceVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOnlyServiceVolumesQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetServiceOnlyServiceVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>(GetServiceOnlyServiceVolumesDocument, options);
      }
export function useGetServiceOnlyServiceVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>(GetServiceOnlyServiceVolumesDocument, options);
        }
// @ts-ignore
export function useGetServiceOnlyServiceVolumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>;
export function useGetServiceOnlyServiceVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyServiceVolumesQuery | undefined, GetServiceOnlyServiceVolumesQueryVariables>;
export function useGetServiceOnlyServiceVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>(GetServiceOnlyServiceVolumesDocument, options);
        }
export type GetServiceOnlyServiceVolumesQueryHookResult = ReturnType<typeof useGetServiceOnlyServiceVolumesQuery>;
export type GetServiceOnlyServiceVolumesLazyQueryHookResult = ReturnType<typeof useGetServiceOnlyServiceVolumesLazyQuery>;
export type GetServiceOnlyServiceVolumesSuspenseQueryHookResult = ReturnType<typeof useGetServiceOnlyServiceVolumesSuspenseQuery>;
export type GetServiceOnlyServiceVolumesQueryResult = Apollo.QueryResult<GetServiceOnlyServiceVolumesQuery, GetServiceOnlyServiceVolumesQueryVariables>;
export const GetServiceOnlyWorkspaceDetailsDocument = gql`
    query GetServiceOnlyWorkspaceDetails($workspaceId: String!) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    name
    description
    objective
    createdAt
    createdBy
    updatedAt
    updatedBy
    users
    visibility
  }
}
    `;

/**
 * __useGetServiceOnlyWorkspaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetServiceOnlyWorkspaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOnlyWorkspaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOnlyWorkspaceDetailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetServiceOnlyWorkspaceDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables> & ({ variables: GetServiceOnlyWorkspaceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>(GetServiceOnlyWorkspaceDetailsDocument, options);
      }
export function useGetServiceOnlyWorkspaceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>(GetServiceOnlyWorkspaceDetailsDocument, options);
        }
// @ts-ignore
export function useGetServiceOnlyWorkspaceDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>;
export function useGetServiceOnlyWorkspaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyWorkspaceDetailsQuery | undefined, GetServiceOnlyWorkspaceDetailsQueryVariables>;
export function useGetServiceOnlyWorkspaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>(GetServiceOnlyWorkspaceDetailsDocument, options);
        }
export type GetServiceOnlyWorkspaceDetailsQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceDetailsQuery>;
export type GetServiceOnlyWorkspaceDetailsLazyQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceDetailsLazyQuery>;
export type GetServiceOnlyWorkspaceDetailsSuspenseQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceDetailsSuspenseQuery>;
export type GetServiceOnlyWorkspaceDetailsQueryResult = Apollo.QueryResult<GetServiceOnlyWorkspaceDetailsQuery, GetServiceOnlyWorkspaceDetailsQueryVariables>;
export const GetWorkspaceMembersDocument = gql`
    query GetWorkspaceMembers($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    users
  }
}
    `;

/**
 * __useGetWorkspaceMembersQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>(GetWorkspaceMembersDocument, options);
      }
export function useGetWorkspaceMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>(GetWorkspaceMembersDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>;
export function useGetWorkspaceMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMembersQuery | undefined, GetWorkspaceMembersQueryVariables>;
export function useGetWorkspaceMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>(GetWorkspaceMembersDocument, options);
        }
export type GetWorkspaceMembersQueryHookResult = ReturnType<typeof useGetWorkspaceMembersQuery>;
export type GetWorkspaceMembersLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMembersLazyQuery>;
export type GetWorkspaceMembersSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceMembersSuspenseQuery>;
export type GetWorkspaceMembersQueryResult = Apollo.QueryResult<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>;
export const GetServiceOnlyWorkspaceServicesDocument = gql`
    query GetServiceOnlyWorkspaceServices($workspaceId: String) {
  getServices(workspaceId: $workspaceId) {
    type
    name
    serviceId
    serviceType
    description
    persistentServiceId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetServiceOnlyWorkspaceServicesQuery__
 *
 * To run a query within a React component, call `useGetServiceOnlyWorkspaceServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOnlyWorkspaceServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOnlyWorkspaceServicesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetServiceOnlyWorkspaceServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>(GetServiceOnlyWorkspaceServicesDocument, options);
      }
export function useGetServiceOnlyWorkspaceServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>(GetServiceOnlyWorkspaceServicesDocument, options);
        }
// @ts-ignore
export function useGetServiceOnlyWorkspaceServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>;
export function useGetServiceOnlyWorkspaceServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyWorkspaceServicesQuery | undefined, GetServiceOnlyWorkspaceServicesQueryVariables>;
export function useGetServiceOnlyWorkspaceServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>(GetServiceOnlyWorkspaceServicesDocument, options);
        }
export type GetServiceOnlyWorkspaceServicesQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceServicesQuery>;
export type GetServiceOnlyWorkspaceServicesLazyQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceServicesLazyQuery>;
export type GetServiceOnlyWorkspaceServicesSuspenseQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceServicesSuspenseQuery>;
export type GetServiceOnlyWorkspaceServicesQueryResult = Apollo.QueryResult<GetServiceOnlyWorkspaceServicesQuery, GetServiceOnlyWorkspaceServicesQueryVariables>;
export const GetServiceOnlyWorkspaceVolumesDocument = gql`
    query GetServiceOnlyWorkspaceVolumes($workspaceId: String, $serviceVolumes: Boolean) {
  getVolumes(workspaceId: $workspaceId, serviceVolumes: $serviceVolumes) {
    size
    name
    description
    volumeId
    workspaceVolume
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetServiceOnlyWorkspaceVolumesQuery__
 *
 * To run a query within a React component, call `useGetServiceOnlyWorkspaceVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOnlyWorkspaceVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOnlyWorkspaceVolumesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      serviceVolumes: // value for 'serviceVolumes'
 *   },
 * });
 */
export function useGetServiceOnlyWorkspaceVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>(GetServiceOnlyWorkspaceVolumesDocument, options);
      }
export function useGetServiceOnlyWorkspaceVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>(GetServiceOnlyWorkspaceVolumesDocument, options);
        }
// @ts-ignore
export function useGetServiceOnlyWorkspaceVolumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>;
export function useGetServiceOnlyWorkspaceVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyWorkspaceVolumesQuery | undefined, GetServiceOnlyWorkspaceVolumesQueryVariables>;
export function useGetServiceOnlyWorkspaceVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>(GetServiceOnlyWorkspaceVolumesDocument, options);
        }
export type GetServiceOnlyWorkspaceVolumesQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceVolumesQuery>;
export type GetServiceOnlyWorkspaceVolumesLazyQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceVolumesLazyQuery>;
export type GetServiceOnlyWorkspaceVolumesSuspenseQueryHookResult = ReturnType<typeof useGetServiceOnlyWorkspaceVolumesSuspenseQuery>;
export type GetServiceOnlyWorkspaceVolumesQueryResult = Apollo.QueryResult<GetServiceOnlyWorkspaceVolumesQuery, GetServiceOnlyWorkspaceVolumesQueryVariables>;
export const GetWorkspaceServersDocument = gql`
    query GetWorkspaceServers($workspaceId: String) {
  getEditors(workspaceId: $workspaceId) {
    status {
      state
      message
    }
    editorId
    name
    url
    sshPort
    serverPath
    instanceType
    createdAt
    createdBy
    storageSize
    startedAt
    autoStopEnabled
    autoStopCpuThreshold
    autoStopTimeoutMinutes
    autoDeleteEnabled
    autoDeleteTimeoutDays
    autoUpdateEnabled
    deleteAfter
    visibility
    users
  }
}
    `;

/**
 * __useGetWorkspaceServersQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceServersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceServersQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>(GetWorkspaceServersDocument, options);
      }
export function useGetWorkspaceServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>(GetWorkspaceServersDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceServersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>;
export function useGetWorkspaceServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceServersQuery | undefined, GetWorkspaceServersQueryVariables>;
export function useGetWorkspaceServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>(GetWorkspaceServersDocument, options);
        }
export type GetWorkspaceServersQueryHookResult = ReturnType<typeof useGetWorkspaceServersQuery>;
export type GetWorkspaceServersLazyQueryHookResult = ReturnType<typeof useGetWorkspaceServersLazyQuery>;
export type GetWorkspaceServersSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceServersSuspenseQuery>;
export type GetWorkspaceServersQueryResult = Apollo.QueryResult<GetWorkspaceServersQuery, GetWorkspaceServersQueryVariables>;
export const GetServiceOnlyOrganizationWorkspacesDocument = gql`
    query GetServiceOnlyOrganizationWorkspaces($organizationId: String, $cursor: String, $limit: Int, $filters: WorkspaceFilter) {
  getWorkspaces(
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    createdAt
    createdBy
    name
    organizationId
    status
    updatedAt
    workspaceId
    visibility
    template {
      templateId
      version
    }
  }
}
    `;

/**
 * __useGetServiceOnlyOrganizationWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetServiceOnlyOrganizationWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOnlyOrganizationWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOnlyOrganizationWorkspacesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetServiceOnlyOrganizationWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>(GetServiceOnlyOrganizationWorkspacesDocument, options);
      }
export function useGetServiceOnlyOrganizationWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>(GetServiceOnlyOrganizationWorkspacesDocument, options);
        }
// @ts-ignore
export function useGetServiceOnlyOrganizationWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>;
export function useGetServiceOnlyOrganizationWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceOnlyOrganizationWorkspacesQuery | undefined, GetServiceOnlyOrganizationWorkspacesQueryVariables>;
export function useGetServiceOnlyOrganizationWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>(GetServiceOnlyOrganizationWorkspacesDocument, options);
        }
export type GetServiceOnlyOrganizationWorkspacesQueryHookResult = ReturnType<typeof useGetServiceOnlyOrganizationWorkspacesQuery>;
export type GetServiceOnlyOrganizationWorkspacesLazyQueryHookResult = ReturnType<typeof useGetServiceOnlyOrganizationWorkspacesLazyQuery>;
export type GetServiceOnlyOrganizationWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetServiceOnlyOrganizationWorkspacesSuspenseQuery>;
export type GetServiceOnlyOrganizationWorkspacesQueryResult = Apollo.QueryResult<GetServiceOnlyOrganizationWorkspacesQuery, GetServiceOnlyOrganizationWorkspacesQueryVariables>;
export const GetWorkspaceResourcesCountsDocument = gql`
    query GetWorkspaceResourcesCounts($workspaceId: String!) {
  getServices(workspaceId: $workspaceId) {
    serviceId
    name
  }
  getVolumes(workspaceId: $workspaceId, serviceVolumes: true) {
    volumeId
    name
    workspaceVolume
  }
  getEditors(workspaceId: $workspaceId) {
    status {
      state
      message
    }
    editorId
    name
    url
    sshPort
    serverPath
    instanceType
    createdAt
    autoStopEnabled
    autoStopCpuThreshold
    autoStopTimeoutMinutes
    autoDeleteEnabled
    autoDeleteTimeoutDays
    autoUpdateEnabled
    deleteAfter
  }
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    users
  }
}
    `;

/**
 * __useGetWorkspaceResourcesCountsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesCountsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesCountsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables> & ({ variables: GetWorkspaceResourcesCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>(GetWorkspaceResourcesCountsDocument, options);
      }
export function useGetWorkspaceResourcesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>(GetWorkspaceResourcesCountsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceResourcesCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>;
export function useGetWorkspaceResourcesCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesCountsQuery | undefined, GetWorkspaceResourcesCountsQueryVariables>;
export function useGetWorkspaceResourcesCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>(GetWorkspaceResourcesCountsDocument, options);
        }
export type GetWorkspaceResourcesCountsQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesCountsQuery>;
export type GetWorkspaceResourcesCountsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesCountsLazyQuery>;
export type GetWorkspaceResourcesCountsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesCountsSuspenseQuery>;
export type GetWorkspaceResourcesCountsQueryResult = Apollo.QueryResult<GetWorkspaceResourcesCountsQuery, GetWorkspaceResourcesCountsQueryVariables>;
export const GetStripeCustomerDetailsDocument = gql`
    query GetStripeCustomerDetails($organizationId: String!) {
  getStripeCustomerDetails(organizationId: $organizationId) {
    autoPayEnabled
    paymentMethods {
      id
      type
      isDefault
      card {
        brand
        last4
        expMonth
        expYear
      }
    }
    invoices {
      open {
        id
        number
        status
        amountDue
        amountPaid
        currency
        created
        hostedInvoiceUrl
        invoicePdf
      }
      paid {
        id
        number
        status
        amountDue
        amountPaid
        currency
        created
        hostedInvoiceUrl
        invoicePdf
      }
    }
  }
}
    `;

/**
 * __useGetStripeCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetStripeCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCustomerDetailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetStripeCustomerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables> & ({ variables: GetStripeCustomerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>(GetStripeCustomerDetailsDocument, options);
      }
export function useGetStripeCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>(GetStripeCustomerDetailsDocument, options);
        }
// @ts-ignore
export function useGetStripeCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>;
export function useGetStripeCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStripeCustomerDetailsQuery | undefined, GetStripeCustomerDetailsQueryVariables>;
export function useGetStripeCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>(GetStripeCustomerDetailsDocument, options);
        }
export type GetStripeCustomerDetailsQueryHookResult = ReturnType<typeof useGetStripeCustomerDetailsQuery>;
export type GetStripeCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetStripeCustomerDetailsLazyQuery>;
export type GetStripeCustomerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStripeCustomerDetailsSuspenseQuery>;
export type GetStripeCustomerDetailsQueryResult = Apollo.QueryResult<GetStripeCustomerDetailsQuery, GetStripeCustomerDetailsQueryVariables>;
export const GetOrganizationUsageHistoryDocument = gql`
    query GetOrganizationUsageHistory($organizationId: String!, $records: Int) {
  getOrganizationUsageHistory(organizationId: $organizationId, records: $records) {
    compute {
      cost
      usage
      units
      byInstance {
        instanceType
        usage
        cost
        units
      }
      byUser {
        email
        usage
        cost
        units
      }
    }
    credit
    credits
    totalServers
    runningServers
    endDate
    startDate
    storage {
      cost
      usage
      units
      byStorageType {
        storageType
        usage
        cost
        units
      }
      byUser {
        email
        usage
        cost
        units
      }
    }
    tokens {
      cost
      usage
      units
      byModel {
        model
        promptTokens
        completionTokens
        usage
        cost
        units
      }
      byUser {
        email
        promptTokens
        completionTokens
        usage
        cost
        units
      }
    }
    totalCost
  }
}
    `;

/**
 * __useGetOrganizationUsageHistoryQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsageHistoryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      records: // value for 'records'
 *   },
 * });
 */
export function useGetOrganizationUsageHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables> & ({ variables: GetOrganizationUsageHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>(GetOrganizationUsageHistoryDocument, options);
      }
export function useGetOrganizationUsageHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>(GetOrganizationUsageHistoryDocument, options);
        }
// @ts-ignore
export function useGetOrganizationUsageHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>;
export function useGetOrganizationUsageHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationUsageHistoryQuery | undefined, GetOrganizationUsageHistoryQueryVariables>;
export function useGetOrganizationUsageHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>(GetOrganizationUsageHistoryDocument, options);
        }
export type GetOrganizationUsageHistoryQueryHookResult = ReturnType<typeof useGetOrganizationUsageHistoryQuery>;
export type GetOrganizationUsageHistoryLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsageHistoryLazyQuery>;
export type GetOrganizationUsageHistorySuspenseQueryHookResult = ReturnType<typeof useGetOrganizationUsageHistorySuspenseQuery>;
export type GetOrganizationUsageHistoryQueryResult = Apollo.QueryResult<GetOrganizationUsageHistoryQuery, GetOrganizationUsageHistoryQueryVariables>;
export const GetOrganizationInvitationsDocument = gql`
    query GetOrganizationInvitations($organizationId: String) {
  getInvitations(organizationId: $organizationId) {
    createdAt
    email
    organizationId
    role
  }
}
    `;

/**
 * __useGetOrganizationInvitationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInvitationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>(GetOrganizationInvitationsDocument, options);
      }
export function useGetOrganizationInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>(GetOrganizationInvitationsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>;
export function useGetOrganizationInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInvitationsQuery | undefined, GetOrganizationInvitationsQueryVariables>;
export function useGetOrganizationInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>(GetOrganizationInvitationsDocument, options);
        }
export type GetOrganizationInvitationsQueryHookResult = ReturnType<typeof useGetOrganizationInvitationsQuery>;
export type GetOrganizationInvitationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationInvitationsLazyQuery>;
export type GetOrganizationInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationInvitationsSuspenseQuery>;
export type GetOrganizationInvitationsQueryResult = Apollo.QueryResult<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>;
export const GetAPIKeysDocument = gql`
    query GetAPIKeys {
  getAPIKeys {
    createdAt
    expiresAt
    name
    organizationId
    scope
    workspaceId
  }
}
    `;

/**
 * __useGetAPIKeysQuery__
 *
 * To run a query within a React component, call `useGetAPIKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAPIKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAPIKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAPIKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAPIKeysQuery, GetAPIKeysQueryVariables>(GetAPIKeysDocument, options);
      }
export function useGetAPIKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAPIKeysQuery, GetAPIKeysQueryVariables>(GetAPIKeysDocument, options);
        }
// @ts-ignore
export function useGetAPIKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetAPIKeysQuery, GetAPIKeysQueryVariables>;
export function useGetAPIKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetAPIKeysQuery | undefined, GetAPIKeysQueryVariables>;
export function useGetAPIKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAPIKeysQuery, GetAPIKeysQueryVariables>(GetAPIKeysDocument, options);
        }
export type GetAPIKeysQueryHookResult = ReturnType<typeof useGetAPIKeysQuery>;
export type GetAPIKeysLazyQueryHookResult = ReturnType<typeof useGetAPIKeysLazyQuery>;
export type GetAPIKeysSuspenseQueryHookResult = ReturnType<typeof useGetAPIKeysSuspenseQuery>;
export type GetAPIKeysQueryResult = Apollo.QueryResult<GetAPIKeysQuery, GetAPIKeysQueryVariables>;
export const GetSSHKeysDocument = gql`
    query GetSSHKeys {
  getSSHKeys {
    name
    key
    createdAt
  }
}
    `;

/**
 * __useGetSSHKeysQuery__
 *
 * To run a query within a React component, call `useGetSSHKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSSHKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSSHKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSSHKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSSHKeysQuery, GetSSHKeysQueryVariables>(GetSSHKeysDocument, options);
      }
export function useGetSSHKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSSHKeysQuery, GetSSHKeysQueryVariables>(GetSSHKeysDocument, options);
        }
// @ts-ignore
export function useGetSSHKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetSSHKeysQuery, GetSSHKeysQueryVariables>;
export function useGetSSHKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetSSHKeysQuery | undefined, GetSSHKeysQueryVariables>;
export function useGetSSHKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSSHKeysQuery, GetSSHKeysQueryVariables>(GetSSHKeysDocument, options);
        }
export type GetSSHKeysQueryHookResult = ReturnType<typeof useGetSSHKeysQuery>;
export type GetSSHKeysLazyQueryHookResult = ReturnType<typeof useGetSSHKeysLazyQuery>;
export type GetSSHKeysSuspenseQueryHookResult = ReturnType<typeof useGetSSHKeysSuspenseQuery>;
export type GetSSHKeysQueryResult = Apollo.QueryResult<GetSSHKeysQuery, GetSSHKeysQueryVariables>;
export const GetOrganizationServicesDocument = gql`
    query GetOrganizationServices($organizationId: String, $cursor: String, $limit: Int, $filters: ServicesFilter, $sort: Sort) {
  getServices(
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
    sort: $sort
  ) {
    createdAt
    createdBy
    name
    serviceId
    serviceType
    instance
    updatedAt
    tags
    description
  }
}
    `;

/**
 * __useGetOrganizationServicesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationServicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>(GetOrganizationServicesDocument, options);
      }
export function useGetOrganizationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>(GetOrganizationServicesDocument, options);
        }
// @ts-ignore
export function useGetOrganizationServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>;
export function useGetOrganizationServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationServicesQuery | undefined, GetOrganizationServicesQueryVariables>;
export function useGetOrganizationServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>(GetOrganizationServicesDocument, options);
        }
export type GetOrganizationServicesQueryHookResult = ReturnType<typeof useGetOrganizationServicesQuery>;
export type GetOrganizationServicesLazyQueryHookResult = ReturnType<typeof useGetOrganizationServicesLazyQuery>;
export type GetOrganizationServicesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationServicesSuspenseQuery>;
export type GetOrganizationServicesQueryResult = Apollo.QueryResult<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>;
export const GetOrganizationServicesSearchDetailDocument = gql`
    query GetOrganizationServicesSearchDetail($organizationId: String, $filters: ServicesFilter) {
  getServicesSearchDetail(organizationId: $organizationId, filters: $filters) {
    serviceTypes {
      display
      value
    }
    tags {
      display
      value
    }
    users {
      display
      value
    }
  }
}
    `;

/**
 * __useGetOrganizationServicesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetOrganizationServicesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationServicesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationServicesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrganizationServicesSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>(GetOrganizationServicesSearchDetailDocument, options);
      }
export function useGetOrganizationServicesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>(GetOrganizationServicesSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetOrganizationServicesSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>;
export function useGetOrganizationServicesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationServicesSearchDetailQuery | undefined, GetOrganizationServicesSearchDetailQueryVariables>;
export function useGetOrganizationServicesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>(GetOrganizationServicesSearchDetailDocument, options);
        }
export type GetOrganizationServicesSearchDetailQueryHookResult = ReturnType<typeof useGetOrganizationServicesSearchDetailQuery>;
export type GetOrganizationServicesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetOrganizationServicesSearchDetailLazyQuery>;
export type GetOrganizationServicesSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationServicesSearchDetailSuspenseQuery>;
export type GetOrganizationServicesSearchDetailQueryResult = Apollo.QueryResult<GetOrganizationServicesSearchDetailQuery, GetOrganizationServicesSearchDetailQueryVariables>;
export const GetDatasetRunsCountDocument = gql`
    query GetDatasetRunsCount($workspaceId: String!, $datasetId: String!) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    runs
  }
}
    `;

/**
 * __useGetDatasetRunsCountQuery__
 *
 * To run a query within a React component, call `useGetDatasetRunsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetRunsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetRunsCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetRunsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables> & ({ variables: GetDatasetRunsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>(GetDatasetRunsCountDocument, options);
      }
export function useGetDatasetRunsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>(GetDatasetRunsCountDocument, options);
        }
// @ts-ignore
export function useGetDatasetRunsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>;
export function useGetDatasetRunsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetRunsCountQuery | undefined, GetDatasetRunsCountQueryVariables>;
export function useGetDatasetRunsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>(GetDatasetRunsCountDocument, options);
        }
export type GetDatasetRunsCountQueryHookResult = ReturnType<typeof useGetDatasetRunsCountQuery>;
export type GetDatasetRunsCountLazyQueryHookResult = ReturnType<typeof useGetDatasetRunsCountLazyQuery>;
export type GetDatasetRunsCountSuspenseQueryHookResult = ReturnType<typeof useGetDatasetRunsCountSuspenseQuery>;
export type GetDatasetRunsCountQueryResult = Apollo.QueryResult<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>;
export const GetWorkspaceAnalyticsDocument = gql`
    query GetWorkspaceAnalytics($workspaceId: String!, $cursor: String, $limit: Int, $filters: AnalyticsFilter) {
  getAnalytics(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    analyticsId
    createdAt
    createdBy
    dataset
    datasetId
    result
    status
    tags
    type
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables> & ({ variables: GetWorkspaceAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
      }
export function useGetWorkspaceAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>;
export function useGetWorkspaceAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceAnalyticsQuery | undefined, GetWorkspaceAnalyticsQueryVariables>;
export function useGetWorkspaceAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
        }
export type GetWorkspaceAnalyticsQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsQuery>;
export type GetWorkspaceAnalyticsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsLazyQuery>;
export type GetWorkspaceAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsSuspenseQuery>;
export type GetWorkspaceAnalyticsQueryResult = Apollo.QueryResult<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>;
export const GetAnalyticsSearchDetailDocument = gql`
    query GetAnalyticsSearchDetail($workspaceId: String!, $filters: AnalyticsFilter, $datasetId: String) {
  getAnalyticsSearchDetail(
    workspaceId: $workspaceId
    filters: $filters
    datasetId: $datasetId
  ) {
    status {
      display
      value
    }
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetAnalyticsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetAnalyticsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables> & ({ variables: GetAnalyticsSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
      }
export function useGetAnalyticsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>;
export function useGetAnalyticsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsSearchDetailQuery | undefined, GetAnalyticsSearchDetailQueryVariables>;
export function useGetAnalyticsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
        }
export type GetAnalyticsSearchDetailQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailQuery>;
export type GetAnalyticsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailLazyQuery>;
export type GetAnalyticsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailSuspenseQuery>;
export type GetAnalyticsSearchDetailQueryResult = Apollo.QueryResult<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>;
export const GetWorkspaceUMAPsDocument = gql`
    query GetWorkspaceUMAPs($workspaceId: String!, $cursor: String, $limit: Int, $filters: UMAPFilter) {
  getUMAPs(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    createdAt
    createdBy
    datasets {
      dataset
      datasetId
    }
    name
    results
    samples
    seed
    status
    tags
    umapId
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceUMAPsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUMAPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUMAPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUMAPsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceUMAPsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables> & ({ variables: GetWorkspaceUMAPsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>(GetWorkspaceUMAPsDocument, options);
      }
export function useGetWorkspaceUMAPsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>(GetWorkspaceUMAPsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceUMAPsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>;
export function useGetWorkspaceUMAPsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceUMAPsQuery | undefined, GetWorkspaceUMAPsQueryVariables>;
export function useGetWorkspaceUMAPsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>(GetWorkspaceUMAPsDocument, options);
        }
export type GetWorkspaceUMAPsQueryHookResult = ReturnType<typeof useGetWorkspaceUMAPsQuery>;
export type GetWorkspaceUMAPsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceUMAPsLazyQuery>;
export type GetWorkspaceUMAPsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceUMAPsSuspenseQuery>;
export type GetWorkspaceUMAPsQueryResult = Apollo.QueryResult<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>;
export const GetUMAPsSearchDetailDocument = gql`
    query GetUMAPsSearchDetail($workspaceId: String!, $datasetId: String, $filters: UMAPFilter) {
  getUMAPsSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
  }
}
    `;

/**
 * __useGetUMAPsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetUMAPsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUMAPsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUMAPsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUMAPsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables> & ({ variables: GetUMAPsSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>(GetUMAPsSearchDetailDocument, options);
      }
export function useGetUMAPsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>(GetUMAPsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetUMAPsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>;
export function useGetUMAPsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetUMAPsSearchDetailQuery | undefined, GetUMAPsSearchDetailQueryVariables>;
export function useGetUMAPsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>(GetUMAPsSearchDetailDocument, options);
        }
export type GetUMAPsSearchDetailQueryHookResult = ReturnType<typeof useGetUMAPsSearchDetailQuery>;
export type GetUMAPsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetUMAPsSearchDetailLazyQuery>;
export type GetUMAPsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetUMAPsSearchDetailSuspenseQuery>;
export type GetUMAPsSearchDetailQueryResult = Apollo.QueryResult<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>;
export const GetWorkspaceMLModelsDocument = gql`
    query GetWorkspaceMLModels($workspaceId: String!, $cursor: String, $limit: Int, $filters: MLModelFilter) {
  getMLModels(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    architecture
    architectureId
    checkpoints
    classes
    createdBy
    createdAt
    dataset
    datasetId
    description
    map
    mapId
    metrics
    modelId
    name
    parameters
    status
    tags
  }
}
    `;

/**
 * __useGetWorkspaceMLModelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMLModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMLModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMLModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceMLModelsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables> & ({ variables: GetWorkspaceMLModelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>(GetWorkspaceMLModelsDocument, options);
      }
export function useGetWorkspaceMLModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>(GetWorkspaceMLModelsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceMLModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>;
export function useGetWorkspaceMLModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMLModelsQuery | undefined, GetWorkspaceMLModelsQueryVariables>;
export function useGetWorkspaceMLModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>(GetWorkspaceMLModelsDocument, options);
        }
export type GetWorkspaceMLModelsQueryHookResult = ReturnType<typeof useGetWorkspaceMLModelsQuery>;
export type GetWorkspaceMLModelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMLModelsLazyQuery>;
export type GetWorkspaceMLModelsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceMLModelsSuspenseQuery>;
export type GetWorkspaceMLModelsQueryResult = Apollo.QueryResult<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>;
export const GetMLModelsSearchDetailDocument = gql`
    query GetMLModelsSearchDetail($workspaceId: String!, $datasetId: String, $filters: MLModelFilter) {
  getMLModelsSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
    architectures {
      value
      display
    }
  }
}
    `;

/**
 * __useGetMLModelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetMLModelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMLModelsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables> & ({ variables: GetMLModelsSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>(GetMLModelsSearchDetailDocument, options);
      }
export function useGetMLModelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>(GetMLModelsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetMLModelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>;
export function useGetMLModelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelsSearchDetailQuery | undefined, GetMLModelsSearchDetailQueryVariables>;
export function useGetMLModelsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>(GetMLModelsSearchDetailDocument, options);
        }
export type GetMLModelsSearchDetailQueryHookResult = ReturnType<typeof useGetMLModelsSearchDetailQuery>;
export type GetMLModelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetMLModelsSearchDetailLazyQuery>;
export type GetMLModelsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetMLModelsSearchDetailSuspenseQuery>;
export type GetMLModelsSearchDetailQueryResult = Apollo.QueryResult<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>;
export const GetWorkspaceMLInferencesDocument = gql`
    query GetWorkspaceMLInferences($workspaceId: String!, $cursor: String, $limit: Int, $filters: MLInferenceFilter) {
  getMLInferences(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    datasetId
    dataset
    map
    mapId
    metrics
    model
    modelId
    status
    inferenceId
    workspaceId
    createdBy
    createdAt
    tags
  }
}
    `;

/**
 * __useGetWorkspaceMLInferencesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMLInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMLInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMLInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceMLInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables> & ({ variables: GetWorkspaceMLInferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>(GetWorkspaceMLInferencesDocument, options);
      }
export function useGetWorkspaceMLInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>(GetWorkspaceMLInferencesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceMLInferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>;
export function useGetWorkspaceMLInferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceMLInferencesQuery | undefined, GetWorkspaceMLInferencesQueryVariables>;
export function useGetWorkspaceMLInferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>(GetWorkspaceMLInferencesDocument, options);
        }
export type GetWorkspaceMLInferencesQueryHookResult = ReturnType<typeof useGetWorkspaceMLInferencesQuery>;
export type GetWorkspaceMLInferencesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMLInferencesLazyQuery>;
export type GetWorkspaceMLInferencesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceMLInferencesSuspenseQuery>;
export type GetWorkspaceMLInferencesQueryResult = Apollo.QueryResult<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>;
export const GetMLInferencesSearchDetailDocument = gql`
    query GetMLInferencesSearchDetail($workspaceId: String!, $datasetId: String, $filters: MLInferenceFilter) {
  getMLInferencesSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
    architectures {
      value
      display
    }
  }
}
    `;

/**
 * __useGetMLInferencesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetMLInferencesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferencesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferencesSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMLInferencesSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables> & ({ variables: GetMLInferencesSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>(GetMLInferencesSearchDetailDocument, options);
      }
export function useGetMLInferencesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>(GetMLInferencesSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetMLInferencesSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>;
export function useGetMLInferencesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLInferencesSearchDetailQuery | undefined, GetMLInferencesSearchDetailQueryVariables>;
export function useGetMLInferencesSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>(GetMLInferencesSearchDetailDocument, options);
        }
export type GetMLInferencesSearchDetailQueryHookResult = ReturnType<typeof useGetMLInferencesSearchDetailQuery>;
export type GetMLInferencesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetMLInferencesSearchDetailLazyQuery>;
export type GetMLInferencesSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetMLInferencesSearchDetailSuspenseQuery>;
export type GetMLInferencesSearchDetailQueryResult = Apollo.QueryResult<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>;
export const GetMLModelInferencesDocument = gql`
    query GetMLModelInferences($workspaceId: String!, $modelId: String) {
  getMLInferences(workspaceId: $workspaceId, modelId: $modelId) {
    datasetId
    dataset
    model
    modelId
    status
    inferenceId
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetMLModelInferencesQuery__
 *
 * To run a query within a React component, call `useGetMLModelInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables> & ({ variables: GetMLModelInferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>(GetMLModelInferencesDocument, options);
      }
export function useGetMLModelInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>(GetMLModelInferencesDocument, options);
        }
// @ts-ignore
export function useGetMLModelInferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>;
export function useGetMLModelInferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMLModelInferencesQuery | undefined, GetMLModelInferencesQueryVariables>;
export function useGetMLModelInferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>(GetMLModelInferencesDocument, options);
        }
export type GetMLModelInferencesQueryHookResult = ReturnType<typeof useGetMLModelInferencesQuery>;
export type GetMLModelInferencesLazyQueryHookResult = ReturnType<typeof useGetMLModelInferencesLazyQuery>;
export type GetMLModelInferencesSuspenseQueryHookResult = ReturnType<typeof useGetMLModelInferencesSuspenseQuery>;
export type GetMLModelInferencesQueryResult = Apollo.QueryResult<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>;
export const GetDatasetFilesCountDocument = gql`
    query GetDatasetFilesCount($workspaceId: String!, $datasetId: String!) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    files
  }
}
    `;

/**
 * __useGetDatasetFilesCountQuery__
 *
 * To run a query within a React component, call `useGetDatasetFilesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetFilesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetFilesCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetFilesCountQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables> & ({ variables: GetDatasetFilesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>(GetDatasetFilesCountDocument, options);
      }
export function useGetDatasetFilesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>(GetDatasetFilesCountDocument, options);
        }
// @ts-ignore
export function useGetDatasetFilesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>;
export function useGetDatasetFilesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetFilesCountQuery | undefined, GetDatasetFilesCountQueryVariables>;
export function useGetDatasetFilesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>(GetDatasetFilesCountDocument, options);
        }
export type GetDatasetFilesCountQueryHookResult = ReturnType<typeof useGetDatasetFilesCountQuery>;
export type GetDatasetFilesCountLazyQueryHookResult = ReturnType<typeof useGetDatasetFilesCountLazyQuery>;
export type GetDatasetFilesCountSuspenseQueryHookResult = ReturnType<typeof useGetDatasetFilesCountSuspenseQuery>;
export type GetDatasetFilesCountQueryResult = Apollo.QueryResult<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>;
export const GetAddGraphAvailableChannelsDocument = gql`
    query GetAddGraphAvailableChannels($workspaceId: String!) {
  getChannels(workspaceId: $workspaceId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetAddGraphAvailableChannelsQuery__
 *
 * To run a query within a React component, call `useGetAddGraphAvailableChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddGraphAvailableChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddGraphAvailableChannelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAddGraphAvailableChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables> & ({ variables: GetAddGraphAvailableChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>(GetAddGraphAvailableChannelsDocument, options);
      }
export function useGetAddGraphAvailableChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>(GetAddGraphAvailableChannelsDocument, options);
        }
// @ts-ignore
export function useGetAddGraphAvailableChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>;
export function useGetAddGraphAvailableChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddGraphAvailableChannelsQuery | undefined, GetAddGraphAvailableChannelsQueryVariables>;
export function useGetAddGraphAvailableChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>(GetAddGraphAvailableChannelsDocument, options);
        }
export type GetAddGraphAvailableChannelsQueryHookResult = ReturnType<typeof useGetAddGraphAvailableChannelsQuery>;
export type GetAddGraphAvailableChannelsLazyQueryHookResult = ReturnType<typeof useGetAddGraphAvailableChannelsLazyQuery>;
export type GetAddGraphAvailableChannelsSuspenseQueryHookResult = ReturnType<typeof useGetAddGraphAvailableChannelsSuspenseQuery>;
export type GetAddGraphAvailableChannelsQueryResult = Apollo.QueryResult<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>;
export const GraphUpdatedDocument = gql`
    subscription GraphUpdated($workspaceId: String!, $graphId: String!, $uid: String!) {
  graphUpdates(workspaceId: $workspaceId, graphId: $graphId, uid: $uid) {
    name
    description
    graphId
    graph
  }
}
    `;

/**
 * __useGraphUpdatedSubscription__
 *
 * To run a query within a React component, call `useGraphUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGraphUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGraphUpdatedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGraphUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GraphUpdatedSubscription, GraphUpdatedSubscriptionVariables> & ({ variables: GraphUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GraphUpdatedSubscription, GraphUpdatedSubscriptionVariables>(GraphUpdatedDocument, options);
      }
export type GraphUpdatedSubscriptionHookResult = ReturnType<typeof useGraphUpdatedSubscription>;
export type GraphUpdatedSubscriptionResult = Apollo.SubscriptionResult<GraphUpdatedSubscription>;
export const GetGraphsDocument = gql`
    query GetGraphs($workspaceId: String!, $staged: Boolean, $cursor: String, $limit: Int) {
  getGraphs(
    workspaceId: $workspaceId
    staged: $staged
    cursor: $cursor
    limit: $limit
  ) {
    channel
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetGraphsQuery__
 *
 * To run a query within a React component, call `useGetGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables> & ({ variables: GetGraphsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
      }
export function useGetGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
        }
// @ts-ignore
export function useGetGraphsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphsQuery, GetGraphsQueryVariables>;
export function useGetGraphsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphsQuery | undefined, GetGraphsQueryVariables>;
export function useGetGraphsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
        }
export type GetGraphsQueryHookResult = ReturnType<typeof useGetGraphsQuery>;
export type GetGraphsLazyQueryHookResult = ReturnType<typeof useGetGraphsLazyQuery>;
export type GetGraphsSuspenseQueryHookResult = ReturnType<typeof useGetGraphsSuspenseQuery>;
export type GetGraphsQueryResult = Apollo.QueryResult<GetGraphsQuery, GetGraphsQueryVariables>;
export const GetGraphMetadataDocument = gql`
    query GetGraphMetadata($workspaceId: String!, $graphId: String) {
  getGraphs(workspaceId: $workspaceId, graphId: $graphId) {
    channel
    channelId
    description
    graphId
    name
    previewId
    readOnly
    showPreview
    tags
    workspaceId
    updatedAt
  }
}
    `;

/**
 * __useGetGraphMetadataQuery__
 *
 * To run a query within a React component, call `useGetGraphMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphMetadataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useGetGraphMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables> & ({ variables: GetGraphMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
      }
export function useGetGraphMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
        }
// @ts-ignore
export function useGetGraphMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>;
export function useGetGraphMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphMetadataQuery | undefined, GetGraphMetadataQueryVariables>;
export function useGetGraphMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
        }
export type GetGraphMetadataQueryHookResult = ReturnType<typeof useGetGraphMetadataQuery>;
export type GetGraphMetadataLazyQueryHookResult = ReturnType<typeof useGetGraphMetadataLazyQuery>;
export type GetGraphMetadataSuspenseQueryHookResult = ReturnType<typeof useGetGraphMetadataSuspenseQuery>;
export type GetGraphMetadataQueryResult = Apollo.QueryResult<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>;
export const GetPreviewDocument = gql`
    query GetPreview($workspaceId: String!, $previewId: String!) {
  getPreview(workspaceId: $workspaceId, previewId: $previewId) {
    status
    previewId
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetPreviewQuery__
 *
 * To run a query within a React component, call `useGetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables> & ({ variables: GetPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
      }
export function useGetPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
        }
// @ts-ignore
export function useGetPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewQuery, GetPreviewQueryVariables>;
export function useGetPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewQuery | undefined, GetPreviewQueryVariables>;
export function useGetPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
        }
export type GetPreviewQueryHookResult = ReturnType<typeof useGetPreviewQuery>;
export type GetPreviewLazyQueryHookResult = ReturnType<typeof useGetPreviewLazyQuery>;
export type GetPreviewSuspenseQueryHookResult = ReturnType<typeof useGetPreviewSuspenseQuery>;
export type GetPreviewQueryResult = Apollo.QueryResult<GetPreviewQuery, GetPreviewQueryVariables>;
export const GetGraphLastUpdatedDocument = gql`
    query GetGraphLastUpdated($workspaceId: String!, $graphId: String) {
  getGraphs(workspaceId: $workspaceId, graphId: $graphId) {
    graphId
    updatedAt
  }
}
    `;

/**
 * __useGetGraphLastUpdatedQuery__
 *
 * To run a query within a React component, call `useGetGraphLastUpdatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphLastUpdatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphLastUpdatedQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useGetGraphLastUpdatedQuery(baseOptions: Apollo.QueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables> & ({ variables: GetGraphLastUpdatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
      }
export function useGetGraphLastUpdatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
        }
// @ts-ignore
export function useGetGraphLastUpdatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>;
export function useGetGraphLastUpdatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphLastUpdatedQuery | undefined, GetGraphLastUpdatedQueryVariables>;
export function useGetGraphLastUpdatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
        }
export type GetGraphLastUpdatedQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedQuery>;
export type GetGraphLastUpdatedLazyQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedLazyQuery>;
export type GetGraphLastUpdatedSuspenseQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedSuspenseQuery>;
export type GetGraphLastUpdatedQueryResult = Apollo.QueryResult<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>;
export const GetChannelSchemaDocument = gql`
    query GetChannelSchema($channelId: String) {
  getChannelSchema(channelId: $channelId)
}
    `;

/**
 * __useGetChannelSchemaQuery__
 *
 * To run a query within a React component, call `useGetChannelSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSchemaQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
      }
export function useGetChannelSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
        }
// @ts-ignore
export function useGetChannelSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>;
export function useGetChannelSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelSchemaQuery | undefined, GetChannelSchemaQueryVariables>;
export function useGetChannelSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
        }
export type GetChannelSchemaQueryHookResult = ReturnType<typeof useGetChannelSchemaQuery>;
export type GetChannelSchemaLazyQueryHookResult = ReturnType<typeof useGetChannelSchemaLazyQuery>;
export type GetChannelSchemaSuspenseQueryHookResult = ReturnType<typeof useGetChannelSchemaSuspenseQuery>;
export type GetChannelSchemaQueryResult = Apollo.QueryResult<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>;
export const GetPreviewLogDocument = gql`
    query GetPreviewLog($workspaceId: String!, $previewId: String!) {
  getPreviewLog(workspaceId: $workspaceId, previewId: $previewId) {
    log
    previewId
    status
  }
}
    `;

/**
 * __useGetPreviewLogQuery__
 *
 * To run a query within a React component, call `useGetPreviewLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetPreviewLogQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables> & ({ variables: GetPreviewLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
      }
export function useGetPreviewLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
        }
// @ts-ignore
export function useGetPreviewLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewLogQuery, GetPreviewLogQueryVariables>;
export function useGetPreviewLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewLogQuery | undefined, GetPreviewLogQueryVariables>;
export function useGetPreviewLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
        }
export type GetPreviewLogQueryHookResult = ReturnType<typeof useGetPreviewLogQuery>;
export type GetPreviewLogLazyQueryHookResult = ReturnType<typeof useGetPreviewLogLazyQuery>;
export type GetPreviewLogSuspenseQueryHookResult = ReturnType<typeof useGetPreviewLogSuspenseQuery>;
export type GetPreviewLogQueryResult = Apollo.QueryResult<GetPreviewLogQuery, GetPreviewLogQueryVariables>;
export const GetGraphsWithFiltersDocument = gql`
    query GetGraphsWithFilters($workspaceId: String!, $filters: GraphFilter, $staged: Boolean, $cursor: String, $limit: Int) {
  getGraphs(
    workspaceId: $workspaceId
    filters: $filters
    staged: $staged
    cursor: $cursor
    limit: $limit
  ) {
    channel
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetGraphsWithFiltersQuery__
 *
 * To run a query within a React component, call `useGetGraphsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsWithFiltersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphsWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables> & ({ variables: GetGraphsWithFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
      }
export function useGetGraphsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
        }
// @ts-ignore
export function useGetGraphsWithFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>;
export function useGetGraphsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphsWithFiltersQuery | undefined, GetGraphsWithFiltersQueryVariables>;
export function useGetGraphsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
        }
export type GetGraphsWithFiltersQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersQuery>;
export type GetGraphsWithFiltersLazyQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersLazyQuery>;
export type GetGraphsWithFiltersSuspenseQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersSuspenseQuery>;
export type GetGraphsWithFiltersQueryResult = Apollo.QueryResult<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>;
export const GetGraphsSearchDetailDocument = gql`
    query GetGraphsSearchDetail($workspaceId: String!, $staged: Boolean, $filters: GraphFilter) {
  getGraphsSearchDetail(
    workspaceId: $workspaceId
    staged: $staged
    filters: $filters
  ) {
    tags {
      value
      display
    }
    channels {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetGraphsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetGraphsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGraphsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables> & ({ variables: GetGraphsSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
      }
export function useGetGraphsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetGraphsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>;
export function useGetGraphsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphsSearchDetailQuery | undefined, GetGraphsSearchDetailQueryVariables>;
export function useGetGraphsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
        }
export type GetGraphsSearchDetailQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailQuery>;
export type GetGraphsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailLazyQuery>;
export type GetGraphsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailSuspenseQuery>;
export type GetGraphsSearchDetailQueryResult = Apollo.QueryResult<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>;
export const GetJobsDocument = gql`
    query GetJobs($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetJobFilter) {
  getDatasetJobs(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    datasetId
    status
    priority
    graphId
    channelId
    workspaceId
    averageRuntime
    instancesQueued
    instancesRunning
    instancesStarting
    runsSuccess
    runsTimeout
    seed
    runsRunning
    runsFailed
    runsCancelled
    runs
    runsStarting
    runsQueued
    updatedAt
    estimatedEndAt
    createdBy
    createdAt
    channel
  }
}
    `;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables> & ({ variables: GetJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
// @ts-ignore
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobsQuery, GetJobsQueryVariables>;
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobsQuery | undefined, GetJobsQueryVariables>;
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetStagedGraphsDocument = gql`
    query GetStagedGraphs($workspaceId: String!, $staged: Boolean, $cursor: String, $limit: Int, $filters: GraphFilter) {
  getGraphs(
    workspaceId: $workspaceId
    staged: $staged
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channel
    channelId
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    workspaceId
    updatedAt
  }
}
    `;

/**
 * __useGetStagedGraphsQuery__
 *
 * To run a query within a React component, call `useGetStagedGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStagedGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStagedGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetStagedGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables> & ({ variables: GetStagedGraphsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
      }
export function useGetStagedGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
        }
// @ts-ignore
export function useGetStagedGraphsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>;
export function useGetStagedGraphsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStagedGraphsQuery | undefined, GetStagedGraphsQueryVariables>;
export function useGetStagedGraphsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
        }
export type GetStagedGraphsQueryHookResult = ReturnType<typeof useGetStagedGraphsQuery>;
export type GetStagedGraphsLazyQueryHookResult = ReturnType<typeof useGetStagedGraphsLazyQuery>;
export type GetStagedGraphsSuspenseQueryHookResult = ReturnType<typeof useGetStagedGraphsSuspenseQuery>;
export type GetStagedGraphsQueryResult = Apollo.QueryResult<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>;
export const GetDatasetJobsSearchDetailDocument = gql`
    query GetDatasetJobsSearchDetail($organizationId: String, $workspaceId: String, $filters: DatasetJobFilter) {
  getDatasetJobsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    tags {
      value
      display
    }
    users {
      value
      display
    }
    channels {
      value
      display
    }
    type {
      value
      display
    }
  }
}
    `;

/**
 * __useGetDatasetJobsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetDatasetJobsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetJobsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetJobsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetJobsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
      }
export function useGetDatasetJobsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetDatasetJobsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>;
export function useGetDatasetJobsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetJobsSearchDetailQuery | undefined, GetDatasetJobsSearchDetailQueryVariables>;
export function useGetDatasetJobsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
        }
export type GetDatasetJobsSearchDetailQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailQuery>;
export type GetDatasetJobsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailLazyQuery>;
export type GetDatasetJobsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailSuspenseQuery>;
export type GetDatasetJobsSearchDetailQueryResult = Apollo.QueryResult<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>;
export const GetGraphThumbnailsDocument = gql`
    query GetGraphThumbnails($workspaceId: String!) {
  getGraphs(workspaceId: $workspaceId) {
    graphId
    thumbnail
  }
}
    `;

/**
 * __useGetGraphThumbnailsQuery__
 *
 * To run a query within a React component, call `useGetGraphThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphThumbnailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetGraphThumbnailsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables> & ({ variables: GetGraphThumbnailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>(GetGraphThumbnailsDocument, options);
      }
export function useGetGraphThumbnailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>(GetGraphThumbnailsDocument, options);
        }
// @ts-ignore
export function useGetGraphThumbnailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>;
export function useGetGraphThumbnailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGraphThumbnailsQuery | undefined, GetGraphThumbnailsQueryVariables>;
export function useGetGraphThumbnailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>(GetGraphThumbnailsDocument, options);
        }
export type GetGraphThumbnailsQueryHookResult = ReturnType<typeof useGetGraphThumbnailsQuery>;
export type GetGraphThumbnailsLazyQueryHookResult = ReturnType<typeof useGetGraphThumbnailsLazyQuery>;
export type GetGraphThumbnailsSuspenseQueryHookResult = ReturnType<typeof useGetGraphThumbnailsSuspenseQuery>;
export type GetGraphThumbnailsQueryResult = Apollo.QueryResult<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>;
export const GetWorkspaceThumbnailDocument = gql`
    query GetWorkspaceThumbnail($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    previewThumbnail
  }
}
    `;

/**
 * __useGetWorkspaceThumbnailQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceThumbnailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceThumbnailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceThumbnailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceThumbnailQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>(GetWorkspaceThumbnailDocument, options);
      }
export function useGetWorkspaceThumbnailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>(GetWorkspaceThumbnailDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceThumbnailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>;
export function useGetWorkspaceThumbnailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceThumbnailQuery | undefined, GetWorkspaceThumbnailQueryVariables>;
export function useGetWorkspaceThumbnailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>(GetWorkspaceThumbnailDocument, options);
        }
export type GetWorkspaceThumbnailQueryHookResult = ReturnType<typeof useGetWorkspaceThumbnailQuery>;
export type GetWorkspaceThumbnailLazyQueryHookResult = ReturnType<typeof useGetWorkspaceThumbnailLazyQuery>;
export type GetWorkspaceThumbnailSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceThumbnailSuspenseQuery>;
export type GetWorkspaceThumbnailQueryResult = Apollo.QueryResult<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>;
export const GetRecentJobsDocument = gql`
    query GetRecentJobs($workspaceId: String!) {
  getDatasetJobs(workspaceId: $workspaceId, limit: 15) {
    createdAt
    datasetId
    estimatedEndAt
    name
    status
  }
}
    `;

/**
 * __useGetRecentJobsQuery__
 *
 * To run a query within a React component, call `useGetRecentJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentJobsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecentJobsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables> & ({ variables: GetRecentJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
      }
export function useGetRecentJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
        }
// @ts-ignore
export function useGetRecentJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentJobsQuery, GetRecentJobsQueryVariables>;
export function useGetRecentJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentJobsQuery | undefined, GetRecentJobsQueryVariables>;
export function useGetRecentJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
        }
export type GetRecentJobsQueryHookResult = ReturnType<typeof useGetRecentJobsQuery>;
export type GetRecentJobsLazyQueryHookResult = ReturnType<typeof useGetRecentJobsLazyQuery>;
export type GetRecentJobsSuspenseQueryHookResult = ReturnType<typeof useGetRecentJobsSuspenseQuery>;
export type GetRecentJobsQueryResult = Apollo.QueryResult<GetRecentJobsQuery, GetRecentJobsQueryVariables>;
export const GetRecentGraphsDocument = gql`
    query GetRecentGraphs($workspaceId: String!, $staged: Boolean) {
  getGraphs(workspaceId: $workspaceId, staged: $staged, limit: 15) {
    channel
    channelId
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetRecentGraphsQuery__
 *
 * To run a query within a React component, call `useGetRecentGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *   },
 * });
 */
export function useGetRecentGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables> & ({ variables: GetRecentGraphsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
      }
export function useGetRecentGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
        }
// @ts-ignore
export function useGetRecentGraphsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>;
export function useGetRecentGraphsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentGraphsQuery | undefined, GetRecentGraphsQueryVariables>;
export function useGetRecentGraphsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
        }
export type GetRecentGraphsQueryHookResult = ReturnType<typeof useGetRecentGraphsQuery>;
export type GetRecentGraphsLazyQueryHookResult = ReturnType<typeof useGetRecentGraphsLazyQuery>;
export type GetRecentGraphsSuspenseQueryHookResult = ReturnType<typeof useGetRecentGraphsSuspenseQuery>;
export type GetRecentGraphsQueryResult = Apollo.QueryResult<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>;
export const GetRecentDatasetsDocument = gql`
    query GetRecentDatasets($workspaceId: String!) {
  getDatasets(workspaceId: $workspaceId, limit: 30) {
    createdAt
    datasetId
    name
    runs
  }
}
    `;

/**
 * __useGetRecentDatasetsQuery__
 *
 * To run a query within a React component, call `useGetRecentDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecentDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables> & ({ variables: GetRecentDatasetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
      }
export function useGetRecentDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
        }
// @ts-ignore
export function useGetRecentDatasetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>;
export function useGetRecentDatasetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentDatasetsQuery | undefined, GetRecentDatasetsQueryVariables>;
export function useGetRecentDatasetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
        }
export type GetRecentDatasetsQueryHookResult = ReturnType<typeof useGetRecentDatasetsQuery>;
export type GetRecentDatasetsLazyQueryHookResult = ReturnType<typeof useGetRecentDatasetsLazyQuery>;
export type GetRecentDatasetsSuspenseQueryHookResult = ReturnType<typeof useGetRecentDatasetsSuspenseQuery>;
export type GetRecentDatasetsQueryResult = Apollo.QueryResult<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>;
export const GetWorkspaceResourcesAvailableChannelsDocument = gql`
    query GetWorkspaceResourcesAvailableChannels($organizationId: String) {
  getChannels(organizationId: $organizationId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesAvailableChannelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesAvailableChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesAvailableChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesAvailableChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesAvailableChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>(GetWorkspaceResourcesAvailableChannelsDocument, options);
      }
export function useGetWorkspaceResourcesAvailableChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>(GetWorkspaceResourcesAvailableChannelsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceResourcesAvailableChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>;
export function useGetWorkspaceResourcesAvailableChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesAvailableChannelsQuery | undefined, GetWorkspaceResourcesAvailableChannelsQueryVariables>;
export function useGetWorkspaceResourcesAvailableChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>(GetWorkspaceResourcesAvailableChannelsDocument, options);
        }
export type GetWorkspaceResourcesAvailableChannelsQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableChannelsQuery>;
export type GetWorkspaceResourcesAvailableChannelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableChannelsLazyQuery>;
export type GetWorkspaceResourcesAvailableChannelsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableChannelsSuspenseQuery>;
export type GetWorkspaceResourcesAvailableChannelsQueryResult = Apollo.QueryResult<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>;
export const GetWorkspaceResourcesWorkspaceChannelsDocument = gql`
    query GetWorkspaceResourcesWorkspaceChannels($workspaceId: String) {
  getChannels(workspaceId: $workspaceId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesWorkspaceChannelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesWorkspaceChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesWorkspaceChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesWorkspaceChannelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesWorkspaceChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>(GetWorkspaceResourcesWorkspaceChannelsDocument, options);
      }
export function useGetWorkspaceResourcesWorkspaceChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>(GetWorkspaceResourcesWorkspaceChannelsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceResourcesWorkspaceChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>;
export function useGetWorkspaceResourcesWorkspaceChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesWorkspaceChannelsQuery | undefined, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>;
export function useGetWorkspaceResourcesWorkspaceChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>(GetWorkspaceResourcesWorkspaceChannelsDocument, options);
        }
export type GetWorkspaceResourcesWorkspaceChannelsQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceChannelsQuery>;
export type GetWorkspaceResourcesWorkspaceChannelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceChannelsLazyQuery>;
export type GetWorkspaceResourcesWorkspaceChannelsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceChannelsSuspenseQuery>;
export type GetWorkspaceResourcesWorkspaceChannelsQueryResult = Apollo.QueryResult<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>;
export const GetWorkspaceResourcesAvailableVolumesDocument = gql`
    query GetWorkspaceResourcesAvailableVolumes($organizationId: String) {
  getVolumes(organizationId: $organizationId) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesAvailableVolumesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesAvailableVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesAvailableVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesAvailableVolumesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesAvailableVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>(GetWorkspaceResourcesAvailableVolumesDocument, options);
      }
export function useGetWorkspaceResourcesAvailableVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>(GetWorkspaceResourcesAvailableVolumesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceResourcesAvailableVolumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>;
export function useGetWorkspaceResourcesAvailableVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesAvailableVolumesQuery | undefined, GetWorkspaceResourcesAvailableVolumesQueryVariables>;
export function useGetWorkspaceResourcesAvailableVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>(GetWorkspaceResourcesAvailableVolumesDocument, options);
        }
export type GetWorkspaceResourcesAvailableVolumesQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableVolumesQuery>;
export type GetWorkspaceResourcesAvailableVolumesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableVolumesLazyQuery>;
export type GetWorkspaceResourcesAvailableVolumesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableVolumesSuspenseQuery>;
export type GetWorkspaceResourcesAvailableVolumesQueryResult = Apollo.QueryResult<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>;
export const GetWorkspaceResourcesWorkspaceVolumesDocument = gql`
    query GetWorkspaceResourcesWorkspaceVolumes($workspaceId: String) {
  getVolumes(workspaceId: $workspaceId) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesWorkspaceVolumesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesWorkspaceVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesWorkspaceVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesWorkspaceVolumesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesWorkspaceVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>(GetWorkspaceResourcesWorkspaceVolumesDocument, options);
      }
export function useGetWorkspaceResourcesWorkspaceVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>(GetWorkspaceResourcesWorkspaceVolumesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceResourcesWorkspaceVolumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>;
export function useGetWorkspaceResourcesWorkspaceVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceResourcesWorkspaceVolumesQuery | undefined, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>;
export function useGetWorkspaceResourcesWorkspaceVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>(GetWorkspaceResourcesWorkspaceVolumesDocument, options);
        }
export type GetWorkspaceResourcesWorkspaceVolumesQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceVolumesQuery>;
export type GetWorkspaceResourcesWorkspaceVolumesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceVolumesLazyQuery>;
export type GetWorkspaceResourcesWorkspaceVolumesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceVolumesSuspenseQuery>;
export type GetWorkspaceResourcesWorkspaceVolumesQueryResult = Apollo.QueryResult<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>;
export const GetAnalyticForDownloadDocument = gql`
    query GetAnalyticForDownload($workspaceId: String!, $analyticsId: String!) {
  getAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    analyticsId
    dataset
    result
  }
}
    `;

/**
 * __useGetAnalyticForDownloadQuery__
 *
 * To run a query within a React component, call `useGetAnalyticForDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticForDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticForDownloadQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticForDownloadQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables> & ({ variables: GetAnalyticForDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>(GetAnalyticForDownloadDocument, options);
      }
export function useGetAnalyticForDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>(GetAnalyticForDownloadDocument, options);
        }
// @ts-ignore
export function useGetAnalyticForDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>;
export function useGetAnalyticForDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticForDownloadQuery | undefined, GetAnalyticForDownloadQueryVariables>;
export function useGetAnalyticForDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>(GetAnalyticForDownloadDocument, options);
        }
export type GetAnalyticForDownloadQueryHookResult = ReturnType<typeof useGetAnalyticForDownloadQuery>;
export type GetAnalyticForDownloadLazyQueryHookResult = ReturnType<typeof useGetAnalyticForDownloadLazyQuery>;
export type GetAnalyticForDownloadSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticForDownloadSuspenseQuery>;
export type GetAnalyticForDownloadQueryResult = Apollo.QueryResult<GetAnalyticForDownloadQuery, GetAnalyticForDownloadQueryVariables>;
export const GetDatasetImageFilenamesDocument = gql`
    query GetDatasetImageFilenames($workspaceId: String!, $datasetId: String!, $path: String, $cursor: String, $limit: Int) {
  getDatasetFiles(
    workspaceId: $workspaceId
    datasetId: $datasetId
    path: $path
    cursor: $cursor
    limit: $limit
  )
}
    `;

/**
 * __useGetDatasetImageFilenamesQuery__
 *
 * To run a query within a React component, call `useGetDatasetImageFilenamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetImageFilenamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetImageFilenamesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      path: // value for 'path'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDatasetImageFilenamesQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables> & ({ variables: GetDatasetImageFilenamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
      }
export function useGetDatasetImageFilenamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
        }
// @ts-ignore
export function useGetDatasetImageFilenamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>;
export function useGetDatasetImageFilenamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetImageFilenamesQuery | undefined, GetDatasetImageFilenamesQueryVariables>;
export function useGetDatasetImageFilenamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
        }
export type GetDatasetImageFilenamesQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesQuery>;
export type GetDatasetImageFilenamesLazyQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesLazyQuery>;
export type GetDatasetImageFilenamesSuspenseQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesSuspenseQuery>;
export type GetDatasetImageFilenamesQueryResult = Apollo.QueryResult<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>;
export const GetImageInferenceDocument = gql`
    query GetImageInference($workspaceId: String!, $inferenceId: String!, $filename: String!) {
  getImageInference(
    workspaceId: $workspaceId
    inferenceId: $inferenceId
    filename: $filename
  ) {
    image
    inferences {
      bbox
      class
      className
      confidence
    }
  }
}
    `;

/**
 * __useGetImageInferenceQuery__
 *
 * To run a query within a React component, call `useGetImageInferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageInferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageInferenceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetImageInferenceQuery(baseOptions: Apollo.QueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables> & ({ variables: GetImageInferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
      }
export function useGetImageInferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
        }
// @ts-ignore
export function useGetImageInferenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>): Apollo.UseSuspenseQueryResult<GetImageInferenceQuery, GetImageInferenceQueryVariables>;
export function useGetImageInferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>): Apollo.UseSuspenseQueryResult<GetImageInferenceQuery | undefined, GetImageInferenceQueryVariables>;
export function useGetImageInferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
        }
export type GetImageInferenceQueryHookResult = ReturnType<typeof useGetImageInferenceQuery>;
export type GetImageInferenceLazyQueryHookResult = ReturnType<typeof useGetImageInferenceLazyQuery>;
export type GetImageInferenceSuspenseQueryHookResult = ReturnType<typeof useGetImageInferenceSuspenseQuery>;
export type GetImageInferenceQueryResult = Apollo.QueryResult<GetImageInferenceQuery, GetImageInferenceQueryVariables>;
export const GetImageAnnotationDocument = gql`
    query GetImageAnnotation($workspaceId: String!, $datasetId: String!, $filename: String!) {
  getImageAnnotation(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filename: $filename
  ) {
    data
    datasetId
    filename
  }
}
    `;

/**
 * __useGetImageAnnotationQuery__
 *
 * To run a query within a React component, call `useGetImageAnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageAnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageAnnotationQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetImageAnnotationQuery(baseOptions: Apollo.QueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables> & ({ variables: GetImageAnnotationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
      }
export function useGetImageAnnotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
        }
// @ts-ignore
export function useGetImageAnnotationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>): Apollo.UseSuspenseQueryResult<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>;
export function useGetImageAnnotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>): Apollo.UseSuspenseQueryResult<GetImageAnnotationQuery | undefined, GetImageAnnotationQueryVariables>;
export function useGetImageAnnotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
        }
export type GetImageAnnotationQueryHookResult = ReturnType<typeof useGetImageAnnotationQuery>;
export type GetImageAnnotationLazyQueryHookResult = ReturnType<typeof useGetImageAnnotationLazyQuery>;
export type GetImageAnnotationSuspenseQueryHookResult = ReturnType<typeof useGetImageAnnotationSuspenseQuery>;
export type GetImageAnnotationQueryResult = Apollo.QueryResult<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>;
export const GetDatasetsForMixDocument = gql`
    query GetDatasetsForMix($workspaceId: String!, $cursor: String, $limit: Int) {
  getDatasets(workspaceId: $workspaceId, cursor: $cursor, limit: $limit) {
    classes
    datasetId
    files
    name
  }
}
    `;

/**
 * __useGetDatasetsForMixQuery__
 *
 * To run a query within a React component, call `useGetDatasetsForMixQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsForMixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsForMixQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDatasetsForMixQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables> & ({ variables: GetDatasetsForMixQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>(GetDatasetsForMixDocument, options);
      }
export function useGetDatasetsForMixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>(GetDatasetsForMixDocument, options);
        }
// @ts-ignore
export function useGetDatasetsForMixSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>;
export function useGetDatasetsForMixSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetsForMixQuery | undefined, GetDatasetsForMixQueryVariables>;
export function useGetDatasetsForMixSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>(GetDatasetsForMixDocument, options);
        }
export type GetDatasetsForMixQueryHookResult = ReturnType<typeof useGetDatasetsForMixQuery>;
export type GetDatasetsForMixLazyQueryHookResult = ReturnType<typeof useGetDatasetsForMixLazyQuery>;
export type GetDatasetsForMixSuspenseQueryHookResult = ReturnType<typeof useGetDatasetsForMixSuspenseQuery>;
export type GetDatasetsForMixQueryResult = Apollo.QueryResult<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>;
export const GetDatasetDetailsAnalyticsDocument = gql`
    query GetDatasetDetailsAnalytics($workspaceId: String!, $datasetId: String) {
  getAnalytics(workspaceId: $workspaceId, datasetId: $datasetId) {
    analyticsId
    datasetId
    status
    tags
    type
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetDetailsAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables> & ({ variables: GetDatasetDetailsAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
      }
export function useGetDatasetDetailsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetDatasetDetailsAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>;
export function useGetDatasetDetailsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetDetailsAnalyticsQuery | undefined, GetDatasetDetailsAnalyticsQueryVariables>;
export function useGetDatasetDetailsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
        }
export type GetDatasetDetailsAnalyticsQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsQuery>;
export type GetDatasetDetailsAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsLazyQuery>;
export type GetDatasetDetailsAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsSuspenseQuery>;
export type GetDatasetDetailsAnalyticsQueryResult = Apollo.QueryResult<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>;
export const GetAnnotationsDocument = gql`
    query GetAnnotations($workspaceId: String!, $datasetId: String) {
  getAnnotations(workspaceId: $workspaceId, datasetId: $datasetId) {
    annotationId
    datasetId
    format
    map
    status
    tags
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables> & ({ variables: GetAnnotationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
      }
export function useGetAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
        }
// @ts-ignore
export function useGetAnnotationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationsQuery, GetAnnotationsQueryVariables>;
export function useGetAnnotationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnotationsQuery | undefined, GetAnnotationsQueryVariables>;
export function useGetAnnotationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
        }
export type GetAnnotationsQueryHookResult = ReturnType<typeof useGetAnnotationsQuery>;
export type GetAnnotationsLazyQueryHookResult = ReturnType<typeof useGetAnnotationsLazyQuery>;
export type GetAnnotationsSuspenseQueryHookResult = ReturnType<typeof useGetAnnotationsSuspenseQuery>;
export type GetAnnotationsQueryResult = Apollo.QueryResult<GetAnnotationsQuery, GetAnnotationsQueryVariables>;
export const GetDatasetDetailsGANDatasetsDocument = gql`
    query GetDatasetDetailsGANDatasets($workspaceId: String!, $datasetId: String) {
  getGANDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    description
    model
    name
    parentId
    status
    tags
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetDetailsGANDatasetsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsGANDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsGANDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsGANDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsGANDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables> & ({ variables: GetDatasetDetailsGANDatasetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>(GetDatasetDetailsGANDatasetsDocument, options);
      }
export function useGetDatasetDetailsGANDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>(GetDatasetDetailsGANDatasetsDocument, options);
        }
// @ts-ignore
export function useGetDatasetDetailsGANDatasetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>;
export function useGetDatasetDetailsGANDatasetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetDetailsGANDatasetsQuery | undefined, GetDatasetDetailsGANDatasetsQueryVariables>;
export function useGetDatasetDetailsGANDatasetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>(GetDatasetDetailsGANDatasetsDocument, options);
        }
export type GetDatasetDetailsGANDatasetsQueryHookResult = ReturnType<typeof useGetDatasetDetailsGANDatasetsQuery>;
export type GetDatasetDetailsGANDatasetsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsGANDatasetsLazyQuery>;
export type GetDatasetDetailsGANDatasetsSuspenseQueryHookResult = ReturnType<typeof useGetDatasetDetailsGANDatasetsSuspenseQuery>;
export type GetDatasetDetailsGANDatasetsQueryResult = Apollo.QueryResult<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>;
export const GetDatasetDetailsUMAPsDocument = gql`
    query GetDatasetDetailsUMAPs($workspaceId: String!, $datasetId: String) {
  getUMAPs(workspaceId: $workspaceId, datasetId: $datasetId) {
    name
    status
    tags
    umapId
  }
}
    `;

/**
 * __useGetDatasetDetailsUMAPsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsUMAPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsUMAPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsUMAPsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsUMAPsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables> & ({ variables: GetDatasetDetailsUMAPsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>(GetDatasetDetailsUMAPsDocument, options);
      }
export function useGetDatasetDetailsUMAPsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>(GetDatasetDetailsUMAPsDocument, options);
        }
// @ts-ignore
export function useGetDatasetDetailsUMAPsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>;
export function useGetDatasetDetailsUMAPsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetDetailsUMAPsQuery | undefined, GetDatasetDetailsUMAPsQueryVariables>;
export function useGetDatasetDetailsUMAPsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>(GetDatasetDetailsUMAPsDocument, options);
        }
export type GetDatasetDetailsUMAPsQueryHookResult = ReturnType<typeof useGetDatasetDetailsUMAPsQuery>;
export type GetDatasetDetailsUMAPsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsUMAPsLazyQuery>;
export type GetDatasetDetailsUMAPsSuspenseQueryHookResult = ReturnType<typeof useGetDatasetDetailsUMAPsSuspenseQuery>;
export type GetDatasetDetailsUMAPsQueryResult = Apollo.QueryResult<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>;
export const GetDatasetInferencesDocument = gql`
    query GetDatasetInferences($workspaceId: String!, $datasetId: String) {
  getMLInferences(workspaceId: $workspaceId, datasetId: $datasetId) {
    inferenceId
    dataset
    datasetId
    modelId
    model
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetInferencesQuery__
 *
 * To run a query within a React component, call `useGetDatasetInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables> & ({ variables: GetDatasetInferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
      }
export function useGetDatasetInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
        }
// @ts-ignore
export function useGetDatasetInferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>;
export function useGetDatasetInferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetInferencesQuery | undefined, GetDatasetInferencesQueryVariables>;
export function useGetDatasetInferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
        }
export type GetDatasetInferencesQueryHookResult = ReturnType<typeof useGetDatasetInferencesQuery>;
export type GetDatasetInferencesLazyQueryHookResult = ReturnType<typeof useGetDatasetInferencesLazyQuery>;
export type GetDatasetInferencesSuspenseQueryHookResult = ReturnType<typeof useGetDatasetInferencesSuspenseQuery>;
export type GetDatasetInferencesQueryResult = Apollo.QueryResult<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>;
export const GetDatasetModelsDocument = gql`
    query GetDatasetModels($workspaceId: String!, $datasetId: String) {
  getMLModels(workspaceId: $workspaceId, datasetId: $datasetId) {
    modelId
    name
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetModelsQuery__
 *
 * To run a query within a React component, call `useGetDatasetModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetModelsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables> & ({ variables: GetDatasetModelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
      }
export function useGetDatasetModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
        }
// @ts-ignore
export function useGetDatasetModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>;
export function useGetDatasetModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetModelsQuery | undefined, GetDatasetModelsQueryVariables>;
export function useGetDatasetModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
        }
export type GetDatasetModelsQueryHookResult = ReturnType<typeof useGetDatasetModelsQuery>;
export type GetDatasetModelsLazyQueryHookResult = ReturnType<typeof useGetDatasetModelsLazyQuery>;
export type GetDatasetModelsSuspenseQueryHookResult = ReturnType<typeof useGetDatasetModelsSuspenseQuery>;
export type GetDatasetModelsQueryResult = Apollo.QueryResult<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>;
export const GetDatasetsWithFilterDocument = gql`
    query GetDatasetsWithFilter($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetFilter) {
  getDatasets(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channel
    channelId
    classes
    createdAt
    createdBy
    datasetId
    description
    files
    graphId
    name
    runs
    seed
    size
    source
    status
    tags
    type
  }
}
    `;

/**
 * __useGetDatasetsWithFilterQuery__
 *
 * To run a query within a React component, call `useGetDatasetsWithFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsWithFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsWithFilterQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetsWithFilterQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables> & ({ variables: GetDatasetsWithFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
      }
export function useGetDatasetsWithFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
        }
// @ts-ignore
export function useGetDatasetsWithFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>;
export function useGetDatasetsWithFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetsWithFilterQuery | undefined, GetDatasetsWithFilterQueryVariables>;
export function useGetDatasetsWithFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
        }
export type GetDatasetsWithFilterQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterQuery>;
export type GetDatasetsWithFilterLazyQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterLazyQuery>;
export type GetDatasetsWithFilterSuspenseQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterSuspenseQuery>;
export type GetDatasetsWithFilterQueryResult = Apollo.QueryResult<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>;
export const GetDatasetsSearchDetailDocument = gql`
    query GetDatasetsSearchDetail($workspaceId: String!, $filters: DatasetFilter) {
  getDatasetsSearchDetail(workspaceId: $workspaceId, filters: $filters) {
    channels {
      value
      display
    }
    tags {
      value
      display
    }
    type {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetDatasetsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetDatasetsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables> & ({ variables: GetDatasetsSearchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
      }
export function useGetDatasetsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
        }
// @ts-ignore
export function useGetDatasetsSearchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>;
export function useGetDatasetsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatasetsSearchDetailQuery | undefined, GetDatasetsSearchDetailQueryVariables>;
export function useGetDatasetsSearchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
        }
export type GetDatasetsSearchDetailQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailQuery>;
export type GetDatasetsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailLazyQuery>;
export type GetDatasetsSearchDetailSuspenseQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailSuspenseQuery>;
export type GetDatasetsSearchDetailQueryResult = Apollo.QueryResult<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>;
export const GetAvailableChannelsForNewWorkspaceDocument = gql`
    query GetAvailableChannelsForNewWorkspace($organizationId: String!) {
  getChannels(organizationId: $organizationId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetAvailableChannelsForNewWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetAvailableChannelsForNewWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableChannelsForNewWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableChannelsForNewWorkspaceQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAvailableChannelsForNewWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables> & ({ variables: GetAvailableChannelsForNewWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>(GetAvailableChannelsForNewWorkspaceDocument, options);
      }
export function useGetAvailableChannelsForNewWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>(GetAvailableChannelsForNewWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetAvailableChannelsForNewWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>;
export function useGetAvailableChannelsForNewWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableChannelsForNewWorkspaceQuery | undefined, GetAvailableChannelsForNewWorkspaceQueryVariables>;
export function useGetAvailableChannelsForNewWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>(GetAvailableChannelsForNewWorkspaceDocument, options);
        }
export type GetAvailableChannelsForNewWorkspaceQueryHookResult = ReturnType<typeof useGetAvailableChannelsForNewWorkspaceQuery>;
export type GetAvailableChannelsForNewWorkspaceLazyQueryHookResult = ReturnType<typeof useGetAvailableChannelsForNewWorkspaceLazyQuery>;
export type GetAvailableChannelsForNewWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetAvailableChannelsForNewWorkspaceSuspenseQuery>;
export type GetAvailableChannelsForNewWorkspaceQueryResult = Apollo.QueryResult<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>;